// Game SEO: patterns, gamesSlugMap, optional gameSeo per `/p/{provider}/{game}` (use `{brand}` in copy).
// Keep in sync with libs/content/src/lib/seo/en.json. Slug map names must match catalog API (GameInfo / ProviderInfo).
// Patterns - {game}, {provider}, {brand} substituted at runtime
export const gameSeoPatterns = {
    title: 'Play {game} by {provider} | {brand}',
    description: 'Play {game} by {provider} at {brand}. Crypto deposits, instant withdrawals, demo play, and fast payouts on this online slot.'
};
// slug → game info map - generated from catalog (pnpm sync:catalog-sitemap)
export { gamesSlugMap } from './games-slug-map.generated.js';
const gameSeoBase = {
    '/p/pgsoft/garuda_gems': {
        title: 'Garuda Gems Ways Slot by PG Soft | {brand}',
        description: 'Garuda Gems by PG Soft at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pgsoft/legendary_monkey_king': {
        title: 'Legendary Monkey King: Play Online with Crypto | {brand}',
        description: 'Legendary Monkey King from PG Soft, with a 6,030x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pgsoft/shaolin_soccer': {
        title: 'Shaolin Soccer by PG Soft at {brand} | Free Demo & Crypto Play',
        description: 'Play Shaolin Soccer by PG Soft at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pgsoft/destiny_of_sun_and_moon': {
        title: 'Destiny of Sun and Moon: Play Online with Crypto | {brand}',
        description: 'Destiny of Sun and Moon from PG Soft, with a 3,913x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pgsoft/mr_treasures_fortune': {
        title: "Mr Treasure's Fortune by PG Soft at {brand} | Free Demo & Crypto Play",
        description: "Spin Mr Treasure's Fortune by PG Soft at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/pgsoft/dreams_of_macau': {
        title: 'Play Dreams of Macau by PG Soft at {brand} | 6,160x Max Win',
        description: 'Play Dreams of Macau by PG Soft at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pgsoft/opera_dynasty': {
        title: 'Opera Dynasty by PG Soft at {brand} | Free Demo & Crypto Play',
        description: 'Spin Opera Dynasty by PG Soft at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pgsoft/hip_hop_panda': {
        title: 'Play Hip Hop Panda by PG Soft at {brand} | 572x Max Win',
        description: 'Spin Hip Hop Panda by PG Soft at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pgsoft/wild_coaster': {
        title: 'Play Wild Coaster by PG Soft at {brand} | 16,465x Max Win',
        description: 'Play Wild Coaster by PG Soft at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pgsoft/win_win_won': {
        title: 'Play Win Win Won by PG Soft at {brand} | 2,600x Max Win',
        description: 'Spin Win Win Won by PG Soft at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pgsoft/symbols_of_egypt': {
        title: 'Symbols of Egypt Slot by PG Soft at {brand} | Instant Crypto Payouts',
        description: 'Symbols of Egypt from PG Soft, with a 1,080x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pgsoft/museum_mystery': {
        title: 'Museum Mystery by PG Soft at {brand} | Free Demo & Crypto Play',
        description: 'Play Museum Mystery by PG Soft at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pgsoft/mystic_potion': {
        title: 'Mystic Potion Slot by PG Soft at {brand} | Instant Crypto Payouts',
        description: 'Mystic Potion from PG Soft, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pgsoft/rio_fantasia': {
        title: 'Rio Fantasia by PG Soft at {brand} | Free Demo & Crypto Play',
        description: 'Play Rio Fantasia by PG Soft at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pgsoft/midas_fortune': {
        title: 'Play Midas Fortune by PG Soft at {brand} | 2,138x Max Win',
        description: 'Spin Midas Fortune by PG Soft at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pgsoft/flirting_scholar': {
        title: 'Flirting Scholar by PG Soft at {brand} | Free Demo & Crypto Play',
        description: 'Spin Flirting Scholar by PG Soft at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pgsoft/alibabas_cave_of_fortune': {
        title: "Alibaba's Cave of Fortune by PG Soft at {brand} | Free Demo & Crypto Play",
        description: "Alibaba's Cave of Fortune from PG Soft. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/pgsoft/safari_wilds': {
        title: 'Play Safari Wilds by PG Soft at {brand} | 5,000x Max Win',
        description: 'Play Safari Wilds by PG Soft at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pgsoft/honey_trap_of_diao_chan': {
        title: 'Play Honey Trap of Diao Chan by PG Soft at {brand} | 20,230x Max Win',
        description: 'Spin Honey Trap of Diao Chan by PG Soft at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pgsoft/piggy_gold': {
        title: 'Piggy Gold Ways Slot by PG Soft | {brand}',
        description: 'Piggy Gold from PG Soft, with a 2,990x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pgsoft/wild_fireworks': {
        title: 'Wild Fireworks Ways Slot by PG Soft | {brand}',
        description: 'Wild Fireworks from PG Soft, with a 1,356x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pgsoft/mystical_spirits': {
        title: 'Mystical Spirits: Play Online with Crypto | {brand}',
        description: 'Mystical Spirits by PG Soft at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pgsoft/totem_wonders': {
        title: 'Totem Wonders by PG Soft at {brand} | Free Demo & Crypto Play',
        description: 'Play Totem Wonders by PG Soft at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pgsoft/lucky_neko': {
        title: 'Play Lucky Neko by PG Soft at {brand} | 5,527x Max Win',
        description: 'Play Lucky Neko by PG Soft at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pgsoft/bikini_paradise': {
        title: 'Play Bikini Paradise by PG Soft at {brand} | 5,482x Max Win',
        description: 'Play Bikini Paradise by PG Soft at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pgsoft/oishi_delights': {
        title: 'Oishi Delights: Play Online with Crypto | {brand}',
        description: 'Oishi Delights from PG Soft, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pgsoft/bali_vacation': {
        title: 'Bali Vacation by PG Soft at {brand} | Free Demo & Crypto Play',
        description: 'Spin Bali Vacation by PG Soft at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pgsoft/egypts_book_of_mystery': {
        title: "Play Egypt's Book of Mystery by PG Soft at {brand} | 9,546x Max Win",
        description: "Play Egypt's Book of Mystery by PG Soft at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/pgsoft/songkran_splash': {
        title: 'Songkran Splash Ways Slot by PG Soft | {brand}',
        description: 'Songkran Splash by PG Soft at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pgsoft/vampires_charm': {
        title: "Vampire's Charm Ways Slot by PG Soft | {brand}",
        description: "Vampire's Charm by PG Soft at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/pgsoft/dragon_hatch': {
        title: 'Play Dragon Hatch by PG Soft at {brand} | 2,027x Max Win',
        description: 'Spin Dragon Hatch by PG Soft at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pgsoft/fortune_ox': {
        title: 'Fortune Ox Slot by PG Soft at {brand} | Instant Crypto Payouts',
        description: 'Fortune Ox from PG Soft, with a 2,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pgsoft/guardians_of_ice_and_fire': {
        title: 'Guardians of Ice and Fire Slot by PG Soft at {brand} | Instant Crypto Payouts',
        description: 'Guardians of Ice and Fire by PG Soft at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pgsoft/pinata_wins': {
        title: 'Pinata Wins: Play Online with Crypto | {brand}',
        description: 'Pinata Wins by PG Soft at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pgsoft/galaxy_miner': {
        title: 'Play Galaxy Miner by PG Soft at {brand} | 1,000x Max Win',
        description: 'Spin Galaxy Miner by PG Soft at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pgsoft/mahjong_ways': {
        title: 'Mahjong Ways: Play Online with Crypto | {brand}',
        description: 'Mahjong Ways by PG Soft at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pgsoft/fortune_snake': {
        title: 'Play Fortune Snake by PG Soft at {brand} | 5,000x Max Win',
        description: 'Play Fortune Snake by PG Soft at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pgsoft/pharaoh_royale': {
        title: 'Play Pharaoh Royale by PG Soft at {brand} | 2,000x Max Win',
        description: 'Spin Pharaoh Royale by PG Soft at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pgsoft/wild_ape_3258': {
        title: 'Play Wild Ape 3258 by PG Soft at {brand} | 10,000x Max Win',
        description: 'Spin Wild Ape 3258 by PG Soft at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pgsoft/buffalo_win': {
        title: 'Play Buffalo Win by PG Soft at {brand} | 1,548x Max Win',
        description: 'Play Buffalo Win by PG Soft at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pgsoft/asgardian_rising': {
        title: 'Asgardian Rising Ways Slot by PG Soft | {brand}',
        description: 'Asgardian Rising by PG Soft at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pgsoft/reel_royale_showdown': {
        title: 'Reel Royale Showdown: Play Online with Crypto | {brand}',
        description: 'Reel Royale Showdown from PG Soft, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pgsoft/majestic_empire': {
        title: 'Majestic Empire Ways Slot by PG Soft | {brand}',
        description: 'Majestic Empire by PG Soft at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pgsoft/knockout_riches': {
        title: 'Knockout Riches: Play Online with Crypto | {brand}',
        description: 'Knockout Riches from PG Soft, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pgsoft/zombie_outbreak': {
        title: 'Play Zombie Outbreak by PG Soft at {brand} | 5,000x Max Win',
        description: 'Play Zombie Outbreak by PG Soft at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pgsoft/plushie_frenzy': {
        title: 'Plushie Frenzy Ways Slot by PG Soft | {brand}',
        description: 'Plushie Frenzy by PG Soft at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pgsoft/reel_love': {
        title: 'Reel Love Slot by PG Soft at {brand} | Instant Crypto Payouts',
        description: 'Reel Love from PG Soft, with a 3,446x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pgsoft/ganesha_fortune': {
        title: 'Ganesha Fortune Ways Slot by PG Soft | {brand}',
        description: 'Ganesha Fortune by PG Soft at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pgsoft/doomsday_rampage': {
        title: 'Play Doomsday Rampage by PG Soft at {brand} | 5,000x Max Win',
        description: 'Spin Doomsday Rampage by PG Soft at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pgsoft/jewels_of_prosperity': {
        title: 'Jewels of Prosperity by PG Soft at {brand} | Free Demo & Crypto Play',
        description: 'Spin Jewels of Prosperity by PG Soft at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pgsoft/genies_3_wishes': {
        title: "Genie's 3 Wishes Ways Slot by PG Soft | {brand}",
        description: "Genie's 3 Wishes by PG Soft at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/pgsoft/fortune_horse': {
        title: 'Fortune Horse Ways Slot by PG Soft | {brand}',
        description: 'Fortune Horse from PG Soft, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pgsoft/hotpot': {
        title: 'Hotpot by PG Soft at {brand} | Free Demo & Crypto Play',
        description: 'Spin Hotpot by PG Soft at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pgsoft/candy_burst': {
        title: 'Play Candy Burst by PG Soft at {brand} | 1,016x Max Win',
        description: 'Play Candy Burst by PG Soft at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pgsoft/candy_bonanza': {
        title: 'Candy Bonanza Slot by PG Soft at {brand} | Instant Crypto Payouts',
        description: 'Candy Bonanza from PG Soft, with a 2,563x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pgsoft/hood_vs_wolf': {
        title: 'Hood vs Wolf Slot by PG Soft at {brand} | Instant Crypto Payouts',
        description: 'Hood vs Wolf by PG Soft at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pgsoft/speed_winner': {
        title: 'Speed Winner: Play Online with Crypto | {brand}',
        description: 'Speed Winner from PG Soft, with a 8,345x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pgsoft/zombie_blasters': {
        title: 'Zombie Blasters Slot by PG Soft at {brand} | Instant Crypto Payouts',
        description: 'Zombie Blasters from PG Soft, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pgsoft/captains_bounty': {
        title: "Captain's Bounty Slot by PG Soft at {brand} | Instant Crypto Payouts",
        description: "Captain's Bounty from PG Soft, with a 4,796x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/pgsoft/jungle_delight': {
        title: 'Jungle Delight Slot by PG Soft at {brand} | Instant Crypto Payouts',
        description: 'Jungle Delight from PG Soft, with a 2,669x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pgsoft/ninja_vs_samurai': {
        title: 'Ninja vs Samurai Ways Slot by PG Soft | {brand}',
        description: 'Ninja vs Samurai from PG Soft, with a 2,610x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pgsoft/jack_frosts_winter': {
        title: "Jack Frost's Winter Ways Slot by PG Soft | {brand}",
        description: "Jack Frost's Winter by PG Soft at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/pgsoft/santas_gift_rush': {
        title: "Play Santa's Gift Rush by PG Soft at {brand} | 689x Max Win",
        description: "Play Santa's Gift Rush by PG Soft at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/pgsoft/mayan_destiny': {
        title: 'Mayan Destiny Ways Slot by PG Soft | {brand}',
        description: 'Mayan Destiny by PG Soft at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pgsoft/the_queens_banquet': {
        title: "The Queen's Banquet by PG Soft at {brand} | Free Demo & Crypto Play",
        description: "Play The Queen's Banquet by PG Soft at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/pgsoft/bakery_bonanza': {
        title: 'Play Bakery Bonanza by PG Soft at {brand} | 12,190x Max Win',
        description: 'Play Bakery Bonanza by PG Soft at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pgsoft/perfect_strike': {
        title: 'Play Perfect Strike by PG Soft at {brand} | 4,000x Max Win',
        description: 'Spin Perfect Strike by PG Soft at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pgsoft/fortune_rabbit': {
        title: 'Fortune Rabbit: Play Online with Crypto | {brand}',
        description: 'Spin Fortune Rabbit by PG Soft at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pgsoft/mermaid_riches': {
        title: 'Play Mermaid Riches by PG Soft at {brand} | 3,513x Max Win',
        description: 'Spin Mermaid Riches by PG Soft at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pgsoft/fortune_mouse': {
        title: 'Fortune Mouse: Play Online with Crypto | {brand}',
        description: 'Fortune Mouse from PG Soft, with a 1,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pgsoft/prosperity_fortune_tree': {
        title: 'Play Prosperity Fortune Tree by PG Soft at {brand} | 1,513x Max Win',
        description: 'Spin Prosperity Fortune Tree by PG Soft at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pgsoft/cash_mania': {
        title: 'Play Cash Mania by PG Soft at {brand} | 2,000x Max Win',
        description: 'Play Cash Mania by PG Soft at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pgsoft/fortune_gods': {
        title: 'Fortune Gods: Play Online with Crypto | {brand}',
        description: 'Fortune Gods by PG Soft at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pgsoft/mighty_mania': {
        title: 'Mighty Mania Ways Slot by PG Soft | {brand}',
        description: 'Mighty Mania by PG Soft at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pgsoft/super_golf_drive': {
        title: 'Super Golf Drive Slot by PG Soft at {brand} | Instant Crypto Payouts',
        description: 'Super Golf Drive by PG Soft at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pgsoft/skylight_wonders': {
        title: 'Skylight Wonders by PG Soft at {brand} | Free Demo & Crypto Play',
        description: 'Play Skylight Wonders by PG Soft at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pgsoft/jack_the_giant_hunter': {
        title: 'Play Jack the Giant Hunter by PG Soft at {brand} | 10,000x Max Win',
        description: 'Spin Jack the Giant Hunter by PG Soft at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pgsoft/rooster_rumble': {
        title: 'Rooster Rumble by PG Soft at {brand} | Free Demo & Crypto Play',
        description: 'Spin Rooster Rumble by PG Soft at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pgsoft/legend_of_perseus': {
        title: 'Legend of Perseus: Play Online with Crypto | {brand}',
        description: 'Legend of Perseus from PG Soft, with a 7,524x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pgsoft/funky_fortunez': {
        title: 'Funky Fortunez Slot by PG Soft at {brand} | Instant Crypto Payouts',
        description: 'Funky Fortunez from PG Soft, with a 2,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pgsoft/poker_kingdom_win': {
        title: 'Poker Kingdom Win by PG Soft at {brand} | Free Demo & Crypto Play',
        description: 'Play Poker Kingdom Win by PG Soft at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pgsoft/gemstones_gold': {
        title: 'Play Gemstones Gold by PG Soft at {brand} | 7,500x Max Win',
        description: 'Play Gemstones Gold by PG Soft at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pgsoft/fortune_dragon': {
        title: 'Fortune Dragon: Play Online with Crypto | {brand}',
        description: 'Fortune Dragon by PG Soft at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pgsoft/forbidden_alchemy': {
        title: 'Forbidden Alchemy: Play Online with Crypto | {brand}',
        description: 'Forbidden Alchemy from PG Soft, with a 8,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pgsoft/ultimate_striker': {
        title: 'Ultimate Striker by PG Soft at {brand} | Free Demo & Crypto Play',
        description: 'Play Ultimate Striker by PG Soft at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pgsoft/ways_of_the_qilin': {
        title: 'Ways of the Qilin by PG Soft at {brand} | Free Demo & Crypto Play',
        description: 'Play Ways of the Qilin by PG Soft at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pgsoft/dragons_treasure_quest': {
        title: "Dragon's Treasure Quest Slot by PG Soft at {brand} | Instant Crypto Payouts",
        description: "Dragon's Treasure Quest by PG Soft at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/pgsoft/legend_of_hou_yi': {
        title: 'Legend of Hou Yi: Play Online with Crypto | {brand}',
        description: 'Legend of Hou Yi from PG Soft, with a 900x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pgsoft/gem_saviour_conquest': {
        title: 'Gem Saviour Conquest by PG Soft at {brand} | Free Demo & Crypto Play',
        description: 'Spin Gem Saviour Conquest by PG Soft at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pgsoft/wings_of_iguazu': {
        title: 'Play Wings of Iguazu by PG Soft at {brand} | 2,000x Max Win',
        description: 'Play Wings of Iguazu by PG Soft at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pgsoft/heist_stakes': {
        title: 'Heist Stakes: Play Online with Crypto | {brand}',
        description: 'Heist Stakes from PG Soft, with a 3,071x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pgsoft/medusa_ii': {
        title: 'Play Medusa II by PG Soft at {brand} | 529x Max Win',
        description: 'Spin Medusa II by PG Soft at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pgsoft/tornado_rampage': {
        title: 'Tornado Rampage: Play Online with Crypto | {brand}',
        description: 'Tornado Rampage from PG Soft, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pgsoft/queen_of_bounty': {
        title: 'Queen of Bounty by PG Soft at {brand} | Free Demo & Crypto Play',
        description: 'Play Queen of Bounty by PG Soft at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pgsoft/cruise_royale': {
        title: 'Play Cruise Royale by PG Soft at {brand} | 2,500x Max Win',
        description: 'Spin Cruise Royale by PG Soft at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pgsoft/yakuza_honor': {
        title: 'Play Yakuza Honor by PG Soft at {brand} | 2,500x Max Win',
        description: 'Spin Yakuza Honor by PG Soft at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pgsoft/emoji_riches': {
        title: 'Emoji Riches: Play Online with Crypto | {brand}',
        description: 'Emoji Riches from PG Soft, with a 2,992x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pgsoft/three_crazy_piggies': {
        title: 'Three Crazy Piggies Ways Slot by PG Soft | {brand}',
        description: 'Three Crazy Piggies from PG Soft, with a 2,500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pgsoft/majestic_treasures': {
        title: 'Majestic Treasures Slot by PG Soft at {brand} | Instant Crypto Payouts',
        description: 'Majestic Treasures from PG Soft, with a 5,236x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pgsoft/diner_delights': {
        title: 'Diner Delights Slot by PG Soft at {brand} | Instant Crypto Payouts',
        description: 'Diner Delights from PG Soft, with a 2,989x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pgsoft/gladiators_glory': {
        title: "Play Gladiator's Glory by PG Soft at {brand} | 5,000x Max Win",
        description: "Play Gladiator's Glory by PG Soft at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/pgsoft/galactic_gems': {
        title: 'Galactic Gems Ways Slot by PG Soft | {brand}',
        description: 'Galactic Gems by PG Soft at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pgsoft/gem_saviour': {
        title: 'Gem Saviour Slot by PG Soft at {brand} | Instant Crypto Payouts',
        description: 'Gem Saviour from PG Soft, with a 74x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pgsoft/butterfly_blossom': {
        title: 'Butterfly Blossom: Play Online with Crypto | {brand}',
        description: 'Butterfly Blossom from PG Soft, with a 7,125x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pgsoft/diner_frenzy_spins': {
        title: 'Diner Frenzy Spins: Play Online with Crypto | {brand}',
        description: 'Diner Frenzy Spins from PG Soft, with a 2,105x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pgsoft/supermarket_spree': {
        title: 'Supermarket Spree: Play Online with Crypto | {brand}',
        description: 'Supermarket Spree by PG Soft at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pgsoft/leprechaun_riches': {
        title: 'Play Leprechaun Riches by PG Soft at {brand} | 9,893x Max Win',
        description: 'Play Leprechaun Riches by PG Soft at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pgsoft/chicky_run': {
        title: 'Chicky Run Slot by PG Soft at {brand} | Instant Crypto Payouts',
        description: 'Chicky Run by PG Soft at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pgsoft/rise_of_apollo': {
        title: 'Rise of Apollo: Play Online with Crypto | {brand}',
        description: 'Rise of Apollo by PG Soft at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pgsoft/futebol_fever': {
        title: 'Play Futebol Fever by PG Soft at {brand} | 2,000x Max Win',
        description: 'Spin Futebol Fever by PG Soft at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pgsoft/dragon_legend': {
        title: 'Dragon Legend Ways Slot by PG Soft | {brand}',
        description: 'Dragon Legend by PG Soft at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pgsoft/secrets_of_cleopatra': {
        title: 'Secrets of Cleopatra: Play Online with Crypto | {brand}',
        description: 'Secrets of Cleopatra from PG Soft, with a 8,649x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pgsoft/super_wildrix': {
        title: 'Super Wildrix Slot by PG Soft at {brand} | Instant Crypto Payouts',
        description: 'Super Wildrix from PG Soft, with a 20,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pgsoft/muay_thai_champion': {
        title: 'Muay Thai Champion: Play Online with Crypto | {brand}',
        description: 'Muay Thai Champion by PG Soft at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pgsoft/lucky_piggy': {
        title: 'Lucky Piggy: Play Online with Crypto | {brand}',
        description: 'Lucky Piggy by PG Soft at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pgsoft/tree_of_fortune': {
        title: 'Tree of Fortune by PG Soft at {brand} | Free Demo & Crypto Play',
        description: 'Play Tree of Fortune by PG Soft at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pgsoft/thai_river_wonders': {
        title: 'Play Thai River Wonders by PG Soft at {brand} | 8,716x Max Win',
        description: 'Play Thai River Wonders by PG Soft at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pgsoft/lucky_clover_riches': {
        title: 'Lucky Clover Riches Ways Slot by PG Soft | {brand}',
        description: 'Lucky Clover Riches by PG Soft at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pgsoft/journey_to_the_wealth': {
        title: 'Play Journey to the Wealth by PG Soft at {brand} | 1,268x Max Win',
        description: 'Spin Journey to the Wealth by PG Soft at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pgsoft/circus_delight': {
        title: 'Circus Delight Slot by PG Soft at {brand} | Instant Crypto Payouts',
        description: 'Circus Delight from PG Soft, with a 5,467x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pgsoft/mr_hallowwin': {
        title: 'Mr. Hallow-Win Ways Slot by PG Soft | {brand}',
        description: 'Mr. Hallow-Win by PG Soft at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pgsoft/mythical_guardians': {
        title: 'Mythical Guardians by PG Soft at {brand} | Free Demo & Crypto Play',
        description: 'Spin Mythical Guardians by PG Soft at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pgsoft/treasures_of_aztec': {
        title: 'Play Treasures of Aztec by PG Soft at {brand} | 9,071x Max Win',
        description: 'Spin Treasures of Aztec by PG Soft at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pgsoft/wild_bounty_showdown': {
        title: 'Play Wild Bounty Showdown by PG Soft at {brand} | 5,000x Max Win',
        description: 'Play Wild Bounty Showdown by PG Soft at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pgsoft/dead_mans_riches': {
        title: "Dead Man's Riches Ways Slot by PG Soft | {brand}",
        description: "Dead Man's Riches by PG Soft at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/pgsoft/mahjong_ways_2': {
        title: 'Mahjong Ways 2 by PG Soft at {brand} | Free Demo & Crypto Play',
        description: 'Spin Mahjong Ways 2 by PG Soft at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pgsoft/caishen_wins': {
        title: 'Caishen Wins: Play Online with Crypto | {brand}',
        description: 'Caishen Wins by PG Soft at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pgsoft/phoenix_rises': {
        title: 'Play Phoenix Rises by PG Soft at {brand} | 2,990x Max Win',
        description: 'Play Phoenix Rises by PG Soft at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pgsoft/graffiti_rush': {
        title: 'Graffiti Rush Slot by PG Soft at {brand} | Instant Crypto Payouts',
        description: 'Graffiti Rush from PG Soft, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pgsoft/dragon_tiger_luck': {
        title: 'Dragon Tiger Luck Slot by PG Soft at {brand} | Instant Crypto Payouts',
        description: 'Dragon Tiger Luck by PG Soft at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pgsoft/fruit_candy': {
        title: 'Play Fruit Candy by PG Soft at {brand} | 10,000x Max Win',
        description: 'Play Fruit Candy by PG Soft at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pgsoft/forge_of_wealth': {
        title: 'Forge of Wealth Slot by PG Soft at {brand} | Instant Crypto Payouts',
        description: 'Forge of Wealth by PG Soft at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pgsoft/anubis_wrath': {
        title: 'Anubis Wrath Ways Slot by PG Soft | {brand}',
        description: 'Anubis Wrath from PG Soft, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pgsoft/inferno_mayhem': {
        title: 'Inferno Mayhem Ways Slot by PG Soft | {brand}',
        description: 'Inferno Mayhem from PG Soft, with a 25,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pgsoft/gem_saviour_sword': {
        title: 'Gem Saviour Sword: Play Online with Crypto | {brand}',
        description: 'Gem Saviour Sword by PG Soft at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pgsoft/geishas_revenge': {
        title: "Geisha's Revenge: Play Online with Crypto | {brand}",
        description: "Geisha's Revenge by PG Soft at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/pgsoft/emperors_favour': {
        title: "Emperor's Favour: Play Online with Crypto | {brand}",
        description: "Emperor's Favour by PG Soft at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/pgsoft/ninja_raccoon_frenzy': {
        title: 'Ninja Raccoon Frenzy Slot by PG Soft at {brand} | Instant Crypto Payouts',
        description: 'Ninja Raccoon Frenzy by PG Soft at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pgsoft/medusa': {
        title: 'Medusa Ways Slot by PG Soft | {brand}',
        description: 'Medusa from PG Soft, with a 550x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pgsoft/cocktail_nights': {
        title: 'Cocktail Nights by PG Soft at {brand} | Free Demo & Crypto Play',
        description: 'Play Cocktail Nights by PG Soft at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pgsoft/monkeys_wild_party': {
        title: 'Play Monkeys Wild Party by PG Soft at {brand} | 10,000x Max Win',
        description: 'Spin Monkeys Wild Party by PG Soft at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pgsoft/oriental_prosperity': {
        title: 'Oriental Prosperity by PG Soft at {brand} | Free Demo & Crypto Play',
        description: 'Play Oriental Prosperity by PG Soft at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pgsoft/crypto_gold': {
        title: 'Play Crypto Gold by PG Soft at {brand} | 8,329x Max Win',
        description: 'Play Crypto Gold by PG Soft at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pgsoft/grimms_bounty_hanset_and_gretel': {
        title: 'Grimms Bounty Hanset and Gretel Slot by PG Soft at {brand} | Instant Crypto Payouts',
        description: 'Grimms Bounty Hanset and Gretel by PG Soft at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pgsoft/rave_party_fever': {
        title: 'Play Rave Party Fever by PG Soft at {brand} | 4,699x Max Win',
        description: 'Play Rave Party Fever by PG Soft at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pgsoft/raider_janes_crypt_of_fortune': {
        title: "Raider Jane's Crypt of Fortune: Play Online with Crypto | {brand}",
        description: "Spin Raider Jane's Crypt of Fortune by PG Soft at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/pgsoft/fortune_tiger': {
        title: 'Fortune Tiger Ways Slot by PG Soft | {brand}',
        description: 'Fortune Tiger by PG Soft at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pgsoft/jurassic_kingdom': {
        title: 'Jurassic Kingdom by PG Soft at {brand} | Free Demo & Crypto Play',
        description: 'Spin Jurassic Kingdom by PG Soft at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pgsoft/chocolate_deluxe': {
        title: 'Chocolate Deluxe by PG Soft at {brand} | Free Demo & Crypto Play',
        description: 'Play Chocolate Deluxe by PG Soft at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pgsoft/ganesha_gold': {
        title: 'Ganesha Gold by PG Soft at {brand} | Free Demo & Crypto Play',
        description: 'Spin Ganesha Gold by PG Soft at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pgsoft/double_fortune': {
        title: 'Double Fortune Ways Slot by PG Soft | {brand}',
        description: 'Double Fortune from PG Soft, with a 6,165x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pgsoft/alchemy_gold': {
        title: 'Alchemy Gold by PG Soft at {brand} | Free Demo & Crypto Play',
        description: 'Play Alchemy Gold by PG Soft at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pgsoft/shark_hunter': {
        title: 'Play Shark Hunter by PG Soft at {brand} | 5,000x Max Win',
        description: 'Play Shark Hunter by PG Soft at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pgsoft/incan_wonders': {
        title: 'Play Incan Wonders by PG Soft at {brand} | 4,500x Max Win',
        description: 'Spin Incan Wonders by PG Soft at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pgsoft/battleground_royale': {
        title: 'Battleground Royale by PG Soft at {brand} | Free Demo & Crypto Play',
        description: 'Play Battleground Royale by PG Soft at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pgsoft/wild_bandito': {
        title: 'Wild Bandito by PG Soft at {brand} | Free Demo & Crypto Play',
        description: 'Play Wild Bandito by PG Soft at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pgsoft/win_win_fish_prawn_crab': {
        title: 'Win Win Fish Prawn Crab by PG Soft at {brand} | Free Demo & Crypto Play',
        description: 'Play Win Win Fish Prawn Crab by PG Soft at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pgsoft/mask_carnival': {
        title: 'Mask Carnival Slot by PG Soft at {brand} | Instant Crypto Payouts',
        description: 'Mask Carnival by PG Soft at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pgsoft/prosperity_lion': {
        title: 'Play Prosperity Lion by PG Soft at {brand} | 727x Max Win',
        description: 'Spin Prosperity Lion by PG Soft at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pgsoft/spirited_wonders': {
        title: 'Spirited Wonders: Play Online with Crypto | {brand}',
        description: 'Spirited Wonders by PG Soft at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play-live/treasure_island': {
        title: 'Treasure Island Slot by Pragmatic Play Live at {brand} | Instant Crypto Payouts',
        description: 'Play Treasure Island by Pragmatic Play Live at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play-live/speed_auto_roulette': {
        title: 'Speed Auto Roulette Slot by Pragmatic Play Live at {brand} | Instant Crypto Payouts',
        description: 'Speed Auto Roulette by Pragmatic Play Live at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play-live/andar_bahar': {
        title: 'Andar Bahar: Play Online with Crypto | {brand}',
        description: 'Spin Andar Bahar by Pragmatic Play Live at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play-live/roulette_macao': {
        title: 'Roulette Macao by Pragmatic Play Live at {brand} | Free Demo & Crypto Play',
        description: 'Roulette Macao by Pragmatic Play Live at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play-live/dragon_tiger': {
        title: 'Dragon Tiger: Play Online with Crypto | {brand}',
        description: 'Play Dragon Tiger by Pragmatic Play Live at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play-live/one_blackjack': {
        title: 'One Blackjack: Play Online with Crypto | {brand}',
        description: 'Play One Blackjack by Pragmatic Play Live at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play-live/mega_baccarat': {
        title: 'Mega Baccarat: Play Online with Crypto | {brand}',
        description: 'Mega Baccarat by Pragmatic Play Live at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play-live/vegas_ball_bonanza': {
        title: 'Vegas Ball Bonanza: Play Online with Crypto | {brand}',
        description: 'Vegas Ball Bonanza by Pragmatic Play Live at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play-live/powerup_roulette': {
        title: 'PowerUp Roulette by Pragmatic Play Live at {brand} | Free Demo & Crypto Play',
        description: 'Play PowerUp Roulette by Pragmatic Play Live at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play-live/auto_roulette': {
        title: 'Auto Roulette: Play Online with Crypto | {brand}',
        description: 'Auto Roulette by Pragmatic Play Live at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play-live/romanian_roulette': {
        title: 'Romanian Roulette Slot by Pragmatic Play Live at {brand} | Instant Crypto Payouts',
        description: 'Romanian Roulette from Pragmatic Play Live. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play-live/auto_mega_roulette': {
        title: 'Auto Mega Roulette by Pragmatic Play Live at {brand} | Free Demo & Crypto Play',
        description: 'Spin Auto Mega Roulette by Pragmatic Play Live at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play-live/mega_sic_bac': {
        title: 'Mega Sic Bac Slot by Pragmatic Play Live at {brand} | Instant Crypto Payouts',
        description: 'Spin Mega Sic Bac by Pragmatic Play Live at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play-live/mega_wheel': {
        title: 'Mega Wheel by Pragmatic Play Live at {brand} | Free Demo & Crypto Play',
        description: 'Mega Wheel by Pragmatic Play Live at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play-live/mega_sic_bo': {
        title: 'Mega Sic Bo: Play Online with Crypto | {brand}',
        description: 'Mega Sic Bo by Pragmatic Play Live at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play-live/vip_roulette': {
        title: 'VIP Roulette: Play Online with Crypto | {brand}',
        description: 'VIP Roulette by Pragmatic Play Live at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play-live/mega_roulette': {
        title: 'Mega Roulette: Play Online with Crypto | {brand}',
        description: 'Play Mega Roulette by Pragmatic Play Live at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play-live/gates_of_olympus_roulette': {
        title: 'Gates of Olympus Roulette: Play Online with Crypto | {brand}',
        description: 'Spin Gates of Olympus Roulette by Pragmatic Play Live at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play-live/money_time': {
        title: 'Money Time by Pragmatic Play Live at {brand} | Free Demo & Crypto Play',
        description: 'Money Time from Pragmatic Play Live. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play-live/blackjack': {
        title: 'Blackjack Slot by Pragmatic Play Live at {brand} | Instant Crypto Payouts',
        description: 'Blackjack from Pragmatic Play Live. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play-live/brazilian_roulette': {
        title: 'Brazilian Roulette: Play Online with Crypto | {brand}',
        description: 'Spin Brazilian Roulette by Pragmatic Play Live at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play-live/korean_speed_baccarat': {
        title: 'Korean Speed Baccarat: Play Online with Crypto | {brand}',
        description: 'Korean Speed Baccarat from Pragmatic Play Live. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play-live/mega_roulette_3000': {
        title: 'Mega Roulette 3000 by Pragmatic Play Live at {brand} | Free Demo & Crypto Play',
        description: 'Play Mega Roulette 3000 by Pragmatic Play Live at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play-live/turkish_one_blackjack': {
        title: 'Turkish ONE Blackjack by Pragmatic Play Live at {brand} | Free Demo & Crypto Play',
        description: 'Turkish ONE Blackjack from Pragmatic Play Live. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play-live/punto_banco_italia_tricolore': {
        title: 'Punto Banco Italia Tricolore: Play Online with Crypto | {brand}',
        description: 'Play Punto Banco Italia Tricolore by Pragmatic Play Live at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play-live/indonesian_speed_baccarat': {
        title: 'Indonesian Speed Baccarat: Play Online with Crypto | {brand}',
        description: 'Indonesian Speed Baccarat by Pragmatic Play Live at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play-live/vietnamese_roulette': {
        title: 'Vietnamese Roulette: Play Online with Crypto | {brand}',
        description: 'Vietnamese Roulette by Pragmatic Play Live at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play-live/thai_speed_baccarat': {
        title: 'Thai Speed Baccarat Slot by Pragmatic Play Live at {brand} | Instant Crypto Payouts',
        description: 'Thai Speed Baccarat from Pragmatic Play Live. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play-live/fortune_roulette': {
        title: 'Fortune Roulette Slot by Pragmatic Play Live at {brand} | Instant Crypto Payouts',
        description: 'Fortune Roulette by Pragmatic Play Live at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play-live/korean_roulette': {
        title: 'Korean Roulette by Pragmatic Play Live at {brand} | Free Demo & Crypto Play',
        description: 'Spin Korean Roulette by Pragmatic Play Live at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play-live/blackjackx': {
        title: 'BlackjackX by Pragmatic Play Live at {brand} | Free Demo & Crypto Play',
        description: 'BlackjackX by Pragmatic Play Live at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play-live/chinese_speed_baccarat': {
        title: 'Chinese Speed Baccarat Slot by Pragmatic Play Live at {brand} | Instant Crypto Payouts',
        description: 'Spin Chinese Speed Baccarat by Pragmatic Play Live at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play-live/roulette': {
        title: 'Roulette Slot by Pragmatic Play Live at {brand} | Instant Crypto Payouts',
        description: 'Roulette from Pragmatic Play Live. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play-live/roulette_ruby': {
        title: 'Roulette Ruby by Pragmatic Play Live at {brand} | Free Demo & Crypto Play',
        description: 'Play Roulette Ruby by Pragmatic Play Live at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play-live/thai_baccarat': {
        title: 'Thai Baccarat by Pragmatic Play Live at {brand} | Free Demo & Crypto Play',
        description: 'Thai Baccarat from Pragmatic Play Live. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play-live/sic_bo': {
        title: 'Sic Bo Slot by Pragmatic Play Live at {brand} | Instant Crypto Payouts',
        description: 'Play Sic Bo by Pragmatic Play Live at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play-live/indonesian_blackjackx': {
        title: 'Indonesian BlackjackX: Play Online with Crypto | {brand}',
        description: 'Spin Indonesian BlackjackX by Pragmatic Play Live at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play-live/roulette_latina': {
        title: 'Roulette Latina Slot by Pragmatic Play Live at {brand} | Instant Crypto Payouts',
        description: 'Roulette Latina by Pragmatic Play Live at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play-live/24d_spin': {
        title: '24D Spin by Pragmatic Play Live at {brand} | Free Demo & Crypto Play',
        description: 'Play 24D Spin by Pragmatic Play Live at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play-live/german_roulette': {
        title: 'German Roulette by Pragmatic Play Live at {brand} | Free Demo & Crypto Play',
        description: 'Play German Roulette by Pragmatic Play Live at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play-live/roulette_india': {
        title: 'Roulette India: Play Online with Crypto | {brand}',
        description: 'Roulette India from Pragmatic Play Live. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play-live/lucky_roulette': {
        title: 'Lucky Roulette Slot by Pragmatic Play Live at {brand} | Instant Crypto Payouts',
        description: 'Play Lucky Roulette by Pragmatic Play Live at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play-live/roulette_italia_tricolore': {
        title: 'Roulette Italia Tricolore: Play Online with Crypto | {brand}',
        description: 'Spin Roulette Italia Tricolore by Pragmatic Play Live at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play-live/speed_baccarat': {
        title: 'Speed Baccarat: Play Online with Crypto | {brand}',
        description: 'Play Speed Baccarat by Pragmatic Play Live at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play-live/crystal_roulette': {
        title: 'Crystal Roulette by Pragmatic Play Live at {brand} | Free Demo & Crypto Play',
        description: 'Spin Crystal Roulette by Pragmatic Play Live at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play-live/korean_blackjackx': {
        title: 'Korean BlackjackX by Pragmatic Play Live at {brand} | Free Demo & Crypto Play',
        description: 'Play Korean BlackjackX by Pragmatic Play Live at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play-live/the_bingo_spot': {
        title: 'The Bingo Spot Slot by Pragmatic Play Live at {brand} | Instant Crypto Payouts',
        description: 'The Bingo Spot from Pragmatic Play Live. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play-live/hilo_baccarat': {
        title: 'Hi-Lo Baccarat Slot by Pragmatic Play Live at {brand} | Instant Crypto Payouts',
        description: 'Hi-Lo Baccarat from Pragmatic Play Live. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play-live/japanese_speed_baccarat': {
        title: 'Japanese Speed Baccarat: Play Online with Crypto | {brand}',
        description: 'Play Japanese Speed Baccarat by Pragmatic Play Live at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play-live/vietnamese_speed_baccarat': {
        title: 'Vietnamese Speed Baccarat by Pragmatic Play Live at {brand} | Free Demo & Crypto Play',
        description: 'Spin Vietnamese Speed Baccarat by Pragmatic Play Live at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play-live/italian_mega_roulette': {
        title: 'Italian Mega Roulette by Pragmatic Play Live at {brand} | Free Demo & Crypto Play',
        description: 'Italian Mega Roulette from Pragmatic Play Live. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play-live/indonesian_roulette': {
        title: 'Indonesian Roulette: Play Online with Crypto | {brand}',
        description: 'Play Indonesian Roulette by Pragmatic Play Live at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play-live/russian_roulette': {
        title: 'Russian Roulette by Pragmatic Play Live at {brand} | Free Demo & Crypto Play',
        description: 'Russian Roulette from Pragmatic Play Live. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play-live/vip_auto_roulette': {
        title: 'VIP Auto Roulette Slot by Pragmatic Play Live at {brand} | Instant Crypto Payouts',
        description: 'VIP Auto Roulette from Pragmatic Play Live. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play-live/fortune_baccarat': {
        title: 'Fortune Baccarat Slot by Pragmatic Play Live at {brand} | Instant Crypto Payouts',
        description: 'Spin Fortune Baccarat by Pragmatic Play Live at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play-live/baccarat': {
        title: 'Baccarat: Play Online with Crypto | {brand}',
        description: 'Play Baccarat by Pragmatic Play Live at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play-live/prive_lounge_baccarat': {
        title: 'Prive Lounge Baccarat by Pragmatic Play Live at {brand} | Free Demo & Crypto Play',
        description: 'Spin Prive Lounge Baccarat by Pragmatic Play Live at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play-live/prive_lounge_russian_poker': {
        title: 'Prive Lounge Russian Poker Slot by Pragmatic Play Live at {brand} | Instant Crypto Payouts',
        description: 'Spin Prive Lounge Russian Poker by Pragmatic Play Live at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play-live/speed_roulette': {
        title: 'Speed Roulette Slot by Pragmatic Play Live at {brand} | Instant Crypto Payouts',
        description: 'Speed Roulette from Pragmatic Play Live. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play-live/immersive_roulette_deluxe': {
        title: 'Immersive Roulette Deluxe: Play Online with Crypto | {brand}',
        description: 'Immersive Roulette Deluxe from Pragmatic Play Live. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play-live/brazilian_mega_roulette': {
        title: 'Brazilian Mega Roulette Slot by Pragmatic Play Live at {brand} | Instant Crypto Payouts',
        description: 'Brazilian Mega Roulette by Pragmatic Play Live at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play-live/super_baccarat': {
        title: 'Super Baccarat Slot by Pragmatic Play Live at {brand} | Instant Crypto Payouts',
        description: 'Play Super Baccarat by Pragmatic Play Live at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play-live/pay4d_speed_baccarat': {
        title: 'PAY4D SPEED BACCARAT by Pragmatic Play Live at {brand} | Free Demo & Crypto Play',
        description: 'PAY4D SPEED BACCARAT by Pragmatic Play Live at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play-live/dice_city': {
        title: 'Play Dice City by Pragmatic Play Live at {brand} | 10,000x Max Win',
        description: 'Spin Dice City by Pragmatic Play Live at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play-live/turkish_mega_roulette': {
        title: 'Turkish Mega Roulette by Pragmatic Play Live at {brand} | Free Demo & Crypto Play',
        description: 'Turkish Mega Roulette from Pragmatic Play Live. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play-live/turkish_roulette': {
        title: 'Turkish Roulette Slot by Pragmatic Play Live at {brand} | Instant Crypto Payouts',
        description: 'Play Turkish Roulette by Pragmatic Play Live at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play-live/american_roulette': {
        title: 'American Roulette by Pragmatic Play Live at {brand} | Free Demo & Crypto Play',
        description: 'Spin American Roulette by Pragmatic Play Live at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play-live/football_blitz_top_card': {
        title: 'Play Football Blitz Top Card by Pragmatic Play Live at {brand} | 500x Max Win',
        description: 'Football Blitz Top Card from Pragmatic Play Live, with a 500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/avatarux/3_rockin_penguins': {
        title: '3 Rockin Penguins Slot by AvatarUX at {brand} | Instant Crypto Payouts',
        description: '3 Rockin Penguins from AvatarUX, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/avatarux/3_chili_charms': {
        title: '3 Chili Charms: Play Online with Crypto | {brand}',
        description: '3 Chili Charms from AvatarUX, with a 15,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/avatarux/depths_of_fortune_2': {
        title: 'Depths of Fortune 2 by AvatarUX at {brand} | Free Demo & Crypto Play',
        description: 'Play Depths of Fortune 2 by AvatarUX at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/avatarux/crypto_crown_40': {
        title: 'Crypto Crown 40: Play Online with Crypto | {brand}',
        description: 'Crypto Crown 40 by AvatarUX at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/avatarux/pots_of_power_zeus': {
        title: 'Pots of Power Zeus PopWins Slot by AvatarUX | {brand}',
        description: 'Pots of Power Zeus from AvatarUX, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/avatarux/40_power_joker': {
        title: '40 Power Joker: Play Online with Crypto | {brand}',
        description: '40 Power Joker from AvatarUX, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/avatarux/3_power_genies': {
        title: 'Play 3 Power Genies by AvatarUX at {brand} | 10,000x Max Win',
        description: 'Play 3 Power Genies by AvatarUX at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/avatarux/prince_of_purrwood': {
        title: 'Prince of Purrwood PopWins Slot by AvatarUX | {brand}',
        description: 'Prince of Purrwood by AvatarUX at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/avatarux/3_power_dragons': {
        title: '3 Power Dragons: Play Online with Crypto | {brand}',
        description: '3 Power Dragons by AvatarUX at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/avatarux/monkeypop_2': {
        title: 'Play MonkeyPop 2 by AvatarUX at {brand} | 10,000x Max Win',
        description: 'Spin MonkeyPop 2 by AvatarUX at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/avatarux/crypto_crown_10': {
        title: 'Play Crypto Crown 10 by AvatarUX at {brand} | 5,000x Max Win',
        description: 'Spin Crypto Crown 10 by AvatarUX at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/avatarux/3_power_bears': {
        title: 'Play 3 Power Bears by AvatarUX at {brand} | 15,000x Max Win',
        description: 'Spin 3 Power Bears by AvatarUX at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/avatarux/blessings_of_caishen': {
        title: 'Blessings of Caishen Slot by AvatarUX at {brand} | Instant Crypto Payouts',
        description: 'Blessings of Caishen by AvatarUX at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/avatarux/3_builder_piggies': {
        title: '3 Builder Piggies Slot by AvatarUX at {brand} | Instant Crypto Payouts',
        description: '3 Builder Piggies by AvatarUX at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/avatarux/dyna_mule': {
        title: 'Dyna Mule Slot by AvatarUX at {brand} | Instant Crypto Payouts',
        description: 'Dyna Mule from AvatarUX, with a 20,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/avatarux/3_jungle_beats': {
        title: 'Play 3 Jungle Beats by AvatarUX at {brand} | 10,000x Max Win',
        description: 'Spin 3 Jungle Beats by AvatarUX at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/avatarux/crazy_mart_bonanza': {
        title: 'Crazy Mart Bonanza Slot by AvatarUX at {brand} | Instant Crypto Payouts',
        description: 'Crazy Mart Bonanza from AvatarUX, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/avatarux/diamond_dez': {
        title: 'Diamond Dez: Play Online with Crypto | {brand}',
        description: 'Diamond Dez by AvatarUX at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/avatarux/piggy_pop_grand_affair_2': {
        title: 'Piggy Pop Grand Affair 2 PopWins Slot by AvatarUX | {brand}',
        description: 'Piggy Pop Grand Affair 2 by AvatarUX at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/avatarux/crypto_crown_20': {
        title: 'Crypto Crown 20 PopWins Slot by AvatarUX | {brand}',
        description: 'Crypto Crown 20 from AvatarUX, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/avatarux/carioca_vibes': {
        title: 'Carioca Vibes: Play Online with Crypto | {brand}',
        description: 'Carioca Vibes by AvatarUX at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/avatarux/crypto_crown_5': {
        title: 'Crypto Crown 5 by AvatarUX at {brand} | Free Demo & Crypto Play',
        description: 'Spin Crypto Crown 5 by AvatarUX at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/totally_hot': {
        title: 'Totally Hot Provably Fair Slot by BGaming | {brand}',
        description: 'Totally Hot from BGaming, with a 2,500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/aviamasters_xmas': {
        title: 'Play Aviamasters Xmas by BGaming at {brand} | 2,500x Max Win',
        description: 'Play Aviamasters Xmas by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/royal_beellion_hold_and_win': {
        title: 'Royal Beellion Hold and Win Provably Fair Slot by BGaming | {brand}',
        description: 'Royal Beellion Hold and Win by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/clash_of_gods_anubis_vs_hades': {
        title: 'Play Clash of Gods Anubis vs Hades by BGaming at {brand} | 10,000x Max Win',
        description: 'Spin Clash of Gods Anubis vs Hades by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/dusty_duel': {
        title: 'Play Dusty Duel by BGaming at {brand} | 5,000x Max Win',
        description: 'Spin Dusty Duel by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/arrow_game': {
        title: 'Arrow Game: Play Online with Crypto | {brand}',
        description: 'Spin Arrow Game by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/shark_and_spark_hold_and_win': {
        title: 'Play Shark and Spark Hold and Win by BGaming at {brand} | 5,000x Max Win',
        description: 'Spin Shark and Spark Hold and Win by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/chicken_shot': {
        title: 'Chicken Shot by BGaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Chicken Shot by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/multi_rush': {
        title: 'Multi Rush by BGaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Multi Rush by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/lucky_birds': {
        title: 'Lucky Birds Slot by BGaming at {brand} | Instant Crypto Payouts',
        description: 'Lucky Birds from BGaming, with a 12,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/ultras': {
        title: 'Ultras Slot by BGaming at {brand} | Instant Crypto Payouts',
        description: 'Ultras from BGaming, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/the_godfather_3_pillars_of_power': {
        title: 'Play The Godfather: 3 Pillars of Power by BGaming at {brand} | 5,000x Max Win',
        description: 'Spin The Godfather: 3 Pillars of Power by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/fashiontv_diamonds': {
        title: 'FashionTV Diamonds: Play Online with Crypto | {brand}',
        description: 'Spin FashionTV Diamonds by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/always_up': {
        title: 'Always Up Provably Fair Slot by BGaming | {brand}',
        description: 'Always Up from BGaming, with a 559x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/penalty_duel_with_julio_cesar': {
        title: 'Penalty Duel with Julio Cesar by BGaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Penalty Duel with Julio Cesar by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/winter_trophy_hold_and_win': {
        title: 'Winter Trophy Hold and Win Slot by BGaming at {brand} | Instant Crypto Payouts',
        description: 'Winter Trophy Hold and Win by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/always_up_x10000': {
        title: 'Always Up x10000: Play Online with Crypto | {brand}',
        description: 'Always Up x10000 by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/star_trek_the_next_generation': {
        title: 'Play Star Trek The Next Generation by BGaming at {brand} | 10,000x Max Win',
        description: 'Spin Star Trek The Next Generation by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/chicken_fire': {
        title: 'Chicken Fire by BGaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Chicken Fire by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/frozen_fruit': {
        title: 'Frozen Fruit Slot by BGaming at {brand} | Instant Crypto Payouts',
        description: 'Frozen Fruit by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/fishing_time': {
        title: 'Play Fishing Time by BGaming at {brand} | 1,000x Max Win',
        description: 'Play Fishing Time by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/royal_easter': {
        title: 'Play Royal Easter by BGaming at {brand} | 500x Max Win',
        description: 'Play Royal Easter by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/elements_of_power': {
        title: 'Elements of Power: Play Online with Crypto | {brand}',
        description: 'Elements of Power by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/wild_coin': {
        title: 'Wild Coin Provably Fair Slot by BGaming | {brand}',
        description: 'Play Wild Coin by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/yommi_rush': {
        title: 'Play Yommi Rush by BGaming at {brand} | 2,000x Max Win',
        description: 'Spin Yommi Rush by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/bling_blitz_diamond_drop': {
        title: 'Bling Blitz Diamond Drop Provably Fair Slot by BGaming | {brand}',
        description: 'Bling Blitz Diamond Drop from BGaming, with a 3,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/jewel_boom_super_drop': {
        title: 'Jewel Boom Super Drop Provably Fair Slot by BGaming | {brand}',
        description: 'Jewel Boom Super Drop from BGaming, with a 3,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/hot_chilli_bells_100': {
        title: 'Play Hot Chilli Bells 100 by BGaming at {brand} | 5,000x Max Win',
        description: 'Play Hot Chilli Bells 100 by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/wild_million': {
        title: 'Wild Million: Play Online with Crypto | {brand}',
        description: 'Wild Million from BGaming, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/open_it': {
        title: 'Play Open It by BGaming at {brand} | 64x Max Win',
        description: 'Spin Open It by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/reel_of_ra': {
        title: 'Reel of Ra by BGaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Reel of Ra by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/treasure_explorer': {
        title: 'Treasure Explorer Slot by BGaming at {brand} | Instant Crypto Payouts',
        description: 'Treasure Explorer from BGaming, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/chicken_rush_2': {
        title: 'Chicken Rush 2 Provably Fair Slot by BGaming | {brand}',
        description: 'Chicken Rush 2 by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/derby_rush': {
        title: 'Derby Rush: Play Online with Crypto | {brand}',
        description: 'Derby Rush from BGaming, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/hot_rocket_5x_3x_2x': {
        title: 'Hot Rocket 5x 3x 2x Provably Fair Slot by BGaming | {brand}',
        description: 'Hot Rocket 5x 3x 2x by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/golden_paw_hold_and_win': {
        title: 'Golden Paw Hold and Win Provably Fair Slot by BGaming | {brand}',
        description: 'Golden Paw Hold and Win from BGaming, with a 2,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/train_heist_johnny_coin': {
        title: 'Train Heist Johnny Coin Slot by BGaming at {brand} | Instant Crypto Payouts',
        description: 'Train Heist Johnny Coin by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/lucky_pack_2026_cup': {
        title: 'Play Lucky Pack 2026 Cup by BGaming at {brand} | 10,490x Max Win',
        description: 'Spin Lucky Pack 2026 Cup by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/golden_avalon_hold_and_win': {
        title: 'Play Golden Avalon Hold and Win by BGaming at {brand} | 3,000x Max Win',
        description: 'Play Golden Avalon Hold and Win by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/frenzy_clusters': {
        title: 'Play Frenzy Clusters by BGaming at {brand} | 10,000x Max Win',
        description: 'Spin Frenzy Clusters by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/grand_buffalo_hold_and_win': {
        title: 'Grand Buffalo Hold and Win Slot by BGaming at {brand} | Instant Crypto Payouts',
        description: 'Grand Buffalo Hold and Win by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/fishing_club_2': {
        title: 'Play Fishing Club 2 by BGaming at {brand} | 3,000x Max Win',
        description: 'Play Fishing Club 2 by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/mystic_reels': {
        title: 'Mystic Reels Slot by BGaming at {brand} | Instant Crypto Payouts',
        description: 'Mystic Reels by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/miss_cherry_wild_frames': {
        title: 'Play Miss Cherry Wild Frames by BGaming at {brand} | 3,000x Max Win',
        description: 'Spin Miss Cherry Wild Frames by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/surrender_multihand_blackjack': {
        title: 'Play Surrender Multihand Blackjack by BGaming at {brand} | 1,059x Max Win',
        description: 'Play Surrender Multihand Blackjack by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/sweet_samurai': {
        title: 'Sweet Samurai Provably Fair Slot by BGaming | {brand}',
        description: 'Sweet Samurai by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/gemhalla_xtreme': {
        title: 'Gemhalla Xtreme: Play Online with Crypto | {brand}',
        description: 'Gemhalla Xtreme by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/yokai': {
        title: 'Yokai Slot by BGaming at {brand} | Instant Crypto Payouts',
        description: 'Yokai by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/plinko_2_halloween': {
        title: 'Play Plinko 2 Halloween by BGaming at {brand} | 10,000x Max Win',
        description: 'Play Plinko 2 Halloween by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/alien_fruits_3': {
        title: 'Alien Fruits 3: Play Online with Crypto | {brand}',
        description: 'Alien Fruits 3 from BGaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/big_boat_big_catch': {
        title: 'Play Big Boat Big Catch by BGaming at {brand} | 5,000x Max Win',
        description: 'Spin Big Boat Big Catch by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/lucky_lager_x9990': {
        title: 'Lucky Lager X9990 by BGaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Lucky Lager X9990 by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/gates_of_power': {
        title: 'Gates of Power by BGaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Gates of Power by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/train_heist_johnny_cash': {
        title: 'Train Heist Johnny Cash Provably Fair Slot by BGaming | {brand}',
        description: 'Train Heist Johnny Cash from BGaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/money_maker': {
        title: 'Money Maker Provably Fair Slot by BGaming | {brand}',
        description: 'Money Maker by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/fruit_million_respin': {
        title: 'Fruit Million Respin: Play Online with Crypto | {brand}',
        description: 'Fruit Million Respin from BGaming, with a 3,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/wild_tiger_2': {
        title: 'Wild Tiger 2 Slot by BGaming at {brand} | Instant Crypto Payouts',
        description: 'Wild Tiger 2 by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/kicker_mania': {
        title: 'Play Kicker Mania by BGaming at {brand} | 64x Max Win',
        description: 'Play Kicker Mania by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/blueprint-gaming/almighty_mustang_express': {
        title: 'Play Almighty Mustang Express by Blueprint Gaming at {brand} | 5,000x Max Win',
        description: 'Spin Almighty Mustang Express by Blueprint Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/blueprint-gaming/lucky_fire_blitz_megaways': {
        title: 'Play Lucky Fire Blitz Megaways by Blueprint Gaming at {brand} | 5,000x Max Win',
        description: 'Play Lucky Fire Blitz Megaways by Blueprint Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/blueprint-gaming/big_catch_even_bigger_bass': {
        title: 'Play Big Catch Even Bigger Bass by Blueprint Gaming at {brand} | 10,000x Max Win',
        description: 'Spin Big Catch Even Bigger Bass by Blueprint Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/blueprint-gaming/kong_even_bigger_balls': {
        title: 'Play Kong Even Bigger Balls by Blueprint Gaming at {brand} | 10,000x Max Win',
        description: 'Spin Kong Even Bigger Balls by Blueprint Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/blueprint-gaming/fishin_frenzy_the_big_catch_megaways': {
        title: 'Fishin Frenzy The Big Catch Megaways: Play Online with Crypto | {brand}',
        description: 'Spin Fishin Frenzy The Big Catch Megaways by Blueprint Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/blueprint-gaming/mega_charged_cash': {
        title: 'Mega Charged Cash Slot by Blueprint Gaming at {brand} | Instant Crypto Payouts',
        description: 'Mega Charged Cash from Blueprint Gaming, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/blueprint-gaming/lucky_fire_blitz_win_boost': {
        title: 'Lucky Fire Blitz Win Boost by Blueprint Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Lucky Fire Blitz Win Boost by Blueprint Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/blueprint-gaming/wolf_fury_fire_blitz': {
        title: 'Wolf Fury Fire Blitz by Blueprint Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Wolf Fury Fire Blitz by Blueprint Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/blueprint-gaming/wolf_legend_gold_megaways': {
        title: 'Play Wolf Legend Gold Megaways by Blueprint Gaming at {brand} | 10,000x Max Win',
        description: 'Spin Wolf Legend Gold Megaways by Blueprint Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/blueprint-gaming/pig_wizard_cash_lock': {
        title: 'Play Pig Wizard Cash Lock by Blueprint Gaming at {brand} | 5,500x Max Win',
        description: 'Spin Pig Wizard Cash Lock by Blueprint Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/blueprint-gaming/cash_strike_power_force_5_megaways': {
        title: 'Cash Strike Power force 5 Megaways Jackpot King Slot by Blueprint Gaming | {brand}',
        description: 'Cash Strike Power force 5 Megaways from Blueprint Gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/blueprint-gaming/cash_strike_power_force_5': {
        title: 'Play Cash Strike Power Force 5 by Blueprint Gaming at {brand} | 10,000x Max Win',
        description: 'Play Cash Strike Power Force 5 by Blueprint Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/blueprint-gaming/triple_action_cash_strike': {
        title: 'Triple Action Cash Strike by Blueprint Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Triple Action Cash Strike by Blueprint Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/blueprint-gaming/red_hot_catch': {
        title: 'Red Hot Catch: Play Online with Crypto | {brand}',
        description: 'Red Hot Catch from Blueprint Gaming, with a 3,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/blueprint-gaming/big_cat_gold': {
        title: 'Play Big Cat Gold by Blueprint Gaming at {brand} | 2,500x Max Win',
        description: 'Spin Big Cat Gold by Blueprint Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/blueprint-gaming/saint_nicked_3_present_tense': {
        title: 'Play Saint Nicked 3 Present Tense by Blueprint Gaming at {brand} | 10,000x Max Win',
        description: 'Spin Saint Nicked 3 Present Tense by Blueprint Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/blueprint-gaming/kong_even_bigger_christmas': {
        title: 'Play Kong Even Bigger Christmas by Blueprint Gaming at {brand} | 10,000x Max Win',
        description: 'Play Kong Even Bigger Christmas by Blueprint Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/blueprint-gaming/cash_strike_xcash': {
        title: 'Play Cash Strike X-Cash by Blueprint Gaming at {brand} | 10,000x Max Win',
        description: 'Play Cash Strike X-Cash by Blueprint Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/blueprint-gaming/rise_of_atlantis_legacy': {
        title: 'Play Rise of Atlantis Legacy by Blueprint Gaming at {brand} | 10,000x Max Win',
        description: 'Play Rise of Atlantis Legacy by Blueprint Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/blueprint-gaming/cash_strike_hotstepper_2': {
        title: 'Cash Strike Hotstepper 2 by Blueprint Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Cash Strike Hotstepper 2 by Blueprint Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/blueprint-gaming/majestic_fury_power_5': {
        title: 'Majestic Fury Power 5 Jackpot King Slot by Blueprint Gaming | {brand}',
        description: 'Majestic Fury Power 5 from Blueprint Gaming, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/blueprint-gaming/cash_strike_triple_fire': {
        title: 'Cash Strike Triple Fire by Blueprint Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Cash Strike Triple Fire by Blueprint Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/blueprint-gaming/scarab_rising_megaways': {
        title: 'Scarab Rising Megaways by Blueprint Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Scarab Rising Megaways by Blueprint Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/boominggames/wild_silverback': {
        title: 'Play Wild Silverback by Booming Games at {brand} | 5,000x Max Win',
        description: 'Play Wild Silverback by Booming Games at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/boominggames/henhouse_hustle_hold_and_win': {
        title: 'Henhouse Hustle: Play Online with Crypto | {brand}',
        description: 'Henhouse Hustle from Booming Games, with a 6,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/boominggames/diamond_forge_link_and_loot': {
        title: 'Diamond Forge Link and Loot: Play Online with Crypto | {brand}',
        description: 'Diamond Forge Link and Loot from Booming Games, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/boominggames/fortune_paw': {
        title: 'Fortune Paw Bonus Buy Slot by Booming Games | {brand}',
        description: 'Fortune Paw by Booming Games at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/boominggames/mustang_hold_and_win': {
        title: 'Mustang Hold and Win: Play Online with Crypto | {brand}',
        description: 'Mustang Hold and Win by Booming Games at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/boominggames/twin_buffalo_hold_and_win': {
        title: 'Play Twin Buffalo Hold and Win by Booming Games at {brand} | 5,100x Max Win',
        description: 'Play Twin Buffalo Hold and Win by Booming Games at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/boominggames/fish_tales_double_catch_max_scatter': {
        title: 'Fish Tales: Double Catch Max Scatter Bonus Buy Slot by Booming Games | {brand}',
        description: 'Fish Tales: Double Catch Max Scatter from Booming Games, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/boominggames/sacred_buffalo': {
        title: 'Sacred Buffalo: Play Online with Crypto | {brand}',
        description: 'Sacred Buffalo by Booming Games at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/boominggames/mustangs_and_stallions': {
        title: 'Mustangs and Stallions: Play Online with Crypto | {brand}',
        description: 'Mustangs and Stallions by Booming Games at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/boominggames/64_nuggets_hold_and_win': {
        title: 'Play 64 Nuggets Hold and Win by Booming Games at {brand} | 10,000x Max Win',
        description: 'Spin 64 Nuggets Hold and Win by Booming Games at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/boominggames/ultra_buffalo_hold_and_win': {
        title: 'Play Ultra Buffalo Hold and Win by Booming Games at {brand} | 5,000x Max Win',
        description: 'Spin Ultra Buffalo Hold and Win by Booming Games at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/boominggames/black_friday_cart_craze': {
        title: 'Black Friday Cart Craze: Play Online with Crypto | {brand}',
        description: 'Black Friday Cart Craze from Booming Games, with a 8,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/boominggames/mr_oinksters_hold_and_win_10000': {
        title: "Play Mr. Oinkster's Hold and Win 10,000 by Booming Games at {brand} | 10,250x Max Win",
        description: "Play Mr. Oinkster's Hold and Win 10,000 by Booming Games at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/boominggames/berserkin_buffalo_power_hit': {
        title: 'Play Berserkin Buffalo Power Hit by Booming Games at {brand} | 5,000x Max Win',
        description: 'Spin Berserkin Buffalo Power Hit by Booming Games at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/boominggames/fortune_surge': {
        title: 'Fortune Surge Bonus Buy Slot by Booming Games | {brand}',
        description: 'Fortune Surge by Booming Games at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/boominggames/64_presents_hold_and_win': {
        title: '64 Presents Hold and Win Slot by Booming Games at {brand} | Instant Crypto Payouts',
        description: '64 Presents Hold and Win by Booming Games at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/boominggames/blazing_bullets_hold_and_win': {
        title: 'Blazing Bullets Bonus Buy Slot by Booming Games | {brand}',
        description: 'Blazing Bullets by Booming Games at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/boominggames/gold_and_glamour_hold_and_win': {
        title: 'Play Gold and Glamour Hold and Win by Booming Games at {brand} | 2,000x Max Win',
        description: 'Spin Gold and Glamour Hold and Win by Booming Games at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/boominggames/way_of_the_wolf_hold_and_win_extreme_10000': {
        title: 'Way of the Wolf Hold and Win Extreme 10000 Slot by Booming Games at {brand} | Instant Crypto Payouts',
        description: 'Way of the Wolf Hold and Win Extreme 10000 by Booming Games at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/boominggames/fish_tales_monster_bass_10000': {
        title: 'Play Fish Tales Monster Bass 10000 by Booming Games at {brand} | 10,000x Max Win',
        description: 'Spin Fish Tales Monster Bass 10000 by Booming Games at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/boominggames/tasty_bonanza_max_scatter': {
        title: 'Play Tasty Bonanza Max Scatter by Booming Games at {brand} | 15,000x Max Win',
        description: 'Play Tasty Bonanza Max Scatter by Booming Games at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/boominggames/inferno_fortune_instastrike': {
        title: 'Play Inferno Fortune InstaStrike by Booming Games at {brand} | 2,150x Max Win',
        description: 'Spin Inferno Fortune InstaStrike by Booming Games at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/boominggames/polar_buffalo_extreme_hold_and_win_25000': {
        title: 'Polar Buffalo Extreme Hold and Win 25,000 Bonus Buy Slot by Booming Games | {brand}',
        description: 'Polar Buffalo Extreme Hold and Win 25,000 from Booming Games, with a 27,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/boominggames/classico': {
        title: 'Classico by Booming Games at {brand} | Free Demo & Crypto Play',
        description: 'Spin Classico by Booming Games at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/boominggames/ronaldinhos_streetball_bonanza': {
        title: "Ronaldinho's Streetball Bonanza Slot by Booming Games at {brand} | Instant Crypto Payouts",
        description: "Ronaldinho's Streetball Bonanza from Booming Games, with a 6,500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/boominggames/mr_oinksters_power_hit': {
        title: "Mr. Oinkster's Power Hit Bonus Buy Slot by Booming Games | {brand}",
        description: "Mr. Oinkster's Power Hit by Booming Games at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/boominggames/greedy_for_gold_hold_and_win': {
        title: 'Greedy for Gold: Hold and Win Bonus Buy Slot by Booming Games | {brand}',
        description: 'Greedy for Gold: Hold and Win by Booming Games at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/boominggames/bubble_works': {
        title: 'Play Bubble Works by Booming Games at {brand} | 6,000x Max Win',
        description: 'Play Bubble Works by Booming Games at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/boominggames/blazin_bonus': {
        title: "Blazin' Bonus Slot by Booming Games at {brand} | Instant Crypto Payouts",
        description: "Blazin' Bonus from Booming Games, with a 2,680x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/boominggames/booming_buffalo_hold_and_win_extreme_25000': {
        title: 'Play Booming Buffalo Hold and Win Extreme 25,000 by Booming Games at {brand} | 27,000x Max Win',
        description: 'Spin Booming Buffalo Hold and Win Extreme 25,000 by Booming Games at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/flush-originals/crash': {
        title: 'Crash: 98% RTP, Provably Fair | {brand}',
        description: 'Crash runs at 98% RTP at {brand}, one of the highest returns in crypto casino gaming. Provably fair, instant withdrawals, no platform fee.'
    },
    '/p/flush-originals/dragons_tower': {
        title: "Dragon's Tower: 98% RTP, Provably Fair | {brand}",
        description: "Dragon's Tower runs at 98% RTP at {brand}, one of the highest returns in crypto casino gaming. Provably fair, instant withdrawals, no platform fee."
    },
    '/p/flush-originals/keno': {
        title: 'Keno: 98% RTP, Provably Fair | {brand}',
        description: 'Keno runs at 98% RTP at {brand}, one of the highest returns in crypto casino gaming. Provably fair, instant withdrawals, no platform fee.'
    },
    '/p/flush-originals/baccarat': {
        title: 'Baccarat: 98% RTP, Provably Fair | {brand}',
        description: 'Baccarat runs at 98% RTP at {brand}, one of the highest returns in crypto casino gaming. Provably fair, instant withdrawals, no platform fee.'
    },
    '/p/flush-originals/limbo': {
        title: 'Limbo: 98% RTP, Provably Fair | {brand}',
        description: 'Limbo runs at 98% RTP at {brand}, one of the highest returns in crypto casino gaming. Provably fair, instant withdrawals, no platform fee.'
    },
    '/p/flush-originals/mines': {
        title: 'Mines: 98% RTP, Provably Fair | {brand}',
        description: 'Mines runs at 98% RTP at {brand}, one of the highest returns in crypto casino gaming. Provably fair, instant withdrawals, no platform fee.'
    },
    '/p/flush-originals/blackjack': {
        title: 'Blackjack: 98% RTP, Provably Fair | {brand}',
        description: 'Blackjack runs at 98% RTP at {brand}, one of the highest returns in crypto casino gaming. Provably fair, instant withdrawals, no platform fee.'
    },
    '/p/flush-originals/cross_the_road': {
        title: 'Cross the Road: 98% RTP, Provably Fair | {brand}',
        description: 'Cross the Road runs at 98% RTP at {brand}, one of the highest returns in crypto casino gaming. Provably fair, instant withdrawals, no platform fee.'
    },
    '/p/flush-originals/dice': {
        title: 'Dice: 98% RTP, Provably Fair | {brand}',
        description: 'Dice runs at 98% RTP at {brand}, one of the highest returns in crypto casino gaming. Provably fair, instant withdrawals, no platform fee.'
    },
    '/p/flush-originals/plinko': {
        title: 'Plinko: 98% RTP, Provably Fair | {brand}',
        description: 'Plinko runs at 98% RTP at {brand}, one of the highest returns in crypto casino gaming. Provably fair, instant withdrawals, no platform fee.'
    },
    '/p/flush-originals/cross_the_lake': {
        title: 'Cross The Lake: 98% RTP, Provably Fair | {brand}',
        description: 'Cross The Lake runs at 98% RTP at {brand}, one of the highest returns in crypto casino gaming. Provably fair, instant withdrawals, no platform fee.'
    },
    '/p/flush-originals/american_roulette': {
        title: 'American Roulette: 98% RTP, Provably Fair | {brand}',
        description: 'American Roulette runs at 98% RTP at {brand}, one of the highest returns in crypto casino gaming. Provably fair, instant withdrawals, no platform fee.'
    },
    '/p/flush-originals/traffic_jam': {
        title: 'Traffic Jam: 98% RTP, Provably Fair | {brand}',
        description: 'Traffic Jam runs at 98% RTP at {brand}, one of the highest returns in crypto casino gaming. Provably fair, instant withdrawals, no platform fee.'
    },
    '/p/flush-originals/video_poker': {
        title: 'Video Poker: 98% RTP, Provably Fair | {brand}',
        description: 'Video Poker runs at 98% RTP at {brand}, one of the highest returns in crypto casino gaming. Provably fair, instant withdrawals, no platform fee.'
    },
    '/p/flush-originals/coin_flip': {
        title: 'Coin Flip: 98% RTP, Provably Fair | {brand}',
        description: 'Coin Flip runs at 98% RTP at {brand}, one of the highest returns in crypto casino gaming. Provably fair, instant withdrawals, no platform fee.'
    },
    '/p/flush-originals/hilo': {
        title: 'Hilo: 98% RTP, Provably Fair | {brand}',
        description: 'Hilo runs at 98% RTP at {brand}, one of the highest returns in crypto casino gaming. Provably fair, instant withdrawals, no platform fee.'
    },
    '/p/flush-originals/slider': {
        title: 'Slider: 98% RTP, Provably Fair | {brand}',
        description: 'Slider runs at 98% RTP at {brand}, one of the highest returns in crypto casino gaming. Provably fair, instant withdrawals, no platform fee.'
    },
    '/p/flush-originals/diamonds': {
        title: 'Diamonds: 98% RTP, Provably Fair | {brand}',
        description: 'Diamonds runs at 98% RTP at {brand}, one of the highest returns in crypto casino gaming. Provably fair, instant withdrawals, no platform fee.'
    },
    '/p/flush-originals/roulette': {
        title: 'Roulette: 98% RTP, Provably Fair | {brand}',
        description: 'Roulette runs at 98% RTP at {brand}, one of the highest returns in crypto casino gaming. Provably fair, instant withdrawals, no platform fee.'
    },
    '/p/flush-originals/wheel': {
        title: 'Wheel: 98% RTP, Provably Fair | {brand}',
        description: 'Wheel runs at 98% RTP at {brand}, one of the highest returns in crypto casino gaming. Provably fair, instant withdrawals, no platform fee.'
    },
    '/p/hacksaw-gaming/the_luxe': {
        title: 'The Luxe xWays Slot by Hacksaw Gaming | {brand}',
        description: 'The Luxe by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/miami_mayhem': {
        title: 'Miami Mayhem by Hacksaw Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Miami Mayhem by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/prince_treasure': {
        title: 'Play Prince Treasure by Hacksaw Gaming at {brand} | 40,000x Max Win',
        description: 'Spin Prince Treasure by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/happy_scratch': {
        title: 'Happy Scratch by Hacksaw Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Happy Scratch by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/plinko': {
        title: 'Plinko by Hacksaw Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Plinko by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/3_cursed_chests_hold_and_win': {
        title: '3 Cursed Chests: Hold and Win xWays Slot by Hacksaw Gaming | {brand}',
        description: '3 Cursed Chests: Hold and Win by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/balloons': {
        title: 'Balloons: Play Online with Crypto | {brand}',
        description: 'Balloons by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/crown_of_the_undying': {
        title: 'Crown of the Undying by Hacksaw Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Crown of the Undying from Hacksaw Gaming. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/hacksaw-gaming/scratch_platinum': {
        title: 'Play SCRATCH! Platinum by Hacksaw Gaming at {brand} | 100,000x Max Win',
        description: 'Play SCRATCH! Platinum by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/sand_and_ashes': {
        title: 'Play Sand and Ashes by Hacksaw Gaming at {brand} | 10,000x Max Win',
        description: 'Play Sand and Ashes by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/jaws_of_justice': {
        title: 'Jaws of Justice by Hacksaw Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Jaws of Justice by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/le_digger': {
        title: 'Le Digger xWays Slot by Hacksaw Gaming | {brand}',
        description: 'Le Digger from Hacksaw Gaming, with a 15,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/hacksaw-gaming/the_perfect_scratch': {
        title: 'The Perfect Scratch: Play Online with Crypto | {brand}',
        description: 'The Perfect Scratch by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/miss_candys_sweet_escape': {
        title: "Miss Candy's Sweet Escape by Hacksaw Gaming at {brand} | Free Demo & Crypto Play",
        description: "Miss Candy's Sweet Escape from Hacksaw Gaming. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/hacksaw-gaming/supreme_zeus': {
        title: 'Play Supreme Zeus by Hacksaw Gaming at {brand} | 12,500x Max Win',
        description: 'Spin Supreme Zeus by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/aliens_among_us': {
        title: 'Aliens Among Us xWays Slot by Hacksaw Gaming | {brand}',
        description: 'Aliens Among Us from Hacksaw Gaming, with a 15,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/hacksaw-gaming/love_is_all_you_need': {
        title: 'LOVE is all you need Slot by Hacksaw Gaming at {brand} | Instant Crypto Payouts',
        description: 'LOVE is all you need by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/ruby_rush': {
        title: 'Ruby Rush by Hacksaw Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Ruby Rush by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/diamond_rush': {
        title: 'Play Diamond Rush by Hacksaw Gaming at {brand} | 40,000x Max Win',
        description: 'Spin Diamond Rush by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/behind_bars_master_plan': {
        title: 'Behind Bars: Master Plan by Hacksaw Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Behind Bars: Master Plan from Hacksaw Gaming. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/hacksaw-gaming/eggstra_cash': {
        title: 'Play Eggstra Cash by Hacksaw Gaming at {brand} | 50,000x Max Win',
        description: 'Play Eggstra Cash by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/spooky_scary_scratchy': {
        title: 'Spooky Scary Scratchy xWays Slot by Hacksaw Gaming | {brand}',
        description: 'Spooky Scary Scratchy by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/scratchy_mini': {
        title: 'Play Scratchy Mini by Hacksaw Gaming at {brand} | 25,000x Max Win',
        description: 'Play Scratchy Mini by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/death_becomes_you': {
        title: 'Death Becomes You by Hacksaw Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Death Becomes You by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/opa_santorini': {
        title: 'Opa Santorini! Slot by Hacksaw Gaming at {brand} | Instant Crypto Payouts',
        description: 'Opa Santorini! by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/le_hooligan': {
        title: 'Play Le Hooligan by Hacksaw Gaming at {brand} | 10,000x Max Win',
        description: 'Spin Le Hooligan by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/army_of_ares': {
        title: 'Play Army of Ares by Hacksaw Gaming at {brand} | 15,000x Max Win',
        description: 'Play Army of Ares by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/le_football_fan': {
        title: 'Le Football Fan by Hacksaw Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Le Football Fan by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/lucky_scratch': {
        title: 'Play Lucky Scratch by Hacksaw Gaming at {brand} | 10,000x Max Win',
        description: 'Play Lucky Scratch by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/marlin_masters_og': {
        title: 'Marlin Masters OG: Play Online with Crypto | {brand}',
        description: 'Marlin Masters OG by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/shave_the_beard': {
        title: 'Shave the Beard Slot by Hacksaw Gaming at {brand} | Instant Crypto Payouts',
        description: 'Shave the Beard by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/chaos_crew_scratch': {
        title: 'Play Chaos Crew Scratch by Hacksaw Gaming at {brand} | 100,000x Max Win',
        description: 'Spin Chaos Crew Scratch by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/grug_make_fire': {
        title: 'Play Grug Make Fire by Hacksaw Gaming at {brand} | 10,000x Max Win',
        description: 'Play Grug Make Fire by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/lucky_numbers_x8': {
        title: 'Lucky Numbers x8: Play Online with Crypto | {brand}',
        description: 'Lucky Numbers x8 by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/go_panda': {
        title: 'Play Go Panda by Hacksaw Gaming at {brand} | 100,000x Max Win',
        description: 'Spin Go Panda by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/magic_piggy_og': {
        title: 'Play Magic Piggy OG by Hacksaw Gaming at {brand} | 2,500x Max Win',
        description: 'Play Magic Piggy OG by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/dream_car_speed': {
        title: 'Dream Car Speed Slot by Hacksaw Gaming at {brand} | Instant Crypto Payouts',
        description: 'Dream Car Speed from Hacksaw Gaming, with a 20,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/hacksaw-gaming/belle_the_blade_hunter': {
        title: 'Belle the Blade Hunter by Hacksaw Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Belle the Blade Hunter from Hacksaw Gaming. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/hacksaw-gaming/lucky_numbers_x16': {
        title: 'Lucky Numbers x16 by Hacksaw Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Lucky Numbers x16 by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/arena_of_iron': {
        title: 'Arena of Iron by Hacksaw Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Arena of Iron from Hacksaw Gaming. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/hacksaw-gaming/rat_riches': {
        title: 'Rat Riches: Play Online with Crypto | {brand}',
        description: 'Rat Riches by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/cut_the_grass': {
        title: 'Play Cut the Grass by Hacksaw Gaming at {brand} | 50,000x Max Win',
        description: 'Play Cut the Grass by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/express_200_scratch': {
        title: 'Express 200 Scratch: Play Online with Crypto | {brand}',
        description: 'Express 200 Scratch by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/le_bunny': {
        title: 'Le Bunny: Play Online with Crypto | {brand}',
        description: 'Le Bunny by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/king_treasure': {
        title: 'Play King Treasure by Hacksaw Gaming at {brand} | 40,000x Max Win',
        description: 'Play King Treasure by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/lucky_numbers_x20': {
        title: 'Lucky Numbers x20: Play Online with Crypto | {brand}',
        description: 'Lucky Numbers x20 by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/crownlings_clusters': {
        title: 'Crownlings Clusters Slot by Hacksaw Gaming at {brand} | Instant Crypto Payouts',
        description: 'Crownlings Clusters by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/frogs_scratch': {
        title: 'Frogs Scratch xWays Slot by Hacksaw Gaming | {brand}',
        description: 'Frogs Scratch by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/cursed_crypt': {
        title: 'Play Cursed Crypt by Hacksaw Gaming at {brand} | 10,000x Max Win',
        description: 'Play Cursed Crypt by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/cash_pool': {
        title: 'Cash Pool Slot by Hacksaw Gaming at {brand} | Instant Crypto Payouts',
        description: 'Cash Pool from Hacksaw Gaming, with a 100,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/hacksaw-gaming/drill_the_thrill': {
        title: 'Drill the Thrill xWays Slot by Hacksaw Gaming | {brand}',
        description: 'Play Drill the Thrill by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/shave_the_sheep': {
        title: 'Play Shave the Sheep by Hacksaw Gaming at {brand} | 75,000x Max Win',
        description: 'Spin Shave the Sheep by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/le_cowboy': {
        title: 'Play Le Cowboy by Hacksaw Gaming at {brand} | 25,000x Max Win',
        description: 'Play Le Cowboy by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/grinning_harvest': {
        title: 'Grinning Harvest by Hacksaw Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Grinning Harvest from Hacksaw Gaming. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/hacksaw-gaming/gold_coins': {
        title: 'Gold Coins by Hacksaw Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Gold Coins by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/lucky_shot': {
        title: 'Play Lucky Shot by Hacksaw Gaming at {brand} | 75,000x Max Win',
        description: 'Play Lucky Shot by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/great_game_rockies': {
        title: 'Great Game Rockies by Hacksaw Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Great Game Rockies by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/the_crime_file': {
        title: 'The Crime File: Play Online with Crypto | {brand}',
        description: 'Spin The Crime File by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/clawsy_collector': {
        title: 'Clawsy Collector: Play Online with Crypto | {brand}',
        description: 'Spin Clawsy Collector by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/queen_treasure': {
        title: 'Queen Treasure xWays Slot by Hacksaw Gaming | {brand}',
        description: 'Queen Treasure by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/henry_8th_calves_of_steel': {
        title: 'Henry 8th Calves of Steel Slot by Hacksaw Gaming at {brand} | Instant Crypto Payouts',
        description: 'Henry 8th Calves of Steel by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/jelly_slice': {
        title: 'Play Jelly Slice by Hacksaw Gaming at {brand} | 10,000x Max Win',
        description: 'Spin Jelly Slice by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/koi_cash': {
        title: 'Koi Cash by Hacksaw Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Koi Cash by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/tiger_scratch': {
        title: 'Tiger Scratch Slot by Hacksaw Gaming at {brand} | Instant Crypto Payouts',
        description: 'Tiger Scratch by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/stack_em_scratch': {
        title: "Stack 'em Scratch Slot by Hacksaw Gaming at {brand} | Instant Crypto Payouts",
        description: "Stack 'em Scratch from Hacksaw Gaming, with a 100,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/hacksaw-gaming/twentyone': {
        title: 'Play Twenty-One by Hacksaw Gaming at {brand} | 1,500x Max Win',
        description: 'Spin Twenty-One by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/scratchy': {
        title: 'Play Scratchy by Hacksaw Gaming at {brand} | 25,000x Max Win',
        description: 'Spin Scratchy by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/scratch_gold': {
        title: 'SCRATCH! Gold by Hacksaw Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play SCRATCH! Gold by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/dandy_diamonds': {
        title: 'Dandy Diamonds: Play Online with Crypto | {brand}',
        description: 'Dandy Diamonds by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/cash_vault_i': {
        title: 'Cash Vault I: Play Online with Crypto | {brand}',
        description: 'Cash Vault I by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/dynasty_of_death': {
        title: 'Play Dynasty of Death by Hacksaw Gaming at {brand} | 12,500x Max Win',
        description: 'Spin Dynasty of Death by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/dream_car_urban': {
        title: 'Play Dream Car Urban by Hacksaw Gaming at {brand} | 10,000x Max Win',
        description: 'Play Dream Car Urban by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/its_bananas': {
        title: "Play It's Bananas! by Hacksaw Gaming at {brand} | 75,000x Max Win",
        description: "Play It's Bananas! by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/hacksaw-gaming/leather_heads': {
        title: 'Leather Heads: Play Online with Crypto | {brand}',
        description: 'Spin Leather Heads by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/rise_of_fortuna': {
        title: 'Play Rise of Fortuna by Hacksaw Gaming at {brand} | 10,000x Max Win',
        description: 'Play Rise of Fortuna by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/nitro_nights': {
        title: 'Nitro Nights: Play Online with Crypto | {brand}',
        description: 'Nitro Nights by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/lucky_numbers_x12': {
        title: 'Play Lucky Numbers x12 by Hacksaw Gaming at {brand} | 75,000x Max Win',
        description: 'Spin Lucky Numbers x12 by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/cash_vault_ii': {
        title: 'Play Cash Vault II by Hacksaw Gaming at {brand} | 30,000x Max Win',
        description: 'Spin Cash Vault II by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/mines': {
        title: 'Mines Slot by Hacksaw Gaming at {brand} | Instant Crypto Payouts',
        description: 'Mines from Hacksaw Gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/hacksaw-gaming/colors': {
        title: 'Colors xWays Slot by Hacksaw Gaming | {brand}',
        description: 'Colors by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/demon_queen': {
        title: 'Demon Queen Slot by Hacksaw Gaming at {brand} | Instant Crypto Payouts',
        description: 'Demon Queen by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/summer_scratch': {
        title: 'Summer Scratch Slot by Hacksaw Gaming at {brand} | Instant Crypto Payouts',
        description: 'Summer Scratch from Hacksaw Gaming, with a 100,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/hacksaw-gaming/coins': {
        title: 'Coins Slot by Hacksaw Gaming at {brand} | Instant Crypto Payouts',
        description: 'Coins by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/tai_the_toad': {
        title: 'Play Tai the Toad by Hacksaw Gaming at {brand} | 7,500x Max Win',
        description: 'Spin Tai the Toad by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/mirage_city': {
        title: 'Mirage City: Play Online with Crypto | {brand}',
        description: 'Spin Mirage City by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/snow_scratcher': {
        title: 'Play Snow Scratcher by Hacksaw Gaming at {brand} | 50,000x Max Win',
        description: 'Spin Snow Scratcher by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/le_prachaun': {
        title: 'Le Prachaun xWays Slot by Hacksaw Gaming | {brand}',
        description: 'Le Prachaun from Hacksaw Gaming, with a 15,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/hacksaw-gaming/harvest_wilds': {
        title: 'Play Harvest Wilds by Hacksaw Gaming at {brand} | 10,000x Max Win',
        description: 'Play Harvest Wilds by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/power_of_ten': {
        title: 'Power of Ten by Hacksaw Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Power of Ten by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/marlin_masters_atlantis': {
        title: 'Marlin Masters: Atlantis xWays Slot by Hacksaw Gaming | {brand}',
        description: 'Marlin Masters: Atlantis by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/red_rascal': {
        title: 'Red Rascal Slot by Hacksaw Gaming at {brand} | Instant Crypto Payouts',
        description: 'Red Rascal by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/crazy_donuts': {
        title: 'Play Crazy Donuts by Hacksaw Gaming at {brand} | 150,000x Max Win',
        description: 'Spin Crazy Donuts by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/le_santa': {
        title: 'Play Le Santa by Hacksaw Gaming at {brand} | 20,000x Max Win',
        description: 'Spin Le Santa by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/scratch_bronze': {
        title: 'Play SCRATCH! Bronze by Hacksaw Gaming at {brand} | 100,000x Max Win',
        description: 'Spin SCRATCH! Bronze by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/scratch_silver': {
        title: 'SCRATCH! Silver Slot by Hacksaw Gaming at {brand} | Instant Crypto Payouts',
        description: 'SCRATCH! Silver from Hacksaw Gaming, with a 100,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/hacksaw-gaming/break_the_ice': {
        title: 'Break the Ice: Play Online with Crypto | {brand}',
        description: 'Spin Break the Ice by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/football_scratch': {
        title: 'Football Scratch xWays Slot by Hacksaw Gaming | {brand}',
        description: 'Football Scratch by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/scratchy_big': {
        title: 'Scratchy Big xWays Slot by Hacksaw Gaming | {brand}',
        description: 'Scratchy Big by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/play-n-go/xmas_magic': {
        title: "Play Xmas Magic by Play'n GO at {brand} | 4,000x Max Win",
        description: "Play Xmas Magic by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/golden_ticket': {
        title: "Golden Ticket Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Golden Ticket by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/temple_of_three': {
        title: "Temple of Three Book Slot by Play'n GO | {brand}",
        description: "Temple of Three from Play'n GO, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/wild_north_radiant_skies': {
        title: "Wild North Radiant Skies Book Slot by Play'n GO | {brand}",
        description: "Wild North Radiant Skies by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/reactoonz_blitzways': {
        title: "Play Reactoonz Blitzways by Play'n GO at {brand} | 10,000x Max Win",
        description: "Spin Reactoonz Blitzways by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/legion_gold_reckoning': {
        title: 'Legion Gold Reckoning: Play Online with Crypto | {brand}',
        description: "Legion Gold Reckoning by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/stompin_gold': {
        title: "Play Stompin' Gold by Play'n GO at {brand} | 50,000x Max Win",
        description: "Play Stompin' Gold by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/valhalluck': {
        title: "Play Valhalluck by Play'n GO at {brand} | 3,000x Max Win",
        description: "Spin Valhalluck by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/cursed_moon_power_collection': {
        title: "Cursed Moon Power Collection by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Play Cursed Moon Power Collection by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/rise_of_olympus_bingo': {
        title: "Play Rise of Olympus Bingo by Play'n GO at {brand} | 4,250x Max Win",
        description: "Play Rise of Olympus Bingo by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/holy_moo_extreme_power': {
        title: "Play Holy Moo! Extreme Power by Play'n GO at {brand} | 4,000x Max Win",
        description: "Play Holy Moo! Extreme Power by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/wrappin_gold': {
        title: 'Wrappin Gold: Play Online with Crypto | {brand}',
        description: "Wrappin Gold by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/triple_launch_fortune_wild': {
        title: "Triple Launch Fortune Wild by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Spin Triple Launch Fortune Wild by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/track_n_gold': {
        title: "Track n' Gold by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Play Track n' Gold by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/moon_princess_extreme': {
        title: 'Moon Princess Extreme: Play Online with Crypto | {brand}',
        description: "Moon Princess Extreme from Play'n GO, with a 50,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/unigoat': {
        title: "Play Unigoat by Play'n GO at {brand} | 20,000x Max Win",
        description: "Play Unigoat by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/crabbys_gold_ii': {
        title: "Crabby's Gold II: Play Online with Crypto | {brand}",
        description: "Crabby's Gold II from Play'n GO, with a 30,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/lawn_n_disorder': {
        title: "Lawn N' Disorder Book Slot by Play'n GO | {brand}",
        description: "Lawn N' Disorder from Play'n GO, with a 50,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/piggy_blitz_casino_gold': {
        title: "Piggy Blitz Casino Gold by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Spin Piggy Blitz Casino Gold by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/viking_runecraft_1000': {
        title: "Viking Runecraft 1000 by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Spin Viking Runecraft 1000 by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/nugget_n_nonsense': {
        title: "Nugget N' Nonsense by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Play Nugget N' Nonsense by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/manta_mayhem': {
        title: "Manta Mayhem by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Spin Manta Mayhem by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/fates_fortune': {
        title: "Play Fate's Fortune by Play'n GO at {brand} | 5,000x Max Win",
        description: "Spin Fate's Fortune by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/legion_gold_and_the_throne_of_dead': {
        title: "Play Legion Gold And The Throne Of Dead by Play'n GO at {brand} | 10,000x Max Win",
        description: "Play Legion Gold And The Throne Of Dead by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/primal_rampage': {
        title: "Play Primal Rampage by Play'n GO at {brand} | 2,500x Max Win",
        description: "Spin Primal Rampage by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/gnawn_gold': {
        title: "Gnaw'n Gold Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Gnaw'n Gold from Play'n GO, with a 40,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/grannys_wild': {
        title: "Play Granny's Wild by Play'n GO at {brand} | 2,800x Max Win",
        description: "Play Granny's Wild by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/moon_princess_100': {
        title: "Play Moon Princess 100 by Play'n GO at {brand} | 15,000x Max Win",
        description: "Spin Moon Princess 100 by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/tomb_of_gold_reimagined': {
        title: "Play Tomb of Gold Reimagined by Play'n GO at {brand} | 10,000x Max Win",
        description: "Play Tomb of Gold Reimagined by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/spice_spice_baby': {
        title: 'Spice Spice Baby: Play Online with Crypto | {brand}',
        description: "Spice Spice Baby by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/book_of_dead_go_collect': {
        title: "Book of Dead Go Collect Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Book of Dead Go Collect from Play'n GO, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/shark_feast': {
        title: "Shark Feast by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Spin Shark Feast by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/pragmatic-play/roulette': {
        title: 'Roulette Megaways Slot by Pragmatic Play | {brand}',
        description: 'Play Roulette by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/the_red_queen': {
        title: 'The Red Queen: Play Online with Crypto | {brand}',
        description: 'Spin The Red Queen by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/baccarat': {
        title: 'Baccarat Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Baccarat by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/the_knight_king': {
        title: 'The Knight King Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'The Knight King by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/fire_archer': {
        title: 'Fire Archer Megaways Slot by Pragmatic Play | {brand}',
        description: 'Play Fire Archer by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/firebird_spirit_connect_and_collect': {
        title: 'Firebird Spirit Connect and Collect Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Firebird Spirit Connect and Collect by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/rabbit_garden': {
        title: 'Rabbit Garden: Play Online with Crypto | {brand}',
        description: 'Spin Rabbit Garden by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/da_vincis_treasure': {
        title: "Da Vinci's Treasure: Play Online with Crypto | {brand}",
        description: "Spin Da Vinci's Treasure by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/pragmatic-play/jokers_jewels_hot': {
        title: "Joker's Jewels Hot by Pragmatic Play at {brand} | Free Demo & Crypto Play",
        description: "Joker's Jewels Hot from Pragmatic Play. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/pragmatic-play/candy_jar_clusters': {
        title: 'Candy Jar Clusters Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Candy Jar Clusters by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/big_bass_xmas_xtreme': {
        title: 'Big Bass Xmas Xtreme: Play Online with Crypto | {brand}',
        description: 'Spin Big Bass Xmas Xtreme by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/diamonds_are_forever_3_lines': {
        title: 'Diamonds are Forever 3 Lines Megaways Slot by Pragmatic Play | {brand}',
        description: 'Play Diamonds are Forever 3 Lines by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/amazing_money_machine': {
        title: 'Amazing Money Machine: Play Online with Crypto | {brand}',
        description: 'Spin Amazing Money Machine by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/john_hunter_and_the_tomb_of_the_scarab_queen': {
        title: 'John Hunter and the Tomb of the Scarab Queen by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'John Hunter and the Tomb of the Scarab Queen from Pragmatic Play. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/gold_rush': {
        title: 'Gold Rush: Play Online with Crypto | {brand}',
        description: 'Gold Rush by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/the_dog_house_multihold': {
        title: 'The Dog House Multihold Megaways Slot by Pragmatic Play | {brand}',
        description: 'Play The Dog House Multihold by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/big_bass_hold_and_spinner': {
        title: 'Big Bass Hold and Spinner: Play Online with Crypto | {brand}',
        description: 'Spin Big Bass Hold and Spinner by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/cult': {
        title: 'CULT by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin CULT by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/sweet_bonanza_2500': {
        title: 'Play Sweet Bonanza 2500 by Pragmatic Play at {brand} | 25,000x Max Win',
        description: 'Play Sweet Bonanza 2500 by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/fury_of_anubis': {
        title: 'Fury of Anubis: Play Online with Crypto | {brand}',
        description: 'Fury of Anubis by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/the_dog_house_megaways_1000': {
        title: 'The Dog House Megaways 1000 by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play The Dog House Megaways 1000 by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/snow_party': {
        title: 'Play Snow Party by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Spin Snow Party by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/dragon_pots_megaways': {
        title: 'Dragon Pots Megaways: Play Online with Crypto | {brand}',
        description: 'Dragon Pots Megaways by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/gates_of_olympus_pop': {
        title: 'Gates of Olympus POP by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin Gates of Olympus POP by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/caishens_cash_pots': {
        title: "Caishen's Cash Pots Slot by Pragmatic Play at {brand} | Instant Crypto Payouts",
        description: "Caishen's Cash Pots from Pragmatic Play, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/pragmatic-play/luxor_of_cleopatra': {
        title: 'Play Luxor of Cleopatra by Pragmatic Play at {brand} | 12,500x Max Win',
        description: 'Play Luxor of Cleopatra by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/triple_pot_plinko_hercules': {
        title: 'Play Triple Pot Plinko Hercules by Pragmatic Play at {brand} | 10,000x Max Win',
        description: 'Spin Triple Pot Plinko Hercules by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/candy_rush': {
        title: 'Play Candy Rush by Pragmatic Play at {brand} | 15,000x Max Win',
        description: 'Spin Candy Rush by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/slots_lobby': {
        title: 'Slots Lobby Megaways Slot by Pragmatic Play | {brand}',
        description: 'Play Slots Lobby by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/sanatorium_secrets': {
        title: 'Sanatorium Secrets: Play Online with Crypto | {brand}',
        description: 'Sanatorium Secrets by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/idol_pop_fever': {
        title: 'Idol Pop Fever Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Idol Pop Fever by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/fortune_dragon': {
        title: 'Fortune Dragon Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Fortune Dragon from Pragmatic Play, with a 3,520x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/the_magic_cauldron': {
        title: 'The Magic Cauldron: Play Online with Crypto | {brand}',
        description: 'Spin The Magic Cauldron by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/book_of_tut': {
        title: 'Book of Tut by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Book of Tut from Pragmatic Play. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/steamin_reels': {
        title: 'Steamin Reels Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Steamin Reels by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/furry_bonanza_megaways': {
        title: 'Furry Bonanza Megaways Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Furry Bonanza Megaways from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/the_big_dog_house': {
        title: 'Play The Big Dog House by Pragmatic Play at {brand} | 15,000x Max Win',
        description: 'Play The Big Dog House by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/sunnydaze_asylum': {
        title: 'Sunnydaze Asylum Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Sunnydaze Asylum from Pragmatic Play, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/jokers_revenge': {
        title: "Joker's Revenge Megaways Slot by Pragmatic Play | {brand}",
        description: "Joker's Revenge by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/pragmatic-play/cosmic_clusters': {
        title: 'Play Cosmic Clusters! by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Play Cosmic Clusters! by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/sleeping_dragon_ultra_dark': {
        title: 'Sleeping Dragon Ultra Dark Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Sleeping Dragon Ultra Dark from Pragmatic Play, with a 20,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/bermuda_riches': {
        title: 'Bermuda Riches by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Bermuda Riches from Pragmatic Play. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/heartbreakers': {
        title: 'Heartbreakers Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Heartbreakers from Pragmatic Play, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/plinko': {
        title: 'Plinko+ Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Plinko+ from Pragmatic Play, with a 1,240x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/big_bass_football_bonanza': {
        title: 'Play Big Bass Football Bonanza by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Play Big Bass Football Bonanza by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/dragon_tiger': {
        title: 'Dragon Tiger Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Dragon Tiger by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/dragon_bonus_baccarat': {
        title: 'Dragon Bonus Baccarat Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Dragon Bonus Baccarat by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/spire': {
        title: 'Spire+ Megaways Slot by Pragmatic Play | {brand}',
        description: 'Spire+ by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/launch_to_riches': {
        title: 'Play Launch to Riches by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Spin Launch to Riches by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/wild_gladiator': {
        title: 'Wild Gladiator: Play Online with Crypto | {brand}',
        description: 'Spin Wild Gladiator by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/great_ghosts': {
        title: 'Play Great Ghosts! by Pragmatic Play at {brand} | 40,000x Max Win',
        description: 'Spin Great Ghosts! by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/mahjong_wins_triple_pot': {
        title: 'Mahjong Wins Triple Pot: Play Online with Crypto | {brand}',
        description: 'Mahjong Wins Triple Pot by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/little_gem': {
        title: 'Little Gem: Play Online with Crypto | {brand}',
        description: 'Spin Little Gem by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/irish_crown': {
        title: 'Irish Crown Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Irish Crown from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/better_barn_house_bonanza': {
        title: 'Better Barn House Bonanza: Play Online with Crypto | {brand}',
        description: 'Better Barn House Bonanza from Pragmatic Play, with a 35,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/panda_fortune_2': {
        title: 'Panda Fortune 2 Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Panda Fortune 2 by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/big_bass_trophy_catch': {
        title: 'Big Bass Trophy Catch by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Big Bass Trophy Catch from Pragmatic Play. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/aztec_treasure': {
        title: 'Aztec Treasure by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Aztec Treasure from Pragmatic Play. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/cyber_pup_megaways': {
        title: 'Play Cyber Pup Megaways by Pragmatic Play at {brand} | 40,000x Max Win',
        description: 'Play Cyber Pup Megaways by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/inca_queen': {
        title: 'Play Inca Queen by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Spin Inca Queen by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/mr_nulls_wicked_wares': {
        title: "Mr Null's Wicked Wares Megaways Slot by Pragmatic Play | {brand}",
        description: "Mr Null's Wicked Wares from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/pragmatic-play/book_of_tut_respin': {
        title: 'Book of Tut Respin Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Book of Tut Respin by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/american_blackjack': {
        title: 'American Blackjack Megaways Slot by Pragmatic Play | {brand}',
        description: 'American Blackjack by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/death_dominion': {
        title: 'Death Dominion by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Death Dominion by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/haunted_crypt': {
        title: 'Haunted Crypt by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Haunted Crypt by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/dragons_gate_bonus_choice': {
        title: "Play Dragon's Gate Bonus Choice by Pragmatic Play at {brand} | 10,000x Max Win",
        description: "Spin Dragon's Gate Bonus Choice by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/pragmatic-play/bear_crazy': {
        title: 'Play Bear Crazy by Pragmatic Play at {brand} | 3,900x Max Win',
        description: 'Spin Bear Crazy by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/chicken': {
        title: 'Chicken+ Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Chicken+ from Pragmatic Play, with a 3,138,009x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/spaceman': {
        title: 'Spaceman Megaways Slot by Pragmatic Play | {brand}',
        description: 'Play Spaceman by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/out_of_the_woods': {
        title: 'Out of the Woods Megaways Slot by Pragmatic Play | {brand}',
        description: 'Out of the Woods from Pragmatic Play, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/mines': {
        title: 'Play Mines+ by Pragmatic Play at {brand} | 5,070,293x Max Win',
        description: 'Play Mines+ by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/limbo': {
        title: 'Limbo+: Play Online with Crypto | {brand}',
        description: 'Limbo+ from Pragmatic Play, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/super_gummy_strike': {
        title: 'Super Gummy Strike by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin Super Gummy Strike by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/big_bass_blast': {
        title: 'Big Bass Blast Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Big Bass Blast by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/emerald_king_wheel_of_wealth': {
        title: 'Emerald King Wheel of Wealth Megaways Slot by Pragmatic Play | {brand}',
        description: 'Play Emerald King Wheel of Wealth by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/hell_butcher': {
        title: 'Hell Butcher Megaways Slot by Pragmatic Play | {brand}',
        description: 'Hell Butcher from Pragmatic Play, with a 20,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/jelly_express': {
        title: 'Jelly Express Megaways Slot by Pragmatic Play | {brand}',
        description: 'Jelly Express by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/relax-gaming/money_train_4': {
        title: 'Money Train 4 Slot by Relax Gaming at {brand} | Instant Crypto Payouts',
        description: 'Money Train 4 by Relax Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/million-games/chicken_x_and_friends': {
        title: 'Chicken X and Friends: Play Online with Crypto | {brand}',
        description: 'Chicken X and Friends from Million Games. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play-live/boom_city': {
        title: 'Boom City by Pragmatic Play Live at {brand} | Free Demo & Crypto Play',
        description: 'Spin Boom City by Pragmatic Play Live at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/playson/royal_joker_hold_and_win': {
        title: 'Royal Joker by playson at {brand} | Free Demo & Crypto Play',
        description: 'Royal Joker from playson. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play-live/sweet_bonanza_candyland': {
        title: 'Sweet Bonanza Candyland: Play Online with Crypto | {brand}',
        description: 'Spin Sweet Bonanza Candyland by Pragmatic Play Live at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/indigomagic/ikusa': {
        title: 'Ikusa: Play Online with Crypto | {brand}',
        description: 'Ikusa from IndigoMagic. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/hacksaw-gaming/epic_bullets_and_bounty': {
        title: 'Epic Bullets and Bounty by Hacksaw Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Epic Bullets and Bounty by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/frkn_bananas': {
        title: 'FRKN Bananas xWays Slot by Hacksaw Gaming | {brand}',
        description: 'FRKN Bananas from Hacksaw Gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/sugar_merge_up': {
        title: 'Sugar Merge Up Provably Fair Slot by BGaming | {brand}',
        description: 'Sugar Merge Up from BGaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/hanzos_dojo': {
        title: "Hanzo's Dojo Slot by Yggdrasil at {brand} | Instant Crypto Payouts",
        description: "Hanzo's Dojo by Yggdrasil at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/pgsoft/the_great_icescape': {
        title: 'The Great Icescape Slot by PG Soft at {brand} | Instant Crypto Payouts',
        description: 'The Great Icescape from PG Soft, with a 7,963x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/play-n-go/honey_rush_black_and_yellow': {
        title: "Honey Rush Black and Yellow by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Play Honey Rush Black and Yellow by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/buildin_even_more_bucks': {
        title: "Play Buildin' Even More Bucks by Play'n GO at {brand} | 5,000x Max Win",
        description: "Play Buildin' Even More Bucks by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/indigomagic/golden_gals_cash_towers': {
        title: "Golden Gal's Cash Towers: Play Online with Crypto | {brand}",
        description: "Spin Golden Gal's Cash Towers by IndigoMagic at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/hacksaw-gaming/deal_with_death': {
        title: 'Deal with Death xWays Slot by Hacksaw Gaming | {brand}',
        description: 'Deal with Death by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/munchy_milo': {
        title: 'Munchy Milo: Play Online with Crypto | {brand}',
        description: 'Munchy Milo from Hacksaw Gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/hacksaw-gaming/eternal_duel': {
        title: 'Eternal Duel: Play Online with Crypto | {brand}',
        description: 'Eternal Duel from Hacksaw Gaming, with a 15,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play-live/snakes_and_ladders_live': {
        title: 'Snakes and Ladders Live by Pragmatic Play Live at {brand} | Free Demo & Crypto Play',
        description: 'Snakes and Ladders Live from Pragmatic Play Live, with a 20,570x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/hacksaw-gaming/dark_spiral': {
        title: 'Dark Spiral xWays Slot by Hacksaw Gaming | {brand}',
        description: 'Dark Spiral by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/luckys_wild_pub_2': {
        title: "Lucky's Wild Pub 2 Slot by Pragmatic Play at {brand} | Instant Crypto Payouts",
        description: "Lucky's Wild Pub 2 by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/hacksaw-gaming/stormforged': {
        title: 'Stormforged: Play Online with Crypto | {brand}',
        description: 'Stormforged by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/alice_wonderluck': {
        title: 'Alice Wonderluck Slot by BGaming at {brand} | Instant Crypto Payouts',
        description: 'Alice Wonderluck from BGaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/alien_fruits': {
        title: 'Alien Fruits Provably Fair Slot by BGaming | {brand}',
        description: 'Alien Fruits from BGaming, with a 15,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/alien_fruits_2': {
        title: 'Alien Fruits 2 by BGaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Alien Fruits 2 by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/all_star_fruits': {
        title: 'All Star Fruits by BGaming at {brand} | Free Demo & Crypto Play',
        description: 'Play All Star Fruits by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/aloha_king_elvis': {
        title: 'Aloha King Elvis: Play Online with Crypto | {brand}',
        description: 'Aloha King Elvis from BGaming, with a 2,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/arrow_slot': {
        title: 'Arrow Slot by BGaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Arrow Slot by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/avalon_the_lost_kingdom': {
        title: 'Play Avalon: The Lost Kingdom by BGaming at {brand} | 5,000x Max Win',
        description: 'Play Avalon: The Lost Kingdom by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/aviamasters': {
        title: 'Play Aviamasters by BGaming at {brand} | 250x Max Win',
        description: 'Spin Aviamasters by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/aviamasters_2': {
        title: 'Aviamasters 2 Provably Fair Slot by BGaming | {brand}',
        description: 'Aviamasters 2 from BGaming, with a 1,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/aztec_clusters': {
        title: 'Aztec Clusters: Play Online with Crypto | {brand}',
        description: 'Aztec Clusters from BGaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/aztec_magic_bonanza': {
        title: 'Aztec Magic Bonanza Slot by BGaming at {brand} | Instant Crypto Payouts',
        description: 'Aztec Magic Bonanza by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/aztec_magic_deluxe': {
        title: 'Aztec Magic Deluxe Provably Fair Slot by BGaming | {brand}',
        description: 'Aztec Magic Deluxe from BGaming, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/aztec_magic_megaways': {
        title: 'Play Aztec Magic Megaways by BGaming at {brand} | 12,960x Max Win',
        description: 'Play Aztec Magic Megaways by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/aztecs_claw_wild_dice': {
        title: "Aztec's Claw Wild Dice Provably Fair Slot by BGaming | {brand}",
        description: "Aztec's Claw Wild Dice by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/bgaming/balloon_mania': {
        title: 'Play Balloon Mania by BGaming at {brand} | 64x Max Win',
        description: 'Play Balloon Mania by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/beast_band': {
        title: 'Beast Band: Play Online with Crypto | {brand}',
        description: 'Beast Band by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/beer_bonanza': {
        title: 'Beer Bonanza by BGaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Beer Bonanza by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/big_atlantis_frenzy': {
        title: 'Play Big Atlantis Frenzy by BGaming at {brand} | 4,248x Max Win',
        description: 'Spin Big Atlantis Frenzy by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/blackbeards_bounty': {
        title: "Blackbeard's Bounty by BGaming at {brand} | Free Demo & Crypto Play",
        description: "Spin Blackbeard's Bounty by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/bgaming/blazing_fire_pots_hold_and_spin': {
        title: 'Play Blazing Fire Pots Hold and Spin by BGaming at {brand} | 5,000x Max Win',
        description: 'Play Blazing Fire Pots Hold and Spin by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/bonanza_billion': {
        title: 'Bonanza Billion Provably Fair Slot by BGaming | {brand}',
        description: 'Bonanza Billion from BGaming, with a 15,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/bonanza_billion_xtreme': {
        title: 'Bonanza Billion Xtreme: Play Online with Crypto | {brand}',
        description: 'Bonanza Billion Xtreme from BGaming, with a 20,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/bonanza_trillion': {
        title: 'Bonanza Trillion: Play Online with Crypto | {brand}',
        description: 'Bonanza Trillion from BGaming, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/bone_bonanza': {
        title: 'Play Bone Bonanza by BGaming at {brand} | 14,134x Max Win',
        description: 'Play Bone Bonanza by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/book_of_cats': {
        title: 'Book of Cats: Play Online with Crypto | {brand}',
        description: 'Book of Cats from BGaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/book_of_cats_megaways': {
        title: 'Book of Cats Megaways by BGaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Book of Cats Megaways by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/book_of_kemet': {
        title: 'Play Book of Kemet by BGaming at {brand} | 7,791x Max Win',
        description: 'Spin Book of Kemet by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/book_of_panda_megaways': {
        title: 'Book of Panda Megaways Slot by BGaming at {brand} | Instant Crypto Payouts',
        description: 'Book of Panda Megaways by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/book_of_pyramids': {
        title: 'Book of Pyramids: Play Online with Crypto | {brand}',
        description: 'Book of Pyramids by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/brave_viking': {
        title: 'Brave Viking Slot: Play Online with Crypto | {brand}',
        description: 'Brave Viking Slot by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/burning_chilli_243': {
        title: 'Burning Chilli 243 Provably Fair Slot by BGaming | {brand}',
        description: 'Burning Chilli 243 from BGaming, with a 500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/burning_chilli_x': {
        title: 'Play Burning Chilli X by BGaming at {brand} | 850x Max Win',
        description: 'Play Burning Chilli X by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/candy_monsta': {
        title: 'Candy Monsta by BGaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Candy Monsta by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/capymania_green': {
        title: 'Capymania Green Provably Fair Slot by BGaming | {brand}',
        description: 'Capymania Green from BGaming, with a 100,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/capymania_orange': {
        title: 'Play Capymania Orange by BGaming at {brand} | 100,000x Max Win',
        description: 'Play Capymania Orange by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/capymania_yellow': {
        title: 'Play Capymania Yellow by BGaming at {brand} | 100,000x Max Win',
        description: 'Spin Capymania Yellow by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/carnival_bonanza': {
        title: 'Play Carnival Bonanza by BGaming at {brand} | 14,134x Max Win',
        description: 'Spin Carnival Bonanza by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/catch_the_gold_hold_and_win': {
        title: 'Catch the Gold Hold and Win Slot by BGaming at {brand} | Instant Crypto Payouts',
        description: 'Catch the Gold Hold and Win by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/catdiana': {
        title: 'Catdiana Provably Fair Slot by BGaming | {brand}',
        description: 'Catdiana by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/cats_soup': {
        title: "Cat's Soup Provably Fair Slot by BGaming | {brand}",
        description: "Cat's Soup by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/bgaming/cherry_fiesta': {
        title: 'Cherry Fiesta Slot by BGaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Cherry Fiesta Slot by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/chicken_rush': {
        title: 'Play Chicken Rush by BGaming at {brand} | 5,000x Max Win',
        description: 'Play Chicken Rush by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/classic_multihand_blackjack': {
        title: 'Play Classic Multihand Blackjack by BGaming at {brand} | 3x Max Win',
        description: 'Play Classic Multihand Blackjack by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/clover_bonanza': {
        title: 'Clover Bonanza Provably Fair Slot by BGaming | {brand}',
        description: 'Clover Bonanza from BGaming, with a 15,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/clucking_hell': {
        title: 'Play Clucking Hell by BGaming at {brand} | 6,666x Max Win',
        description: 'Play Clucking Hell by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/crazy_starter': {
        title: 'Crazy Starter Slot Slot by BGaming at {brand} | Instant Crypto Payouts',
        description: 'Crazy Starter Slot by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/crystal_clusters': {
        title: 'Play Crystal Clusters by BGaming at {brand} | 5,000x Max Win',
        description: 'Play Crystal Clusters by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/deep_sea': {
        title: 'Play Deep Sea by BGaming at {brand} | 2,692x Max Win',
        description: 'Spin Deep Sea by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/desert_treasure': {
        title: 'Desert Treasure Slot Slot by BGaming at {brand} | Instant Crypto Payouts',
        description: 'Desert Treasure Slot by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/diamond_of_jungle': {
        title: 'Diamond of Jungle by BGaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Diamond of Jungle by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/dice_bonanza': {
        title: 'Dice Bonanza Provably Fair Slot by BGaming | {brand}',
        description: 'Dice Bonanza by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/dice_million': {
        title: 'Play Dice Million by BGaming at {brand} | 3,000x Max Win',
        description: 'Spin Dice Million by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/dig_dig_digger': {
        title: 'Play Dig Dig Digger by BGaming at {brand} | 7,791x Max Win',
        description: 'Spin Dig Dig Digger by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/disco_party': {
        title: 'Disco Party Provably Fair Slot by BGaming | {brand}',
        description: 'Disco Party by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/divine_queen_heart_of_ice': {
        title: 'Divine Queen Heart of Ice: Play Online with Crypto | {brand}',
        description: 'Divine Queen Heart of Ice by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/domnitors': {
        title: 'Domnitors Slot Slot by BGaming at {brand} | Instant Crypto Payouts',
        description: 'Domnitors Slot by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/domnitors_deluxe': {
        title: 'Domnitors Deluxe Slot: Play Online with Crypto | {brand}',
        description: 'Domnitors Deluxe Slot by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/domnitors_treasure': {
        title: "Domnitor's Treasure Slot by BGaming at {brand} | Instant Crypto Payouts",
        description: "Domnitor's Treasure by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/bgaming/doomsday_saloon': {
        title: 'Doomsday Saloon Provably Fair Slot by BGaming | {brand}',
        description: 'Doomsday Saloon by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/dragon_age_hold_and_win_dragon_age': {
        title: 'Play Dragon Age Hold and Win (Dragon Age) by BGaming at {brand} | 5,624x Max Win',
        description: 'Play Dragon Age Hold and Win (Dragon Age) by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/dragon_queens_megaways': {
        title: 'Play Dragon Queens Megaways by BGaming at {brand} | 6,000x Max Win',
        description: 'Spin Dragon Queens Megaways by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/dragons_gold_100': {
        title: "Dragon's Gold 100 Slot by BGaming at {brand} | Instant Crypto Payouts",
        description: "Dragon's Gold 100 by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/bgaming/easter_heist': {
        title: 'Play Easter Heist by BGaming at {brand} | 5,624x Max Win',
        description: 'Spin Easter Heist by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/elvis_frog_in_vegas': {
        title: 'Elvis Frog in Vegas: Play Online with Crypto | {brand}',
        description: 'Elvis Frog in Vegas by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/elvis_frog_trueways': {
        title: 'Elvis Frog TRUEWAYS: Play Online with Crypto | {brand}',
        description: 'Elvis Frog TRUEWAYS from BGaming, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/face_off': {
        title: 'Face Off: Play Online with Crypto | {brand}',
        description: 'Face Off by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/fantasy_park': {
        title: 'Fantasy Park Slot Provably Fair Slot by BGaming | {brand}',
        description: 'Fantasy Park Slot from BGaming, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/fiesta_clusters': {
        title: 'Fiesta Clusters by BGaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Fiesta Clusters by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/fire_lightning': {
        title: 'Fire Lightning Provably Fair Slot by BGaming | {brand}',
        description: 'Fire Lightning by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/fishing_club': {
        title: 'Fishing Club Provably Fair Slot by BGaming | {brand}',
        description: 'Fishing Club from BGaming, with a 3,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/forgotten': {
        title: 'Play Forgotten by BGaming at {brand} | 7,500x Max Win',
        description: 'Play Forgotten by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/fortuna_trueways': {
        title: 'Fortuna TRUEWAYS by BGaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Fortuna TRUEWAYS by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/fortune_bells': {
        title: 'Play Fortune Bells by BGaming at {brand} | 4,684x Max Win',
        description: 'Play Fortune Bells by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/fortune_red_packets': {
        title: 'Fortune Red Packets Provably Fair Slot by BGaming | {brand}',
        description: 'Fortune Red Packets from BGaming, with a 14x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/fortune_spin': {
        title: 'Play Fortune Spin by BGaming at {brand} | 10,000x Max Win',
        description: 'Spin Fortune Spin by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/forty_fruity_million': {
        title: 'Forty Fruity Million: Play Online with Crypto | {brand}',
        description: 'Forty Fruity Million from BGaming, with a 6,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/four_lucky_clover': {
        title: 'Four Lucky Clover Provably Fair Slot by BGaming | {brand}',
        description: 'Four Lucky Clover by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/four_lucky_diamonds': {
        title: 'Four Lucky Diamonds Provably Fair Slot by BGaming | {brand}',
        description: 'Four Lucky Diamonds from BGaming, with a 2,500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/fruit_million': {
        title: 'Fruit Million: Play Online with Crypto | {brand}',
        description: 'Fruit Million by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/gangsterz': {
        title: 'Gangsterz Provably Fair Slot by BGaming | {brand}',
        description: 'Gangsterz by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/gemhalla': {
        title: 'Gemhalla Slot by BGaming at {brand} | Instant Crypto Payouts',
        description: 'Gemhalla by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/gemza': {
        title: 'Gemza by BGaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Gemza by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/gift_rush': {
        title: 'Gift Rush Slot by BGaming at {brand} | Instant Crypto Payouts',
        description: 'Gift Rush from BGaming, with a 559x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/god_of_wealth_hold_and_win': {
        title: 'God of Wealth Hold And Win Slot by BGaming at {brand} | Instant Crypto Payouts',
        description: 'God of Wealth Hold And Win by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/gold_magnate': {
        title: 'Play Gold Magnate by BGaming at {brand} | 10,490x Max Win',
        description: 'Spin Gold Magnate by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/gold_of_minos': {
        title: 'Gold of Minos Provably Fair Slot by BGaming | {brand}',
        description: 'Gold of Minos by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/gold_rush_with_johnny_cash': {
        title: 'Gold Rush with Johnny Cash Provably Fair Slot by BGaming | {brand}',
        description: 'Gold Rush with Johnny Cash from BGaming, with a 5,820x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/golden_pinata_hold_and_win': {
        title: 'Golden Pinata Hold and Win by BGaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Golden Pinata Hold and Win by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/golden_pride': {
        title: 'Golden Pride by BGaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Golden Pride by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/grand_mustang': {
        title: 'Grand Mustang by BGaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Grand Mustang by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/grand_patron': {
        title: 'Grand Patron Slot by BGaming at {brand} | Instant Crypto Payouts',
        description: 'Grand Patron by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/halloween_bonanza': {
        title: 'Halloween Bonanza Slot by BGaming at {brand} | Instant Crypto Payouts',
        description: 'Halloween Bonanza from BGaming, with a 10,200x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/haunted_reels': {
        title: 'Haunted Reels Slot by BGaming at {brand} | Instant Crypto Payouts',
        description: 'Haunted Reels from BGaming, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/hawaii_cocktails': {
        title: 'Hawaii Cocktails Slot Provably Fair Slot by BGaming | {brand}',
        description: 'Hawaii Cocktails Slot from BGaming, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/heads_and_tails': {
        title: 'Heads and Tails Provably Fair Slot by BGaming | {brand}',
        description: 'Heads and Tails from BGaming, with a 2x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/heads_and_tails_xy': {
        title: 'Heads and Tails XY Slot by BGaming at {brand} | Instant Crypto Payouts',
        description: 'Heads and Tails XY by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/heart_of_tiki': {
        title: 'Play Heart of Tiki by BGaming at {brand} | 5,000x Max Win',
        description: 'Play Heart of Tiki by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/hello_easter': {
        title: 'Hello Easter Slot Slot by BGaming at {brand} | Instant Crypto Payouts',
        description: 'Hello Easter Slot from BGaming, with a 9,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/hit_the_route': {
        title: 'Hit The Route: Play Online with Crypto | {brand}',
        description: 'Hit The Route from BGaming, with a 15,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/hot_chilli_bells': {
        title: 'Play Hot Chilli Bells by BGaming at {brand} | 5,000x Max Win',
        description: 'Spin Hot Chilli Bells by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/hottest_666': {
        title: 'Hottest 666 by BGaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Hottest 666 by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/infinity_pull': {
        title: 'Play Infinity Pull by BGaming at {brand} | 100x Max Win',
        description: 'Spin Infinity Pull by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/jogo_do_bicho': {
        title: 'Jogo Do Bicho Provably Fair Slot by BGaming | {brand}',
        description: 'Jogo Do Bicho by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/jogo_do_bicho_simple': {
        title: 'Jogo Do Bicho Simple by BGaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Jogo Do Bicho Simple by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/johnny_cash': {
        title: 'Johnny Cash by BGaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Johnny Cash by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/joker_queen': {
        title: 'Play Joker Queen by BGaming at {brand} | 1,172x Max Win',
        description: 'Play Joker Queen by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/joker_vs_joker': {
        title: 'Joker vs Joker: Play Online with Crypto | {brand}',
        description: 'Joker vs Joker by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/joker_x_love': {
        title: 'Joker X Love Slot by BGaming at {brand} | Instant Crypto Payouts',
        description: 'Joker X Love by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/jokers_million': {
        title: "Joker's Million: Play Online with Crypto | {brand}",
        description: "Joker's Million by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/bgaming/journey_flirt': {
        title: 'Play Journey Flirt Slot by BGaming at {brand} | 15,000x Max Win',
        description: 'Play Journey Flirt Slot by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/jungle_queen': {
        title: 'Play Jungle Queen by BGaming at {brand} | 10,000x Max Win',
        description: 'Spin Jungle Queen by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/keepers_of_the_secret': {
        title: 'Keepers Of The Secret by BGaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Keepers Of The Secret by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/krakens_hunger': {
        title: "Kraken's Hunger: Play Online with Crypto | {brand}",
        description: "Kraken's Hunger by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/bgaming/lady_lucky_gun': {
        title: 'Play Lady Lucky Gun by BGaming at {brand} | 1,000x Max Win',
        description: 'Spin Lady Lucky Gun by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/lady_wolf_moon': {
        title: 'Lady Wolf Moon: Play Online with Crypto | {brand}',
        description: 'Lady Wolf Moon by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/lady_wolf_moon_megaways': {
        title: 'Play Lady Wolf Moon Megaways by BGaming at {brand} | 6,000x Max Win',
        description: 'Spin Lady Wolf Moon Megaways by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/loki_loot': {
        title: 'Loki Loot by BGaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Loki Loot by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/luck_and_magic': {
        title: 'Luck & Magic Provably Fair Slot by BGaming | {brand}',
        description: 'Luck & Magic from BGaming, with a 1,039x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/lucky_8_merge_up': {
        title: 'Lucky 8 Merge Up by BGaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Lucky 8 Merge Up by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/lucky_blue': {
        title: 'Lucky Blue Slot: Play Online with Crypto | {brand}',
        description: 'Lucky Blue Slot by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/lucky_crew': {
        title: 'Play Lucky Crew by BGaming at {brand} | 3,525x Max Win',
        description: 'Spin Lucky Crew by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/lucky_dama_muerta': {
        title: 'Lucky Dama Muerta Slot by BGaming at {brand} | Instant Crypto Payouts',
        description: 'Lucky Dama Muerta by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/lucky_dragon_multidice_x': {
        title: 'Play Lucky Dragon MultiDice X by BGaming at {brand} | 7,776x Max Win',
        description: 'Spin Lucky Dragon MultiDice X by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/lucky_ducky': {
        title: 'Lucky Ducky Slot by BGaming at {brand} | Instant Crypto Payouts',
        description: 'Lucky Ducky by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/lucky_farm_bonanza': {
        title: 'Lucky Farm Bonanza Provably Fair Slot by BGaming | {brand}',
        description: 'Lucky Farm Bonanza from BGaming, with a 15,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/lucky_ladys_clover': {
        title: "Lucky Lady's Clover by BGaming at {brand} | Free Demo & Crypto Play",
        description: "Play Lucky Lady's Clover by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/bgaming/lucky_lu': {
        title: 'Play Lucky Lu by BGaming at {brand} | 559x Max Win',
        description: 'Spin Lucky Lu by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/lucky_oak': {
        title: 'Play Lucky Oak by BGaming at {brand} | 9,991x Max Win',
        description: 'Play Lucky Oak by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/magic_mummy_megaways': {
        title: 'Play Magic Mummy Megaways by BGaming at {brand} | 5,000x Max Win',
        description: 'Play Magic Mummy Megaways by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/maneki_88_fortunes': {
        title: 'Maneki 88 Fortunes: Play Online with Crypto | {brand}',
        description: 'Maneki 88 Fortunes from BGaming, with a 3,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/maneki_88_gold': {
        title: 'Maneki 88 Gold: Play Online with Crypto | {brand}',
        description: 'Maneki 88 Gold by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/mechanical_clover': {
        title: 'Mechanical Clover Slot by BGaming at {brand} | Instant Crypto Payouts',
        description: 'Mechanical Clover by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/merge_up': {
        title: 'Play Merge Up by BGaming at {brand} | 5,000x Max Win',
        description: 'Play Merge Up by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/merge_up_2': {
        title: 'Merge Up 2 Slot by BGaming at {brand} | Instant Crypto Payouts',
        description: 'Merge Up 2 by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/mice_and_magic_wonder_spin': {
        title: 'Mice and Magic Wonder Spin Slot by BGaming at {brand} | Instant Crypto Payouts',
        description: 'Mice and Magic Wonder Spin from BGaming, with a 2,820x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/miss_cherry_fruits': {
        title: 'Play Miss Cherry Fruits by BGaming at {brand} | 1,000x Max Win',
        description: 'Play Miss Cherry Fruits by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/miss_cherry_fruits_jackpot_party': {
        title: 'Play Miss Cherry Fruits Jackpot Party by BGaming at {brand} | 1,299x Max Win',
        description: 'Spin Miss Cherry Fruits Jackpot Party by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/monster_hunt': {
        title: 'Monster Hunt by BGaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Monster Hunt by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/mummys_gold': {
        title: "Mummy's Gold: Play Online with Crypto | {brand}",
        description: "Mummy's Gold by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/bgaming/mystery_garden': {
        title: 'Mystery Garden Provably Fair Slot by BGaming | {brand}',
        description: 'Mystery Garden by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/mystery_heist': {
        title: 'Mystery Heist: Play Online with Crypto | {brand}',
        description: 'Mystery Heist by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/olympus_trueways': {
        title: 'Play Olympus Trueways by BGaming at {brand} | 5,000x Max Win',
        description: 'Spin Olympus Trueways by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/oof_the_goldmine_planet': {
        title: 'OOF The Goldmine Planet Slot by BGaming at {brand} | Instant Crypto Payouts',
        description: 'OOF The Goldmine Planet by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/panda_fortune_rush': {
        title: 'Panda Fortune Rush Provably Fair Slot by BGaming | {brand}',
        description: 'Panda Fortune Rush from BGaming, with a 1,750x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/panda_luck': {
        title: 'Play Panda Luck by BGaming at {brand} | 2,124x Max Win',
        description: 'Play Panda Luck by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/penalty_duel': {
        title: 'Play Penalty Duel by BGaming at {brand} | 4,860x Max Win',
        description: 'Play Penalty Duel by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/penny_pelican': {
        title: 'Penny Pelican Provably Fair Slot by BGaming | {brand}',
        description: 'Penny Pelican from BGaming, with a 3,525x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/piggy_bank_hold_and_win': {
        title: 'Play Piggy Bank Hold and Win by BGaming at {brand} | 2,500x Max Win',
        description: 'Spin Piggy Bank Hold and Win by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/platinum_lightning': {
        title: 'Platinum Lightning Provably Fair Slot by BGaming | {brand}',
        description: 'Platinum Lightning from BGaming, with a 8,888x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/platinum_lightning_deluxe': {
        title: 'Platinum Lightning Deluxe Slot by BGaming at {brand} | Instant Crypto Payouts',
        description: 'Platinum Lightning Deluxe from BGaming, with a 8,888x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/pop_zen': {
        title: 'Pop Zen Provably Fair Slot by BGaming | {brand}',
        description: 'Pop Zen by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/potion_spells': {
        title: 'Potion Spells Slot by BGaming at {brand} | Instant Crypto Payouts',
        description: 'Potion Spells from BGaming, with a 12,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/princess_of_sky': {
        title: 'Princess Of Sky Slot Provably Fair Slot by BGaming | {brand}',
        description: 'Princess Of Sky Slot from BGaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/recycle_riches': {
        title: 'Recycle Riches by BGaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Recycle Riches by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/retro_trader': {
        title: 'Retro Trader Provably Fair Slot by BGaming | {brand}',
        description: 'Retro Trader from BGaming, with a 3x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/road_2_riches': {
        title: 'Road 2 Riches by BGaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Road 2 Riches by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/robospin': {
        title: 'Robospin by BGaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Robospin by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/rocket_eruption_triple_blast': {
        title: 'Rocket Eruption Triple Blast Slot by BGaming at {brand} | Instant Crypto Payouts',
        description: 'Rocket Eruption Triple Blast from BGaming, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/rotating_element': {
        title: 'Rotating Element Provably Fair Slot by BGaming | {brand}',
        description: 'Rotating Element by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/royal_fruits_multilines': {
        title: 'Play Royal Fruits MultiLines by BGaming at {brand} | 3,000x Max Win',
        description: 'Play Royal Fruits MultiLines by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/royal_highroad': {
        title: 'Play Royal High-Road by BGaming at {brand} | 5,624x Max Win',
        description: 'Play Royal High-Road by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/royal_roulette_500x': {
        title: 'Play Royal Roulette 500x by BGaming at {brand} | 500x Max Win',
        description: 'Play Royal Roulette 500x by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/sakura_riches_60': {
        title: 'Sakura Riches 60 Slot by BGaming at {brand} | Instant Crypto Payouts',
        description: 'Sakura Riches 60 from BGaming, with a 3,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/savage_buffalo_spirit': {
        title: 'Savage Buffalo Spirit: Play Online with Crypto | {brand}',
        description: 'Savage Buffalo Spirit from BGaming, with a 4,684x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/savage_buffalo_spirit_megaways': {
        title: 'Savage Buffalo Spirit Megaways by BGaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Savage Buffalo Spirit Megaways by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/secret_bar_multidice_x': {
        title: 'Play Secret Bar Multidice X by BGaming at {brand} | 2,500x Max Win',
        description: 'Play Secret Bar Multidice X by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/slot_machine': {
        title: 'Play Slot Machine by BGaming at {brand} | 2,124x Max Win',
        description: 'Play Slot Machine by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/snoop_dogg_dollars': {
        title: 'Snoop Dogg Dollars Slot by BGaming at {brand} | Instant Crypto Payouts',
        description: 'Snoop Dogg Dollars by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/soccermania': {
        title: 'Soccermania: Play Online with Crypto | {brand}',
        description: 'Soccermania by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/spin_and_spell': {
        title: 'Spin And Spell: Play Online with Crypto | {brand}',
        description: 'Spin And Spell from BGaming, with a 1,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/street_power': {
        title: 'Street Power: Play Online with Crypto | {brand}',
        description: 'Street Power by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/sugar_mix': {
        title: 'Sugar Mix: Play Online with Crypto | {brand}',
        description: 'Sugar Mix from BGaming, with a 4,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/sweet_rush_megaways': {
        title: 'Play Sweet Rush Megaways by BGaming at {brand} | 12,960x Max Win',
        description: 'Play Sweet Rush Megaways by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/tile_master': {
        title: 'Tile Master Provably Fair Slot by BGaming | {brand}',
        description: 'Tile Master from BGaming, with a 100x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/train_to_rio_grande': {
        title: 'Train to Rio Grande: Play Online with Crypto | {brand}',
        description: 'Train to Rio Grande by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/tramp_day': {
        title: 'Tramp Day: Play Online with Crypto | {brand}',
        description: 'Tramp Day from BGaming, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/tramp_day_trueways': {
        title: 'Tramp Day Trueways by BGaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Tramp Day Trueways by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/treasure_of_anubis': {
        title: 'Treasure of Anubis by BGaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Treasure of Anubis by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/ufo_pyramids': {
        title: 'Play UFO Pyramids by BGaming at {brand} | 5,000x Max Win',
        description: 'Spin UFO Pyramids by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/voodoo_people': {
        title: 'Play Voodoo People by BGaming at {brand} | 7,500x Max Win',
        description: 'Spin Voodoo People by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/wbc_ring_of_riches': {
        title: 'WBC Ring Of Riches by BGaming at {brand} | Free Demo & Crypto Play',
        description: 'Play WBC Ring Of Riches by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/west_town': {
        title: 'Play West Town by BGaming at {brand} | 5,000x Max Win',
        description: 'Play West Town by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/wild_card_gang': {
        title: 'Wild Card Gang Slot by BGaming at {brand} | Instant Crypto Payouts',
        description: 'Wild Card Gang by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/wild_cash': {
        title: 'Play Wild Cash by BGaming at {brand} | 1,039x Max Win',
        description: 'Spin Wild Cash by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/wild_cash_dice': {
        title: 'Wild Cash Dice by BGaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Wild Cash Dice by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/wild_cash_x9990': {
        title: 'Wild Cash x9990 by BGaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Wild Cash x9990 by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/wild_chicago': {
        title: 'Wild Chicago: Play Online with Crypto | {brand}',
        description: 'Wild Chicago by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/wild_clusters': {
        title: 'Wild Clusters by BGaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Wild Clusters by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/wild_heart': {
        title: 'Wild Heart Slot by BGaming at {brand} | Instant Crypto Payouts',
        description: 'Wild Heart by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/wild_moon_thieves': {
        title: 'Wild Moon Thieves Slot by BGaming at {brand} | Instant Crypto Payouts',
        description: 'Wild Moon Thieves from BGaming, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/wild_tiger': {
        title: 'Play Wild Tiger by BGaming at {brand} | 3,000x Max Win',
        description: 'Play Wild Tiger by BGaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/bgaming/wild_west_trueways': {
        title: 'Wild West TRUEWAYS Provably Fair Slot by BGaming | {brand}',
        description: 'Wild West TRUEWAYS by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/wild_wick': {
        title: 'Wild Wick Provably Fair Slot by BGaming | {brand}',
        description: 'Wild Wick from BGaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/winter_fishing_club': {
        title: 'Winter Fishing Club: Play Online with Crypto | {brand}',
        description: 'Winter Fishing Club by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/zeus_goes_wild': {
        title: 'Zeus Goes Wild Provably Fair Slot by BGaming | {brand}',
        description: 'Zeus Goes Wild by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/2_wild_2_die': {
        title: '2 Wild 2 Die by Hacksaw Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin 2 Wild 2 Die by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/aiko_and_the_wind_spirit': {
        title: 'Aiko and the Wind Spirit by Hacksaw Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Aiko and the Wind Spirit by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/alpha_eagle': {
        title: 'Play Alpha Eagle by Hacksaw Gaming at {brand} | 10,000x Max Win',
        description: 'Play Alpha Eagle by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/aztec_twist': {
        title: 'Aztec Twist Slot: Play Online with Crypto | {brand}',
        description: 'Spin Aztec Twist Slot by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/bash_bros': {
        title: 'Play Bash Bros by Hacksaw Gaming at {brand} | 10,000x Max Win',
        description: 'Play Bash Bros by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/beam_boys': {
        title: 'Play Beam Boys by Hacksaw Gaming at {brand} | 12,500x Max Win',
        description: 'Play Beam Boys by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/beast_below': {
        title: 'Play Beast Below by Hacksaw Gaming at {brand} | 10,000x Max Win',
        description: 'Spin Beast Below by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/benny_the_beer': {
        title: 'Play Benny the Beer by Hacksaw Gaming at {brand} | 10,000x Max Win',
        description: 'Spin Benny the Beer by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/bloodthirst': {
        title: 'Bloodthirst xWays Slot by Hacksaw Gaming | {brand}',
        description: 'Bloodthirst from Hacksaw Gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/hacksaw-gaming/book_of_time': {
        title: 'Play Book of Time by Hacksaw Gaming at {brand} | 10,000x Max Win',
        description: 'Spin Book of Time by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/booze_bash': {
        title: 'Booze Bash: Play Online with Crypto | {brand}',
        description: 'Booze Bash from Hacksaw Gaming, with a 12,500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/hacksaw-gaming/born_wild': {
        title: 'Born Wild Slot by Hacksaw Gaming at {brand} | Instant Crypto Payouts',
        description: 'Born Wild from Hacksaw Gaming, with a 2,500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/hacksaw-gaming/bouncy_bombs': {
        title: 'Bouncy Bombs xWays Slot by Hacksaw Gaming | {brand}',
        description: 'Bouncy Bombs from Hacksaw Gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/hacksaw-gaming/break_bones': {
        title: 'Play Break Bones by Hacksaw Gaming at {brand} | 3,333x Max Win',
        description: 'Play Break Bones by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/buffalo_stacknsync': {
        title: "Buffalo Stack'n'Sync: Play Online with Crypto | {brand}",
        description: "Spin Buffalo Stack'n'Sync by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/hacksaw-gaming/bullets_and_bounty': {
        title: 'Play Bullets and Bounty by Hacksaw Gaming at {brand} | 20,000x Max Win',
        description: 'Play Bullets and Bounty by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/cash_compass': {
        title: 'Cash Compass by Hacksaw Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Cash Compass from Hacksaw Gaming. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/hacksaw-gaming/cash_crew': {
        title: 'Cash Crew by Hacksaw Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Cash Crew by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/cash_quest': {
        title: 'Cash Quest xWays Slot by Hacksaw Gaming | {brand}',
        description: 'Cash Quest from Hacksaw Gaming, with a 7,500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/hacksaw-gaming/chaos_crew': {
        title: 'Chaos Crew Slot by Hacksaw Gaming at {brand} | Instant Crypto Payouts',
        description: 'Chaos Crew by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/chaos_crew_2': {
        title: 'Play Chaos Crew 2 by Hacksaw Gaming at {brand} | 20,000x Max Win',
        description: 'Spin Chaos Crew 2 by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/chaos_crew_3': {
        title: 'Chaos Crew 3 Slot by Hacksaw Gaming at {brand} | Instant Crypto Payouts',
        description: 'Chaos Crew 3 by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/circle_of_life': {
        title: 'Circle of Life by Hacksaw Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Circle of Life by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/cloud_princess': {
        title: 'Play Cloud Princess by Hacksaw Gaming at {brand} | 10,000x Max Win',
        description: 'Spin Cloud Princess by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/cubes': {
        title: 'Cubes Slot by Hacksaw Gaming at {brand} | Instant Crypto Payouts',
        description: 'Cubes by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/cubes_2': {
        title: 'Cubes 2: Play Online with Crypto | {brand}',
        description: 'Spin Cubes 2 by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/cursed_seas': {
        title: 'Play Cursed Seas by Hacksaw Gaming at {brand} | 12,500x Max Win',
        description: 'Spin Cursed Seas by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/danny_dollar': {
        title: 'Play Danny Dollar by Hacksaw Gaming at {brand} | 12,500x Max Win',
        description: 'Spin Danny Dollar by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/dark_summoning': {
        title: 'Dark Summoning Slot by Hacksaw Gaming at {brand} | Instant Crypto Payouts',
        description: 'Dark Summoning by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/dawn_of_kings': {
        title: 'Dawn of Kings by Hacksaw Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Dawn of Kings by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/densho': {
        title: 'Densho by Hacksaw Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Densho by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/divine_drop': {
        title: 'Play Divine Drop by Hacksaw Gaming at {brand} | 10,000x Max Win',
        description: 'Play Divine Drop by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/donny_and_danny': {
        title: 'Donny and Danny by Hacksaw Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Donny and Danny by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/donut_division': {
        title: 'Donut Division: Play Online with Crypto | {brand}',
        description: 'Donut Division from Hacksaw Gaming, with a 12,500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/hacksaw-gaming/dork_unit': {
        title: 'Play Dork Unit by Hacksaw Gaming at {brand} | 10,000x Max Win',
        description: 'Play Dork Unit by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/dorks_of_the_deep': {
        title: 'Dorks of the Deep: Play Online with Crypto | {brand}',
        description: 'Dorks of the Deep by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/double_rainbow': {
        title: 'Double Rainbow: Play Online with Crypto | {brand}',
        description: 'Double Rainbow by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/dragons_domain': {
        title: "Play Dragon's Domain by Hacksaw Gaming at {brand} | 10,000x Max Win",
        description: "Spin Dragon's Domain by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/hacksaw-gaming/dropem': {
        title: "Drop'em by Hacksaw Gaming at {brand} | Free Demo & Crypto Play",
        description: "Spin Drop'em by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/hacksaw-gaming/duel_at_dawn': {
        title: 'Duel at Dawn by Hacksaw Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Duel at Dawn by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/dusk_princess': {
        title: 'Play Dusk Princess by Hacksaw Gaming at {brand} | 10,000x Max Win',
        description: 'Play Dusk Princess by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/evil_eyes': {
        title: 'Evil Eyes by Hacksaw Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Evil Eyes by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/eye_of_medusa': {
        title: 'Play Eye of Medusa by Hacksaw Gaming at {brand} | 10,000x Max Win',
        description: 'Spin Eye of Medusa by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/eye_of_the_panda': {
        title: 'Eye of the Panda: Play Online with Crypto | {brand}',
        description: 'Eye of the Panda from Hacksaw Gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/hacksaw-gaming/fear_the_dark': {
        title: 'Play Fear the Dark by Hacksaw Gaming at {brand} | 5,000x Max Win',
        description: 'Play Fear the Dark by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/feel_the_beat': {
        title: 'Play Feel the Beat by Hacksaw Gaming at {brand} | 10,000x Max Win',
        description: 'Spin Feel the Beat by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/fighter_pit': {
        title: 'Play Fighter Pit by Hacksaw Gaming at {brand} | 10,000x Max Win',
        description: 'Spin Fighter Pit by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/fire_my_laser': {
        title: 'Play Fire My Laser by Hacksaw Gaming at {brand} | 15,000x Max Win',
        description: 'Spin Fire My Laser by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/fist_of_destruction': {
        title: 'Play Fist of Destruction by Hacksaw Gaming at {brand} | 10,000x Max Win',
        description: 'Spin Fist of Destruction by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/forest_fortune': {
        title: 'Play Forest Fortune by Hacksaw Gaming at {brand} | 5,000x Max Win',
        description: 'Spin Forest Fortune by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/franks_farm': {
        title: "Frank's Farm Slot by Hacksaw Gaming at {brand} | Instant Crypto Payouts",
        description: "Frank's Farm from Hacksaw Gaming, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/hacksaw-gaming/freds_food_truck': {
        title: "Play Fred's Food Truck by Hacksaw Gaming at {brand} | 10,000x Max Win",
        description: "Play Fred's Food Truck by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/hacksaw-gaming/fruit_duel': {
        title: 'Fruit Duel by Hacksaw Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Fruit Duel by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/frutz': {
        title: 'Frutz xWays Slot by Hacksaw Gaming | {brand}',
        description: 'Play Frutz by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/get_the_cheese': {
        title: 'Get the Cheese: Play Online with Crypto | {brand}',
        description: 'Get the Cheese from Hacksaw Gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/hacksaw-gaming/gladiator_legends': {
        title: 'Gladiator Legends: Play Online with Crypto | {brand}',
        description: 'Gladiator Legends by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/gronks_gems': {
        title: "Gronk's Gems by Hacksaw Gaming at {brand} | Free Demo & Crypto Play",
        description: "Spin Gronk's Gems by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/hacksaw-gaming/hand_of_anubis': {
        title: 'Hand of Anubis xWays Slot by Hacksaw Gaming | {brand}',
        description: 'Hand of Anubis by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/hopnpop': {
        title: 'HopnPop Slot Slot by Hacksaw Gaming at {brand} | Instant Crypto Payouts',
        description: 'HopnPop Slot from Hacksaw Gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/hacksaw-gaming/hot_ross': {
        title: 'Play Hot Ross by Hacksaw Gaming at {brand} | 15,000x Max Win',
        description: 'Spin Hot Ross by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/hounds_of_hell': {
        title: 'Play Hounds of Hell by Hacksaw Gaming at {brand} | 20,000x Max Win',
        description: 'Play Hounds of Hell by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/immortal_desire': {
        title: 'Immortal Desire: Play Online with Crypto | {brand}',
        description: 'Immortal Desire by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/invictus': {
        title: 'Play Invictus by Hacksaw Gaming at {brand} | 10,000x Max Win',
        description: 'Spin Invictus by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/itero': {
        title: 'Play Itero by Hacksaw Gaming at {brand} | 10,000x Max Win',
        description: 'Play Itero by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/joker_bombs': {
        title: 'Play Joker Bombs by Hacksaw Gaming at {brand} | 5,000x Max Win',
        description: 'Spin Joker Bombs by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/keep_em_cool': {
        title: "Keep 'em Cool: Play Online with Crypto | {brand}",
        description: "Keep 'em Cool from Hacksaw Gaming, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/hacksaw-gaming/keepem': {
        title: "Play Keep'em by Hacksaw Gaming at {brand} | 10,000x Max Win",
        description: "Play Keep'em by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/hacksaw-gaming/king_carrot': {
        title: 'Play King Carrot by Hacksaw Gaming at {brand} | 10,000x Max Win',
        description: 'Play King Carrot by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/klowns': {
        title: 'Klowns xWays Slot by Hacksaw Gaming | {brand}',
        description: 'Klowns from Hacksaw Gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/hacksaw-gaming/le_bandit': {
        title: 'Le Bandit xWays Slot by Hacksaw Gaming | {brand}',
        description: 'Le Bandit by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/le_fisherman': {
        title: 'Play Le Fisherman by Hacksaw Gaming at {brand} | 15,000x Max Win',
        description: 'Spin Le Fisherman by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/le_king': {
        title: 'Play Le King by Hacksaw Gaming at {brand} | 20,000x Max Win',
        description: 'Spin Le King by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/le_pharaoh': {
        title: 'Play Le Pharaoh by Hacksaw Gaming at {brand} | 15,000x Max Win',
        description: 'Spin Le Pharaoh by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/le_viking': {
        title: 'Le Viking Slot by Hacksaw Gaming at {brand} | Instant Crypto Payouts',
        description: 'Le Viking from Hacksaw Gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/hacksaw-gaming/le_zeus': {
        title: 'Play Le Zeus by Hacksaw Gaming at {brand} | 20,000x Max Win',
        description: 'Play Le Zeus by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/let_it_snow': {
        title: 'Let it Snow xWays Slot by Hacksaw Gaming | {brand}',
        description: 'Play Let it Snow by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/life_and_death': {
        title: 'Life and Death by Hacksaw Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Life and Death by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/magic_piggy': {
        title: 'Magic Piggy Slot by Hacksaw Gaming at {brand} | Instant Crypto Payouts',
        description: 'Magic Piggy by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/marlin_masters': {
        title: 'Marlin Masters by Hacksaw Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Marlin Masters by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/marlin_masters_the_big_haul': {
        title: 'Play Marlin Masters: The Big Haul by Hacksaw Gaming at {brand} | 10,000x Max Win',
        description: 'Play Marlin Masters: The Big Haul by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/mayan_stackways': {
        title: 'Mayan Stackways by Hacksaw Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Mayan Stackways by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/miami_multiplier': {
        title: 'Miami Multiplier: Play Online with Crypto | {brand}',
        description: 'Spin Miami Multiplier by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/mighty_masks': {
        title: 'Mighty Masks: Play Online with Crypto | {brand}',
        description: 'Mighty Masks from Hacksaw Gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/hacksaw-gaming/mystery_motel': {
        title: 'Mystery Motel: Play Online with Crypto | {brand}',
        description: 'Spin Mystery Motel by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/octo_attack': {
        title: 'Octo Attack Slot by Hacksaw Gaming at {brand} | Instant Crypto Payouts',
        description: 'Octo Attack from Hacksaw Gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/hacksaw-gaming/omnom': {
        title: 'OmNom: Play Online with Crypto | {brand}',
        description: 'OmNom by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/orb_of_destiny': {
        title: 'Orb of Destiny Slot by Hacksaw Gaming at {brand} | Instant Crypto Payouts',
        description: 'Orb of Destiny from Hacksaw Gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/hacksaw-gaming/outlaws_inc': {
        title: 'Outlaws Inc. xWays Slot by Hacksaw Gaming | {brand}',
        description: 'Outlaws Inc. by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/phoenix_duelreels': {
        title: 'Play Phoenix DuelReels by Hacksaw Gaming at {brand} | 10,000x Max Win',
        description: 'Spin Phoenix DuelReels by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/pray_for_six': {
        title: 'Pray for Six by Hacksaw Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Pray for Six by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/pray_for_three': {
        title: 'Play Pray for Three by Hacksaw Gaming at {brand} | 13,333x Max Win',
        description: 'Spin Pray for Three by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/pug_life': {
        title: 'Pug Life by Hacksaw Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Pug Life by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/rad_maxx': {
        title: 'Rad Maxx: Play Online with Crypto | {brand}',
        description: 'Rad Maxx from Hacksaw Gaming, with a 12,500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/hacksaw-gaming/rainbow_princess': {
        title: 'Rainbow Princess xWays Slot by Hacksaw Gaming | {brand}',
        description: 'Rainbow Princess from Hacksaw Gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/hacksaw-gaming/reign_of_rome': {
        title: 'Play Reign of Rome by Hacksaw Gaming at {brand} | 15,000x Max Win',
        description: 'Play Reign of Rome by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/rip_city': {
        title: 'Play RIP City by Hacksaw Gaming at {brand} | 12,500x Max Win',
        description: 'Play RIP City by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/rise_of_ymir': {
        title: 'Rise of Ymir by Hacksaw Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Rise of Ymir by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/rocket_reels': {
        title: 'Rocket Reels xWays Slot by Hacksaw Gaming | {brand}',
        description: 'Rocket Reels from Hacksaw Gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/hacksaw-gaming/ronin_stackways': {
        title: 'Play Ronin Stackways by Hacksaw Gaming at {brand} | 5,000x Max Win',
        description: 'Play Ronin Stackways by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/rotten': {
        title: 'Rotten Slot by Hacksaw Gaming at {brand} | Instant Crypto Payouts',
        description: 'Rotten from Hacksaw Gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/hacksaw-gaming/rusty_and_curly': {
        title: 'Play Rusty and Curly by Hacksaw Gaming at {brand} | 10,000x Max Win',
        description: 'Play Rusty and Curly by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/shaolin_master': {
        title: 'Play Shaolin Master by Hacksaw Gaming at {brand} | 10,000x Max Win',
        description: 'Spin Shaolin Master by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/sixsixsix': {
        title: 'SixSixSix: Play Online with Crypto | {brand}',
        description: 'SixSixSix by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/slayers_inc': {
        title: 'Slayers Inc Slot by Hacksaw Gaming at {brand} | Instant Crypto Payouts',
        description: 'Slayers Inc from Hacksaw Gaming, with a 15,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/hacksaw-gaming/smoking_dragon': {
        title: 'Smoking Dragon Slot by Hacksaw Gaming at {brand} | Instant Crypto Payouts',
        description: 'Smoking Dragon from Hacksaw Gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/hacksaw-gaming/snow_slingers': {
        title: 'Play Snow Slingers by Hacksaw Gaming at {brand} | 10,000x Max Win',
        description: 'Spin Snow Slingers by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/spear_of_athena': {
        title: 'Play Spear of Athena by Hacksaw Gaming at {brand} | 15,000x Max Win',
        description: 'Spin Spear of Athena by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/spinman': {
        title: 'Spinman xWays Slot by Hacksaw Gaming | {brand}',
        description: 'Spinman from Hacksaw Gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/hacksaw-gaming/spinman_hv': {
        title: 'Play Spinman H.V. by Hacksaw Gaming at {brand} | 10,000x Max Win',
        description: 'Play Spinman H.V. by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/stackem': {
        title: "Stack'em Slot by Hacksaw Gaming at {brand} | Instant Crypto Payouts",
        description: "Stack'em from Hacksaw Gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/hacksaw-gaming/steamrunners': {
        title: 'Steamrunners by Hacksaw Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Steamrunners by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/stickem': {
        title: 'StickEm Slot by Hacksaw Gaming at {brand} | Free Demo & Crypto Play',
        description: 'StickEm Slot from Hacksaw Gaming. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/hacksaw-gaming/stormborn': {
        title: 'Stormborn Slot by Hacksaw Gaming at {brand} | Instant Crypto Payouts',
        description: 'Stormborn by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/strength_of_hercules': {
        title: 'Play Strength of Hercules by Hacksaw Gaming at {brand} | 10,000x Max Win',
        description: 'Play Strength of Hercules by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/sun_princess': {
        title: 'Sun Princess Slot by Hacksaw Gaming at {brand} | Instant Crypto Payouts',
        description: 'Sun Princess by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/superstar_sevens': {
        title: 'Superstar Sevens xWays Slot by Hacksaw Gaming | {brand}',
        description: 'Superstar Sevens by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/tasty_treats': {
        title: 'Play Tasty Treats by Hacksaw Gaming at {brand} | 10,000x Max Win',
        description: 'Play Tasty Treats by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/temple_of_torment': {
        title: 'Temple of Torment by Hacksaw Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Temple of Torment by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/the_bowery_boys': {
        title: 'The Bowery Boys xWays Slot by Hacksaw Gaming | {brand}',
        description: 'The Bowery Boys by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/the_count': {
        title: 'Play The Count by Hacksaw Gaming at {brand} | 12,500x Max Win',
        description: 'Spin The Count by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/the_respinners': {
        title: 'The Respinners Slot: Play Online with Crypto | {brand}',
        description: 'Spin The Respinners Slot by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/the_wildwood_curse': {
        title: 'The Wildwood Curse: Play Online with Crypto | {brand}',
        description: 'The Wildwood Curse by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/tiger_legends': {
        title: 'Tiger Legends: Play Online with Crypto | {brand}',
        description: 'Tiger Legends by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/time_spinners': {
        title: 'Time Spinners Slot by Hacksaw Gaming at {brand} | Instant Crypto Payouts',
        description: 'Time Spinners from Hacksaw Gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/hacksaw-gaming/toshi_video_club': {
        title: 'Toshi Video Club xWays Slot by Hacksaw Gaming | {brand}',
        description: 'Toshi Video Club by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/toshi_ways_club': {
        title: 'Toshi Ways Club by Hacksaw Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Toshi Ways Club by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/twisted_lab': {
        title: 'Twisted Lab xWays Slot by Hacksaw Gaming | {brand}',
        description: 'Twisted Lab from Hacksaw Gaming, with a 15,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/hacksaw-gaming/ultimate_slot_of_america': {
        title: 'Ultimate Slot of America by Hacksaw Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Ultimate Slot of America by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/undead_fortune': {
        title: 'Undead Fortune by Hacksaw Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Undead Fortune by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/vending_machine': {
        title: 'Play Vending Machine by Hacksaw Gaming at {brand} | 5,000x Max Win',
        description: 'Spin Vending Machine by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/wanted_dead_or_a_wild': {
        title: 'Play Wanted Dead or a Wild by Hacksaw Gaming at {brand} | 12,500x Max Win',
        description: 'Spin Wanted Dead or a Wild by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/warrior_ways': {
        title: 'Warrior Ways by Hacksaw Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Warrior Ways by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/wings_of_horus': {
        title: 'Wings of Horus Slot: Play Online with Crypto | {brand}',
        description: 'Wings of Horus Slot by Hacksaw Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/hacksaw-gaming/wishbringer': {
        title: 'Wishbringer xWays Slot by Hacksaw Gaming | {brand}',
        description: 'Wishbringer from Hacksaw Gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/hacksaw-gaming/xmas_drop': {
        title: 'Play Xmas Drop by Hacksaw Gaming at {brand} | 12,500x Max Win',
        description: 'Play Xmas Drop by Hacksaw Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/hacksaw-gaming/xpander': {
        title: 'Xpander Slot Slot by Hacksaw Gaming at {brand} | Instant Crypto Payouts',
        description: 'Xpander Slot from Hacksaw Gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/hacksaw-gaming/ze_zeus': {
        title: 'Play Ze Zeus by Hacksaw Gaming at {brand} | 10,000x Max Win',
        description: 'Spin Ze Zeus by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/hacksaw-gaming/zeus_ze_zecond': {
        title: 'Zeus Ze Zecond by Hacksaw Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Zeus Ze Zecond by Hacksaw Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/3_buzzing_wilds': {
        title: '3 Buzzing Wilds: Play Online with Crypto | {brand}',
        description: '3 Buzzing Wilds from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/3_dancing_monkeys': {
        title: '3 Dancing Monkeys Megaways Slot by Pragmatic Play | {brand}',
        description: '3 Dancing Monkeys from Pragmatic Play, with a 12,077x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/3_genie_wishes': {
        title: 'Play 3 Genie Wishes by Pragmatic Play at {brand} | 519x Max Win',
        description: 'Play 3 Genie Wishes by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/3_kingdoms_battle_of_red_cliffs': {
        title: '3 Kingdoms - Battle of Red Cliffs: Play Online with Crypto | {brand}',
        description: '3 Kingdoms - Battle of Red Cliffs from Pragmatic Play, with a 200x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/3_magic_eggs': {
        title: '3 Magic Eggs by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play 3 Magic Eggs by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/5_frozen_charms_megaways': {
        title: 'Play 5 Frozen Charms Megaways by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Play 5 Frozen Charms Megaways by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/5_lions': {
        title: '5 Lions Megaways Slot by Pragmatic Play | {brand}',
        description: '5 Lions from Pragmatic Play, with a 3,520x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/5_lions_dance': {
        title: '5 Lions Dance: Play Online with Crypto | {brand}',
        description: '5 Lions Dance from Pragmatic Play, with a 2,700x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/5_lions_gold': {
        title: 'Play 5 Lions Gold by Pragmatic Play at {brand} | 7,342x Max Win',
        description: 'Spin 5 Lions Gold by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/5_lions_megaways': {
        title: '5 Lions MegaWays by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play 5 Lions MegaWays by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/5_lions_megaways_2': {
        title: '5 Lions Megaways 2 Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: '5 Lions Megaways 2 by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/5_lions_reborn': {
        title: '5 Lions Reborn by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin 5 Lions Reborn by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/5_rabbits_megaways': {
        title: 'Play 5 Rabbits MegaWays by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Spin 5 Rabbits MegaWays by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/6_jokers': {
        title: '6 Jokers: Play Online with Crypto | {brand}',
        description: '6 Jokers from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/7_clovers_of_fortune': {
        title: 'Play 7 Clovers of Fortune by Pragmatic Play at {brand} | 4,454x Max Win',
        description: 'Spin 7 Clovers of Fortune by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/7_monkeys': {
        title: 'Play 7 Monkeys by Pragmatic Play at {brand} | 4,500x Max Win',
        description: 'Play 7 Monkeys by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/7_monkeys_jp': {
        title: '7 Monkeys JP by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: '7 Monkeys JP from Pragmatic Play. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/7_piggies': {
        title: 'Play 7 Piggies by Pragmatic Play at {brand} | 39,000x Max Win',
        description: 'Spin 7 Piggies by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/888_bonanza': {
        title: '888 Bonanza: Play Online with Crypto | {brand}',
        description: 'Spin 888 Bonanza by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/888_dragons': {
        title: '888 Dragons Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: '888 Dragons from Pragmatic Play, with a 100x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/888_gold': {
        title: '888 Gold: Play Online with Crypto | {brand}',
        description: '888 Gold by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/8_dragons': {
        title: '8 Dragons Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: '8 Dragons from Pragmatic Play, with a 7,500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/8_golden_dragon_challenge': {
        title: '8 Golden Dragon Challenge: Play Online with Crypto | {brand}',
        description: 'Spin 8 Golden Dragon Challenge by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/african_elephant': {
        title: 'African Elephant by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play African Elephant by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/aladdin_and_the_sorcerer': {
        title: 'Aladdin and The Sorcerer Megaways Slot by Pragmatic Play | {brand}',
        description: 'Aladdin and The Sorcerer from Pragmatic Play, with a 6,532x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/alien_invaders': {
        title: 'Play Alien Invaders by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Spin Alien Invaders by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/anacoda_gold': {
        title: 'Play Anacoda Gold by Pragmatic Play at {brand} | 10,000x Max Win',
        description: 'Spin Anacoda Gold by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/ancient_egypt': {
        title: 'Play Ancient Egypt by Pragmatic Play at {brand} | 5,511x Max Win',
        description: 'Play Ancient Egypt by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/ancient_egypt_classic': {
        title: 'Ancient Egypt Classic Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Ancient Egypt Classic by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/ancient_island_megaways': {
        title: 'Ancient Island Megaways Megaways Slot by Pragmatic Play | {brand}',
        description: 'Ancient Island Megaways from Pragmatic Play, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/angel_vs_sinner': {
        title: 'Angel vs Sinner: Play Online with Crypto | {brand}',
        description: 'Angel vs Sinner by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/anime_mecha_megaways': {
        title: 'Play Anime Mecha Megaways by Pragmatic Play at {brand} | 40,000x Max Win',
        description: 'Play Anime Mecha Megaways by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/argonauts': {
        title: 'Play Argonauts by Pragmatic Play at {brand} | 10,000x Max Win',
        description: 'Play Argonauts by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/asgard': {
        title: 'Asgard by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin Asgard by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/aztec_blaze': {
        title: 'Play Aztec Blaze by Pragmatic Play at {brand} | 2,000x Max Win',
        description: 'Play Aztec Blaze by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/aztec_bonanza': {
        title: 'Aztec Bonanza: Play Online with Crypto | {brand}',
        description: 'Aztec Bonanza by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/aztec_gems': {
        title: 'Aztec Gems by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin Aztec Gems by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/aztec_gems_deluxe': {
        title: 'Play Aztec Gems Deluxe by Pragmatic Play at {brand} | 22,519x Max Win',
        description: 'Play Aztec Gems Deluxe by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/aztec_gems_megaways': {
        title: 'Aztec Gems Megaways Megaways Slot by Pragmatic Play | {brand}',
        description: 'Aztec Gems Megaways by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/aztec_king': {
        title: 'Aztec King Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Aztec King from Pragmatic Play, with a 10,500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/aztec_king_megaways': {
        title: 'Play Aztec King MegaWays by Pragmatic Play at {brand} | 20,000x Max Win',
        description: 'Play Aztec King MegaWays by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/aztec_powernudge': {
        title: 'Play Aztec Powernudge by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Play Aztec Powernudge by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/aztec_smash': {
        title: 'Play Aztec Smash by Pragmatic Play at {brand} | 9,000x Max Win',
        description: 'Spin Aztec Smash by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/aztec_treasure_hunt': {
        title: 'Aztec Treasure Hunt Megaways Slot by Pragmatic Play | {brand}',
        description: 'Aztec Treasure Hunt from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/badge_blitz': {
        title: 'Badge Blitz: Play Online with Crypto | {brand}',
        description: 'Badge Blitz from Pragmatic Play, with a 3,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/bali_dragon': {
        title: 'Play Bali Dragon by Pragmatic Play at {brand} | 1,040x Max Win',
        description: 'Spin Bali Dragon by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/bandit_megaways': {
        title: 'Bandit Megaways Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Bandit Megaways from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/barn_festival': {
        title: 'Play Barn Festival by Pragmatic Play at {brand} | 20,000x Max Win',
        description: 'Play Barn Festival by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/barnyard_megahays_megaways': {
        title: 'Barnyard Megahays Megaways by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin Barnyard Megahays Megaways by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/bee_keeper': {
        title: 'Bee Keeper: Play Online with Crypto | {brand}',
        description: 'Bee Keeper by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/beware_the_deep_megaways': {
        title: 'Play Beware The Deep Megaways by Pragmatic Play at {brand} | 10,000x Max Win',
        description: 'Play Beware The Deep Megaways by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/big_bass_amazon_xtreme': {
        title: 'Big Bass Amazon Xtreme by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Big Bass Amazon Xtreme from Pragmatic Play. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/big_bass_bonanza': {
        title: 'Play Big Bass Bonanza by Pragmatic Play at {brand} | 2,100x Max Win',
        description: 'Play Big Bass Bonanza by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/big_bass_bonanza_1000': {
        title: 'Big Bass Bonanza 1000: Play Online with Crypto | {brand}',
        description: 'Spin Big Bass Bonanza 1000 by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/big_bass_bonanza_3_reeler': {
        title: 'Big Bass Bonanza 3 Reeler: Play Online with Crypto | {brand}',
        description: 'Spin Big Bass Bonanza 3 Reeler by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/big_bass_bonanza_hold_and_spinner': {
        title: 'Big Bass Bonanza Hold And Spinner Slot Megaways Slot by Pragmatic Play | {brand}',
        description: 'Play Big Bass Bonanza Hold And Spinner Slot by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/big_bass_bonanza_keeping_it_reel': {
        title: 'Big Bass Bonanza Keeping it Reel by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Big Bass Bonanza Keeping it Reel from Pragmatic Play. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/big_bass_bonanza_megaways': {
        title: 'Big Bass Bonanza Megaways by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Big Bass Bonanza Megaways from Pragmatic Play. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/big_bass_bonanza_reel_action': {
        title: 'Big Bass Bonanza Reel Action Megaways Slot by Pragmatic Play | {brand}',
        description: 'Play Big Bass Bonanza Reel Action by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/big_bass_boxing_bonus_round': {
        title: 'Big Bass Boxing Bonus Round Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Big Bass Boxing Bonus Round by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/big_bass_christmas_bash': {
        title: 'Big Bass Christmas Bash: Play Online with Crypto | {brand}',
        description: 'Spin Big Bass Christmas Bash by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/big_bass_christmas_frozen_lake': {
        title: 'Big Bass Christmas Frozen Lake Megaways Slot by Pragmatic Play | {brand}',
        description: 'Play Big Bass Christmas Frozen Lake by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/big_bass_crash': {
        title: 'Play BIg Bass Crash by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Spin BIg Bass Crash by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/big_bass_day_at_the_races': {
        title: 'Big Bass Day At The Races Megaways Slot by Pragmatic Play | {brand}',
        description: 'Play Big Bass Day At The Races by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/big_bass_floats_my_boat': {
        title: 'Big Bass Floats My Boat Megaways Slot by Pragmatic Play | {brand}',
        description: 'Play Big Bass Floats My Boat by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/big_bass_halloween': {
        title: 'Play Big Bass Halloween by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Play Big Bass Halloween by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/big_bass_halloween_2': {
        title: 'Big Bass Halloween 2: Play Online with Crypto | {brand}',
        description: 'Big Bass Halloween 2 by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/big_bass_halloween_3': {
        title: 'Play Big Bass Halloween 3 by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Play Big Bass Halloween 3 by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/big_bass_hold_and_spinner_megaways': {
        title: 'Big Bass Hold and Spinner Megaways Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Big Bass Hold and Spinner Megaways by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/big_bass_mission_fishin': {
        title: "Big Bass Mission Fishin' by Pragmatic Play at {brand} | Free Demo & Crypto Play",
        description: "Big Bass Mission Fishin' from Pragmatic Play. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/pragmatic-play/big_bass_raceday_repeat': {
        title: 'Big Bass Raceday Repeat by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Big Bass Raceday Repeat by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/big_bass_reel_repeat': {
        title: 'Big Bass Reel Repeat: Play Online with Crypto | {brand}',
        description: 'Big Bass Reel Repeat by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/big_bass_return_to_the_races': {
        title: 'Big Bass Return to the Races: Play Online with Crypto | {brand}',
        description: 'Spin Big Bass Return to the Races by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/big_bass_secrets_of_the_golden_lake': {
        title: 'Big Bass Secrets of the Golden Lake Megaways Slot by Pragmatic Play | {brand}',
        description: 'Play Big Bass Secrets of the Golden Lake by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/big_bass_splash': {
        title: 'Big Bass Splash by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Big Bass Splash by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/big_bass_splash_1000': {
        title: 'Big Bass Splash 1000: Play Online with Crypto | {brand}',
        description: 'Spin Big Bass Splash 1000 by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/big_bass_vegas_double_down_deluxe': {
        title: 'Big Bass Vegas Double Down Deluxe Megaways Slot by Pragmatic Play | {brand}',
        description: 'Play Big Bass Vegas Double Down Deluxe by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/big_burger_load_it_up_with_xtra_cheese': {
        title: 'Big Burger Load it up with Xtra cheese Megaways Slot by Pragmatic Play | {brand}',
        description: 'Play Big Burger Load it up with Xtra cheese by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/big_juan': {
        title: 'Big Juan Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Big Juan by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/bigger_barn_house_bonanza': {
        title: 'Bigger Barn House Bonanza Megaways Slot by Pragmatic Play | {brand}',
        description: 'Bigger Barn House Bonanza from Pragmatic Play, with a 25,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/bigger_bass_blizzard_christmas_catch': {
        title: 'Bigger Bass Blizzard Christmas Catch Megaways Slot by Pragmatic Play | {brand}',
        description: 'Play Bigger Bass Blizzard Christmas Catch by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/bigger_bass_bonanza': {
        title: 'Play Bigger Bass Bonanza by Pragmatic Play at {brand} | 4,000x Max Win',
        description: 'Play Bigger Bass Bonanza by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/bigger_bass_splash': {
        title: 'Bigger Bass Splash Megaways Slot by Pragmatic Play | {brand}',
        description: 'Play Bigger Bass Splash by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/bingo_mania': {
        title: 'Play Bingo Mania by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Spin Bingo Mania by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/black_bull': {
        title: 'Black Bull Megaways Slot by Pragmatic Play | {brand}',
        description: 'Black Bull by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/blade_and_fangs': {
        title: 'Play Blade & Fangs by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Play Blade & Fangs by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/blazing_wilds_megaways': {
        title: 'Blazing Wilds Megaways by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Blazing Wilds Megaways by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/blitz_super_wheel': {
        title: 'Blitz Super Wheel Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Blitz Super Wheel from Pragmatic Play, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/bloody_dawn': {
        title: 'Play Bloody Dawn by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Play Bloody Dawn by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/bomb_bonanza': {
        title: 'Play Bomb Bonanza by Pragmatic Play at {brand} | 2,015x Max Win',
        description: 'Play Bomb Bonanza by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/bonanza_gold': {
        title: 'Bonanza Gold by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin Bonanza Gold by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/book_of_aztec_king': {
        title: 'Book of Aztec King Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Book of Aztec King by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/book_of_golden_sands': {
        title: 'Book of Golden Sands Megaways Slot by Pragmatic Play | {brand}',
        description: 'Book of Golden Sands by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/book_of_kingdoms': {
        title: 'Book of Kingdoms: Play Online with Crypto | {brand}',
        description: 'Spin Book of Kingdoms by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/book_of_monsters': {
        title: 'Book of Monsters: Play Online with Crypto | {brand}',
        description: 'Book of Monsters by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/book_of_the_fallen': {
        title: 'Book of the Fallen by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Book of the Fallen by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/bounty_gold': {
        title: 'Play Bounty Gold by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Play Bounty Gold by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/bounty_hunter': {
        title: 'Bounty Hunter by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Bounty Hunter by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/bow_of_artemis': {
        title: 'Bow of Artemis by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin Bow of Artemis by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/brick_house_bonanza': {
        title: 'Brick House Bonanza by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Brick House Bonanza by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/bubble_pop': {
        title: 'Play Bubble Pop by Pragmatic Play at {brand} | 27,000x Max Win',
        description: 'Spin Bubble Pop by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/buffalo_king': {
        title: 'Buffalo King Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Buffalo King from Pragmatic Play, with a 93,750x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/buffalo_king_megaways': {
        title: 'Play Buffalo King MegaWays by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Play Buffalo King MegaWays by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/buffalo_king_untamed_megaways': {
        title: 'Buffalo King Untamed Megaways Megaways Slot by Pragmatic Play | {brand}',
        description: 'Buffalo King Untamed Megaways from Pragmatic Play, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/bull_fiesta': {
        title: 'Bull Fiesta by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin Bull Fiesta by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/busy_bees': {
        title: 'Busy Bees Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Busy Bees by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/caishens_cash': {
        title: "Play Caishen's Cash by Pragmatic Play at {brand} | 21,749x Max Win",
        description: "Play Caishen's Cash by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/pragmatic-play/caishens_gold': {
        title: "Caishen's Gold Slot by Pragmatic Play at {brand} | Instant Crypto Payouts",
        description: "Caishen's Gold from Pragmatic Play, with a 21,749x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/pragmatic-play/candy_blitz': {
        title: 'Candy Blitz: Play Online with Crypto | {brand}',
        description: 'Candy Blitz by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/candy_blitz_bombs': {
        title: 'Candy Blitz Bombs Megaways Slot by Pragmatic Play | {brand}',
        description: 'Candy Blitz Bombs from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/candy_corner': {
        title: 'Candy Corner Megaways Slot by Pragmatic Play | {brand}',
        description: 'Candy Corner by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/candy_jar_cluster': {
        title: 'Play Candy Jar Cluster by Pragmatic Play at {brand} | 10,000x Max Win',
        description: 'Play Candy Jar Cluster by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/candy_stars': {
        title: 'Candy Stars Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Candy Stars by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/candy_village': {
        title: 'Candy Village by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin Candy Village by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/captain_kraken_megaways': {
        title: 'Play Captain Kraken Megaways by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Play Captain Kraken Megaways by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/cash_bonanza': {
        title: 'Cash Bonanza Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Cash Bonanza from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/cash_box': {
        title: 'Cash Box Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Cash Box by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/cash_chips': {
        title: 'Cash Chips: Play Online with Crypto | {brand}',
        description: 'Cash Chips by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/cash_elevator': {
        title: 'Cash Elevator: Play Online with Crypto | {brand}',
        description: 'Spin Cash Elevator by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/cash_patrol': {
        title: 'Play Cash Patrol by Pragmatic Play at {brand} | 10,500x Max Win',
        description: 'Play Cash Patrol by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/cash_surge': {
        title: 'Play Cash Surge by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Spin Cash Surge by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/casino_heist_megaways': {
        title: 'Play Casino Heist Megaways by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Spin Casino Heist Megaways by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/castle_of_fire': {
        title: 'Castle of Fire Megaways Slot by Pragmatic Play | {brand}',
        description: 'Castle of Fire by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/chase_for_glory': {
        title: 'Play Chase for Glory by Pragmatic Play at {brand} | 7,887x Max Win',
        description: 'Spin Chase for Glory by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/cheeky_emperor': {
        title: 'Play Cheeky Emperor by Pragmatic Play at {brand} | 2,500x Max Win',
        description: 'Play Cheeky Emperor by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/chests_of_cai_shen': {
        title: 'Chests of Cai Shen: Play Online with Crypto | {brand}',
        description: 'Chests of Cai Shen from Pragmatic Play, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/chests_of_cai_shen_2': {
        title: 'Chests of Cai Shen 2 by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Chests of Cai Shen 2 by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/chicken_chase': {
        title: 'Chicken Chase by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Chicken Chase by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/chicken_drop': {
        title: 'Chicken Drop Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Chicken Drop from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/chilli_heat': {
        title: 'Play Chilli Heat by Pragmatic Play at {brand} | 2,512x Max Win',
        description: 'Spin Chilli Heat by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/chilli_heat_megaways': {
        title: 'Chilli Heat MegaWays: Play Online with Crypto | {brand}',
        description: 'Chilli Heat MegaWays by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/chilli_heat_spicy_spins': {
        title: 'Chilli Heat Spicy Spins Megaways Slot by Pragmatic Play | {brand}',
        description: 'Chilli Heat Spicy Spins by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/christmas_big_bass_bonanza': {
        title: 'Christmas Big Bass Bonanza by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Christmas Big Bass Bonanza from Pragmatic Play. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/christmas_carol_megaways': {
        title: 'Christmas Carol MegaWays: Play Online with Crypto | {brand}',
        description: 'Christmas Carol MegaWays from Pragmatic Play, with a 20,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/cleocatra': {
        title: 'Play Cleocatra by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Spin Cleocatra by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/clover_gold': {
        title: 'Clover Gold by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin Clover Gold by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/club_tropicana': {
        title: 'Play Club Tropicana by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Spin Club Tropicana by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/club_tropicana_happy_hour': {
        title: 'Club Tropicana Happy Hour by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Club Tropicana Happy Hour by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/coffee_wild': {
        title: 'Coffee Wild Megaways Slot by Pragmatic Play | {brand}',
        description: 'Coffee Wild from Pragmatic Play, with a 4,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/colossal_cash_zone': {
        title: 'Colossal Cash Zone Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Colossal Cash Zone by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/congo_cash': {
        title: 'Congo Cash by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Congo Cash by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/congo_cash_xl': {
        title: 'Congo Cash XL Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Congo Cash XL by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/cosmic_cash': {
        title: 'Play Cosmic Cash by Pragmatic Play at {brand} | 2,650x Max Win',
        description: 'Spin Cosmic Cash by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/cowboy_coins': {
        title: 'Cowboy Coins by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Cowboy Coins by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/cowboys_gold': {
        title: 'Cowboys Gold Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Cowboys Gold from Pragmatic Play, with a 6,065x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/crank_it_up': {
        title: 'Crank It Up: Play Online with Crypto | {brand}',
        description: 'Crank It Up by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/crown_of_fire': {
        title: 'Play Crown of Fire by Pragmatic Play at {brand} | 1,000x Max Win',
        description: 'Spin Crown of Fire by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/crown_of_fire_jackpot_play': {
        title: 'Play Crown of Fire Jackpot Play by Pragmatic Play at {brand} | 1,000x Max Win',
        description: 'Spin Crown of Fire Jackpot Play by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/crystal_caverns_megaways': {
        title: 'Crystal Caverns MegaWays by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Crystal Caverns MegaWays by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/curse_of_the_werewolf_megaways': {
        title: 'Curse of the Werewolf MegaWays: Play Online with Crypto | {brand}',
        description: 'Curse of the Werewolf MegaWays from Pragmatic Play, with a 40,976x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/cyber_heist': {
        title: 'Cyber Heist Megaways Slot by Pragmatic Play | {brand}',
        description: 'Cyber Heist by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/cyberheist_city': {
        title: 'Cyberheist City by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin Cyberheist City by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/cyclops_smash': {
        title: 'Cyclops Smash by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Cyclops Smash by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/dance_party': {
        title: 'Dance Party by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin Dance Party by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/davincis_treasure': {
        title: "DaVinci's Treasure: Play Online with Crypto | {brand}",
        description: "DaVinci's Treasure by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/pragmatic-play/day_of_dead': {
        title: 'Day of Dead Megaways Slot by Pragmatic Play | {brand}',
        description: 'Day of Dead from Pragmatic Play, with a 4,500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/demon_pots': {
        title: 'Demon Pots: Play Online with Crypto | {brand}',
        description: 'Spin Demon Pots by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/devilicious': {
        title: 'Play Devilicious by Pragmatic Play at {brand} | 10,000x Max Win',
        description: 'Spin Devilicious by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/devils_13': {
        title: "Devil's 13 by Pragmatic Play at {brand} | Free Demo & Crypto Play",
        description: "Spin Devil's 13 by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/pragmatic-play/diamond_cascade': {
        title: 'Diamond Cascade Megaways Slot by Pragmatic Play | {brand}',
        description: 'Diamond Cascade from Pragmatic Play, with a 8,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/diamond_strike': {
        title: 'Diamond Strike Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Diamond Strike from Pragmatic Play, with a 1,246x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/diamonds_of_egypt': {
        title: 'Diamonds of Egypt Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Diamonds of Egypt by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/ding_dong_christmas_bells': {
        title: 'Ding Dong Christmas Bells Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Ding Dong Christmas Bells from Pragmatic Play, with a 2,100x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/disco_lady': {
        title: 'Disco Lady Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Disco Lady by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/down_the_rails': {
        title: 'Play Down the Rails by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Spin Down the Rails by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/drago_jewels_of_fortune': {
        title: 'Play Drago - Jewels of Fortune by Pragmatic Play at {brand} | 48,000x Max Win',
        description: 'Play Drago - Jewels of Fortune by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/dragon_gold_88': {
        title: 'Dragon Gold 88 Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Dragon Gold 88 by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/dragon_hero': {
        title: 'Dragon Hero by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin Dragon Hero by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/dragon_hot_hold_and_spin': {
        title: 'Dragon Hot Hold and Spin Megaways Slot by Pragmatic Play | {brand}',
        description: 'Play Dragon Hot Hold and Spin by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/dragon_king_hot_pots': {
        title: 'Dragon King Hot Pots Megaways Slot by Pragmatic Play | {brand}',
        description: 'Play Dragon King Hot Pots by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/dragon_kingdom': {
        title: 'Dragon Kingdom Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Dragon Kingdom by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/dragon_kingdom_eyes_of_fire': {
        title: 'Dragon Kingdom Eyes of Fire: Play Online with Crypto | {brand}',
        description: 'Dragon Kingdom Eyes of Fire from Pragmatic Play, with a 1,250x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/dragon_tiger_fortunes': {
        title: 'Play Dragon Tiger Fortunes by Pragmatic Play at {brand} | 8,200x Max Win',
        description: 'Spin Dragon Tiger Fortunes by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/drill_that_gold': {
        title: 'Play Drill that Gold by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Play Drill that Gold by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/duel_of_night_and_day': {
        title: 'Play Duel of Night and Day by Pragmatic Play at {brand} | 10,000x Max Win',
        description: 'Play Duel of Night and Day by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/dwarf_and_dragon': {
        title: 'Dwarf and Dragon by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Dwarf and Dragon by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/dwarven_gold_deluxe': {
        title: 'Dwarven Gold Deluxe by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin Dwarven Gold Deluxe by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/dynamite_diggin_doug': {
        title: 'Dynamite Diggin Doug Megaways Slot by Pragmatic Play | {brand}',
        description: 'Play Dynamite Diggin Doug by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/egg_rush_jackpot_play': {
        title: 'Egg Rush Jackpot Play: Play Online with Crypto | {brand}',
        description: 'Spin Egg Rush Jackpot Play by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/egyptian_fortunes': {
        title: 'Play Egyptian Fortunes by Pragmatic Play at {brand} | 309x Max Win',
        description: 'Spin Egyptian Fortunes by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/elemental_gems_megaways': {
        title: 'Elemental Gems MegaWays Megaways Slot by Pragmatic Play | {brand}',
        description: 'Elemental Gems MegaWays from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/emerald_king': {
        title: 'Emerald King: Play Online with Crypto | {brand}',
        description: 'Spin Emerald King by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/emerald_king_rainbow_road': {
        title: 'Emerald King Rainbow Road: Play Online with Crypto | {brand}',
        description: 'Spin Emerald King Rainbow Road by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/emperor_caishen': {
        title: 'Play Emperor Caishen by Pragmatic Play at {brand} | 2,500x Max Win',
        description: 'Spin Emperor Caishen by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/empty_the_bank': {
        title: 'Empty the Bank! by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Empty the Bank! by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/escape_the_pyramid_fire_and_ice': {
        title: 'Escape the Pyramid Fire and Ice: Play Online with Crypto | {brand}',
        description: 'Escape the Pyramid Fire and Ice from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/eternal_empress_freeze_time': {
        title: 'Eternal Empress Freeze Time Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Eternal Empress Freeze Time by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/excalibur_unleashed': {
        title: 'Excalibur Unleashed by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Excalibur Unleashed from Pragmatic Play. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/extra_juicy': {
        title: 'Extra Juicy Megaways Slot by Pragmatic Play | {brand}',
        description: 'Extra Juicy from Pragmatic Play, with a 60,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/extra_juicy_megaways': {
        title: 'Extra Juicy MegaWays by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Extra Juicy MegaWays by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/eye_of_cleopatra': {
        title: 'Eye of Cleopatra Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Eye of Cleopatra from Pragmatic Play, with a 4,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/eye_of_spartacus': {
        title: 'Play Eye of Spartacus by Pragmatic Play at {brand} | 10,000x Max Win',
        description: 'Play Eye of Spartacus by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/eye_of_the_storm': {
        title: 'Eye of the Storm by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Eye of the Storm from Pragmatic Play. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/fairytale_fortune': {
        title: 'Fairytale Fortune Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Fairytale Fortune from Pragmatic Play, with a 500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/fangtastic_freespins': {
        title: 'Fangtastic Freespins: Play Online with Crypto | {brand}',
        description: 'Spin Fangtastic Freespins by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/fat_panda': {
        title: 'Play Fat Panda by Pragmatic Play at {brand} | 20,000x Max Win',
        description: 'Play Fat Panda by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/fiesta_fortune': {
        title: 'Fiesta Fortune by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Fiesta Fortune by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/finger_lickn_free_spins': {
        title: "Play Finger Lick'n Free Spins by Pragmatic Play at {brand} | 6,000x Max Win",
        description: "Spin Finger Lick'n Free Spins by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/pragmatic-play/fire_88': {
        title: 'Fire 88 Megaways Slot by Pragmatic Play | {brand}',
        description: 'Fire 88 from Pragmatic Play, with a 902x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/fire_hot_100': {
        title: 'Fire Hot 100 by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin Fire Hot 100 by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/fire_hot_100_jackpot_play': {
        title: 'Fire Hot 100 Jackpot Play: Play Online with Crypto | {brand}',
        description: 'Spin Fire Hot 100 Jackpot Play by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/fire_hot_20': {
        title: 'Fire Hot 20: Play Online with Crypto | {brand}',
        description: 'Fire Hot 20 from Pragmatic Play, with a 1,234x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/fire_hot_20_jackpot_play': {
        title: 'Fire Hot 20 Jackpot Play Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Fire Hot 20 Jackpot Play by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/fire_hot_40': {
        title: 'Fire Hot 40 Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Fire Hot 40 by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/fire_hot_40_jackpot_play': {
        title: 'Fire Hot 40 Jackpot Play Megaways Slot by Pragmatic Play | {brand}',
        description: 'Fire Hot 40 Jackpot Play from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/fire_hot_5': {
        title: 'Fire Hot 5 by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin Fire Hot 5 by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/fire_hot_5_jackpot_play': {
        title: 'Fire Hot 5 Jackpot Play: Play Online with Crypto | {brand}',
        description: 'Spin Fire Hot 5 Jackpot Play by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/fire_portals': {
        title: 'Fire Portals by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin Fire Portals by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/fire_stampede': {
        title: 'Play Fire Stampede by Pragmatic Play at {brand} | 4,275x Max Win',
        description: 'Play Fire Stampede by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/fire_stampede_2': {
        title: 'Fire Stampede 2 Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Fire Stampede 2 by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/fire_stampede_ultimate': {
        title: 'Fire Stampede Ultimate by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Fire Stampede Ultimate by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/fire_strike': {
        title: 'Fire Strike Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Fire Strike by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/fire_strike_2': {
        title: 'Play Fire Strike 2 by Pragmatic Play at {brand} | 25,000x Max Win',
        description: 'Spin Fire Strike 2 by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/fish_eye': {
        title: 'Fish Eye: Play Online with Crypto | {brand}',
        description: 'Spin Fish Eye by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/fishin_reels': {
        title: "Fishin' Reels: Play Online with Crypto | {brand}",
        description: "Fishin' Reels by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/pragmatic-play/floating_dragon': {
        title: 'Play Floating Dragon by Pragmatic Play at {brand} | 3,000x Max Win',
        description: 'Play Floating Dragon by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/floating_dragon_dragon_boat_festival': {
        title: 'Floating Dragon Dragon Boat Festival: Play Online with Crypto | {brand}',
        description: 'Spin Floating Dragon Dragon Boat Festival by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/floating_dragon_hold_and_spin_megaways': {
        title: 'Floating Dragon Hold And Spin Megaways Slot: Play Online with Crypto | {brand}',
        description: 'Spin Floating Dragon Hold And Spin Megaways Slot by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/floating_dragon_megaways': {
        title: 'Floating Dragon Megaways by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Floating Dragon Megaways from Pragmatic Play. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/floating_dragon_new_year_festival_ultra_megaways': {
        title: 'Floating Dragon New Year Festival Ultra Megaways Megaways Slot by Pragmatic Play | {brand}',
        description: 'Play Floating Dragon New Year Festival Ultra Megaways by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/floating_dragon_wild_horses': {
        title: 'Floating Dragon Wild Horses Megaways Slot by Pragmatic Play | {brand}',
        description: 'Play Floating Dragon Wild Horses by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/floating_dragon_year_of_the_snake': {
        title: 'Floating Dragon Year of the Snake Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Floating Dragon Year of the Snake from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/fonzos_feline_fortunes': {
        title: "Fonzo's Feline Fortunes Megaways Slot by Pragmatic Play | {brand}",
        description: "Play Fonzo's Feline Fortunes by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/pragmatic-play/forge_of_olympus': {
        title: 'Forge of Olympus Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Forge of Olympus from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/forging_wilds': {
        title: 'Play Forging Wilds by Pragmatic Play at {brand} | 10,000x Max Win',
        description: 'Spin Forging Wilds by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/fortune_ace': {
        title: 'Fortune Ace: Play Online with Crypto | {brand}',
        description: 'Fortune Ace from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/fortune_ace_scatter': {
        title: 'Play Fortune Ace Scatter by Pragmatic Play at {brand} | 100,000x Max Win',
        description: 'Play Fortune Ace Scatter by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/fortune_hitn_roll': {
        title: "Fortune Hit'n Roll Megaways Slot by Pragmatic Play | {brand}",
        description: "Fortune Hit'n Roll by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/pragmatic-play/fortune_of_giza': {
        title: 'Fortune of Giza Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Fortune of Giza by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/fortune_of_olympus': {
        title: 'Fortune of Olympus Megaways Slot by Pragmatic Play | {brand}',
        description: 'Fortune of Olympus by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/fortunes_of_aztec': {
        title: 'Play Fortunes of Aztec by Pragmatic Play at {brand} | 10,000x Max Win',
        description: 'Spin Fortunes of Aztec by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/frightening_frankie': {
        title: 'Play Frightening Frankie by Pragmatic Play at {brand} | 2,800x Max Win',
        description: 'Spin Frightening Frankie by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/frogs_and_bugs': {
        title: 'Frogs & Bugs Megaways Slot by Pragmatic Play | {brand}',
        description: 'Frogs & Bugs by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/front_runner_odds_on': {
        title: 'Front Runner Odds On by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Front Runner Odds On from Pragmatic Play. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/frozen_tropics': {
        title: 'Frozen Tropics Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Frozen Tropics by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/fruit_party': {
        title: 'Fruit Party Megaways Slot by Pragmatic Play | {brand}',
        description: 'Fruit Party by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/fruit_party_2': {
        title: 'Play Fruit Party 2 by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Spin Fruit Party 2 by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/fruit_rainbow': {
        title: 'Fruit Rainbow: Play Online with Crypto | {brand}',
        description: 'Fruit Rainbow by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/fruity_treats': {
        title: 'Fruity Treats Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Fruity Treats by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/fu_fu_fu': {
        title: 'Fu Fu Fu Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Fu Fu Fu by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/fury_of_odin_megaways': {
        title: 'Play Fury of Odin MegaWays by Pragmatic Play at {brand} | 15,000x Max Win',
        description: 'Play Fury of Odin MegaWays by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/gameshow_party_jackpot_play': {
        title: 'Gameshow Party Jackpot Play: Play Online with Crypto | {brand}',
        description: 'Spin Gameshow Party Jackpot Play by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/gates_of_aztec': {
        title: 'Gates of Aztec by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Gates of Aztec by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/gates_of_gatot_kaca': {
        title: 'Gates of Gatot Kaca Megaways Slot by Pragmatic Play | {brand}',
        description: 'Gates of Gatot Kaca from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/gates_of_gatot_kaca_1000': {
        title: 'Gates of Gatot Kaca 1000 Megaways Slot by Pragmatic Play | {brand}',
        description: 'Gates of Gatot Kaca 1000 from Pragmatic Play, with a 15,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/gates_of_gatot_kaca_super_scatter': {
        title: 'Play Gates of Gatot Kaca Super Scatter by Pragmatic Play at {brand} | 50,000x Max Win',
        description: 'Play Gates of Gatot Kaca Super Scatter by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/gates_of_hades': {
        title: 'Gates of Hades by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Gates of Hades by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/gates_of_olympus': {
        title: 'Play Gates of Olympus by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Play Gates of Olympus by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/gates_of_olympus_1000': {
        title: 'Gates of Olympus 1,000 by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin Gates of Olympus 1,000 by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/gates_of_olympus_dice': {
        title: 'Play Gates of Olympus Dice by Pragmatic Play at {brand} | 15,000x Max Win',
        description: 'Spin Gates of Olympus Dice by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/gates_of_olympus_super_scatter': {
        title: 'Gates of Olympus Super Scatter: Play Online with Crypto | {brand}',
        description: 'Gates of Olympus Super Scatter by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/gates_of_olympus_xmas_1000': {
        title: 'Play Gates of Olympus Xmas 1000 by Pragmatic Play at {brand} | 15,000x Max Win',
        description: 'Play Gates of Olympus Xmas 1000 by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/gates_of_valhalla': {
        title: 'Play Gates of Valhalla by Pragmatic Play at {brand} | 10,000x Max Win',
        description: 'Play Gates of Valhalla by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/gatot_kacas_fury': {
        title: "Play Gatot Kaca's Fury by Pragmatic Play at {brand} | 5,000x Max Win",
        description: "Spin Gatot Kaca's Fury by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/pragmatic-play/gears_of_horus': {
        title: 'Gears of Horus by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Gears of Horus by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/gem_elevator': {
        title: 'Gem Elevator by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin Gem Elevator by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/gem_fire_fortune': {
        title: 'Play Gem Fire Fortune by Pragmatic Play at {brand} | 15,000x Max Win',
        description: 'Play Gem Fire Fortune by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/gem_trio': {
        title: 'Gem Trio by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Gem Trio by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/gems_bonanza': {
        title: 'Play Gems Bonanza by Pragmatic Play at {brand} | 10,000x Max Win',
        description: 'Spin Gems Bonanza by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/gems_of_serengeti': {
        title: 'Gems of Serengeti Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Gems of Serengeti by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/gemstone': {
        title: 'Gemstone: Play Online with Crypto | {brand}',
        description: 'Spin Gemstone by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/genies_gem_bonanza': {
        title: "Genie's Gem Bonanza Megaways Slot by Pragmatic Play | {brand}",
        description: "Genie's Gem Bonanza from Pragmatic Play, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/pragmatic-play/goblin_heist_powernudge': {
        title: 'Play Goblin Heist Powernudge by Pragmatic Play at {brand} | 4,000x Max Win',
        description: 'Play Goblin Heist Powernudge by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/gods_of_giza': {
        title: 'Gods of Giza: Play Online with Crypto | {brand}',
        description: 'Gods of Giza from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/gold_oasis': {
        title: 'Gold Oasis by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Gold Oasis by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/gold_party': {
        title: 'Gold Party Megaways Slot by Pragmatic Play | {brand}',
        description: 'Gold Party by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/gold_party_2_after_hours': {
        title: 'Gold Party 2 After Hours Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Gold Party 2 After Hours by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/gold_train': {
        title: 'Gold Train Megaways Slot by Pragmatic Play | {brand}',
        description: 'Gold Train from Pragmatic Play, with a 513x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/golden_ox': {
        title: 'Golden Ox Megaways Slot by Pragmatic Play | {brand}',
        description: 'Golden Ox by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/golden_pig': {
        title: 'Golden Pig by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Golden Pig by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/good_luck_and_good_fortune': {
        title: 'Good Luck and Good Fortune Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Good Luck and Good Fortune by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/gorilla_mayhem': {
        title: 'Play Gorilla Mayhem by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Play Gorilla Mayhem by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/grace_of_ebisu': {
        title: 'Grace of Ebisu Megaways Slot by Pragmatic Play | {brand}',
        description: 'Grace of Ebisu from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/gravity_bonanza': {
        title: 'Play Gravity Bonanza by Pragmatic Play at {brand} | 10,000x Max Win',
        description: 'Play Gravity Bonanza by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/great_lagoon': {
        title: 'Great Lagoon: Play Online with Crypto | {brand}',
        description: 'Spin Great Lagoon by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/great_reef': {
        title: 'Great Reef by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin Great Reef by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/great_rhino': {
        title: 'Play Great Rhino by Pragmatic Play at {brand} | 900x Max Win',
        description: 'Spin Great Rhino by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/great_rhino_deluxe': {
        title: 'Great Rhino Deluxe by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Great Rhino Deluxe by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/great_rhino_megaways': {
        title: 'Great Rhino MegaWays Megaways Slot by Pragmatic Play | {brand}',
        description: 'Great Rhino MegaWays by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/greedy_fortune_pig': {
        title: 'Greedy Fortune Pig: Play Online with Crypto | {brand}',
        description: 'Greedy Fortune Pig from Pragmatic Play, with a 8,888x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/greedy_wolf': {
        title: 'Greedy Wolf Megaways Slot by Pragmatic Play | {brand}',
        description: 'Greedy Wolf from Pragmatic Play, with a 3,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/greek_gods': {
        title: 'Greek Gods by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin Greek Gods by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/hammerstorm': {
        title: 'Hammerstorm: Play Online with Crypto | {brand}',
        description: 'Hammerstorm by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/hand_of_midas_2': {
        title: 'Hand of Midas 2 Megaways Slot by Pragmatic Play | {brand}',
        description: 'Hand of Midas 2 from Pragmatic Play, with a 8,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/happy_fortune': {
        title: 'Play Happy Fortune by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Spin Happy Fortune by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/heart_of_cleopatra': {
        title: 'Play Heart of Cleopatra by Pragmatic Play at {brand} | 10,000x Max Win',
        description: 'Play Heart of Cleopatra by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/heart_of_rio': {
        title: 'Heart of Rio Megaways Slot by Pragmatic Play | {brand}',
        description: 'Heart of Rio from Pragmatic Play, with a 10,500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/heist_for_the_golden_nuggets': {
        title: 'Heist for the Golden Nuggets by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Heist for the Golden Nuggets from Pragmatic Play. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/hellvis_wild': {
        title: 'Hellvis Wild: Play Online with Crypto | {brand}',
        description: 'Spin Hellvis Wild by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/hercules_and_pegasus': {
        title: 'Hercules and Pegasus by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin Hercules and Pegasus by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/hercules_son_of_zeus': {
        title: 'Play Hercules Son of Zeus by Pragmatic Play at {brand} | 800x Max Win',
        description: 'Play Hercules Son of Zeus by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/heroic_spin': {
        title: 'Heroic Spin: Play Online with Crypto | {brand}',
        description: 'Heroic Spin from Pragmatic Play, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/heroic_spins': {
        title: 'Play Heroic Spins by Pragmatic Play at {brand} | 10,000x Max Win',
        description: 'Spin Heroic Spins by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/high_flyer': {
        title: 'High Flyer: Play Online with Crypto | {brand}',
        description: 'High Flyer by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/himalayan_wild': {
        title: 'Himalayan Wild Megaways Slot by Pragmatic Play | {brand}',
        description: 'Himalayan Wild from Pragmatic Play, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/hockey_attack': {
        title: 'Play Hockey Attack by Pragmatic Play at {brand} | 2,500x Max Win',
        description: 'Play Hockey Attack by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/hokkaido_wolf': {
        title: 'Hokkaido Wolf Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Hokkaido Wolf by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/holiday_ride': {
        title: 'Holiday Ride Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Holiday Ride by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/honey_honey_honey': {
        title: 'Honey Honey Honey: Play Online with Crypto | {brand}',
        description: 'Honey Honey Honey by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/hot_chilli': {
        title: 'Hot Chilli Megaways Slot by Pragmatic Play | {brand}',
        description: 'Hot Chilli by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/hot_fiesta': {
        title: 'Hot Fiesta by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Hot Fiesta by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/hot_pepper': {
        title: 'Hot Pepper by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Hot Pepper by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/hot_safari': {
        title: 'Play Hot Safari by Pragmatic Play at {brand} | 4,000x Max Win',
        description: 'Spin Hot Safari by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/hot_to_burn': {
        title: 'Hot to Burn Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Hot to Burn from Pragmatic Play, with a 1,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/hot_to_burn_7_deadly_free_spins': {
        title: 'Hot to Burn 7 Deadly Free Spins: Play Online with Crypto | {brand}',
        description: 'Spin Hot to Burn 7 Deadly Free Spins by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/hot_to_burn_extreme': {
        title: 'Hot to Burn Extreme: Play Online with Crypto | {brand}',
        description: 'Spin Hot to Burn Extreme by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/hot_to_burn_hold_and_spin': {
        title: 'Hot to Burn Hold and Spin Megaways Slot by Pragmatic Play | {brand}',
        description: 'Play Hot to Burn Hold and Spin by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/hot_to_burn_jackpot_play': {
        title: 'Hot to Burn Jackpot Play: Play Online with Crypto | {brand}',
        description: 'Hot to Burn Jackpot Play by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/hot_to_burn_multiplier': {
        title: 'Hot to Burn Multiplier Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Hot to Burn Multiplier by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/hot_tuna': {
        title: 'Play Hot Tuna by Pragmatic Play at {brand} | 2,500x Max Win',
        description: 'Spin Hot Tuna by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/hundreds_and_thousands': {
        title: 'Hundreds and Thousands Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Hundreds and Thousands by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/ice_lobster': {
        title: 'Ice Lobster Megaways Slot by Pragmatic Play | {brand}',
        description: 'Ice Lobster from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/ice_mint': {
        title: 'Play Ice Mint by Pragmatic Play at {brand} | 10,000x Max Win',
        description: 'Spin Ice Mint by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/infective_wild': {
        title: 'Play Infective Wild by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Spin Infective Wild by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/irish_charms': {
        title: 'Play Irish Charms by Pragmatic Play at {brand} | 3,000x Max Win',
        description: 'Spin Irish Charms by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/jackpot_blaze': {
        title: 'Jackpot Blaze: Play Online with Crypto | {brand}',
        description: 'Jackpot Blaze from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/jackpot_hunter': {
        title: 'Jackpot Hunter Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Jackpot Hunter from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/jade_butterfly': {
        title: 'Play Jade Butterfly by Pragmatic Play at {brand} | 636x Max Win',
        description: 'Play Jade Butterfly by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/jane_hunter_and_the_mask_of_montezuma': {
        title: 'Jane Hunter and the Mask of Montezuma: Play Online with Crypto | {brand}',
        description: 'Jane Hunter and the Mask of Montezuma by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/jasmine_dreams': {
        title: 'Play Jasmine Dreams by Pragmatic Play at {brand} | 2,500x Max Win',
        description: 'Play Jasmine Dreams by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/jewel_rush': {
        title: 'Jewel Rush by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Jewel Rush by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/john_hunter_and_galileos_secrets': {
        title: "John Hunter and Galileo's Secrets Megaways Slot by Pragmatic Play | {brand}",
        description: "John Hunter and Galileo's Secrets by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/pragmatic-play/john_hunter_and_the_aztec_treasure': {
        title: 'Play John Hunter and the Aztec Treasure by Pragmatic Play at {brand} | 10,804x Max Win',
        description: 'Spin John Hunter and the Aztec Treasure by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/john_hunter_and_the_book_of_tut': {
        title: 'John Hunter and the Book of Tut by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play John Hunter and the Book of Tut by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/john_hunter_and_the_book_of_tut_megaways': {
        title: 'John Hunter and the Book of Tut Megaways Megaways Slot by Pragmatic Play | {brand}',
        description: 'John Hunter and the Book of Tut Megaways from Pragmatic Play, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/john_hunter_and_the_book_of_tut_respin': {
        title: 'Play John Hunter and the Book of Tut Respin by Pragmatic Play at {brand} | 4,000x Max Win',
        description: 'Play John Hunter and the Book of Tut Respin by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/john_hunter_and_the_mayan_gods': {
        title: 'John Hunter and the Mayan Gods Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'John Hunter and the Mayan Gods from Pragmatic Play, with a 500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/john_hunter_and_the_quest_for_bermuda_riches': {
        title: 'John Hunter and the Quest for Bermuda Riches Megaways Slot by Pragmatic Play | {brand}',
        description: 'John Hunter and the Quest for Bermuda Riches from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/john_hunter_tomb_of_the_scarab_queen': {
        title: 'John Hunter - Tomb of the Scarab Queen: Play Online with Crypto | {brand}',
        description: 'John Hunter - Tomb of the Scarab Queen by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/joker_jewels_dice': {
        title: 'Play Joker Jewels Dice by Pragmatic Play at {brand} | 1,040x Max Win',
        description: 'Spin Joker Jewels Dice by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/joker_king': {
        title: 'Joker King Megaways Slot by Pragmatic Play | {brand}',
        description: 'Joker King by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/joker_race': {
        title: 'Joker Race by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Joker Race from Pragmatic Play. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/jokers_jewel_hot': {
        title: "Play Joker's Jewel Hot by Pragmatic Play at {brand} | 27,000x Max Win",
        description: "Spin Joker's Jewel Hot by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/pragmatic-play/jokers_jewels': {
        title: "Joker's Jewels Megaways Slot by Pragmatic Play | {brand}",
        description: "Joker's Jewels by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/pragmatic-play/jokers_jewels_cash': {
        title: "Joker's Jewels Cash Slot by Pragmatic Play at {brand} | Instant Crypto Payouts",
        description: "Joker's Jewels Cash by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/pragmatic-play/jokers_jewels_hold_and_spin': {
        title: "Joker's Jewels Hold and Spin by Pragmatic Play at {brand} | Free Demo & Crypto Play",
        description: "Spin Joker's Jewels Hold and Spin by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/pragmatic-play/jokers_jewels_wild': {
        title: "Play Joker's Jewels Wild by Pragmatic Play at {brand} | 1,420x Max Win",
        description: "Spin Joker's Jewels Wild by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/pragmatic-play/journey_to_the_west': {
        title: 'Play Journey to the West by Pragmatic Play at {brand} | 400x Max Win',
        description: 'Spin Journey to the West by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/juicy_fruits': {
        title: 'Play Juicy Fruits by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Spin Juicy Fruits by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/juicy_fruits_multihold': {
        title: 'Juicy Fruits Multihold: Play Online with Crypto | {brand}',
        description: 'Juicy Fruits Multihold by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/jumbo_safari': {
        title: 'Play Jumbo Safari by Pragmatic Play at {brand} | 3,000x Max Win',
        description: 'Play Jumbo Safari by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/jungle_gorilla': {
        title: 'Play Jungle Gorilla by Pragmatic Play at {brand} | 2,806x Max Win',
        description: 'Play Jungle Gorilla by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/king_of_spear': {
        title: 'King of Spear Megaways Slot by Pragmatic Play | {brand}',
        description: 'King of Spear from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/kingdom_of_asgard': {
        title: 'Play Kingdom of Asgard by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Spin Kingdom of Asgard by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/kingdom_of_atlantis_jackpot_play': {
        title: 'Kingdom of Atlantis Jackpot Play Megaways Slot by Pragmatic Play | {brand}',
        description: 'Play Kingdom of Atlantis Jackpot Play by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/kingdom_of_the_dead': {
        title: 'Kingdom of The Dead by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin Kingdom of The Dead by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/knight_hot_spotz': {
        title: 'Play Knight Hot Spotz by Pragmatic Play at {brand} | 2,000x Max Win',
        description: 'Play Knight Hot Spotz by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/knights_vs_barbarians': {
        title: 'Knights vs Barbarians by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin Knights vs Barbarians by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/koi_pond': {
        title: 'Koi Pond Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Koi Pond by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/krakens_sky_bounty': {
        title: "Kraken's Sky Bounty Slot by Pragmatic Play at {brand} | Instant Crypto Payouts",
        description: "Kraken's Sky Bounty by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/pragmatic-play/lady_godiva': {
        title: 'Lady Godiva Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Lady Godiva from Pragmatic Play, with a 2,400x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/lamp_of_infinity': {
        title: 'Lamp Of Infinity Megaways Slot by Pragmatic Play | {brand}',
        description: 'Lamp Of Infinity from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/lava_balls': {
        title: 'Lava Balls: Play Online with Crypto | {brand}',
        description: 'Lava Balls from Pragmatic Play, with a 4,800x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/legend_of_heroes_megaways': {
        title: 'Legend of Heroes MegaWays: Play Online with Crypto | {brand}',
        description: 'Legend of Heroes MegaWays by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/leprechaun_carol': {
        title: 'Leprechaun Carol: Play Online with Crypto | {brand}',
        description: 'Leprechaun Carol from Pragmatic Play, with a 6,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/leprechaun_song': {
        title: 'Leprechaun Song: Play Online with Crypto | {brand}',
        description: 'Leprechaun Song from Pragmatic Play, with a 757x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/little_gem_hold_and_spin': {
        title: 'Little Gem Hold And Spin Slot by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Little Gem Hold And Spin Slot from Pragmatic Play. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/lobster_bobs_crazy_crab_shack': {
        title: "Play Lobster Bob's Crazy Crab Shack by Pragmatic Play at {brand} | 5,000x Max Win",
        description: "Spin Lobster Bob's Crazy Crab Shack by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/pragmatic-play/lobster_bobs_sea_food_and_win_it': {
        title: "Lobster Bob's Sea Food and Win It Megaways Slot by Pragmatic Play | {brand}",
        description: "Play Lobster Bob's Sea Food and Win It by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/pragmatic-play/lobster_house': {
        title: 'Lobster House by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin Lobster House by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/lokis_riches': {
        title: "Loki's Riches Megaways Slot by Pragmatic Play | {brand}",
        description: "Loki's Riches by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/pragmatic-play/lucky_dragon_ball': {
        title: 'Play Lucky Dragon Ball by Pragmatic Play at {brand} | 10,000x Max Win',
        description: 'Play Lucky Dragon Ball by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/lucky_dragons': {
        title: 'Lucky Dragons Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Lucky Dragons from Pragmatic Play, with a 800x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/lucky_fishing_megaways': {
        title: 'Play Lucky Fishing MegaWays by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Spin Lucky Fishing MegaWays by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/lucky_grace_and_charm': {
        title: 'Lucky, Grace and Charm by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Lucky, Grace and Charm from Pragmatic Play. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/lucky_lightning': {
        title: 'Lucky Lightning Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Lucky Lightning by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/lucky_new_year': {
        title: 'Lucky New Year Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Lucky New Year by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/lucky_new_year_tiger_treasures': {
        title: 'Lucky New Year: Tiger Treasures by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Lucky New Year: Tiger Treasures by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/luckys_wild_pub': {
        title: "Play Lucky's Wild Pub by Pragmatic Play at {brand} | 10,000x Max Win",
        description: "Play Lucky's Wild Pub by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/pragmatic-play/madame_destiny': {
        title: 'Madame Destiny by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Madame Destiny by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/madame_destiny_megaways': {
        title: 'Madame Destiny MegaWays Megaways Slot by Pragmatic Play | {brand}',
        description: 'Madame Destiny MegaWays from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/magic_journey': {
        title: 'Magic Journey by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin Magic Journey by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/magic_money_maze': {
        title: 'Magic Money Maze Megaways Slot by Pragmatic Play | {brand}',
        description: 'Play Magic Money Maze by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/magicians_secrets': {
        title: "Play Magician's Secrets by Pragmatic Play at {brand} | 5,000x Max Win",
        description: "Spin Magician's Secrets by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/pragmatic-play/mahjong_panda': {
        title: 'Mahjong Panda Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Mahjong Panda from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/mahjong_wins': {
        title: 'Play Mahjong Wins by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Play Mahjong Wins by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/mahjong_wins_bonus': {
        title: 'Mahjong Wins Bonus by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Mahjong Wins Bonus by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/mahjong_wins_super_scatter': {
        title: 'Mahjong Wins Super Scatter: Play Online with Crypto | {brand}',
        description: 'Mahjong Wins Super Scatter by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/mahjong_x': {
        title: 'Mahjong X: Play Online with Crypto | {brand}',
        description: 'Mahjong X by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/majestic_express_gold_run': {
        title: 'Play Majestic Express Gold Run by Pragmatic Play at {brand} | 20,000x Max Win',
        description: 'Play Majestic Express Gold Run by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/mammoth_gold_megaways': {
        title: 'Mammoth Gold MegaWays Megaways Slot by Pragmatic Play | {brand}',
        description: 'Mammoth Gold MegaWays from Pragmatic Play, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/master_chens_fortune': {
        title: "Master Chen's Fortune by Pragmatic Play at {brand} | Free Demo & Crypto Play",
        description: "Spin Master Chen's Fortune by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/pragmatic-play/master_joker': {
        title: 'Play Master Joker by Pragmatic Play at {brand} | 10,000x Max Win',
        description: 'Spin Master Joker by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/medusas_stone': {
        title: "Medusa's Stone by Pragmatic Play at {brand} | Free Demo & Crypto Play",
        description: "Spin Medusa's Stone by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/pragmatic-play/mermaids_treasure_love': {
        title: "Mermaid's Treasure Love Slot by Pragmatic Play at {brand} | Instant Crypto Payouts",
        description: "Mermaid's Treasure Love from Pragmatic Play, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/pragmatic-play/might_of_freya_megaways': {
        title: 'Might of Freya Megaways by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Might of Freya Megaways by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/might_of_ra': {
        title: 'Might of Ra Megaways Slot by Pragmatic Play | {brand}',
        description: 'Might of Ra by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/mighty_kong': {
        title: 'Play Mighty Kong by Pragmatic Play at {brand} | 955x Max Win',
        description: 'Spin Mighty Kong by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/mighty_munching_melons': {
        title: 'Mighty Munching Melons Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Mighty Munching Melons by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/mining_rush': {
        title: 'Mining Rush: Play Online with Crypto | {brand}',
        description: 'Mining Rush by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/mochimon': {
        title: 'Mochimon by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin Mochimon by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/moleionaire': {
        title: 'Play Moleionaire by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Play Moleionaire by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/money_money_money': {
        title: 'Play Money Money Money by Pragmatic Play at {brand} | 88x Max Win',
        description: 'Spin Money Money Money by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/money_mouse': {
        title: 'Play Money Mouse by Pragmatic Play at {brand} | 2,500x Max Win',
        description: 'Spin Money Mouse by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/money_roll': {
        title: 'Money Roll by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Money Roll by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/money_stacks': {
        title: 'Money Stacks by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin Money Stacks by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/money_stacks_megaways': {
        title: 'Money Stacks Megaways Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Money Stacks Megaways by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/monkey_king_rush': {
        title: 'Monkey King Rush by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Monkey King Rush by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/monkey_madness': {
        title: 'Monkey Madness Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Monkey Madness by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/monkey_warrior': {
        title: 'Play Monkey Warrior by Pragmatic Play at {brand} | 6,080x Max Win',
        description: 'Spin Monkey Warrior by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/monster_superlanche': {
        title: 'Monster Superlanche Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Monster Superlanche from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/moonshot': {
        title: 'Moonshot Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Moonshot by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/muertos_multiplier_megaways': {
        title: 'Play Muertos Multiplier MegaWays by Pragmatic Play at {brand} | 10,000x Max Win',
        description: 'Play Muertos Multiplier MegaWays by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/multihand_blackjack': {
        title: 'Multihand Blackjack Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Multihand Blackjack by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/mummys_jewels': {
        title: "Mummy's Jewels Slot by Pragmatic Play at {brand} | Instant Crypto Payouts",
        description: "Mummy's Jewels from Pragmatic Play, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/pragmatic-play/mummys_jewels_100': {
        title: "Mummy's Jewels 100: Play Online with Crypto | {brand}",
        description: "Mummy's Jewels 100 by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/pragmatic-play/mustang_gold': {
        title: 'Play Mustang Gold by Pragmatic Play at {brand} | 12,000x Max Win',
        description: 'Spin Mustang Gold by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/mustang_gold_megaways': {
        title: 'Mustang Gold Megaways Megaways Slot by Pragmatic Play | {brand}',
        description: 'Mustang Gold Megaways by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/mustang_trail': {
        title: 'Play Mustang Trail by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Play Mustang Trail by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/mysterious': {
        title: 'Play Mysterious by Pragmatic Play at {brand} | 9,648x Max Win',
        description: 'Spin Mysterious by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/mysterious_egypt': {
        title: 'Play Mysterious Egypt by Pragmatic Play at {brand} | 5,533x Max Win',
        description: 'Spin Mysterious Egypt by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/mystery_mice': {
        title: 'Play Mystery Mice by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Spin Mystery Mice by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/mystic_chief': {
        title: 'Mystic Chief: Play Online with Crypto | {brand}',
        description: 'Mystic Chief from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/nile_fortune': {
        title: 'Play Nile Fortune by Pragmatic Play at {brand} | 2,500x Max Win',
        description: 'Spin Nile Fortune by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/north_guardians': {
        title: 'North Guardians by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play North Guardians by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/octobeer_fortunes': {
        title: 'Octobeer Fortunes by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin Octobeer Fortunes by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/old_gold_miner_megaways': {
        title: 'Old Gold Miner MegaWays Megaways Slot by Pragmatic Play | {brand}',
        description: 'Old Gold Miner MegaWays from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/oodles_of_noodles': {
        title: 'Oodles of Noodles by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Oodles of Noodles from Pragmatic Play. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/oracle_of_gold': {
        title: 'Oracle of Gold: Play Online with Crypto | {brand}',
        description: 'Oracle of Gold by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/pandas_fortune': {
        title: "Panda's Fortune Slot by Pragmatic Play at {brand} | Instant Crypto Payouts",
        description: "Panda's Fortune by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/pragmatic-play/pandas_fortune_2': {
        title: "Play Panda's Fortune 2 by Pragmatic Play at {brand} | 5,000x Max Win",
        description: "Spin Panda's Fortune 2 by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/pragmatic-play/pandemic_rising': {
        title: 'Play Pandemic Rising by Pragmatic Play at {brand} | 14,000x Max Win',
        description: 'Play Pandemic Rising by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/peking_luck': {
        title: 'Play Peking Luck by Pragmatic Play at {brand} | 180,000x Max Win',
        description: 'Play Peking Luck by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/penguins_christmas_party_time': {
        title: 'Penguins Christmas Party Time Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Penguins Christmas Party Time by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/peppes_pepperoni_pizza_plaza': {
        title: "Peppe's Pepperoni Pizza Plaza: Play Online with Crypto | {brand}",
        description: "Spin Peppe's Pepperoni Pizza Plaza by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/pragmatic-play/phoenix_forge': {
        title: 'Phoenix Forge: Play Online with Crypto | {brand}',
        description: 'Phoenix Forge by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/piggy_bank_bills': {
        title: 'Piggy Bank Bills by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Piggy Bank Bills by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/piggy_bankers': {
        title: 'Piggy Bankers: Play Online with Crypto | {brand}',
        description: 'Piggy Bankers by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/pinup_girls': {
        title: 'Pinup Girls by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Pinup Girls by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/pirate_gold': {
        title: 'Play Pirate Gold by Pragmatic Play at {brand} | 32,270x Max Win',
        description: 'Spin Pirate Gold by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/pirate_gold_deluxe': {
        title: 'Play Pirate Gold Deluxe by Pragmatic Play at {brand} | 15,000x Max Win',
        description: 'Play Pirate Gold Deluxe by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/pirate_golden_age': {
        title: 'Pirate Golden Age: Play Online with Crypto | {brand}',
        description: 'Pirate Golden Age by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/pirates_pub': {
        title: 'Pirates Pub by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Pirates Pub by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/pixie_wings': {
        title: 'Play Pixie Wings by Pragmatic Play at {brand} | 500x Max Win',
        description: 'Play Pixie Wings by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/pizza_pizza_pizza': {
        title: 'PIZZA PIZZA PIZZA: Play Online with Crypto | {brand}',
        description: 'Spin PIZZA PIZZA PIZZA by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/pompeii_megareels_megaways': {
        title: 'Play Pompeii Megareels Megaways by Pragmatic Play at {brand} | 10,000x Max Win',
        description: 'Spin Pompeii Megareels Megaways by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/pot_of_fortune': {
        title: 'Pot of Fortune Megaways Slot by Pragmatic Play | {brand}',
        description: 'Pot of Fortune by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/power_ball_1_min': {
        title: 'Power Ball 1 min: Play Online with Crypto | {brand}',
        description: 'Spin Power Ball 1 min by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/power_ball_2_min': {
        title: 'Power Ball 2 min Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Power Ball 2 min by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/power_ball_3_min': {
        title: 'Power Ball 3 min Megaways Slot by Pragmatic Play | {brand}',
        description: 'Play Power Ball 3 min by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/power_ball_4_min': {
        title: 'Power Ball 4 min by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Power Ball 4 min from Pragmatic Play. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/power_ball_5_min': {
        title: 'Power Ball 5 min: Play Online with Crypto | {brand}',
        description: 'Spin Power Ball 5 min by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/power_of_merlin_megaways': {
        title: 'Power of Merlin Megaways Megaways Slot by Pragmatic Play | {brand}',
        description: 'Play Power of Merlin Megaways by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/power_of_ninja': {
        title: 'Play Power of Ninja by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Play Power of Ninja by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/power_of_thor_megaways': {
        title: 'Play Power of Thor MegaWays by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Play Power of Thor MegaWays by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/pub_kings': {
        title: 'Pub Kings by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin Pub Kings by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/pyramid_bonanza': {
        title: 'Pyramid Bonanza by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin Pyramid Bonanza by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/pyramid_king': {
        title: 'Play Pyramid King by Pragmatic Play at {brand} | 2,500x Max Win',
        description: 'Spin Pyramid King by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/queen_of_gods': {
        title: 'Play Queen of Gods by Pragmatic Play at {brand} | 1,839x Max Win',
        description: 'Spin Queen of Gods by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/queenie': {
        title: 'Queenie: Play Online with Crypto | {brand}',
        description: 'Spin Queenie by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/raging_bull': {
        title: 'Play Raging Bull by Pragmatic Play at {brand} | 7,342x Max Win',
        description: 'Play Raging Bull by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/raging_waterfall_megaways': {
        title: 'Play Raging Waterfall Megaways by Pragmatic Play at {brand} | 10,000x Max Win',
        description: 'Play Raging Waterfall Megaways by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/rainbow_gold': {
        title: 'Rainbow Gold: Play Online with Crypto | {brand}',
        description: 'Rainbow Gold from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/rainbow_reels': {
        title: 'Rainbow Reels by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Rainbow Reels by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/reel_banks': {
        title: 'Play Reel Banks by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Spin Reel Banks by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/release_the_bison': {
        title: 'Release the Bison Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Release the Bison from Pragmatic Play, with a 3,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/release_the_kraken': {
        title: 'Play Release the Kraken by Pragmatic Play at {brand} | 10,000x Max Win',
        description: 'Play Release the Kraken by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/release_the_kraken_2': {
        title: 'Release the Kraken 2 Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Release the Kraken 2 by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/release_the_kraken_megaways': {
        title: 'Release the Kraken Megaways Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Release the Kraken Megaways from Pragmatic Play, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/resurrecting_riches': {
        title: 'Resurrecting Riches by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Resurrecting Riches by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/return_of_the_dead': {
        title: 'Return of the Dead Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Return of the Dead by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/revenge_of_loki_megaways': {
        title: 'Revenge of Loki Megaways: Play Online with Crypto | {brand}',
        description: 'Revenge of Loki Megaways from Pragmatic Play, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/ride_the_lightning': {
        title: 'Ride the Lightning Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Ride the Lightning from Pragmatic Play, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/ripe_rewards': {
        title: 'Ripe Rewards Megaways Slot by Pragmatic Play | {brand}',
        description: 'Ripe Rewards from Pragmatic Play, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/rise_of_giza_powernudge': {
        title: 'Play Rise of Giza PowerNudge by Pragmatic Play at {brand} | 4,000x Max Win',
        description: 'Spin Rise of Giza PowerNudge by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/rise_of_pyramids': {
        title: 'Rise of Pyramids Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Rise of Pyramids from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/rise_of_samurai': {
        title: 'Rise of Samurai by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin Rise of Samurai by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/rise_of_samurai_4': {
        title: 'Rise of Samurai 4 Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Rise of Samurai 4 by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/rise_of_samurai_iii': {
        title: 'Play Rise of Samurai III by Pragmatic Play at {brand} | 10,000x Max Win',
        description: 'Play Rise of Samurai III by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/rise_of_samurai_megaways': {
        title: 'Rise of Samurai MegaWays Megaways Slot by Pragmatic Play | {brand}',
        description: 'Rise of Samurai MegaWays by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/robber_strike': {
        title: 'Robber Strike Megaways Slot by Pragmatic Play | {brand}',
        description: 'Robber Strike by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/rock_vegas': {
        title: 'Rock Vegas Megaways Slot by Pragmatic Play | {brand}',
        description: 'Play Rock Vegas by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/rocket_blast_megaways': {
        title: 'Play Rocket Blast Megaways by Pragmatic Play at {brand} | 10,000x Max Win',
        description: 'Play Rocket Blast Megaways by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/rolling_in_treasures': {
        title: 'Play Rolling in Treasures by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Play Rolling in Treasures by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/rujak_bonanza': {
        title: 'Rujak Bonanza Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Rujak Bonanza by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/running_sushi': {
        title: 'Running Sushi by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin Running Sushi by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/safari_king': {
        title: 'Safari King by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin Safari King by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/saiyan_mania': {
        title: 'Saiyan Mania by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin Saiyan Mania by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/samurai_code': {
        title: 'Samurai Code Megaways Slot by Pragmatic Play | {brand}',
        description: 'Play Samurai Code by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/santa': {
        title: 'Santa Megaways Slot by Pragmatic Play | {brand}',
        description: 'Santa from Pragmatic Play, with a 451x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/santas_great_gifts': {
        title: "Santa's Great Gifts by Pragmatic Play at {brand} | Free Demo & Crypto Play",
        description: "Play Santa's Great Gifts by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/pragmatic-play/santas_slay': {
        title: "Play Santa's Slay by Pragmatic Play at {brand} | 2,000x Max Win",
        description: "Spin Santa's Slay by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/pragmatic-play/santas_wonderland': {
        title: "Santa's Wonderland Slot by Pragmatic Play at {brand} | Instant Crypto Payouts",
        description: "Santa's Wonderland by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/pragmatic-play/santas_xmas_rush': {
        title: "Santa's Xmas Rush Slot by Pragmatic Play at {brand} | Instant Crypto Payouts",
        description: "Santa's Xmas Rush by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/pragmatic-play/savannah_legend': {
        title: 'Play Savannah Legend by Pragmatic Play at {brand} | 10,000x Max Win',
        description: 'Play Savannah Legend by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/sea_fantasy': {
        title: 'Play Sea Fantasy by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Spin Sea Fantasy by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/secret_city_gold': {
        title: 'Secret City Gold Megaways Slot by Pragmatic Play | {brand}',
        description: 'Secret City Gold from Pragmatic Play, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/shield_of_sparta': {
        title: 'Shield of Sparta: Play Online with Crypto | {brand}',
        description: 'Shield of Sparta from Pragmatic Play, with a 3,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/shining_hot_100': {
        title: 'Play Shining Hot 100 by Pragmatic Play at {brand} | 2,500x Max Win',
        description: 'Play Shining Hot 100 by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/shining_hot_100_jackpot_play': {
        title: 'Shining Hot 100 Jackpot Play Megaways Slot by Pragmatic Play | {brand}',
        description: 'Play Shining Hot 100 Jackpot Play by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/shining_hot_20': {
        title: 'Shining Hot 20: Play Online with Crypto | {brand}',
        description: 'Shining Hot 20 by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/shining_hot_20_jackpot_play': {
        title: 'Shining Hot 20 Jackpot play by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Shining Hot 20 Jackpot play from Pragmatic Play. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/shining_hot_40': {
        title: 'Shining Hot 40 Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Shining Hot 40 from Pragmatic Play, with a 2,500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/shining_hot_40_jackpot_play': {
        title: 'Shining Hot 40 Jackpot Play Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Shining Hot 40 Jackpot Play by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/shining_hot_5': {
        title: 'Shining Hot 5 by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Shining Hot 5 by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/shining_hot_5_jackpot_play': {
        title: 'Shining Hot 5 Jackpot Play Megaways Slot by Pragmatic Play | {brand}',
        description: 'Play Shining Hot 5 Jackpot Play by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/sleeping_dragon': {
        title: 'Sleeping Dragon Megaways Slot by Pragmatic Play | {brand}',
        description: 'Sleeping Dragon by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/smugglers_cove': {
        title: 'Smugglers Cove Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Smugglers Cove from Pragmatic Play, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/snakes_and_ladders_megadice': {
        title: 'Snakes and Ladders Megadice Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Snakes and Ladders Megadice by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/snakes_and_ladders_snake_eyes': {
        title: 'Snakes and Ladders Snake Eyes Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Snakes and Ladders Snake Eyes by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/spartan_king': {
        title: 'Spartan King: Play Online with Crypto | {brand}',
        description: 'Spartan King by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/spellbinding_mystery': {
        title: 'Spellbinding Mystery by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spellbinding Mystery from Pragmatic Play. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/spellmaster': {
        title: 'Play Spellmaster by Pragmatic Play at {brand} | 40,000x Max Win',
        description: 'Spin Spellmaster by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/spin_and_score_megaways': {
        title: 'Play Spin and Score MegaWays by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Play Spin and Score MegaWays by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/spirit_of_adventure': {
        title: 'Spirit of adventure: Play Online with Crypto | {brand}',
        description: 'Spin Spirit of adventure by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/star_bounty': {
        title: 'Play Star Bounty by Pragmatic Play at {brand} | 25,920x Max Win',
        description: 'Play Star Bounty by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/star_pirates_code': {
        title: 'Star Pirates Code Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Star Pirates Code by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/starlight_archer_1000': {
        title: 'Starlight Archer 1000 by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Starlight Archer 1000 by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/starlight_christmas': {
        title: 'Starlight Christmas Megaways Slot by Pragmatic Play | {brand}',
        description: 'Starlight Christmas by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/starlight_princess': {
        title: 'Starlight Princess by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Starlight Princess by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/starlight_princess_1000': {
        title: 'Play Starlight Princess 1000 by Pragmatic Play at {brand} | 15,000x Max Win',
        description: 'Spin Starlight Princess 1000 by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/starlight_princess_pachi': {
        title: 'Starlight Princess Pachi by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Starlight Princess Pachi by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/starlight_princess_super_scatter': {
        title: 'Starlight Princess Super Scatter Megaways Slot by Pragmatic Play | {brand}',
        description: 'Starlight Princess Super Scatter by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/starz_megaways': {
        title: 'Starz MegaWays: Play Online with Crypto | {brand}',
        description: 'Starz MegaWays from Pragmatic Play, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/sticky_bees': {
        title: 'Sticky Bees Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Sticky Bees by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/strawberry_cocktail': {
        title: 'Play Strawberry Cocktail by Pragmatic Play at {brand} | 16,000x Max Win',
        description: 'Play Strawberry Cocktail by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/street_racer': {
        title: 'Street Racer: Play Online with Crypto | {brand}',
        description: 'Street Racer from Pragmatic Play, with a 2,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/striking_hot_5': {
        title: 'Striking Hot 5 Megaways Slot by Pragmatic Play | {brand}',
        description: 'Striking Hot 5 by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/striking_hot_5_jackpot_play': {
        title: 'Striking Hot 5 Jackpot Play by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Striking Hot 5 Jackpot Play from Pragmatic Play. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/sugar_rush': {
        title: 'Sugar Rush Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Sugar Rush from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/sugar_rush_1000': {
        title: 'Sugar Rush 1000 Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Sugar Rush 1000 from Pragmatic Play, with a 25,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/sugar_rush_super_scatter': {
        title: 'Sugar Rush Super Scatter by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Sugar Rush Super Scatter by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/sugar_rush_xmas': {
        title: 'Sugar Rush Xmas Megaways Slot by Pragmatic Play | {brand}',
        description: 'Sugar Rush Xmas from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/sugar_supreme_powernudge': {
        title: 'Sugar Supreme Powernudge Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Sugar Supreme Powernudge from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/sumo_supreme_megaways': {
        title: 'Sumo Supreme Megaways Megaways Slot by Pragmatic Play | {brand}',
        description: 'Sumo Supreme Megaways by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/super_7s': {
        title: 'Play Super 7s by Pragmatic Play at {brand} | 1,000x Max Win',
        description: 'Play Super 7s by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/super_joker': {
        title: 'Super Joker: Play Online with Crypto | {brand}',
        description: 'Super Joker by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/super_tiki_strike': {
        title: 'Play Super Tiki Strike by Pragmatic Play at {brand} | 50,000x Max Win',
        description: 'Spin Super Tiki Strike by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/super_x': {
        title: 'Super X by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Super X by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/supermania': {
        title: 'Supermania Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Supermania by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/sweet_bonanza': {
        title: 'Sweet Bonanza by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin Sweet Bonanza by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/sweet_bonanza_1000': {
        title: 'Play Sweet Bonanza 1000 by Pragmatic Play at {brand} | 25,000x Max Win',
        description: 'Play Sweet Bonanza 1000 by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/sweet_bonanza_dice': {
        title: 'Play Sweet Bonanza Dice by Pragmatic Play at {brand} | 21,175x Max Win',
        description: 'Play Sweet Bonanza Dice by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/sweet_bonanza_super_scatter': {
        title: 'Sweet Bonanza Super Scatter: Play Online with Crypto | {brand}',
        description: 'Sweet Bonanza Super Scatter from Pragmatic Play, with a 50,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/sweet_bonanza_xmas': {
        title: 'Play Sweet Bonanza Xmas by Pragmatic Play at {brand} | 21,175x Max Win',
        description: 'Play Sweet Bonanza Xmas by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/sweet_craze': {
        title: 'Sweet Craze by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin Sweet Craze by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/sweet_kingdom': {
        title: 'Play Sweet Kingdom by Pragmatic Play at {brand} | 10,000x Max Win',
        description: 'Play Sweet Kingdom by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/sweet_powernudge': {
        title: 'Sweet Powernudge Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Sweet Powernudge from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/sweet_rush_bonanza': {
        title: 'Sweet Rush Bonanza Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Sweet Rush Bonanza from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/sword_of_ares': {
        title: 'Sword of Ares: Play Online with Crypto | {brand}',
        description: 'Sword of Ares from Pragmatic Play, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/temple_guardians': {
        title: 'Play Temple Guardians by Pragmatic Play at {brand} | 10,000x Max Win',
        description: 'Play Temple Guardians by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/temujin_treasures': {
        title: 'Temujin Treasures Megaways Slot by Pragmatic Play | {brand}',
        description: 'Temujin Treasures by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/the_alter_ego': {
        title: 'Play The Alter Ego by Pragmatic Play at {brand} | 10,000x Max Win',
        description: 'Spin The Alter Ego by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/the_amazing_money_machine': {
        title: 'The Amazing Money Machine Slot by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play The Amazing Money Machine Slot by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/the_big_dawgs': {
        title: 'The Big Dawgs Megaways Slot by Pragmatic Play | {brand}',
        description: 'The Big Dawgs from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/the_dog_house': {
        title: 'The Dog House Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'The Dog House by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/the_dog_house_dice_show': {
        title: 'The Dog House Dice Show: Play Online with Crypto | {brand}',
        description: 'The Dog House Dice Show from Pragmatic Play, with a 6,750x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/the_dog_house_dog_or_alive': {
        title: 'Play The Dog House - Dog or Alive by Pragmatic Play at {brand} | 10,000x Max Win',
        description: 'Play The Dog House - Dog or Alive by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/the_dog_house_megaways': {
        title: 'Play The Dog House MegaWays by Pragmatic Play at {brand} | 12,305x Max Win',
        description: 'Spin The Dog House MegaWays by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/the_dog_house_muttley_crew': {
        title: 'The Dog House Muttley Crew by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play The Dog House Muttley Crew by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/the_dog_house_royal_hunt': {
        title: 'The Dog House Royal Hunt Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'The Dog House Royal Hunt by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/the_dragon_tiger': {
        title: 'The Dragon Tiger Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'The Dragon Tiger from Pragmatic Play, with a 18,125x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/the_great_chicken_escape': {
        title: 'The Great Chicken Escape: Play Online with Crypto | {brand}',
        description: 'The Great Chicken Escape by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/the_great_stickup': {
        title: 'The Great Stick-Up: Play Online with Crypto | {brand}',
        description: 'The Great Stick-Up by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/the_hand_of_midas': {
        title: 'Play The Hand of Midas by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Play The Hand of Midas by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/the_magic_cauldron_enchanted_brew': {
        title: 'The Magic Cauldron: Enchanted Brew: Play Online with Crypto | {brand}',
        description: 'Spin The Magic Cauldron: Enchanted Brew by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/the_money_men_megaways': {
        title: 'Play The Money Men Megaways by Pragmatic Play at {brand} | 10,000x Max Win',
        description: 'Play The Money Men Megaways by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/the_tiger_warrior': {
        title: 'The Tiger Warrior by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play The Tiger Warrior by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/the_tweety_house': {
        title: 'The Tweety House Megaways Slot by Pragmatic Play | {brand}',
        description: 'The Tweety House by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/the_ultimate_5': {
        title: 'The Ultimate 5 Megaways Slot by Pragmatic Play | {brand}',
        description: 'The Ultimate 5 from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/the_wild_gang': {
        title: 'The Wild Gang by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin The Wild Gang by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/the_wild_machine': {
        title: 'Play The Wild Machine by Pragmatic Play at {brand} | 7,000x Max Win',
        description: 'Play The Wild Machine by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/three_star_fortune': {
        title: 'Three Star Fortune: Play Online with Crypto | {brand}',
        description: 'Three Star Fortune from Pragmatic Play, with a 500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/tic_tac_take': {
        title: 'Tic Tac Take by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Tic Tac Take from Pragmatic Play. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/tiki_hut_megaways_jackpot_play': {
        title: 'Tiki Hut Megaways Jackpot Play: Play Online with Crypto | {brand}',
        description: 'Spin Tiki Hut Megaways Jackpot Play by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/timber_stacks': {
        title: 'Timber Stacks Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Timber Stacks by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/tiny_toads': {
        title: 'Play Tiny Toads by Pragmatic Play at {brand} | 4,000x Max Win',
        description: 'Spin Tiny Toads by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/towering_fortunes': {
        title: 'Towering Fortunes by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Towering Fortunes by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/treasure_horse': {
        title: 'Treasure Horse: Play Online with Crypto | {brand}',
        description: 'Treasure Horse from Pragmatic Play, with a 6,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/treasure_wild': {
        title: 'Play Treasure Wild by Pragmatic Play at {brand} | 4,500x Max Win',
        description: 'Spin Treasure Wild by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/treasures_of_osiris': {
        title: 'Play Treasures of Osiris by Pragmatic Play at {brand} | 10,000x Max Win',
        description: 'Play Treasures of Osiris by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/tree_of_riches': {
        title: 'Tree of Riches Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Tree of Riches from Pragmatic Play, with a 2,880x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/trees_of_treasure': {
        title: 'Trees of Treasure Megaways Slot by Pragmatic Play | {brand}',
        description: 'Trees of Treasure from Pragmatic Play, with a 15,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/triple_dragons': {
        title: 'Triple Dragons Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Triple Dragons by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/triple_pot_diamond': {
        title: 'Triple Pot Diamond: Play Online with Crypto | {brand}',
        description: 'Triple Pot Diamond from Pragmatic Play, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/triple_pot_god': {
        title: 'Triple Pot God: Play Online with Crypto | {brand}',
        description: 'Triple Pot God from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/triple_pot_gold': {
        title: 'Triple Pot Gold Megaways Slot by Pragmatic Play | {brand}',
        description: 'Triple Pot Gold by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/triple_tigers': {
        title: 'Triple Tigers Megaways Slot by Pragmatic Play | {brand}',
        description: 'Triple Tigers from Pragmatic Play, with a 500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/tropical_pop_jackpot_play': {
        title: 'Tropical Pop Jackpot Play: Play Online with Crypto | {brand}',
        description: 'Spin Tropical Pop Jackpot Play by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/tropical_tiki': {
        title: 'Tropical Tiki by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin Tropical Tiki by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/tundras_fortune': {
        title: "Tundra's Fortune Megaways Slot by Pragmatic Play | {brand}",
        description: "Tundra's Fortune by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/pragmatic-play/twilight_princess': {
        title: 'Twilight Princess by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Twilight Princess by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/ultra_burn': {
        title: 'Ultra Burn: Play Online with Crypto | {brand}',
        description: 'Spin Ultra Burn by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/ultra_hold_and_spin': {
        title: 'Ultra Hold and Spin Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Ultra Hold and Spin by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/vampires_vs_wolves': {
        title: 'Play Vampires vs Wolves by Pragmatic Play at {brand} | 1,000x Max Win',
        description: 'Play Vampires vs Wolves by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/vampy_party': {
        title: 'Play Vampy Party by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Spin Vampy Party by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/vegas_magic': {
        title: 'Play Vegas Magic by Pragmatic Play at {brand} | 3,549x Max Win',
        description: 'Play Vegas Magic by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/vegas_nights': {
        title: 'Vegas Nights by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Vegas Nights by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/viking_forge': {
        title: 'Viking Forge by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin Viking Forge by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/volcano_goddess': {
        title: 'Play Volcano Goddess by Pragmatic Play at {brand} | 20,000x Max Win',
        description: 'Play Volcano Goddess by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/voodoo_magic': {
        title: 'Play Voodoo Magic by Pragmatic Play at {brand} | 1,000x Max Win',
        description: 'Play Voodoo Magic by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/waves_of_poseidon': {
        title: 'Play Waves of Poseidon by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Spin Waves of Poseidon by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/wheel_o_gold': {
        title: 'Play Wheel O Gold Slot by Pragmatic Play at {brand} | 10,000x Max Win',
        description: 'Play Wheel O Gold Slot by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/wheel_of_happiness': {
        title: 'Wheel of Happiness Megaways Slot by Pragmatic Play | {brand}',
        description: 'Wheel of Happiness by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/wheel_ogold': {
        title: "Wheel O'Gold Slot by Pragmatic Play at {brand} | Instant Crypto Payouts",
        description: "Wheel O'Gold by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/pragmatic-play/wild_beach_party': {
        title: 'Wild Beach Party: Play Online with Crypto | {brand}',
        description: 'Wild Beach Party from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/wild_bison_charge': {
        title: 'Wild Bison Charge by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Wild Bison Charge from Pragmatic Play. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/wild_booster': {
        title: 'Wild Booster: Play Online with Crypto | {brand}',
        description: 'Wild Booster by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/wild_celebrity_bus_megaways': {
        title: 'Play Wild Celebrity Bus Megaways by Pragmatic Play at {brand} | 4,000x Max Win',
        description: 'Spin Wild Celebrity Bus Megaways by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/wild_depths': {
        title: 'Wild Depths: Play Online with Crypto | {brand}',
        description: 'Wild Depths from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/wild_gladiators': {
        title: 'Wild Gladiators Megaways Slot by Pragmatic Play | {brand}',
        description: 'Wild Gladiators from Pragmatic Play, with a 4,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/wild_hop_and_drop': {
        title: 'Wild Hop & Drop by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin Wild Hop & Drop by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/wild_pixies': {
        title: 'Wild Pixies Megaways Slot by Pragmatic Play | {brand}',
        description: 'Wild Pixies from Pragmatic Play, with a 261x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/wild_skullz': {
        title: 'Wild Skullz by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin Wild Skullz by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/wild_spells': {
        title: 'Wild Spells by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Wild Spells by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/wild_walker': {
        title: 'Wild Walker Megaways Slot by Pragmatic Play | {brand}',
        description: 'Wild Walker by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/wild_west_gold': {
        title: 'Wild West Gold Megaways Slot by Pragmatic Play | {brand}',
        description: 'Wild West Gold by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/wild_west_gold_blazing_bounty': {
        title: 'Wild West Gold Blazing Bounty Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Wild West Gold Blazing Bounty by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/wild_west_gold_megaways': {
        title: 'Play Wild West Gold MegaWays by Pragmatic Play at {brand} | 5,000x Max Win',
        description: 'Spin Wild West Gold MegaWays by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/wild_wild_bananas': {
        title: 'Play Wild Wild Bananas by Pragmatic Play at {brand} | 12,000x Max Win',
        description: 'Spin Wild Wild Bananas by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/wild_wild_joker': {
        title: 'Wild Wild Joker Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Wild Wild Joker by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/wild_wild_pearls': {
        title: 'Wild Wild Pearls: Play Online with Crypto | {brand}',
        description: 'Wild Wild Pearls from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/wild_wild_riches': {
        title: 'Play Wild Wild Riches by Pragmatic Play at {brand} | 4,608x Max Win',
        description: 'Spin Wild Wild Riches by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/wild_wild_riches_returns': {
        title: 'Wild Wild Riches Returns by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin Wild Wild Riches Returns by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/wild_wildebeest_wins': {
        title: 'Wild Wildebeest Wins Megaways Slot by Pragmatic Play | {brand}',
        description: 'Wild Wildebeest Wins from Pragmatic Play, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/wildies': {
        title: 'Wildies Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Wildies from Pragmatic Play, with a 7,500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/wildman_super_bonanza': {
        title: 'Play Wildman Super Bonanza by Pragmatic Play at {brand} | 10,000x Max Win',
        description: 'Spin Wildman Super Bonanza by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/wisdom_of_athena': {
        title: 'Wisdom of Athena Megaways Slot by Pragmatic Play | {brand}',
        description: 'Wisdom of Athena from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/wisdom_of_athena_1000': {
        title: 'Wisdom of Athena 1000: Play Online with Crypto | {brand}',
        description: 'Wisdom of Athena 1000 from Pragmatic Play, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/wisdom_of_athena_1000_xmas': {
        title: 'Wisdom of Athena 1000 Xmas Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Wisdom of Athena 1000 Xmas from Pragmatic Play, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/witch_heart_megaways': {
        title: 'Witch Heart Megaways: Play Online with Crypto | {brand}',
        description: 'Witch Heart Megaways by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/wolf_gold': {
        title: 'Wolf Gold Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Wolf Gold from Pragmatic Play, with a 2,500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/wolf_gold_4_pack': {
        title: 'Wolf Gold 4 Pack by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin Wolf Gold 4 Pack by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/wolf_gold_ultimate': {
        title: 'Wolf Gold Ultimate: Play Online with Crypto | {brand}',
        description: 'Wolf Gold Ultimate by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/wukong_rush': {
        title: 'Wukong Rush Megaways Slot by Pragmatic Play | {brand}',
        description: 'Play Wukong Rush by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/year_of_the_dragon_king': {
        title: 'Year of the Dragon King Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Year of the Dragon King by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/yeti_quest': {
        title: 'Yeti Quest by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Play Yeti Quest by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/you_can_piggy_bank_on_it': {
        title: 'Play You Can Piggy Bank On It by Pragmatic Play at {brand} | 2,100x Max Win',
        description: 'Spin You Can Piggy Bank On It by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/yum_yum_powerways': {
        title: 'Yum Yum PowerWays Slot by Pragmatic Play at {brand} | Instant Crypto Payouts',
        description: 'Yum Yum PowerWays from Pragmatic Play, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/zeus_vs_hades_gods_of_war': {
        title: 'Zeus vs Hades - Gods of War by Pragmatic Play at {brand} | Free Demo & Crypto Play',
        description: 'Spin Zeus vs Hades - Gods of War by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play/zeus_vs_hades_gods_of_war_250': {
        title: 'Play Zeus vs Hades Gods of War 250 by Pragmatic Play at {brand} | 25,000x Max Win',
        description: 'Play Zeus vs Hades Gods of War 250 by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/zeus_vs_typhoon': {
        title: 'Zeus vs Typhoon: Play Online with Crypto | {brand}',
        description: 'Zeus vs Typhoon from Pragmatic Play, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/pragmatic-play/zombie_carnival': {
        title: 'Zombie Carnival: Play Online with Crypto | {brand}',
        description: 'Zombie Carnival by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play/zombie_school_megaways': {
        title: 'Play Zombie School Megaways by Pragmatic Play at {brand} | 10,000x Max Win',
        description: 'Play Zombie School Megaways by Pragmatic Play at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play/zombie_train': {
        title: 'Zombie Train Megaways Slot by Pragmatic Play | {brand}',
        description: 'Zombie Train by Pragmatic Play at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/avatarux/80spop': {
        title: '80sPOP PopWins Slot by AvatarUX | {brand}',
        description: '80sPOP from AvatarUX, with a 20,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/avatarux/animals_strike': {
        title: 'Animals Strike PopWins Slot by AvatarUX | {brand}',
        description: 'Animals Strike from AvatarUX, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/avatarux/arcanapop': {
        title: 'Play ArcanaPop by AvatarUX at {brand} | 20,000x Max Win',
        description: 'Play ArcanaPop by AvatarUX at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/avatarux/astropop': {
        title: 'AstroPop Slot by AvatarUX at {brand} | Instant Crypto Payouts',
        description: 'AstroPop from AvatarUX, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/avatarux/beastly_burglars': {
        title: 'Play Beastly Burglars by AvatarUX at {brand} | 10,000x Max Win',
        description: 'Play Beastly Burglars by AvatarUX at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/avatarux/big_catch_craze': {
        title: 'Big Catch Craze Slot by AvatarUX at {brand} | Instant Crypto Payouts',
        description: 'Big Catch Craze by AvatarUX at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/avatarux/big_catch_xmas': {
        title: 'Big Catch Xmas Slot by AvatarUX at {brand} | Instant Crypto Payouts',
        description: 'Big Catch Xmas from AvatarUX, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/avatarux/bounty_pop': {
        title: 'Play Bounty Pop by AvatarUX at {brand} | 37,910x Max Win',
        description: 'Play Bounty Pop by AvatarUX at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/avatarux/canyon_riches': {
        title: 'Play Canyon Riches by AvatarUX at {brand} | 20,000x Max Win',
        description: 'Spin Canyon Riches by AvatarUX at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/avatarux/captain_moregain': {
        title: "Captain More'gain by AvatarUX at {brand} | Free Demo & Crypto Play",
        description: "Spin Captain More'gain by AvatarUX at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/avatarux/cherry_pop': {
        title: 'Cherry Pop by AvatarUX at {brand} | Free Demo & Crypto Play',
        description: 'Spin Cherry Pop by AvatarUX at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/avatarux/cherry_pop_deluxe': {
        title: 'Play Cherry Pop Deluxe by AvatarUX at {brand} | 20,000x Max Win',
        description: 'Play Cherry Pop Deluxe by AvatarUX at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/avatarux/cherrypop_burst': {
        title: 'CherryPop Burst by AvatarUX at {brand} | Free Demo & Crypto Play',
        description: 'Spin CherryPop Burst by AvatarUX at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/avatarux/cosmic_jokers': {
        title: 'Play Cosmic Jokers by AvatarUX at {brand} | 10,000x Max Win',
        description: 'Play Cosmic Jokers by AvatarUX at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/avatarux/coyote_gold': {
        title: 'Coyote Gold: Play Online with Crypto | {brand}',
        description: 'Coyote Gold from AvatarUX, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/avatarux/critter_pop': {
        title: 'Critter Pop by AvatarUX at {brand} | Free Demo & Crypto Play',
        description: 'Spin Critter Pop by AvatarUX at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/avatarux/crypto_bro': {
        title: 'Crypto Bro by AvatarUX at {brand} | Free Demo & Crypto Play',
        description: 'Play Crypto Bro by AvatarUX at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/avatarux/depths_of_fortune': {
        title: 'Depths of Fortune PopWins Slot by AvatarUX | {brand}',
        description: 'Depths of Fortune from AvatarUX, with a 20,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/avatarux/donkey_and_the_goats': {
        title: 'Play Donkey & The Goats by AvatarUX at {brand} | 10,000x Max Win',
        description: 'Spin Donkey & The Goats by AvatarUX at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/avatarux/duck_hunt_500': {
        title: 'Play Duck Hunt 500 by AvatarUX at {brand} | 10,000x Max Win',
        description: 'Play Duck Hunt 500 by AvatarUX at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/avatarux/electric_rush': {
        title: 'Electric Rush PopWins Slot by AvatarUX | {brand}',
        description: 'Electric Rush by AvatarUX at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/avatarux/electro_cubes': {
        title: 'Electro Cubes by AvatarUX at {brand} | Free Demo & Crypto Play',
        description: 'Play Electro Cubes by AvatarUX at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/avatarux/floridaman': {
        title: 'Play Floridaman by AvatarUX at {brand} | 20,000x Max Win',
        description: 'Play Floridaman by AvatarUX at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/avatarux/fruitillionaire': {
        title: 'Fruitillionaire Slot by AvatarUX at {brand} | Instant Crypto Payouts',
        description: 'Fruitillionaire by AvatarUX at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/avatarux/gempops': {
        title: 'GemPOPs: Play Online with Crypto | {brand}',
        description: 'Spin GemPOPs by AvatarUX at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/avatarux/gods_gone_wild': {
        title: 'Gods Gone Wild: Play Online with Crypto | {brand}',
        description: 'Gods Gone Wild from AvatarUX, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/avatarux/heliopopolis': {
        title: 'HelioPOPolis by AvatarUX at {brand} | Free Demo & Crypto Play',
        description: 'Spin HelioPOPolis by AvatarUX at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/avatarux/hiphop_pop': {
        title: 'Hip-Hop Pop: Play Online with Crypto | {brand}',
        description: 'Hip-Hop Pop by AvatarUX at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/avatarux/hippo_pop': {
        title: 'Hippo Pop PopWins Slot by AvatarUX | {brand}',
        description: 'Hippo Pop from AvatarUX, with a 20,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/avatarux/imperial_coins': {
        title: 'Imperial Coins: Play Online with Crypto | {brand}',
        description: 'Imperial Coins from AvatarUX, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/avatarux/jinglepop': {
        title: 'JinglePOP: Play Online with Crypto | {brand}',
        description: 'JinglePOP from AvatarUX, with a 20,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/avatarux/juicypop': {
        title: 'JuicyPop by AvatarUX at {brand} | Free Demo & Crypto Play',
        description: 'Play JuicyPop by AvatarUX at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/avatarux/jungle_pop': {
        title: 'Play Jungle Pop by AvatarUX at {brand} | 50,000x Max Win',
        description: 'Spin Jungle Pop by AvatarUX at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/avatarux/king_of_samba': {
        title: 'King of Samba: Play Online with Crypto | {brand}',
        description: 'King of Samba by AvatarUX at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/avatarux/kittypopins': {
        title: 'KittyPOPins Slot by AvatarUX at {brand} | Instant Crypto Payouts',
        description: 'KittyPOPins from AvatarUX, with a 20,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/avatarux/kokeshi_pop': {
        title: 'Kokeshi Pop: Play Online with Crypto | {brand}',
        description: 'Kokeshi Pop from AvatarUX, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/avatarux/lolli_pop': {
        title: 'Lolli Pop Slot by AvatarUX at {brand} | Instant Crypto Payouts',
        description: 'Lolli Pop from AvatarUX, with a 13,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/avatarux/looney_pop': {
        title: 'Looney Pop PopWins Slot by AvatarUX | {brand}',
        description: 'Looney Pop by AvatarUX at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/avatarux/majestic_meow': {
        title: 'Majestic Meow by AvatarUX at {brand} | Free Demo & Crypto Play',
        description: 'Spin Majestic Meow by AvatarUX at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/avatarux/midnight_hunt': {
        title: 'Midnight Hunt Slot by AvatarUX at {brand} | Instant Crypto Payouts',
        description: 'Midnight Hunt by AvatarUX at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/avatarux/monkey_pop': {
        title: 'Monkey Pop by AvatarUX at {brand} | Free Demo & Crypto Play',
        description: 'Play Monkey Pop by AvatarUX at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/avatarux/nugget': {
        title: 'Nugget: Play Online with Crypto | {brand}',
        description: 'Nugget from AvatarUX, with a 25,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/avatarux/papaya_pop': {
        title: 'Papaya Pop: Play Online with Crypto | {brand}',
        description: 'Papaya Pop by AvatarUX at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/avatarux/piggy_pop': {
        title: 'Piggy Pop PopWins Slot by AvatarUX | {brand}',
        description: 'Piggy Pop by AvatarUX at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/avatarux/piggypop_grand_affair': {
        title: 'PiggyPop Grand Affair PopWins Slot by AvatarUX | {brand}',
        description: 'PiggyPop Grand Affair by AvatarUX at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/avatarux/pixel_paws': {
        title: 'Pixel Paws PopWins Slot by AvatarUX | {brand}',
        description: 'Pixel Paws from AvatarUX, with a 20,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/avatarux/pixiepop': {
        title: 'PixiePop: Play Online with Crypto | {brand}',
        description: 'PixiePop from AvatarUX, with a 20,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/avatarux/pop_noir': {
        title: 'Pop Noir: Play Online with Crypto | {brand}',
        description: 'Pop Noir by AvatarUX at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/avatarux/pop_ogold': {
        title: "Play Pop o'Gold by AvatarUX at {brand} | 20,000x Max Win",
        description: "Spin Pop o'Gold by AvatarUX at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/avatarux/pop_rocks': {
        title: 'Pop Rocks Slot by AvatarUX at {brand} | Instant Crypto Payouts',
        description: 'Pop Rocks from AvatarUX, with a 72,188x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/avatarux/raging_pop': {
        title: 'Raging Pop PopWins Slot by AvatarUX | {brand}',
        description: 'Raging Pop by AvatarUX at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/avatarux/rebel_paws': {
        title: 'Rebel Paws: Play Online with Crypto | {brand}',
        description: 'Rebel Paws from AvatarUX, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/avatarux/reef_pop': {
        title: 'Reef Pop by AvatarUX at {brand} | Free Demo & Crypto Play',
        description: 'Reef Pop from AvatarUX. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/avatarux/reel_warriors': {
        title: 'Reel Warriors: Play Online with Crypto | {brand}',
        description: 'Reel Warriors by AvatarUX at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/avatarux/shippy_d_pop': {
        title: 'Shippy D Pop: Play Online with Crypto | {brand}',
        description: 'Shippy D Pop by AvatarUX at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/avatarux/silicon_spinners': {
        title: 'Silicon Spinners PopWins Slot by AvatarUX | {brand}',
        description: 'Silicon Spinners from AvatarUX, with a 20,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/avatarux/sphinx_treasure': {
        title: 'Sphinx Treasure: Play Online with Crypto | {brand}',
        description: 'Sphinx Treasure by AvatarUX at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/avatarux/spinfection': {
        title: 'Spinfection: Play Online with Crypto | {brand}',
        description: 'Spinfection by AvatarUX at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/avatarux/spinxiety': {
        title: 'Play Spinxiety by AvatarUX at {brand} | 20,000x Max Win',
        description: 'Play Spinxiety by AvatarUX at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/avatarux/sweet_gummy': {
        title: 'Sweet Gummy Slot by AvatarUX at {brand} | Instant Crypto Payouts',
        description: 'Sweet Gummy from AvatarUX, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/avatarux/the_vault_chase': {
        title: 'The Vault Chase by AvatarUX at {brand} | Free Demo & Crypto Play',
        description: 'Play The Vault Chase by AvatarUX at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/avatarux/tik_talkers': {
        title: 'Play Tik Talkers by AvatarUX at {brand} | 10,000x Max Win',
        description: 'Spin Tik Talkers by AvatarUX at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/avatarux/tiki_pop': {
        title: 'Play Tiki Pop by AvatarUX at {brand} | 32,000x Max Win',
        description: 'Play Tiki Pop by AvatarUX at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/avatarux/tikipop_spooky_temples': {
        title: 'Play TikiPop Spooky Temples by AvatarUX at {brand} | 32,000x Max Win',
        description: 'Spin TikiPop Spooky Temples by AvatarUX at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/avatarux/toads_bounty': {
        title: "Play Toad's Bounty by AvatarUX at {brand} | 10,000x Max Win",
        description: "Play Toad's Bounty by AvatarUX at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/avatarux/vegas_fortune': {
        title: 'Vegas Fortune Slot by AvatarUX at {brand} | Instant Crypto Payouts',
        description: 'Vegas Fortune from AvatarUX, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/avatarux/wild_pops': {
        title: 'Wild Pops by AvatarUX at {brand} | Free Demo & Crypto Play',
        description: 'Play Wild Pops by AvatarUX at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/avatarux/witchy_poppins': {
        title: 'Witchy POPpins: Play Online with Crypto | {brand}',
        description: 'Witchy POPpins from AvatarUX, with a 20,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/avatarux/worms_of_valor': {
        title: 'Worms of Valor by AvatarUX at {brand} | Free Demo & Crypto Play',
        description: 'Spin Worms of Valor by AvatarUX at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/avatarux/xmas_pop_delight': {
        title: 'Play Xmas Pop Delight by AvatarUX at {brand} | 20,000x Max Win',
        description: 'Spin Xmas Pop Delight by AvatarUX at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/avatarux/zombie_apopalypse': {
        title: 'Play Zombie aPOPalypse by AvatarUX at {brand} | 20,000x Max Win',
        description: 'Spin Zombie aPOPalypse by AvatarUX at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/big-time-gaming/apollo_pays': {
        title: 'Apollo Pays Slot by big-time-gaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Apollo Pays Slot by big-time-gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/big-time-gaming/beef_lightning': {
        title: 'Play Play Beef Lightning Slot by big-time-gaming at {brand} | 56,000x Max Win',
        description: 'Play Play Beef Lightning Slot by big-time-gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/big-time-gaming/big_bad_bison': {
        title: 'Play Big Bad Bison Megaways Slot by big-time-gaming | {brand}',
        description: 'Play Big Bad Bison from big-time-gaming, with a 55,260x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/big-time-gaming/big_bucks_deluxe': {
        title: 'Play Big Bucks Deluxe Slot by big-time-gaming at {brand} | 89,600x Max Win',
        description: 'Spin Big Bucks Deluxe Slot by big-time-gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/big-time-gaming/bonanza': {
        title: 'Play Bonanza Slot by big-time-gaming at {brand} | 29,000x Max Win',
        description: 'Play Bonanza Slot by big-time-gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/big-time-gaming/bonanza_falls': {
        title: 'Bonanza Falls Slot Slot by big-time-gaming at {brand} | Instant Crypto Payouts',
        description: 'Bonanza Falls Slot from big-time-gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/big-time-gaming/bonanza_megaways': {
        title: 'Bonanza Megaways Megaways Slot by big-time-gaming | {brand}',
        description: 'Bonanza Megaways from big-time-gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/big-time-gaming/boo': {
        title: 'Play Boo: Play Online with Crypto | {brand}',
        description: 'Play Boo from big-time-gaming, with a 47,050x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/big-time-gaming/book_of_gods': {
        title: 'Play Book Of Gods Slot by big-time-gaming at {brand} | 10,000x Max Win',
        description: 'Spin Book Of Gods Slot by big-time-gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/big-time-gaming/burgers': {
        title: 'Burgers Slot Slot by big-time-gaming at {brand} | Instant Crypto Payouts',
        description: 'Burgers Slot from big-time-gaming, with a 102,840x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/big-time-gaming/castle_of_terror': {
        title: 'Play Castle of Terror by big-time-gaming at {brand} | 13,000x Max Win',
        description: 'Spin Castle of Terror by big-time-gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/big-time-gaming/chocolates': {
        title: 'Play Chocolates Slot by big-time-gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Play Chocolates Slot by big-time-gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/big-time-gaming/christmas_bonanza': {
        title: 'Christmas Bonanza Slot Slot by big-time-gaming at {brand} | Instant Crypto Payouts',
        description: 'Christmas Bonanza Slot by big-time-gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/big-time-gaming/christmas_catch': {
        title: 'Christmas Catch Slot by big-time-gaming at {brand} | Instant Crypto Payouts',
        description: 'Christmas Catch from big-time-gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/big-time-gaming/crystal_towers': {
        title: 'Play Crystal Towers Slot by big-time-gaming at {brand} | 10,000x Max Win',
        description: 'Play Crystal Towers Slot by big-time-gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/big-time-gaming/cyberslot_megaclusters': {
        title: 'Play Cyberslot MegaClusters Slot by big-time-gaming at {brand} | 23,960x Max Win',
        description: 'Play Cyberslot MegaClusters Slot by big-time-gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/big-time-gaming/danger_high_voltage': {
        title: 'Play Danger High Voltage by big-time-gaming at {brand} | 10,000x Max Win',
        description: 'Play Danger High Voltage by big-time-gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/big-time-gaming/danger_high_voltage_2': {
        title: 'Danger High Voltage 2: Play Online with Crypto | {brand}',
        description: 'Danger High Voltage 2 by big-time-gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/big-time-gaming/danger_high_voltage_2_megaways': {
        title: 'Play Danger High Voltage 2 Megaways Slot by big-time-gaming at {brand} | 10,000x Max Win',
        description: 'Spin Danger High Voltage 2 Megaways Slot by big-time-gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/big-time-gaming/diamond_fruits': {
        title: 'Play Diamond Fruits: Play Online with Crypto | {brand}',
        description: 'Play Diamond Fruits by big-time-gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/big-time-gaming/donuts': {
        title: 'Play Donuts by big-time-gaming at {brand} | 13,000x Max Win',
        description: 'Spin Donuts by big-time-gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/big-time-gaming/dragon_born': {
        title: 'Play Dragon Born Slot by big-time-gaming at {brand} | 13,000x Max Win',
        description: 'Play Dragon Born Slot by big-time-gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/big-time-gaming/extra_chilli': {
        title: 'Play Extra Chilli Slot by big-time-gaming at {brand} | Instant Crypto Payouts',
        description: 'Play Extra Chilli from big-time-gaming, with a 32,250x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/big-time-gaming/extra_chilli_megaways': {
        title: 'Extra Chilli Megaways by big-time-gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Extra Chilli Megaways by big-time-gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/big-time-gaming/extra_chilli_nfd': {
        title: 'Play Extra Chilli (NFD) by big-time-gaming at {brand} | 13,000x Max Win',
        description: 'Spin Extra Chilli (NFD) by big-time-gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/big-time-gaming/fireworks_megaways': {
        title: 'Play Fireworks Megaways Slot by big-time-gaming at {brand} | 10,000x Max Win',
        description: 'Spin Fireworks Megaways Slot by big-time-gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/big-time-gaming/fizzy_pennyslot': {
        title: 'Play Fizzy Pennyslot by big-time-gaming at {brand} | 10,170x Max Win',
        description: 'Play Fizzy Pennyslot by big-time-gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/big-time-gaming/gifts_of_fortune': {
        title: 'Play Gifts of Fortune Slot by big-time-gaming at {brand} | 13,000x Max Win',
        description: 'Spin Gifts of Fortune Slot by big-time-gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/big-time-gaming/gold_megaways': {
        title: 'Play Gold Megaways Slot by big-time-gaming at {brand} | 13,000x Max Win',
        description: 'Play Gold Megaways Slot by big-time-gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/big-time-gaming/golden_catch': {
        title: 'Play Golden Catch Slot by big-time-gaming at {brand} | 10,000x Max Win',
        description: 'Spin Golden Catch Slot by big-time-gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/big-time-gaming/golden_goose_megaways': {
        title: 'Play Golden Goose Megaways Megaways Slot by big-time-gaming | {brand}',
        description: 'Play Golden Goose Megaways from big-time-gaming, with a 29,030x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/big-time-gaming/holy_diver': {
        title: 'Holy Diver Slot by big-time-gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Holy Diver Slot by big-time-gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/big-time-gaming/holy_diver_megaways': {
        title: 'Play Holy Diver Megaways Megaways Slot by big-time-gaming | {brand}',
        description: 'Play Holy Diver Megaways from big-time-gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/big-time-gaming/king_of_cats': {
        title: 'Play King of Cats by big-time-gaming at {brand} | 13,000x Max Win',
        description: 'Spin King of Cats by big-time-gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/big-time-gaming/kingmaker': {
        title: 'Play KingMaker by big-time-gaming at {brand} | 13,000x Max Win',
        description: 'Play KingMaker by big-time-gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/big-time-gaming/kingmaker_fully_loaded': {
        title: 'Play Kingmaker Fully Loaded: Play Online with Crypto | {brand}',
        description: 'Play Kingmaker Fully Loaded from big-time-gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/big-time-gaming/lil_devil': {
        title: 'Lil Devil Megaways Slot by big-time-gaming | {brand}',
        description: 'Lil Devil by big-time-gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/big-time-gaming/lucky_streak_mk2': {
        title: 'Play Lucky Streak Mk2: Play Online with Crypto | {brand}',
        description: 'Play Lucky Streak Mk2 by big-time-gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/big-time-gaming/max_megaways': {
        title: 'Play Max Megaways Slot by big-time-gaming at {brand} | 13,000x Max Win',
        description: 'Spin Max Megaways Slot by big-time-gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/big-time-gaming/max_megaways_2': {
        title: 'Play Max Megaways 2 Slot by big-time-gaming at {brand} | Instant Crypto Payouts',
        description: 'Play Max Megaways 2 from big-time-gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/big-time-gaming/max_megaways_3': {
        title: 'Play Max Megaways 3 by big-time-gaming at {brand} | 10,000x Max Win',
        description: 'Spin Max Megaways 3 by big-time-gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/big-time-gaming/millionaire': {
        title: 'Play Play Millionaire Megapots Slot by big-time-gaming at {brand} | 3,600x Max Win',
        description: 'Spin Play Millionaire Megapots Slot by big-time-gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/big-time-gaming/millionaire_mystery_box': {
        title: 'Play Millionaire Mystery Box Slot by big-time-gaming at {brand} | 13,000x Max Win',
        description: 'Spin Millionaire Mystery Box Slot by big-time-gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/big-time-gaming/millionaire_rush': {
        title: 'Millionaire Rush Slot by big-time-gaming at {brand} | Instant Crypto Payouts',
        description: 'Millionaire Rush from big-time-gaming, with a 13,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/big-time-gaming/monopoly_rush_hour': {
        title: 'Monopoly Rush Hour Slot by big-time-gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Monopoly Rush Hour Slot by big-time-gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/big-time-gaming/more_turkey': {
        title: 'More Turkey Slot: Play Online with Crypto | {brand}',
        description: 'More Turkey Slot by big-time-gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/big-time-gaming/opal_fruits': {
        title: 'Play Opal Fruits Slot by big-time-gaming at {brand} | Instant Crypto Payouts',
        description: 'Play Opal Fruits from big-time-gaming, with a 13,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/big-time-gaming/outlaw': {
        title: 'Play Outlaw Slot by big-time-gaming at {brand} | Instant Crypto Payouts',
        description: 'Play Outlaw from big-time-gaming, with a 13,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/big-time-gaming/over_the_moon': {
        title: 'Play Over The Moon Slot by big-time-gaming at {brand} | Instant Crypto Payouts',
        description: 'Play Over The Moon from big-time-gaming, with a 24,070x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/big-time-gaming/panda_money': {
        title: 'Panda Money Slot by big-time-gaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Panda Money Slot by big-time-gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/big-time-gaming/pirate_pays': {
        title: 'Play Pirate Pays by big-time-gaming at {brand} | 104,400x Max Win',
        description: 'Play Pirate Pays by big-time-gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/big-time-gaming/pop': {
        title: 'Play Pop Slot by big-time-gaming at {brand} | 13,000x Max Win',
        description: 'Play Pop Slot by big-time-gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/big-time-gaming/queen_of_riches': {
        title: 'Play Queen Of Riches by big-time-gaming at {brand} | 10,000x Max Win',
        description: 'Play Queen Of Riches by big-time-gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/big-time-gaming/rasputin_megaways': {
        title: 'Play Rasputin Megaways by big-time-gaming at {brand} | 13,000x Max Win',
        description: 'Play Rasputin Megaways by big-time-gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/big-time-gaming/royal_mint': {
        title: 'Play Royal Mint Slot by big-time-gaming at {brand} | Instant Crypto Payouts',
        description: 'Play Royal Mint by big-time-gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/big-time-gaming/sanctuary': {
        title: 'Play Sanctuary Slot by big-time-gaming at {brand} | Instant Crypto Payouts',
        description: 'Play Sanctuary by big-time-gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/big-time-gaming/slot_vegas': {
        title: 'Play Slot Vegas by big-time-gaming at {brand} | 22,700x Max Win',
        description: 'Spin Slot Vegas by big-time-gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/big-time-gaming/slot_vegas_fully_loaded': {
        title: 'Slot Vegas Fully Loaded Slot: Play Online with Crypto | {brand}',
        description: 'Slot Vegas Fully Loaded Slot by big-time-gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/big-time-gaming/spicy_meatballs': {
        title: 'Play Spicy Meatballs Slot by big-time-gaming at {brand} | Instant Crypto Payouts',
        description: 'Play Spicy Meatballs by big-time-gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/big-time-gaming/star_clusters': {
        title: 'Star Clusters Slot by big-time-gaming at {brand} | Instant Crypto Payouts',
        description: 'Star Clusters from big-time-gaming, with a 16,708x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/big-time-gaming/temple_quest_spinfinity': {
        title: 'Play Temple Quest Spinfinity: Play Online with Crypto | {brand}',
        description: 'Play Temple Quest Spinfinity by big-time-gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/big-time-gaming/the_final_countdown': {
        title: 'Play The Final Countdown Megaways Slot by big-time-gaming | {brand}',
        description: 'Play The Final Countdown from big-time-gaming, with a 13,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/big-time-gaming/the_golden_catch': {
        title: 'Play The Golden Catch Slot by big-time-gaming at {brand} | 10,000x Max Win',
        description: 'Play The Golden Catch Slot by big-time-gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/big-time-gaming/the_race': {
        title: 'Play Play The Race Slot by big-time-gaming at {brand} | 13,960x Max Win',
        description: 'Play Play The Race Slot by big-time-gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/big-time-gaming/trigger_happy': {
        title: 'Trigger Happy by big-time-gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Trigger Happy by big-time-gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/big-time-gaming/vegas_megaways': {
        title: 'Play Vegas MegaWays Slot by big-time-gaming at {brand} | 13,000x Max Win',
        description: 'Play Vegas MegaWays Slot by big-time-gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/big-time-gaming/vegas_rush': {
        title: 'Vegas Rush by big-time-gaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Vegas Rush by big-time-gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/big-time-gaming/white_rabbit': {
        title: 'White Rabbit Megaways Slot by big-time-gaming | {brand}',
        description: 'White Rabbit from big-time-gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/big-time-gaming/white_rabbit_2': {
        title: 'Play White Rabbit 2 Slot by big-time-gaming at {brand} | 10,000x Max Win',
        description: 'Play White Rabbit 2 Slot by big-time-gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/big-time-gaming/white_rabbit_megaways': {
        title: 'White Rabbit Megaways Slot by big-time-gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play White Rabbit Megaways Slot by big-time-gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/big-time-gaming/white_rabbit_nfd': {
        title: 'Play White Rabbit (NFD) by big-time-gaming at {brand} | 13,000x Max Win',
        description: 'Spin White Rabbit (NFD) by big-time-gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/big-time-gaming/wild_flower': {
        title: 'Wild Flower: Play Online with Crypto | {brand}',
        description: 'Wild Flower by big-time-gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/big-time-gaming/wild_portals': {
        title: 'Play Wild Portals Megaways Slot by big-time-gaming | {brand}',
        description: 'Play Wild Portals by big-time-gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/big-time-gaming/wild_unicorns': {
        title: 'Wild Unicorns Slot by big-time-gaming at {brand} | Instant Crypto Payouts',
        description: 'Wild Unicorns by big-time-gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/blueprint-gaming/777_deluxe': {
        title: '777 Deluxe: Play Online with Crypto | {brand}',
        description: '777 Deluxe from Blueprint Gaming, with a 50,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/blueprint-gaming/almighty_bear_megaways': {
        title: 'Almighty Bear Megaways: Play Online with Crypto | {brand}',
        description: 'Almighty Bear Megaways from Blueprint Gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/blueprint-gaming/bankin_bacon': {
        title: "Bankin' Bacon: Play Online with Crypto | {brand}",
        description: "Bankin' Bacon by Blueprint Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/blueprint-gaming/bankin_more_bacon': {
        title: "Bankin' More Bacon: Play Online with Crypto | {brand}",
        description: "Bankin' More Bacon from Blueprint Gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/blueprint-gaming/barx_safecracker_megaways': {
        title: 'Bar-X Safecracker Megaways Jackpot King Slot by Blueprint Gaming | {brand}',
        description: 'Bar-X Safecracker Megaways by Blueprint Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/blueprint-gaming/big_catch_bass_fishing_megaways': {
        title: 'Big Catch Bass Fishing Megaways by Blueprint Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Big Catch Bass Fishing Megaways by Blueprint Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/blueprint-gaming/big_catch_even_bigger_bass_2': {
        title: 'Big Catch Even Bigger Bass 2: Play Online with Crypto | {brand}',
        description: 'Big Catch Even Bigger Bass 2 from Blueprint Gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/blueprint-gaming/big_catch_even_bigger_bass_3_megaways': {
        title: 'Big Catch Even Bigger Bass 3 Megaways: Play Online with Crypto | {brand}',
        description: 'Big Catch Even Bigger Bass 3 Megaways by Blueprint Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/blueprint-gaming/big_money_frenzy_cash_gains': {
        title: 'Big Money Frenzy Cash Gains: Play Online with Crypto | {brand}',
        description: 'Big Money Frenzy Cash Gains by Blueprint Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/blueprint-gaming/big_money_megaways': {
        title: 'Big Money Megaways: Play Online with Crypto | {brand}',
        description: 'Spin Big Money Megaways by Blueprint Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/blueprint-gaming/bigger_catch_bass_fishing': {
        title: 'Bigger Catch Bass Fishing Jackpot King Slot by Blueprint Gaming | {brand}',
        description: 'Bigger Catch Bass Fishing by Blueprint Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/blueprint-gaming/bison_bonanza': {
        title: 'Bison Bonanza Slot by Blueprint Gaming at {brand} | Instant Crypto Payouts',
        description: 'Bison Bonanza by Blueprint Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/blueprint-gaming/bison_rising_gold_strike': {
        title: 'Play Bison Rising Gold Strike by Blueprint Gaming at {brand} | 10,000x Max Win',
        description: 'Spin Bison Rising Gold Strike by Blueprint Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/blueprint-gaming/bison_rising_megaways': {
        title: 'Bison Rising Megaways Slot by Blueprint Gaming at {brand} | Instant Crypto Payouts',
        description: 'Bison Rising Megaways from Blueprint Gaming, with a 50,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/blueprint-gaming/bison_rising_reloaded_megaways': {
        title: 'Bison Rising Reloaded Megaways: Play Online with Crypto | {brand}',
        description: 'Spin Bison Rising Reloaded Megaways by Blueprint Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/blueprint-gaming/blazing_cash': {
        title: 'Blazing Cash Jackpot King Slot by Blueprint Gaming | {brand}',
        description: 'Blazing Cash from Blueprint Gaming, with a 500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/blueprint-gaming/bounty_hunter_unchained': {
        title: 'Play Bounty Hunter Unchained by Blueprint Gaming at {brand} | 10,000x Max Win',
        description: 'Spin Bounty Hunter Unchained by Blueprint Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/blueprint-gaming/bullion_blitz_power_play': {
        title: 'Play Bullion Blitz Power Play by Blueprint Gaming at {brand} | 10,000x Max Win',
        description: 'Play Bullion Blitz Power Play by Blueprint Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/blueprint-gaming/cash_strike': {
        title: 'Play Cash Strike by Blueprint Gaming at {brand} | 10,000x Max Win',
        description: 'Play Cash Strike by Blueprint Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/blueprint-gaming/cash_strike_hotstepper': {
        title: 'Cash Strike Hotstepper Jackpot King Slot by Blueprint Gaming | {brand}',
        description: 'Cash Strike Hotstepper by Blueprint Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/blueprint-gaming/cash_strike_hotstepper_megaways': {
        title: 'Cash Strike Hotstepper Megaways by Blueprint Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Cash Strike Hotstepper Megaways by Blueprint Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/blueprint-gaming/cash_strike_power_5': {
        title: 'Cash Strike Power 5 by Blueprint Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Cash Strike Power 5 by Blueprint Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/blueprint-gaming/cash_strike_power_up': {
        title: 'Play Cash Strike Power Up by Blueprint Gaming at {brand} | 10,000x Max Win',
        description: 'Play Cash Strike Power Up by Blueprint Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/blueprint-gaming/cash_strike_win_boost': {
        title: 'Cash Strike Win Boost Jackpot King Slot by Blueprint Gaming | {brand}',
        description: 'Cash Strike Win Boost from Blueprint Gaming, with a 50,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/blueprint-gaming/cashpots_blazinator': {
        title: 'Play Cashpots Blazinator by Blueprint Gaming at {brand} | 5,000x Max Win',
        description: 'Spin Cashpots Blazinator by Blueprint Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/blueprint-gaming/chilli_picante_megaways': {
        title: 'Chilli Picante Megaways Jackpot King Slot by Blueprint Gaming | {brand}',
        description: 'Chilli Picante Megaways from Blueprint Gaming, with a 50x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/blueprint-gaming/cop_the_lot_megaways_power_play': {
        title: 'Play Cop the Lot Megaways Power Play by Blueprint Gaming at {brand} | 10,000x Max Win',
        description: 'Spin Cop the Lot Megaways Power Play by Blueprint Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/blueprint-gaming/crabbin_for_cash_extra_big_splash': {
        title: 'Crabbin For Cash Extra Big Splash by Blueprint Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Crabbin For Cash Extra Big Splash from Blueprint Gaming. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/blueprint-gaming/crabbin_for_cash_megaways': {
        title: "Play Crabbin' For Cash Megaways by Blueprint Gaming at {brand} | 50,000x Max Win",
        description: "Spin Crabbin' For Cash Megaways by Blueprint Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/blueprint-gaming/crabbin_for_christmas': {
        title: 'Crabbin For Christmas: Play Online with Crypto | {brand}',
        description: 'Spin Crabbin For Christmas by Blueprint Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/blueprint-gaming/diamond_mine_extra_gold': {
        title: 'Diamond Mine Extra Gold by Blueprint Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Diamond Mine Extra Gold by Blueprint Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/blueprint-gaming/diamond_mine_megaways': {
        title: 'Diamond Mine Megaways Jackpot King Slot by Blueprint Gaming | {brand}',
        description: 'Diamond Mine Megaways from Blueprint Gaming, with a 50x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/blueprint-gaming/divine_links': {
        title: 'Divine Links Jackpot King Slot by Blueprint Gaming | {brand}',
        description: 'Divine Links by Blueprint Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/blueprint-gaming/dragonfall': {
        title: 'Play Dragonfall by Blueprint Gaming at {brand} | 10,000x Max Win',
        description: 'Play Dragonfall by Blueprint Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/blueprint-gaming/eagle_storm': {
        title: 'Play Eagle Storm by Blueprint Gaming at {brand} | 10,000x Max Win',
        description: 'Play Eagle Storm by Blueprint Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/blueprint-gaming/el_jackpotto': {
        title: 'El Jackpotto: Play Online with Crypto | {brand}',
        description: 'El Jackpotto by Blueprint Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/blueprint-gaming/eternal_phoenix_megaways': {
        title: 'Play Eternal Phoenix Megaways by Blueprint Gaming at {brand} | 50,000x Max Win',
        description: 'Spin Eternal Phoenix Megaways by Blueprint Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/blueprint-gaming/eye_of_horus_megaways': {
        title: 'Play Eye of Horus Megaways by Blueprint Gaming at {brand} | 10,000x Max Win',
        description: 'Play Eye of Horus Megaways by Blueprint Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/blueprint-gaming/eye_of_horus_rise_of_egypt': {
        title: 'Eye of Horus Rise of Egypt: Play Online with Crypto | {brand}',
        description: 'Eye of Horus Rise of Egypt by Blueprint Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/blueprint-gaming/eye_of_horus_tablets_of_destiny': {
        title: 'Eye of Horus Tablets of Destiny by Blueprint Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Eye of Horus Tablets of Destiny by Blueprint Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/blueprint-gaming/fat_stacks_miami_cash': {
        title: 'Fat Stacks Miami Cash by Blueprint Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Fat Stacks Miami Cash from Blueprint Gaming. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/blueprint-gaming/fishin_frenzy_big_catch_megaways': {
        title: 'Fishin Frenzy Big Catch Megaways by Blueprint Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Fishin Frenzy Big Catch Megaways by Blueprint Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/blueprint-gaming/fishin_frenzy_megaways': {
        title: 'Play Fishin Frenzy Megaways Slot Slot by Blueprint Gaming at {brand} | Instant Crypto Payouts',
        description: 'Play Fishin Frenzy Megaways Slot from Blueprint Gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/blueprint-gaming/fishin_frenzy_power_4_slots': {
        title: 'Fishin Frenzy Power 4 Slots Slot by Blueprint Gaming at {brand} | Instant Crypto Payouts',
        description: 'Fishin Frenzy Power 4 Slots from Blueprint Gaming, with a 50,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/blueprint-gaming/frankensteins_fortune': {
        title: "Frankenstein's Fortune: Play Online with Crypto | {brand}",
        description: "Frankenstein's Fortune from Blueprint Gaming, with a 2,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/blueprint-gaming/fruitopolis_fortune_play': {
        title: 'Fruitopolis Fortune Play Slot by Blueprint Gaming at {brand} | Instant Crypto Payouts',
        description: 'Fruitopolis Fortune Play by Blueprint Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/blueprint-gaming/full_moon_fever': {
        title: 'Full Moon Fever by Blueprint Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Full Moon Fever by Blueprint Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/blueprint-gaming/funky_buddha': {
        title: 'Play Funky Buddha by Blueprint Gaming at {brand} | 10,000x Max Win',
        description: 'Play Funky Buddha by Blueprint Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/blueprint-gaming/genie_jackpot_combo_frenzy': {
        title: 'Genie Jackpot Combo Frenzy Slot by Blueprint Gaming at {brand} | Instant Crypto Payouts',
        description: 'Genie Jackpot Combo Frenzy by Blueprint Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/blueprint-gaming/genie_jackpots_wishmaker': {
        title: 'Play Genie Jackpots Wishmaker by Blueprint Gaming at {brand} | 50,000x Max Win',
        description: 'Play Genie Jackpots Wishmaker by Blueprint Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/blueprint-gaming/gold_strike': {
        title: 'Gold Strike Slot by Blueprint Gaming at {brand} | Instant Crypto Payouts',
        description: 'Gold Strike by Blueprint Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/blueprint-gaming/gold_strike_2': {
        title: 'Play Gold Strike 2 by Blueprint Gaming at {brand} | 10,000x Max Win',
        description: 'Spin Gold Strike 2 by Blueprint Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/blueprint-gaming/gold_strike_bonanza': {
        title: 'Gold Strike Bonanza Slot by Blueprint Gaming at {brand} | Instant Crypto Payouts',
        description: 'Gold Strike Bonanza from Blueprint Gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/blueprint-gaming/gold_strike_express': {
        title: 'Gold Strike Express by Blueprint Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Gold Strike Express by Blueprint Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/blueprint-gaming/gorilla_gold_megaways_power_4_slots': {
        title: 'Gorilla Gold Megaways: Power 4 slots Jackpot King Slot by Blueprint Gaming | {brand}',
        description: 'Gorilla Gold Megaways: Power 4 slots by Blueprint Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/blueprint-gaming/hope_diamond': {
        title: 'Hope Diamond Slot Slot by Blueprint Gaming at {brand} | Instant Crypto Payouts',
        description: 'Hope Diamond Slot by Blueprint Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/blueprint-gaming/jungle_fortune_build_your_bonus': {
        title: 'Jungle Fortune Build Your Bonus by Blueprint Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Jungle Fortune Build Your Bonus by Blueprint Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/blueprint-gaming/king_kong_cash': {
        title: 'King Kong Cash Slot by Blueprint Gaming at {brand} | Instant Crypto Payouts',
        description: 'King Kong Cash by Blueprint Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/blueprint-gaming/king_kong_cash_dj_prime8': {
        title: 'Play King Kong Cash DJ Prime8 by Blueprint Gaming at {brand} | 10,000x Max Win',
        description: 'Spin King Kong Cash DJ Prime8 by Blueprint Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/blueprint-gaming/king_kong_cash_even_bigger_bananas': {
        title: 'King Kong Cash Even Bigger Bananas Jackpot King Slot by Blueprint Gaming | {brand}',
        description: 'Play King Kong Cash Even Bigger Bananas by Blueprint Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/blueprint-gaming/king_kong_cash_even_bigger_bananas_2': {
        title: 'King Kong Cash Even Bigger Bananas 2: Play Online with Crypto | {brand}',
        description: 'King Kong Cash Even Bigger Bananas 2 by Blueprint Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/blueprint-gaming/king_kong_cash_even_bigger_bananas_4': {
        title: 'King Kong Cash Even Bigger Bananas 4 Slot by Blueprint Gaming at {brand} | Instant Crypto Payouts',
        description: 'King Kong Cash Even Bigger Bananas 4 from Blueprint Gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/blueprint-gaming/king_kong_splash': {
        title: 'King Kong Splash Slot by Blueprint Gaming at {brand} | Instant Crypto Payouts',
        description: 'King Kong Splash by Blueprint Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/blueprint-gaming/king_of_the_west': {
        title: 'King of the West Jackpot King Slot by Blueprint Gaming | {brand}',
        description: 'King of the West by Blueprint Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/blueprint-gaming/kong_3_even_bigger_bonus': {
        title: 'Kong 3 Even Bigger Bonus Jackpot King Slot by Blueprint Gaming | {brand}',
        description: 'Kong 3 Even Bigger Bonus from Blueprint Gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/blueprint-gaming/legacy_of_gods_megaways': {
        title: 'Play Legacy of Gods Megaways by Blueprint Gaming at {brand} | 50,000x Max Win',
        description: 'Spin Legacy of Gods Megaways by Blueprint Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/blueprint-gaming/legacy_of_ra_megaways': {
        title: 'Play Legacy Of Ra Megaways by Blueprint Gaming at {brand} | 50,000x Max Win',
        description: 'Spin Legacy Of Ra Megaways by Blueprint Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/blueprint-gaming/lion_thunder': {
        title: 'Lion Thunder Slot by Blueprint Gaming at {brand} | Instant Crypto Payouts',
        description: 'Lion Thunder by Blueprint Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/blueprint-gaming/loti_fortune_spins': {
        title: 'Play LOTI Fortune Spins by Blueprint Gaming at {brand} | 10,000x Max Win',
        description: 'Spin LOTI Fortune Spins by Blueprint Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/blueprint-gaming/loti_gold_spins': {
        title: 'LOTI Gold Spins: Play Online with Crypto | {brand}',
        description: 'LOTI Gold Spins by Blueprint Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/blueprint-gaming/lucky_pharaoh': {
        title: 'Lucky Pharaoh by Blueprint Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Lucky Pharaoh by Blueprint Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/blueprint-gaming/majestic_fury_megaways': {
        title: 'Majestic Fury Megaways by Blueprint Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Majestic Fury Megaways by Blueprint Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/blueprint-gaming/majestic_fury_megaways_unleashed': {
        title: 'Play Majestic Fury Megaways Unleashed by Blueprint Gaming at {brand} | 10,000x Max Win',
        description: 'Play Majestic Fury Megaways Unleashed by Blueprint Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/blueprint-gaming/majestic_fury_win_stepper': {
        title: 'Majestic Fury Win Stepper by Blueprint Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Majestic Fury Win Stepper by Blueprint Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/blueprint-gaming/maradona': {
        title: 'Maradona Jackpot King Slot by Blueprint Gaming | {brand}',
        description: 'Maradona by Blueprint Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/blueprint-gaming/maradona_el_diez': {
        title: 'Play Maradona El Diez by Blueprint Gaming at {brand} | 50,000x Max Win',
        description: 'Spin Maradona El Diez by Blueprint Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/blueprint-gaming/maradona_el_pibe_de_oro': {
        title: 'Maradona: El Pibe De Oro by Blueprint Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Maradona: El Pibe De Oro from Blueprint Gaming. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/blueprint-gaming/midas_king_of_gold': {
        title: 'Midas King Of Gold Slot by Blueprint Gaming at {brand} | Instant Crypto Payouts',
        description: 'Midas King Of Gold by Blueprint Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/blueprint-gaming/napoleon_2_fat_stacks': {
        title: 'Napoleon 2 Fat Stacks Slot by Blueprint Gaming at {brand} | Instant Crypto Payouts',
        description: 'Napoleon 2 Fat Stacks from Blueprint Gaming, with a 50,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/blueprint-gaming/napoleon_deluxe': {
        title: 'Play Napoleon Deluxe by Blueprint Gaming at {brand} | 20,000x Max Win',
        description: 'Spin Napoleon Deluxe by Blueprint Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/blueprint-gaming/napoleon_megaways': {
        title: 'Napoleon Megaways Slot by Blueprint Gaming at {brand} | Instant Crypto Payouts',
        description: 'Napoleon Megaways from Blueprint Gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/blueprint-gaming/napoleon_rise_of_an_empire': {
        title: 'Napoleon: Rise of an Empire: Play Online with Crypto | {brand}',
        description: 'Napoleon: Rise of an Empire from Blueprint Gaming, with a 100,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/blueprint-gaming/plenty_o_fish': {
        title: "Plenty o' Fish: Play Online with Crypto | {brand}",
        description: "Plenty o' Fish by Blueprint Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/blueprint-gaming/primal_megaways': {
        title: 'Play Primal Megaways by Blueprint Gaming at {brand} | 50,000x Max Win',
        description: 'Spin Primal Megaways by Blueprint Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/blueprint-gaming/red_hot_chilli': {
        title: 'Red Hot Chilli Jackpot King Slot by Blueprint Gaming | {brand}',
        description: 'Red Hot Chilli by Blueprint Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/blueprint-gaming/red_hot_eruption': {
        title: 'Play Red Hot Eruption by Blueprint Gaming at {brand} | 8,000x Max Win',
        description: 'Spin Red Hot Eruption by Blueprint Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/blueprint-gaming/return_of_kong_megaways': {
        title: 'Return of Kong Megaways Slot by Blueprint Gaming at {brand} | Instant Crypto Payouts',
        description: 'Return of Kong Megaways from Blueprint Gaming, with a 50,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/blueprint-gaming/rhino_rampage': {
        title: 'Play Rhino Rampage by Blueprint Gaming at {brand} | 50,000x Max Win',
        description: 'Play Rhino Rampage by Blueprint Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/blueprint-gaming/rise_of_atlantis': {
        title: 'Rise of Atlantis by Blueprint Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Rise of Atlantis by Blueprint Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/blueprint-gaming/rise_of_atlantis_2': {
        title: 'Rise of Atlantis 2 Slot by Blueprint Gaming at {brand} | Instant Crypto Payouts',
        description: 'Rise of Atlantis 2 by Blueprint Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/blueprint-gaming/safari_gold_megaways': {
        title: 'Safari Gold Megaways by Blueprint Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Safari Gold Megaways by Blueprint Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/blueprint-gaming/saint_nicked_2': {
        title: 'Saint Nicked 2 Slot by Blueprint Gaming at {brand} | Instant Crypto Payouts',
        description: 'Saint Nicked 2 from Blueprint Gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/blueprint-gaming/spirit_wolf_wins': {
        title: 'Spirit Wolf Wins by Blueprint Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Spirit Wolf Wins by Blueprint Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/blueprint-gaming/stickermania_wild_rumble': {
        title: 'Play Stickermania Wild Rumble by Blueprint Gaming at {brand} | 10,000x Max Win',
        description: 'Spin Stickermania Wild Rumble by Blueprint Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/blueprint-gaming/super_7_winner': {
        title: 'Super 7 Winner Slot by Blueprint Gaming at {brand} | Instant Crypto Payouts',
        description: 'Super 7 Winner from Blueprint Gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/blueprint-gaming/super_wild_diamonds': {
        title: 'Play Super Wild Diamonds by Blueprint Gaming at {brand} | 10,000x Max Win',
        description: 'Spin Super Wild Diamonds by Blueprint Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/blueprint-gaming/sweet_success_megaways': {
        title: 'Sweet Success Megaways Slot by Blueprint Gaming at {brand} | Instant Crypto Payouts',
        description: 'Sweet Success Megaways by Blueprint Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/blueprint-gaming/tasty_trailz': {
        title: 'Tasty Trailz: Play Online with Crypto | {brand}',
        description: 'Spin Tasty Trailz by Blueprint Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/blueprint-gaming/temple_of_treasures_megaways': {
        title: 'Temple of Treasures Megaways Jackpot King Slot by Blueprint Gaming | {brand}',
        description: 'Temple of Treasures Megaways from Blueprint Gaming, with a 50,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/blueprint-gaming/the_goat': {
        title: 'The G.O.A.T Slot by Blueprint Gaming at {brand} | Instant Crypto Payouts',
        description: 'The G.O.A.T by Blueprint Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/blueprint-gaming/tomb_of_dead_power_4_slots': {
        title: 'Tomb of Dead: Power 4 slots by Blueprint Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Tomb of Dead: Power 4 slots by Blueprint Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/blueprint-gaming/trailblazer': {
        title: 'Play Trailblazer by Blueprint Gaming at {brand} | 5,000x Max Win',
        description: 'Play Trailblazer by Blueprint Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/blueprint-gaming/treasures_of_the_dead': {
        title: 'Treasures of the Dead: Play Online with Crypto | {brand}',
        description: 'Treasures of the Dead from Blueprint Gaming, with a 15,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/blueprint-gaming/valletta_megaways': {
        title: 'Valletta Megaways by Blueprint Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Valletta Megaways by Blueprint Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/blueprint-gaming/viking_fall': {
        title: 'Play Viking Fall by Blueprint Gaming at {brand} | 50,000x Max Win',
        description: 'Spin Viking Fall by Blueprint Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/blueprint-gaming/vikings_unleashed_megaways': {
        title: 'Play Vikings Unleashed MegaWays by Blueprint Gaming at {brand} | 50,000x Max Win',
        description: 'Spin Vikings Unleashed MegaWays by Blueprint Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/blueprint-gaming/vikings_unleashed_reloaded_megaways': {
        title: 'Vikings Unleashed Reloaded Megaways by Blueprint Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Vikings Unleashed Reloaded Megaways from Blueprint Gaming. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/blueprint-gaming/way_of_the_tiger': {
        title: 'Way Of The Tiger Jackpot King Slot by Blueprint Gaming | {brand}',
        description: 'Way Of The Tiger by Blueprint Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/blueprint-gaming/wish_upon_a_cashpot': {
        title: 'Wish Upon a Cashpot Slot by Blueprint Gaming at {brand} | Instant Crypto Payouts',
        description: 'Wish Upon a Cashpot from Blueprint Gaming, with a 50,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/blueprint-gaming/wish_upon_a_jackpot': {
        title: 'Wish Upon a Jackpot Jackpot King Slot by Blueprint Gaming | {brand}',
        description: 'Wish Upon a Jackpot from Blueprint Gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/blueprint-gaming/wish_upon_a_jackpot_megaways': {
        title: 'Wish Upon a Jackpot Megaways by Blueprint Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Wish Upon a Jackpot Megaways by Blueprint Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/blueprint-gaming/wolf_legend_megaways': {
        title: 'Wolf Legend Megaways Jackpot King Slot by Blueprint Gaming | {brand}',
        description: 'Wolf Legend Megaways from Blueprint Gaming, with a 50,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/blueprint-gaming/wolf_legend_spinboost': {
        title: 'Play Wolf Legend Spinboost by Blueprint Gaming at {brand} | 10,000x Max Win',
        description: 'Spin Wolf Legend Spinboost by Blueprint Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/boominggames/64_gold_coins_hold_and_win': {
        title: '64 Gold Coins Hold and Win  by Booming Games at {brand} | Free Demo & Crypto Play',
        description: 'Play 64 Gold Coins Hold and Win  by Booming Games at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/boominggames/64_gold_coins_hold_and_win_20000': {
        title: '64 Gold Coins Hold and Win 20000 Slot by Booming Games at {brand} | Instant Crypto Payouts',
        description: '64 Gold Coins Hold and Win 20000 by Booming Games at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/boominggames/arabian_spins': {
        title: 'Arabian spins by Booming Games at {brand} | Free Demo & Crypto Play',
        description: 'Arabian spins from Booming Games. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/boominggames/bamboo_wilds': {
        title: 'Bamboo Wilds: Play Online with Crypto | {brand}',
        description: 'Bamboo Wilds by Booming Games at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/boominggames/bang_bang': {
        title: 'Play Bang Bang by Booming Games at {brand} | 2,000x Max Win',
        description: 'Spin Bang Bang by Booming Games at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/boominggames/bang_bang_reloaded': {
        title: 'Bang Bang Reloaded Slot by Booming Games at {brand} | Instant Crypto Payouts',
        description: 'Bang Bang Reloaded from Booming Games, with a 5,200x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/boominggames/big_apple_wins': {
        title: 'Play Big Apple Wins by Booming Games at {brand} | 1,200x Max Win',
        description: 'Play Big Apple Wins by Booming Games at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/boominggames/blockchain_megaways': {
        title: 'Play Blockchain Megaways by Booming Games at {brand} | 40,320x Max Win',
        description: 'Play Blockchain Megaways by Booming Games at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/boominggames/bonza_bucks_hold_and_win_extreme_10000': {
        title: 'Play Bonza Bucks Hold and Win Extreme 10000 by Booming Games at {brand} | 12,000x Max Win',
        description: 'Spin Bonza Bucks Hold and Win Extreme 10000 by Booming Games at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/boominggames/boogie_boom': {
        title: 'Boogie Boom by Booming Games at {brand} | Free Demo & Crypto Play',
        description: 'Play Boogie Boom by Booming Games at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/boominggames/book_of_tombs': {
        title: 'Play Book of Tombs by Booming Games at {brand} | 1,200x Max Win',
        description: 'Play Book of Tombs by Booming Games at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/boominggames/booming_seven_deluxe': {
        title: 'Booming Seven Deluxe by Booming Games at {brand} | Free Demo & Crypto Play',
        description: 'Spin Booming Seven Deluxe by Booming Games at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/boominggames/booming_seven_deluxe_legacy': {
        title: 'Booming Seven Deluxe Legacy by Booming Games at {brand} | Free Demo & Crypto Play',
        description: 'Spin Booming Seven Deluxe Legacy by Booming Games at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/boominggames/buffalo_hold_and_win': {
        title: 'Buffalo Hold and Win Slot by Booming Games at {brand} | Instant Crypto Payouts',
        description: 'Buffalo Hold and Win by Booming Games at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/boominggames/buffalo_hold_and_win_extreme': {
        title: 'Buffalo Hold and Win Extreme by Booming Games at {brand} | Free Demo & Crypto Play',
        description: 'Play Buffalo Hold and Win Extreme by Booming Games at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/boominggames/buffalo_hold_and_win_extreme_10000': {
        title: 'Buffalo Hold and Win Extreme 10000 by Booming Games at {brand} | Free Demo & Crypto Play',
        description: 'Spin Buffalo Hold and Win Extreme 10000 by Booming Games at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/boominggames/burning_classic_2': {
        title: 'Play Burning Classic 2 by Booming Games at {brand} | 5,100x Max Win',
        description: 'Play Burning Classic 2 by Booming Games at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/boominggames/burning_classics': {
        title: 'Burning Classics by Booming Games at {brand} | Free Demo & Crypto Play',
        description: 'Spin Burning Classics by Booming Games at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/boominggames/burning_classics_5000': {
        title: 'Burning Classics 5000 by Booming Games at {brand} | Free Demo & Crypto Play',
        description: 'Play Burning Classics 5000 by Booming Games at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/boominggames/burning_classics_royal_edition': {
        title: 'Burning Classics Royal Edition: Play Online with Crypto | {brand}',
        description: 'Burning Classics Royal Edition from Booming Games, with a 2,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/boominggames/burning_love': {
        title: 'Burning Love: Play Online with Crypto | {brand}',
        description: 'Burning Love by Booming Games at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/boominggames/cash_pig': {
        title: 'Cash Pig Slot by Booming Games at {brand} | Instant Crypto Payouts',
        description: 'Cash Pig by Booming Games at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/boominggames/cash_pig_2': {
        title: 'Cash Pig 2 by Booming Games at {brand} | Free Demo & Crypto Play',
        description: 'Spin Cash Pig 2 by Booming Games at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/boominggames/cash_pig_2_15000': {
        title: 'Cash Pig 2 15000 Slot by Booming Games at {brand} | Instant Crypto Payouts',
        description: 'Cash Pig 2 15000 by Booming Games at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/boominggames/chief_hawks_spirit_walk': {
        title: 'Chief Hawks Spirit Walk Slot by Booming Games at {brand} | Instant Crypto Payouts',
        description: 'Chief Hawks Spirit Walk by Booming Games at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/boominggames/classic_coins': {
        title: 'Play Classic Coins by Booming Games at {brand} | 10,000x Max Win',
        description: 'Play Classic Coins by Booming Games at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/boominggames/classic_fantastic': {
        title: 'Classic Fantastic Slot by Booming Games at {brand} | Instant Crypto Payouts',
        description: 'Classic Fantastic from Booming Games, with a 7,063x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/boominggames/coin_crusher_hold_and_win': {
        title: 'Coin Crusher Hold and Win by Booming Games at {brand} | Free Demo & Crypto Play',
        description: 'Play Coin Crusher Hold and Win by Booming Games at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/boominggames/crack_the_bank_hold_and_win': {
        title: 'Crack the Bank Hold and Win Slot by Booming Games at {brand} | Instant Crypto Payouts',
        description: 'Crack the Bank Hold and Win by Booming Games at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/boominggames/diamond_hits': {
        title: 'Play Diamond Hits by Booming Games at {brand} | 2,150x Max Win',
        description: 'Play Diamond Hits by Booming Games at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/boominggames/diamond_hits_trio_instastrike': {
        title: 'Diamond Hits Trio Instastrike: Play Online with Crypto | {brand}',
        description: 'Diamond Hits Trio Instastrike from Booming Games, with a 12,500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/boominggames/diamond_riches': {
        title: 'Play Diamond Riches by Booming Games at {brand} | 1,200x Max Win',
        description: 'Spin Diamond Riches by Booming Games at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/boominggames/diamonds_diamonds_diamonds_hold_and_win': {
        title: 'Diamonds Diamonds Diamonds Hold and Win: Play Online with Crypto | {brand}',
        description: 'Diamonds Diamonds Diamonds Hold and Win by Booming Games at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/boominggames/diamonds_of_liberty': {
        title: 'Diamonds of Liberty by Booming Games at {brand} | Free Demo & Crypto Play',
        description: 'Spin Diamonds of Liberty by Booming Games at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/boominggames/dynamite_trio': {
        title: 'Dynamite Trio: Play Online with Crypto | {brand}',
        description: 'Dynamite Trio from Booming Games, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/boominggames/easter_classics': {
        title: 'Easter Classics Slot by Booming Games at {brand} | Instant Crypto Payouts',
        description: 'Easter Classics from Booming Games, with a 2,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/boominggames/fish_tales_colossal_catch_link_and_loot': {
        title: 'Play Fish Tales Colossal Catch Link and Loot by Booming Games at {brand} | 10,000x Max Win',
        description: 'Play Fish Tales Colossal Catch Link and Loot by Booming Games at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/boominggames/fish_tales_double_catch': {
        title: 'Fish Tales Double Catch: Play Online with Crypto | {brand}',
        description: 'Fish Tales Double Catch from Booming Games, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/boominggames/fish_tales_halloween': {
        title: 'Fish Tales Halloween Bonus Buy Slot by Booming Games | {brand}',
        description: 'Fish Tales Halloween from Booming Games, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/boominggames/fish_tales_monster_bass': {
        title: 'Play Fish Tales Monster Bass by Booming Games at {brand} | 5,000x Max Win',
        description: 'Play Fish Tales Monster Bass by Booming Games at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/boominggames/flaming_chilies': {
        title: 'Flaming Chilies: Play Online with Crypto | {brand}',
        description: 'Flaming Chilies by Booming Games at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/boominggames/flaming_chillies': {
        title: 'Flaming Chillies Slot by Booming Games at {brand} | Instant Crypto Payouts',
        description: 'Flaming Chillies by Booming Games at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/boominggames/forbidden_temple_power_hit': {
        title: 'Play Forbidden Temple Power Hit by Booming Games at {brand} | 10,000x Max Win',
        description: 'Spin Forbidden Temple Power Hit by Booming Games at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/boominggames/fortune_and_finery': {
        title: 'Play Fortune and Finery by Booming Games at {brand} | 8,000x Max Win',
        description: 'Play Fortune and Finery by Booming Games at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/boominggames/fruit_heaven_hold_and_win': {
        title: 'Fruit Heaven Hold and Win by Booming Games at {brand} | Free Demo & Crypto Play',
        description: 'Play Fruit Heaven Hold and Win by Booming Games at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/boominggames/gamblelicious_hold_and_win': {
        title: 'Play Gamblelicious Hold and Win by Booming Games at {brand} | 1,200x Max Win',
        description: 'Spin Gamblelicious Hold and Win by Booming Games at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/boominggames/gold_gold_gold': {
        title: 'Gold Gold Gold by Booming Games at {brand} | Free Demo & Crypto Play',
        description: 'Gold Gold Gold from Booming Games. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/boominggames/gold_gold_gold_5000': {
        title: 'Gold Gold Gold 5000 Slot by Booming Games at {brand} | Instant Crypto Payouts',
        description: 'Gold Gold Gold 5000 from Booming Games, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/boominggames/gold_gold_gold_hold_and_win': {
        title: 'Play Gold Gold Gold Hold and Win by Booming Games at {brand} | 2,000x Max Win',
        description: 'Spin Gold Gold Gold Hold and Win by Booming Games at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/boominggames/greedy_for_gold_power_hit': {
        title: 'Play Greedy for Gold Power Hit by Booming Games at {brand} | 5,000x Max Win',
        description: 'Spin Greedy for Gold Power Hit by Booming Games at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/boominggames/greek_legends': {
        title: 'Greek Legends by Booming Games at {brand} | Free Demo & Crypto Play',
        description: 'Spin Greek Legends by Booming Games at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/boominggames/holly_jolly_bonanza': {
        title: 'Play Holly Jolly Bonanza by Booming Games at {brand} | 6,500x Max Win',
        description: 'Play Holly Jolly Bonanza by Booming Games at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/boominggames/holly_jolly_bonanza_2': {
        title: 'Holly Jolly Bonanza 2 Slot by Booming Games at {brand} | Instant Crypto Payouts',
        description: 'Holly Jolly Bonanza 2 by Booming Games at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/boominggames/holly_jolly_cash_pig': {
        title: 'Holly Jolly Cash Pig: Play Online with Crypto | {brand}',
        description: 'Holly Jolly Cash Pig by Booming Games at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/boominggames/hot_charge': {
        title: 'Hot Charge Slot by Booming Games at {brand} | Instant Crypto Payouts',
        description: 'Hot Charge by Booming Games at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/boominggames/howling_for_gold': {
        title: 'Howling for Gold by Booming Games at {brand} | Free Demo & Crypto Play',
        description: 'Play Howling for Gold by Booming Games at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/boominggames/howling_wolves_megaways': {
        title: 'Howling Wolves Megaways Bonus Buy Slot by Booming Games | {brand}',
        description: 'Howling Wolves Megaways by Booming Games at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/boominggames/inferno_fortune_power_hit': {
        title: 'Play Inferno Fortune Power Hit by Booming Games at {brand} | 5,000x Max Win',
        description: 'Spin Inferno Fortune Power Hit by Booming Games at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/boominggames/jam_bonanza': {
        title: 'Jam Bonanza: Play Online with Crypto | {brand}',
        description: 'Jam Bonanza by Booming Games at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/boominggames/jesters_bells_bonanza': {
        title: "Jester's Bells Bonanza by Booming Games at {brand} | Free Demo & Crypto Play",
        description: "Play Jester's Bells Bonanza by Booming Games at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/boominggames/jesters_riches': {
        title: 'Play Jesters Riches by Booming Games at {brand} | 2,000x Max Win',
        description: 'Play Jesters Riches by Booming Games at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/boominggames/king_cobra': {
        title: 'Play King Cobra by Booming Games at {brand} | 6,500x Max Win',
        description: 'Spin King Cobra by Booming Games at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/boominggames/legendary_diamonds': {
        title: 'Play Legendary Diamonds by Booming Games at {brand} | 1,200x Max Win',
        description: 'Play Legendary Diamonds by Booming Games at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/boominggames/let_it_spin': {
        title: 'Let it Spin Slot by Booming Games at {brand} | Instant Crypto Payouts',
        description: 'Let it Spin from Booming Games, with a 2,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/boominggames/liberty_and_freedom_hold_and_win_extreme_10000': {
        title: 'Liberty and Freedom Hold and Win Extreme 10000 Bonus Buy Slot by Booming Games | {brand}',
        description: 'Liberty and Freedom Hold and Win Extreme 10000 from Booming Games, with a 12,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/boominggames/lucky_charms_trio': {
        title: 'Lucky Charms Trio Slot by Booming Games at {brand} | Instant Crypto Payouts',
        description: 'Lucky Charms Trio by Booming Games at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/boominggames/lucky_oasis': {
        title: 'Lucky Oasis Slot by Booming Games at {brand} | Instant Crypto Payouts',
        description: 'Lucky Oasis by Booming Games at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/boominggames/mighty_gorilla': {
        title: 'Mighty Gorilla by Booming Games at {brand} | Free Demo & Crypto Play',
        description: 'Spin Mighty Gorilla by Booming Games at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/boominggames/mr_oinksters_hold_and_win': {
        title: 'Mr. Oinksters Hold and Win by Booming Games at {brand} | Free Demo & Crypto Play',
        description: 'Spin Mr. Oinksters Hold and Win by Booming Games at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/boominggames/paris_nights': {
        title: 'Paris Nights by Booming Games at {brand} | Free Demo & Crypto Play',
        description: 'Play Paris Nights by Booming Games at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/boominggames/payday_pig': {
        title: 'Payday Pig by Booming Games at {brand} | Free Demo & Crypto Play',
        description: 'Play Payday Pig by Booming Games at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/boominggames/power_of_atlantis_trio': {
        title: 'Play Power of Atlantis Trio by Booming Games at {brand} | 10,000x Max Win',
        description: 'Spin Power of Atlantis Trio by Booming Games at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/boominggames/power_of_hercules_bonanza': {
        title: 'Play Power of Hercules Bonanza by Booming Games at {brand} | 5,000x Max Win',
        description: 'Spin Power of Hercules Bonanza by Booming Games at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/boominggames/power_of_olympus': {
        title: 'Play Power of Olympus by Booming Games at {brand} | 8,066x Max Win',
        description: 'Play Power of Olympus by Booming Games at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/boominggames/power_of_rome': {
        title: 'Play Power of Rome by Booming Games at {brand} | 2,500x Max Win',
        description: 'Spin Power of Rome by Booming Games at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/boominggames/ras_relics_bonanza': {
        title: "Play Ra's Relics Bonanza by Booming Games at {brand} | 6,500x Max Win",
        description: "Spin Ra's Relics Bonanza by Booming Games at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/boominggames/reels_paradise': {
        title: 'Play Reels Paradise by Booming Games at {brand} | 5,000x Max Win',
        description: 'Spin Reels Paradise by Booming Games at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/boominggames/rhino_hold_and_win': {
        title: 'Rhino Hold and Win by Booming Games at {brand} | Free Demo & Crypto Play',
        description: 'Play Rhino Hold and Win by Booming Games at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/boominggames/roll_the_dice': {
        title: 'Play Roll the Dice by Booming Games at {brand} | 1,200x Max Win',
        description: 'Spin Roll the Dice by Booming Games at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/boominggames/ronaldinho_scores_shoot_and_win': {
        title: 'Play Ronaldinho Scores Shoot and Win by Booming Games at {brand} | 4,500x Max Win',
        description: 'Play Ronaldinho Scores Shoot and Win by Booming Games at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/boominggames/ronaldinho_spins': {
        title: 'Ronaldinho Spins Bonus Buy Slot by Booming Games | {brand}',
        description: 'Ronaldinho Spins by Booming Games at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/boominggames/royal_wins': {
        title: 'Royal Wins Bonus Buy Slot by Booming Games | {brand}',
        description: 'Play Royal Wins by Booming Games at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/boominggames/santa_in_vegas': {
        title: 'Santa in Vegas: Play Online with Crypto | {brand}',
        description: 'Santa in Vegas by Booming Games at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/boominggames/santas_snowball_smash_instant_win': {
        title: 'Santas Snowball Smash Instant Win: Play Online with Crypto | {brand}',
        description: 'Spin Santas Snowball Smash Instant Win by Booming Games at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/boominggames/secret_book_of_amun_ra': {
        title: 'Secret Book of Amun Ra Bonus Buy Slot by Booming Games | {brand}',
        description: 'Secret Book of Amun Ra from Booming Games, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/boominggames/shields_of_gold_valkyrie_hold_and_win': {
        title: 'Shields of Gold Valkyrie Hold and Win: Play Online with Crypto | {brand}',
        description: 'Shields of Gold Valkyrie Hold and Win by Booming Games at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/boominggames/smoking_pistols': {
        title: 'Play Smoking Pistols by Booming Games at {brand} | 5,000x Max Win',
        description: 'Play Smoking Pistols by Booming Games at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/boominggames/space_cows_to_the_moon': {
        title: "Play Space Cows to the Moo'n by Booming Games at {brand} | 5,000x Max Win",
        description: "Spin Space Cows to the Moo'n by Booming Games at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/boominggames/space_sam_walk_and_win': {
        title: 'Play Space Sam Walk and Win by Booming Games at {brand} | 7,500x Max Win',
        description: 'Play Space Sam Walk and Win by Booming Games at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/boominggames/spooktacular_bonanza': {
        title: 'Spooktacular Bonanza Slot by Booming Games at {brand} | Instant Crypto Payouts',
        description: 'Spooktacular Bonanza by Booming Games at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/boominggames/stampede_bonanza': {
        title: 'Play Stampede Bonanza by Booming Games at {brand} | 7,500x Max Win',
        description: 'Spin Stampede Bonanza by Booming Games at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/boominggames/super_duper': {
        title: 'Super Duper Bonus Buy Slot by Booming Games | {brand}',
        description: 'Super Duper by Booming Games at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/boominggames/tasty_bonanza': {
        title: 'Play Tasty Bonanza by Booming Games at {brand} | 6,500x Max Win',
        description: 'Play Tasty Bonanza by Booming Games at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/boominggames/tasty_bonanza_1000': {
        title: 'Play Tasty Bonanza 1,000 by Booming Games at {brand} | 10,000x Max Win',
        description: 'Spin Tasty Bonanza 1,000 by Booming Games at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/boominggames/the_chillies': {
        title: 'Play The Chillies by Booming Games at {brand} | 4,000x Max Win',
        description: 'Spin The Chillies by Booming Games at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/boominggames/the_mighty_toro': {
        title: 'Play The Mighty Toro by Booming Games at {brand} | 6,500x Max Win',
        description: 'Spin The Mighty Toro by Booming Games at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/boominggames/the_wild_wings_of_phoenix': {
        title: 'Play The Wild Wings of Phoenix by Booming Games at {brand} | 1,200x Max Win',
        description: 'Play The Wild Wings of Phoenix by Booming Games at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/boominggames/the_wild_wings_of_phoenix_deluxe': {
        title: 'Play The Wild Wings of Phoenix Deluxe by Booming Games at {brand} | 5,000x Max Win',
        description: 'Spin The Wild Wings of Phoenix Deluxe by Booming Games at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/boominggames/thunder_eagle_hold_and_win_10000': {
        title: 'Thunder Eagle Hold and Win 10000 Slot by Booming Games at {brand} | Instant Crypto Payouts',
        description: 'Thunder Eagle Hold and Win 10000 from Booming Games, with a 12,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/boominggames/tnt_bonanza': {
        title: 'TNT Bonanza Slot by Booming Games at {brand} | Instant Crypto Payouts',
        description: 'TNT Bonanza by Booming Games at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/boominggames/tnt_bonanza_2': {
        title: 'TNT Bonanza 2 by Booming Games at {brand} | Free Demo & Crypto Play',
        description: 'Spin TNT Bonanza 2 by Booming Games at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/boominggames/treasure_vault': {
        title: 'Treasure Vault: Play Online with Crypto | {brand}',
        description: 'Treasure Vault by Booming Games at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/boominggames/trollfufu_bonanza': {
        title: 'Play Trollfufu Bonanza by Booming Games at {brand} | 6,500x Max Win',
        description: 'Play Trollfufu Bonanza by Booming Games at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/boominggames/ultimate_hold_n_win': {
        title: "Play Ultimate Hold 'N' Win by Booming Games at {brand} | 5,000x Max Win",
        description: "Play Ultimate Hold 'N' Win by Booming Games at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/boominggames/vegas_wins': {
        title: 'Vegas Wins Slot by Booming Games at {brand} | Instant Crypto Payouts',
        description: 'Vegas Wins from Booming Games, with a 1,200x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/boominggames/vip_filthy_riches': {
        title: 'VIP Filthy Riches: Play Online with Crypto | {brand}',
        description: 'Spin VIP Filthy Riches by Booming Games at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/boominggames/wild_diamond_7x': {
        title: 'Play Wild Diamond 7x by Booming Games at {brand} | 1,200x Max Win',
        description: 'Play Wild Diamond 7x by Booming Games at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/boominggames/wild_wild_vegas': {
        title: 'Wild Wild Vegas Bonus Buy Slot by Booming Games | {brand}',
        description: 'Wild Wild Vegas from Booming Games, with a 2,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/fantasma/alice_in_adventureland': {
        title: 'Alice in Adventureland by Fantasma at {brand} | Free Demo & Crypto Play',
        description: 'Play Alice in Adventureland by Fantasma at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/fantasma/animal_carnival': {
        title: 'Animal Carnival Cluster Slot by Fantasma | {brand}',
        description: 'Animal Carnival from Fantasma, with a 1,642x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/fantasma/bounty_showdown': {
        title: 'Bounty Showdown Cluster Slot by Fantasma | {brand}',
        description: 'Bounty Showdown by Fantasma at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/fantasma/caravan_of_riches': {
        title: 'Caravan of Riches Slot by Fantasma at {brand} | Instant Crypto Payouts',
        description: 'Caravan of Riches from Fantasma, with a 1,312x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/fantasma/circle_of_sylvan': {
        title: 'Play Circle of Sylvan by Fantasma at {brand} | 5,000x Max Win',
        description: 'Spin Circle of Sylvan by Fantasma at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/fantasma/desert_shark': {
        title: 'Desert Shark Cluster Slot by Fantasma | {brand}',
        description: 'Desert Shark by Fantasma at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/fantasma/elemento': {
        title: 'Elemento Cluster Slot by Fantasma | {brand}',
        description: 'Elemento by Fantasma at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/fantasma/flower_fortunes_supreme': {
        title: 'Flower Fortunes Supreme by Fantasma at {brand} | Free Demo & Crypto Play',
        description: 'Play Flower Fortunes Supreme by Fantasma at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/fantasma/fortune_llama': {
        title: 'Fortune Llama Cluster Slot by Fantasma | {brand}',
        description: 'Fortune Llama by Fantasma at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/fantasma/golden_castle_titanways': {
        title: 'Golden Castle TitanWays: Play Online with Crypto | {brand}',
        description: 'Golden Castle TitanWays by Fantasma at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/fantasma/hades_river_of_souls': {
        title: 'Hades: River of Souls Cluster Slot by Fantasma | {brand}',
        description: 'Hades: River of Souls from Fantasma, with a 5,013x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/fantasma/heroes_hunt_2': {
        title: 'Heroes Hunt 2 Slot by Fantasma at {brand} | Instant Crypto Payouts',
        description: 'Heroes Hunt 2 from Fantasma, with a 20,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/fantasma/heroes_hunt_megaways': {
        title: 'Heroes Hunt MegaWays: Play Online with Crypto | {brand}',
        description: 'Heroes Hunt MegaWays by Fantasma at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/fantasma/magikspell': {
        title: 'Magikspell Slot by Fantasma at {brand} | Instant Crypto Payouts',
        description: 'Magikspell by Fantasma at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/fantasma/maze_escape_megaways': {
        title: 'Play Maze Escape MegaWays by Fantasma at {brand} | 25,000x Max Win',
        description: 'Play Maze Escape MegaWays by Fantasma at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/fantasma/medallion_megaways': {
        title: 'Medallion MegaWays by Fantasma at {brand} | Free Demo & Crypto Play',
        description: 'Spin Medallion MegaWays by Fantasma at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/fantasma/mystic_spells': {
        title: 'Mystic Spells Cluster Slot by Fantasma | {brand}',
        description: 'Mystic Spells by Fantasma at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/fantasma/pirate_multi_coins': {
        title: 'Play Pirate Multi Coins by Fantasma at {brand} | 4,999x Max Win',
        description: 'Spin Pirate Multi Coins by Fantasma at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/fantasma/rich_raptors': {
        title: 'Play Rich Raptors by Fantasma at {brand} | 8,024x Max Win',
        description: 'Spin Rich Raptors by Fantasma at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/fantasma/safari_sun': {
        title: 'Safari Sun Cluster Slot by Fantasma | {brand}',
        description: 'Safari Sun from Fantasma, with a 18,792x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/fantasma/serpent_shrine': {
        title: 'Serpent Shrine: Play Online with Crypto | {brand}',
        description: 'Serpent Shrine by Fantasma at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/fantasma/shadow_summoner_elementals': {
        title: 'Play Shadow Summoner Elementals by Fantasma at {brand} | 5,610x Max Win',
        description: 'Spin Shadow Summoner Elementals by Fantasma at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/fantasma/twisted_turbine': {
        title: 'Twisted Turbine by Fantasma at {brand} | Free Demo & Crypto Play',
        description: 'Spin Twisted Turbine by Fantasma at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/fantasma/wins_of_mermaid_multi_power': {
        title: 'Wins of Mermaid Multi Power Slot by Fantasma at {brand} | Instant Crypto Payouts',
        description: 'Wins of Mermaid Multi Power from Fantasma, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/fantasma/wins_of_winter': {
        title: 'Wins of Winter Cluster Slot by Fantasma | {brand}',
        description: 'Wins of Winter from Fantasma, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/nolimit-city/apocalypse_super_xnudge': {
        title: 'Play Apocalypse Slot by Nolimit City at {brand} | Free Demo & Crypto Play',
        description: 'Spin Play Apocalypse Slot by Nolimit City at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/nolimit-city/bangkok_hilton': {
        title: 'Bangkok Hilton: Play Online with Crypto | {brand}',
        description: 'Bangkok Hilton from Nolimit City, with a 44,444x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/nolimit-city/barbarian_fury': {
        title: 'Play Barbarian Fury Slot by Nolimit City at {brand} | Free Demo & Crypto Play',
        description: 'Play Play Barbarian Fury Slot by Nolimit City at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/nolimit-city/beheaded': {
        title: 'Play Beheaded Slot by Nolimit City at {brand} | Instant Crypto Payouts',
        description: 'Play Beheaded by Nolimit City at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/nolimit-city/benji_killed_in_vegas': {
        title: 'Play Benji Killed in Vegas Slot by Nolimit City at {brand} | 10,000x Max Win',
        description: 'Play Benji Killed in Vegas Slot by Nolimit City at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/nolimit-city/bizarre': {
        title: 'Play Play Bizarre Slot by Nolimit City at {brand} | 20,000x Max Win',
        description: 'Spin Play Bizarre Slot by Nolimit City at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/nolimit-city/blood_and_shadow': {
        title: 'Play Blood & Shadow Slot by Nolimit City at {brand} | 6,666x Max Win',
        description: 'Spin Blood & Shadow Slot by Nolimit City at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/nolimit-city/blood_and_shadow_2': {
        title: 'Blood and Shadow 2 xNudge Slot by Nolimit City | {brand}',
        description: 'Blood and Shadow 2 from Nolimit City, with a 16,161x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/nolimit-city/blood_diamond': {
        title: 'Play Blood Diamond Slot by Nolimit City at {brand} | Free Demo & Crypto Play',
        description: 'Spin Play Blood Diamond Slot by Nolimit City at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/nolimit-city/bonus_bunnies': {
        title: 'Play Bonus Bunnies: Play Online with Crypto | {brand}',
        description: 'Play Bonus Bunnies by Nolimit City at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/nolimit-city/book_of_shadows': {
        title: 'Play Book Of Shadows Slot by Nolimit City at {brand} | 30,338x Max Win',
        description: 'Play Book Of Shadows Slot by Nolimit City at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/nolimit-city/bounty_hunters': {
        title: 'Play Play Bounty Hunters Slot by Nolimit City at {brand} | 10,000x Max Win',
        description: 'Play Play Bounty Hunters Slot by Nolimit City at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/nolimit-city/breakout': {
        title: 'Play Play Breakout Slot by Nolimit City at {brand} | 20,000x Max Win',
        description: 'Play Play Breakout Slot by Nolimit City at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/nolimit-city/brick_snake_2000': {
        title: 'Play Brick Snake 2000 Slot by Nolimit City at {brand} | 10,000x Max Win',
        description: 'Play Brick Snake 2000 Slot by Nolimit City at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/nolimit-city/brute_force': {
        title: 'Play Brute Force xNudge Slot by Nolimit City | {brand}',
        description: 'Play Brute Force from Nolimit City, with a 40,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/nolimit-city/brute_force_alien_onslaught': {
        title: 'Play Brute Force Slot by Nolimit City at {brand} | Instant Crypto Payouts',
        description: 'Play Brute Force from Nolimit City, with a 80,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/nolimit-city/buffalo_hunter': {
        title: 'Buffalo Hunter Slot Slot by Nolimit City at {brand} | Instant Crypto Payouts',
        description: 'Buffalo Hunter Slot by Nolimit City at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/nolimit-city/bushido_way_xnudge': {
        title: 'Bushido Way xNudge Slot Slot by Nolimit City at {brand} | Instant Crypto Payouts',
        description: 'Bushido Way xNudge Slot by Nolimit City at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/nolimit-city/casino_win_spin': {
        title: 'Play Play Casino Win Spin Slot by Nolimit City at {brand} | 2,000x Max Win',
        description: 'Spin Play Casino Win Spin Slot by Nolimit City at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/nolimit-city/catfish_hunters': {
        title: 'Play Catfish Hunters: Play Online with Crypto | {brand}',
        description: 'Play Catfish Hunters from Nolimit City, with a 20,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/nolimit-city/coins_of_fortune': {
        title: 'Coins of Fortune: Play Online with Crypto | {brand}',
        description: 'Coins of Fortune by Nolimit City at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/nolimit-city/crazy_ex_girlfriend': {
        title: 'Crazy Ex Girlfriend Slot: Play Online with Crypto | {brand}',
        description: 'Crazy Ex Girlfriend Slot by Nolimit City at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/nolimit-city/d_day': {
        title: 'Play D Day Slot by Nolimit City at {brand} | 10,000x Max Win',
        description: 'Play D Day Slot by Nolimit City at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/nolimit-city/das_xboot': {
        title: 'Das XBoot 2 Slot by Nolimit City at {brand} | Free Demo & Crypto Play',
        description: 'Play Das XBoot 2 Slot by Nolimit City at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/nolimit-city/dead_canary': {
        title: 'Play Dead Canary Slot by Nolimit City at {brand} | 65,000x Max Win',
        description: 'Spin Dead Canary Slot by Nolimit City at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/nolimit-city/dead_dead_or_deader': {
        title: 'Dead Dead or Deader by Nolimit City at {brand} | Free Demo & Crypto Play',
        description: 'Play Dead Dead or Deader by Nolimit City at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/nolimit-city/dead_men_walking': {
        title: 'Play Dead Men Walking Slot by Nolimit City at {brand} | 25,313x Max Win',
        description: 'Spin Dead Men Walking Slot by Nolimit City at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/nolimit-city/deadwood_rip': {
        title: 'Play Deadwood RIP Slot by Nolimit City at {brand} | 100,000x Max Win',
        description: 'Play Deadwood RIP Slot by Nolimit City at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/nolimit-city/deadwood_xnudge': {
        title: 'Play Deadwood xNudge Slot by Nolimit City at {brand} | 13,950x Max Win',
        description: 'Play Deadwood xNudge Slot by Nolimit City at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/nolimit-city/devils_crossroad': {
        title: 'Play Devils Crossroad Slot by Nolimit City at {brand} | Instant Crypto Payouts',
        description: 'Play Devils Crossroad from Nolimit City, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/nolimit-city/disorder': {
        title: 'Disorder Slot xNudge Slot by Nolimit City | {brand}',
        description: 'Disorder Slot from Nolimit City, with a 23,500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/nolimit-city/disturbed': {
        title: 'Disturbed Slot xNudge Slot by Nolimit City | {brand}',
        description: 'Disturbed Slot from Nolimit City, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/nolimit-city/dj_psycho': {
        title: 'Dj Psycho by Nolimit City at {brand} | Free Demo & Crypto Play',
        description: 'Play Dj Psycho by Nolimit City at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/nolimit-city/dragon_tribe': {
        title: 'Play Dragon Tribe xNudge Slot by Nolimit City | {brand}',
        description: 'Play Dragon Tribe by Nolimit City at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/nolimit-city/duck_hunters': {
        title: 'Play Duck Hunters Happy Hour Slot by Nolimit City at {brand} | 33,333x Max Win',
        description: 'Spin Duck Hunters Happy Hour Slot by Nolimit City at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/nolimit-city/dungeon_quest': {
        title: 'Dungeon Quest by Nolimit City at {brand} | Free Demo & Crypto Play',
        description: 'Play Dungeon Quest by Nolimit City at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/nolimit-city/east_coast_vs_west_coast': {
        title: 'Play East Coast Vs West Coast by Nolimit City at {brand} | 30,618x Max Win',
        description: 'Spin East Coast Vs West Coast by Nolimit City at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/nolimit-city/el_paso_gunfight_xnudge': {
        title: 'El Paso Gunfight xNudge Slot Slot by Nolimit City at {brand} | Instant Crypto Payouts',
        description: 'El Paso Gunfight xNudge Slot by Nolimit City at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/nolimit-city/evil_goblins_xbomb': {
        title: 'Play Evil Goblins Xbomb Slot by Nolimit City at {brand} | Instant Crypto Payouts',
        description: 'Play Evil Goblins Xbomb from Nolimit City, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/nolimit-city/fire_in_the_hole_2': {
        title: 'Play Fire In The Hole 2: Play Online with Crypto | {brand}',
        description: 'Play Fire In The Hole 2 by Nolimit City at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/nolimit-city/fire_in_the_hole_3': {
        title: 'Play Fire in the Hole 3 Slot by Nolimit City at {brand} | 70,000x Max Win',
        description: 'Play Fire in the Hole 3 Slot by Nolimit City at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/nolimit-city/fire_in_the_hole_xbomb': {
        title: 'Play Fire In The Hole xBomb xNudge Slot by Nolimit City | {brand}',
        description: 'Play Fire In The Hole xBomb by Nolimit City at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/nolimit-city/flight_mode': {
        title: 'Play Flight Mode xNudge Slot by Nolimit City | {brand}',
        description: 'Play Flight Mode from Nolimit City, with a 5,051x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/nolimit-city/folsom_prison': {
        title: 'Play Folsom Prison: Play Online with Crypto | {brand}',
        description: 'Play Folsom Prison by Nolimit City at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/nolimit-city/fruits': {
        title: 'Play Play Fruits Slot by Nolimit City at {brand} | 2,910x Max Win',
        description: 'Play Play Fruits Slot by Nolimit City at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/nolimit-city/gaelic_gold': {
        title: 'Play Gaelic Gold Slot by Nolimit City at {brand} | Instant Crypto Payouts',
        description: 'Play Gaelic Gold by Nolimit City at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/nolimit-city/gluttony': {
        title: 'Play Gluttony: Play Online with Crypto | {brand}',
        description: 'Play Gluttony by Nolimit City at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/nolimit-city/golden_genie_and_the_walking_wilds': {
        title: 'Play Golden Genie And The Walking Wilds xNudge Slot by Nolimit City | {brand}',
        description: 'Play Golden Genie And The Walking Wilds from Nolimit City, with a 9,583x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/nolimit-city/golden_shower': {
        title: 'Golden Shower Slot xNudge Slot by Nolimit City | {brand}',
        description: 'Golden Shower Slot by Nolimit City at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/nolimit-city/harlequin_carnival': {
        title: 'Harlequin Carnival xNudge Slot by Nolimit City | {brand}',
        description: 'Harlequin Carnival by Nolimit City at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/nolimit-city/highway_to_hell': {
        title: 'Play Play Highway to Hell Slot by Nolimit City at {brand} | 20,066x Max Win',
        description: 'Spin Play Highway to Hell Slot by Nolimit City at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/nolimit-city/home_of_the_brave': {
        title: 'Play Home of the Brave Slot by Nolimit City at {brand} | Instant Crypto Payouts',
        description: 'Play Home of the Brave from Nolimit City, with a 61,446x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/nolimit-city/hot_4_cash': {
        title: 'Hot 4 Cash Slot xNudge Slot by Nolimit City | {brand}',
        description: 'Hot 4 Cash Slot from Nolimit City, with a 2,400x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/nolimit-city/hot_nudge': {
        title: 'Play Hot Nudge Slot by Nolimit City at {brand} | 10,000x Max Win',
        description: 'Play Hot Nudge Slot by Nolimit City at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/nolimit-city/ice_ice_yeti': {
        title: 'Ice Ice Yeti by Nolimit City at {brand} | Free Demo & Crypto Play',
        description: 'Spin Ice Ice Yeti by Nolimit City at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/nolimit-city/immortal_fruits': {
        title: 'Play Immortal Fruits Slot by Nolimit City at {brand} | 2,787x Max Win',
        description: 'Spin Immortal Fruits Slot by Nolimit City at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/nolimit-city/infectious_5_xways': {
        title: 'Play Infectious 5 xWays xNudge Slot by Nolimit City | {brand}',
        description: 'Play Infectious 5 xWays from Nolimit City, with a 55,555x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/nolimit-city/jingle_balls': {
        title: 'Jingle Balls: Play Online with Crypto | {brand}',
        description: 'Jingle Balls by Nolimit City at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/nolimit-city/karen_maneater': {
        title: 'Play Karen Maneater Slot by Nolimit City at {brand} | 11,757x Max Win',
        description: 'Spin Karen Maneater Slot by Nolimit City at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/nolimit-city/kenneth_must_die': {
        title: 'Play Kenneth Must Die Slot by Nolimit City at {brand} | Instant Crypto Payouts',
        description: 'Play Kenneth Must Die by Nolimit City at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/nolimit-city/kill_em_all': {
        title: 'Kill Em All Slot by Nolimit City at {brand} | Free Demo & Crypto Play',
        description: 'Spin Kill Em All Slot by Nolimit City at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/nolimit-city/kiss_my_chainsaw': {
        title: 'Play Kiss My Chainsaw: Play Online with Crypto | {brand}',
        description: 'Play Kiss My Chainsaw by Nolimit City at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/nolimit-city/kitchen_drama_bbq_frenzy': {
        title: 'Kitchen Drama Bbq Frenzy by Nolimit City at {brand} | Free Demo & Crypto Play',
        description: 'Spin Kitchen Drama Bbq Frenzy by Nolimit City at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/nolimit-city/kitchen_drama_sushi_mania': {
        title: 'Play Kitchen Drama Sushi Mania Slot by Nolimit City at {brand} | Instant Crypto Payouts',
        description: 'Play Kitchen Drama Sushi Mania from Nolimit City, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/nolimit-city/land_of_the_free': {
        title: 'Land Of The Free Slot: Play Online with Crypto | {brand}',
        description: 'Land Of The Free Slot by Nolimit City at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/nolimit-city/legion_x': {
        title: 'Play Legion X Slot by Nolimit City at {brand} | 31,000x Max Win',
        description: 'Play Legion X Slot by Nolimit City at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/nolimit-city/little_bighorn': {
        title: 'Play Little Bighorn Slot by Nolimit City at {brand} | Instant Crypto Payouts',
        description: 'Play Little Bighorn by Nolimit City at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/nolimit-city/loner': {
        title: 'Loner xNudge Slot by Nolimit City | {brand}',
        description: 'Loner by Nolimit City at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/nolimit-city/manhattan_goes_wild': {
        title: 'Play Manhattan Goes Wild xNudge Slot by Nolimit City | {brand}',
        description: 'Play Manhattan Goes Wild by Nolimit City at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/nolimit-city/mayan_magic_wildfire': {
        title: 'Play Mayan Magic Wildfire Slot by Nolimit City at {brand} | Free Demo & Crypto Play',
        description: 'Play Play Mayan Magic Wildfire Slot by Nolimit City at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/nolimit-city/mental': {
        title: 'Mental Slot by Nolimit City at {brand} | Free Demo & Crypto Play',
        description: 'Spin Mental Slot by Nolimit City at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/nolimit-city/mental_2': {
        title: 'Play Mental 2: Play Online with Crypto | {brand}',
        description: 'Play Mental 2 from Nolimit City, with a 99,999x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/nolimit-city/milky_ways': {
        title: 'Play Milky Ways by Nolimit City at {brand} | 5,664x Max Win',
        description: 'Spin Milky Ways by Nolimit City at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/nolimit-city/misery_mining': {
        title: 'Play Misery Mining: Play Online with Crypto | {brand}',
        description: 'Play Misery Mining from Nolimit City, with a 70,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/nolimit-city/monkeys_gold_xpays': {
        title: "Monkey's Gold xPays Slot by Nolimit City at {brand} | Free Demo & Crypto Play",
        description: "Play Monkey's Gold xPays Slot by Nolimit City at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/nolimit-city/nine_to_five': {
        title: 'Nine To Five by Nolimit City at {brand} | Free Demo & Crypto Play',
        description: 'Spin Nine To Five by Nolimit City at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/nolimit-city/oktoberfest': {
        title: 'Oktoberfest xNudge Slot by Nolimit City | {brand}',
        description: 'Oktoberfest by Nolimit City at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/nolimit-city/outsourced_payday': {
        title: 'Outsourced Payday Slot xNudge Slot by Nolimit City | {brand}',
        description: 'Outsourced Payday Slot by Nolimit City at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/nolimit-city/outsourced_slash_game': {
        title: 'Outsourced Slash Game Slot: Play Online with Crypto | {brand}',
        description: 'Outsourced Slash Game Slot by Nolimit City at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/nolimit-city/owls': {
        title: 'Play Owls Slot by Nolimit City at {brand} | Free Demo & Crypto Play',
        description: 'Play Play Owls Slot by Nolimit City at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/nolimit-city/pearl_harbor': {
        title: 'Pearl Harbor by Nolimit City at {brand} | Free Demo & Crypto Play',
        description: 'Spin Pearl Harbor by Nolimit City at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/nolimit-city/pixies_vs_pirates': {
        title: 'Play Pixies vs Pirates Slot by Nolimit City at {brand} | Free Demo & Crypto Play',
        description: 'Spin Play Pixies vs Pirates Slot by Nolimit City at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/nolimit-city/poison_eve': {
        title: 'Poison Eve by Nolimit City at {brand} | Free Demo & Crypto Play',
        description: 'Spin Poison Eve by Nolimit City at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/nolimit-city/possessed': {
        title: 'Possessed by Nolimit City at {brand} | Free Demo & Crypto Play',
        description: 'Play Possessed by Nolimit City at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/nolimit-city/punk_rocker': {
        title: 'Play Play Punk Rocker 3 Slot by Nolimit City at {brand} | 19,089x Max Win',
        description: 'Spin Play Punk Rocker 3 Slot by Nolimit City at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/nolimit-city/punk_rocker_2': {
        title: 'Play Punk Rocker 2: Play Online with Crypto | {brand}',
        description: 'Play Punk Rocker 2 from Nolimit City, with a 30,141x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/nolimit-city/punk_toilet': {
        title: 'Play Punk Toilet: Play Online with Crypto | {brand}',
        description: 'Play Punk Toilet from Nolimit City, with a 33,333x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/nolimit-city/remember_gulag': {
        title: 'Play Remember Gulag xNudge Slot by Nolimit City | {brand}',
        description: 'Play Remember Gulag by Nolimit City at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/nolimit-city/road_kill': {
        title: 'Play Road Kill by Nolimit City at {brand} | 10,000x Max Win',
        description: 'Play Road Kill by Nolimit City at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/nolimit-city/road_rage': {
        title: 'Play Road Rage: Play Online with Crypto | {brand}',
        description: 'Play Road Rage by Nolimit City at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/nolimit-city/rock_bottom': {
        title: 'Play Rock Bottom Slot by Nolimit City at {brand} | 19,690x Max Win',
        description: 'Play Rock Bottom Slot by Nolimit City at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/nolimit-city/san_quentin_2_death_row': {
        title: 'San Quentin 2 Death Row xNudge Slot by Nolimit City | {brand}',
        description: 'San Quentin 2 Death Row by Nolimit City at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/nolimit-city/san_quentin_xways': {
        title: 'Play San Quentin xWays: Play Online with Crypto | {brand}',
        description: 'Play San Quentin xWays from Nolimit City, with a 150,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/nolimit-city/serial': {
        title: 'Play Serial: Play Online with Crypto | {brand}',
        description: 'Play Serial from Nolimit City, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/nolimit-city/skate_or_die': {
        title: 'Play Skate or Die Slot by Nolimit City at {brand} | 30,000x Max Win',
        description: 'Spin Skate or Die Slot by Nolimit City at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/nolimit-city/space_donkey': {
        title: 'Play Space Donkey Slot by Nolimit City at {brand} | 10,000x Max Win',
        description: 'Spin Space Donkey Slot by Nolimit City at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/nolimit-city/starstruck': {
        title: 'Starstruck Slot xNudge Slot by Nolimit City | {brand}',
        description: 'Starstruck Slot by Nolimit City at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/nolimit-city/stockholm_syndrome': {
        title: 'Play Stockholm Syndrome: Play Online with Crypto | {brand}',
        description: 'Play Stockholm Syndrome by Nolimit City at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/nolimit-city/supersized': {
        title: 'Supersized Slot xNudge Slot by Nolimit City | {brand}',
        description: 'Supersized Slot from Nolimit City, with a 12,345x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/nolimit-city/tesla_jolt': {
        title: 'Tesla Jolt Slot by Nolimit City at {brand} | Free Demo & Crypto Play',
        description: 'Spin Tesla Jolt Slot by Nolimit City at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/nolimit-city/the_border': {
        title: 'Play The Border Slot by Nolimit City at {brand} | Instant Crypto Payouts',
        description: 'Play The Border by Nolimit City at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/nolimit-city/the_cage': {
        title: 'Play The Cage Slot by Nolimit City at {brand} | Instant Crypto Payouts',
        description: 'Play The Cage by Nolimit City at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/nolimit-city/the_creepy_carnival': {
        title: 'The Creepy Carnival Slot by Nolimit City at {brand} | Free Demo & Crypto Play',
        description: 'Spin The Creepy Carnival Slot by Nolimit City at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/nolimit-city/the_crypt': {
        title: 'The Crypt 2 Slot by Nolimit City at {brand} | Instant Crypto Payouts',
        description: 'The Crypt 2 by Nolimit City at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/nolimit-city/the_rave': {
        title: 'Play The Rave Slot by Nolimit City at {brand} | Instant Crypto Payouts',
        description: 'Play The Rave from Nolimit City, with a 41,500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/nolimit-city/thor_hammer_time': {
        title: 'Thor xNudge Slot by Nolimit City | {brand}',
        description: 'Thor by Nolimit City at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/nolimit-city/tomb_of_akhenaten': {
        title: 'Play Tomb of Akhenaten: Play Online with Crypto | {brand}',
        description: 'Play Tomb of Akhenaten from Nolimit City, with a 26,261x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/nolimit-city/tomb_of_nefertiti': {
        title: 'Play Tomb of Nefertiti by Nolimit City at {brand} | 3,768x Max Win',
        description: 'Play Tomb of Nefertiti by Nolimit City at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/nolimit-city/tombstone': {
        title: 'Play Tombstone Slot by Nolimit City at {brand} | 11,456x Max Win',
        description: 'Play Tombstone Slot by Nolimit City at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/nolimit-city/tombstone_no_mercy': {
        title: 'Play Tombstone No Mercy Slot by Nolimit City at {brand} | Instant Crypto Payouts',
        description: 'Play Tombstone No Mercy from Nolimit City, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/nolimit-city/tombstone_rip': {
        title: 'Play Tombstone RIP Slot by Nolimit City at {brand} | Free Demo & Crypto Play',
        description: 'Spin Play Tombstone RIP Slot by Nolimit City at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/nolimit-city/tombstone_slaughter_el_gordos_revenge': {
        title: 'Play Tombstone Slaughter by Nolimit City at {brand} | 500,000x Max Win',
        description: 'Spin Tombstone Slaughter by Nolimit City at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/nolimit-city/tractor_beam': {
        title: 'Play Tractor Beam Slot by Nolimit City at {brand} | Free Demo & Crypto Play',
        description: 'Play Play Tractor Beam Slot by Nolimit City at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/nolimit-city/true_grit_redemption': {
        title: 'Play True Grit Redemption Slot by Nolimit City at {brand} | 20,220x Max Win',
        description: 'Play True Grit Redemption Slot by Nolimit City at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/nolimit-city/true_kult': {
        title: 'Play True Kult Slot by Nolimit City at {brand} | 10,000x Max Win',
        description: 'Spin True Kult Slot by Nolimit City at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/nolimit-city/tsar_wars': {
        title: 'Play Tsar Wars Slot by Nolimit City at {brand} | Instant Crypto Payouts',
        description: 'Play Tsar Wars from Nolimit City, with a 19,755x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/nolimit-city/ugliest_catch': {
        title: 'Play Ugliest Catch Slot by Nolimit City at {brand} | 10,000x Max Win',
        description: 'Spin Ugliest Catch Slot by Nolimit City at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/nolimit-city/walk_of_shame': {
        title: 'Play Walk of Shame Slot by Nolimit City at {brand} | Instant Crypto Payouts',
        description: 'Play Walk of Shame from Nolimit City, with a 9,822x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/nolimit-city/warrior_graveyard_xnudge': {
        title: 'Warrior Graveyard Xnudge Slot xNudge Slot by Nolimit City | {brand}',
        description: 'Warrior Graveyard Xnudge Slot from Nolimit City, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/nolimit-city/whacked': {
        title: 'Play Whacked Online: Play Online with Crypto | {brand}',
        description: 'Spin Play Whacked Online by Nolimit City at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/nolimit-city/wixx': {
        title: 'Play WiXX xNudge Slot by Nolimit City | {brand}',
        description: 'Play WiXX by Nolimit City at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/nolimit-city/xways_hoarder_2': {
        title: 'Play XWays Hoarder 2 by Nolimit City at {brand} | 25,920x Max Win',
        description: 'Play XWays Hoarder 2 by Nolimit City at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/nolimit-city/xways_hoarder_xsplit': {
        title: 'Play xWays Hoarder xSplit Slot by Nolimit City at {brand} | 11,030x Max Win',
        description: 'Play xWays Hoarder xSplit Slot by Nolimit City at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/play-n-go/1001_mystery_genie_fortunes': {
        title: '1001 Mystery Genie Fortunes: Play Online with Crypto | {brand}',
        description: "1001 Mystery Genie Fortunes from Play'n GO, with a 1,234x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/13th_trial_hercules_abyssways': {
        title: "13th Trial Hercules Abyssways Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "13th Trial Hercules Abyssways by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/15_crystal_roses_a_tale_of_love': {
        title: "15 Crystal Roses: A Tale of Love Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "15 Crystal Roses: A Tale of Love by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/24k_dragon': {
        title: "24K Dragon by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Play 24K Dragon by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/3_blades_and_blessings': {
        title: "3 Blades and Blessings Book Slot by Play'n GO | {brand}",
        description: "3 Blades and Blessings by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/3_clown_monty': {
        title: "3 Clown Monty by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Play 3 Clown Monty by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/3_clown_monty_ii': {
        title: '3 Clown Monty II: Play Online with Crypto | {brand}',
        description: "3 Clown Monty II by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/3_hand_casino': {
        title: "3 Hand Casino by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Spin 3 Hand Casino by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/5x_magic': {
        title: "Play 5x Magic by Play'n GO at {brand} | 1,050x Max Win",
        description: "Play 5x Magic by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/7_sins': {
        title: "7 Sins by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Spin 7 Sins by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/ace_of_spades': {
        title: "Ace of Spades Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Ace of Spades by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/agent_destiny': {
        title: 'Agent Destiny: Play Online with Crypto | {brand}',
        description: "Agent Destiny from Play'n GO, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/agent_of_hearts': {
        title: "Play Agent of Hearts by Play'n GO at {brand} | 5,263x Max Win",
        description: "Play Agent of Hearts by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/animal_madness': {
        title: "Animal Madness Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Animal Madness by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/ankh_of_anubis': {
        title: "Play Ankh of Anubis by Play'n GO at {brand} | 15,000x Max Win",
        description: "Spin Ankh of Anubis by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/ankh_of_anubis_awakening': {
        title: "Ankh of Anubis  Awakening Book Slot by Play'n GO | {brand}",
        description: "Play Ankh of Anubis  Awakening by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/annihilator': {
        title: "Play Annihilator by Play'n GO at {brand} | 5,000x Max Win",
        description: "Spin Annihilator by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/athena_ascending': {
        title: 'Athena Ascending: Play Online with Crypto | {brand}',
        description: "Athena Ascending by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/aztec_idols': {
        title: "Play Aztec Idols by Play'n GO at {brand} | 22,725x Max Win",
        description: "Spin Aztec Idols by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/aztec_warrior_princess': {
        title: "Aztec Warrior Princess Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Aztec Warrior Princess by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/bakers_treat': {
        title: "Baker's Treat by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Play Baker's Treat by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/banana_rock': {
        title: "Play Banana Rock by Play'n GO at {brand} | 2,500x Max Win",
        description: "Play Banana Rock by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/banana_rush': {
        title: "Banana Rush Book Slot by Play'n GO | {brand}",
        description: "Banana Rush by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/banquet_of_dead': {
        title: "Banquet of Dead Book Slot by Play'n GO | {brand}",
        description: "Play Banquet of Dead by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/bao_shi': {
        title: "Play Bao Shi by Play'n GO at {brand} | 15,000x Max Win",
        description: "Spin Bao Shi by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/barn_busters': {
        title: 'Barn Busters: Play Online with Crypto | {brand}',
        description: "Barn Busters from Play'n GO, with a 7,500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/baron_lord_of_saturday': {
        title: "Baron Lord of Saturday Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Baron Lord of Saturday by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/battle_royal': {
        title: "Battle Royal Book Slot by Play'n GO | {brand}",
        description: "Battle Royal by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/beast_of_wealth': {
        title: "Beast Of Wealth by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Spin Beast Of Wealth by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/beasts_of_fire': {
        title: "Beasts of Fire by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Spin Beasts of Fire by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/beasts_of_fire_maximum': {
        title: 'Beasts of Fire Maximum: Play Online with Crypto | {brand}',
        description: "Beasts of Fire Maximum by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/big_win_777': {
        title: "Play Big Win 777 by Play'n GO at {brand} | 5,000x Max Win",
        description: "Spin Big Win 777 by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/big_win_cat': {
        title: "Big Win Cat Book Slot by Play'n GO | {brand}",
        description: "Big Win Cat from Play'n GO, with a 800x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/big_win_city_pawsperity': {
        title: "Big Win City Pawsperity Book Slot by Play'n GO | {brand}",
        description: "Big Win City Pawsperity from Play'n GO, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/black_mamba': {
        title: "Black Mamba Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Black Mamba from Play'n GO, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/blazin_bullfrog': {
        title: "Blazin' Bullfrog Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Blazin' Bullfrog by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/blinged': {
        title: "Play Blinged by Play'n GO at {brand} | 5,000x Max Win",
        description: "Play Blinged by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/boat_bonanza': {
        title: 'Boat Bonanza: Play Online with Crypto | {brand}',
        description: "Boat Bonanza from Play'n GO, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/boat_bonanza_christmas': {
        title: "Boat Bonanza Christmas Book Slot by Play'n GO | {brand}",
        description: "Play Boat Bonanza Christmas by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/boat_bonanza_colossal_catch': {
        title: "Boat Bonanza Colossal Catch Book Slot by Play'n GO | {brand}",
        description: "Play Boat Bonanza Colossal Catch by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/boat_bonanza_croconile': {
        title: "Boat Bonanza Croconile by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Spin Boat Bonanza Croconile by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/boat_bonanza_down_under': {
        title: "Boat Bonanza Down Under Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Boat Bonanza Down Under from Play'n GO, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/boat_bonanza_rider': {
        title: "Boat Bonanza Rider by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Play Boat Bonanza Rider by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/book_of_dead': {
        title: "Book of Dead Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Book of Dead from Play'n GO, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/bubblin_riches': {
        title: "Bubblin Riches by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Spin Bubblin Riches by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/bucking_rider': {
        title: 'Play Bucking Rider: Play Online with Crypto | {brand}',
        description: "Play Bucking Rider by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/buffalo_of_wealth': {
        title: "Play Buffalo of Wealth by Play'n GO at {brand} | 7,000x Max Win",
        description: "Play Buffalo of Wealth by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/buildin_bucks': {
        title: "Buildin Bucks by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Buildin Bucks from Play'n GO. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/buildin_more_bucks': {
        title: 'Buildin More Bucks: Play Online with Crypto | {brand}',
        description: "Buildin More Bucks from Play'n GO, with a 7,500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/bull_in_a_china_shop': {
        title: 'Bull in a China Shop: Play Online with Crypto | {brand}',
        description: "Bull in a China Shop from Play'n GO, with a 5,800x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/bull_in_a_rodeo': {
        title: "Play Bull in a Rodeo by Play'n GO at {brand} | 2,000x Max Win",
        description: "Spin Bull in a Rodeo by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/bullion_express': {
        title: "Bullion Express Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Bullion Express by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/candy_island_princess': {
        title: "Play Candy Island Princess by Play'n GO at {brand} | 2,200x Max Win",
        description: "Spin Candy Island Princess by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/canine_carnage': {
        title: "Canine Carnage Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Canine Carnage from Play'n GO, with a 3,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/captain_glum_pirate_hunter': {
        title: "Play Captain Glum: Pirate Hunter by Play'n GO at {brand} | 9,000x Max Win",
        description: "Spin Captain Glum: Pirate Hunter by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/captain_xenos_earth_adventure': {
        title: "Captain Xeno's Earth Adventure: Play Online with Crypto | {brand}",
        description: "Captain Xeno's Earth Adventure by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/cash_a_cabana': {
        title: "Cash a Cabana Book Slot by Play'n GO | {brand}",
        description: "Cash a Cabana by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/cash_of_command': {
        title: "Play Cash of Command by Play'n GO at {brand} | 5,336x Max Win",
        description: "Play Cash of Command by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/cash_pump': {
        title: "Cash Pump Book Slot by Play'n GO | {brand}",
        description: "Cash Pump from Play'n GO, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/cash_vandal': {
        title: 'Cash Vandal: Play Online with Crypto | {brand}',
        description: "Cash Vandal from Play'n GO, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/cashin_joker': {
        title: "Cashin' Joker: Play Online with Crypto | {brand}",
        description: "Cashin' Joker by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/cat_wilde_and_the_doom_of_dead': {
        title: "Play Cat Wilde and the Doom of Dead by Play'n GO at {brand} | 5,000x Max Win",
        description: "Play Cat Wilde and the Doom of Dead by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/cat_wilde_and_the_incan_quest': {
        title: "Cat Wilde and the Incan Quest by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Play Cat Wilde and the Incan Quest by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/cat_wilde_and_the_lost_chapter': {
        title: "Play Cat Wilde and the Lost Chapter by Play'n GO at {brand} | 10,000x Max Win",
        description: "Play Cat Wilde and the Lost Chapter by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/cat_wilde_and_the_pyramids_of_dead': {
        title: "Play Cat Wilde and the Pyramids of Dead by Play'n GO at {brand} | 10,000x Max Win",
        description: "Spin Cat Wilde and the Pyramids of Dead by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/cat_wilde_in_the_eclipse_of_the_sun_god': {
        title: 'Cat Wilde in the Eclipse of the Sun God: Play Online with Crypto | {brand}',
        description: "Cat Wilde in the Eclipse of the Sun God by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/cats_and_cash': {
        title: "Play Cats and Cash by Play'n GO at {brand} | 1,154x Max Win",
        description: "Spin Cats and Cash by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/celebration_of_wealth': {
        title: "Celebration Of Wealth Book Slot by Play'n GO | {brand}",
        description: "Celebration Of Wealth from Play'n GO, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/chambers_of_ancients': {
        title: "Chambers of Ancients by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Play Chambers of Ancients by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/champions_of_mithrune': {
        title: "Champions of Mithrune by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Spin Champions of Mithrune by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/charlie_chance': {
        title: "Play Charlie Chance by Play'n GO at {brand} | 20,000x Max Win",
        description: "Play Charlie Chance by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/charlie_chance_and_the_curse_of_cleopatra': {
        title: "Charlie Chance and The Curse of Cleopatra Book Slot by Play'n GO | {brand}",
        description: "Charlie Chance and The Curse of Cleopatra from Play'n GO, with a 5,500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/charlie_chance_in_hell_to_pay': {
        title: "Charlie Chance in Hell to Pay Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Charlie Chance in Hell to Pay by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/chinese_new_year': {
        title: 'Chinese New Year: Play Online with Crypto | {brand}',
        description: "Chinese New Year from Play'n GO, with a 22,725x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/chronos_joker': {
        title: 'Chronos Joker: Play Online with Crypto | {brand}',
        description: "Chronos Joker from Play'n GO, with a 1,600x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/city_of_sound': {
        title: "Play City of Sound by Play'n GO at {brand} | 4,000x Max Win",
        description: "Play City of Sound by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/clash_of_camelot': {
        title: "Play Clash of Camelot by Play'n GO at {brand} | 35,000x Max Win",
        description: "Play Clash of Camelot by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/cloud_quest': {
        title: "Cloud Quest Book Slot by Play'n GO | {brand}",
        description: "Cloud Quest from Play'n GO, with a 1,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/coils_of_cash': {
        title: 'Coils of Cash: Play Online with Crypto | {brand}',
        description: "Coils of Cash from Play'n GO, with a 30,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/colt_lightning': {
        title: "Colt Lightning by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Spin Colt Lightning by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/colt_lightning_firestorm': {
        title: "Play Colt Lightning Firestorm by Play'n GO at {brand} | 10,000x Max Win",
        description: "Spin Colt Lightning Firestorm by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/contact': {
        title: "Contact Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Contact from Play'n GO, with a 1,518x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/copsnrobbers': {
        title: "Cops'n'Robbers: Play Online with Crypto | {brand}",
        description: "Cops'n'Robbers from Play'n GO, with a 28,961x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/count_jokula': {
        title: 'Count Jokula: Play Online with Crypto | {brand}',
        description: "Count Jokula by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/court_of_hearts': {
        title: "Play Court of Hearts by Play'n GO at {brand} | 8,500x Max Win",
        description: "Spin Court of Hearts by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/coywolf_cash': {
        title: "Play Coywolf Cash by Play'n GO at {brand} | 4,000x Max Win",
        description: "Spin Coywolf Cash by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/crabbys_gold': {
        title: "Play Crabby's Gold by Play'n GO at {brand} | 70,000x Max Win",
        description: "Spin Crabby's Gold by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/crazy_cows': {
        title: "Crazy Cows Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Crazy Cows from Play'n GO, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/crystal_hall': {
        title: "Crystal Hall by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Crystal Hall from Play'n GO. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/crystal_sun': {
        title: "Crystal Sun by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Play Crystal Sun by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/dansband_pa_turne': {
        title: "Dansband Pa Turne Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Dansband Pa Turne by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/dawn_of_egypt': {
        title: "Dawn of Egypt Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Dawn of Egypt by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/demon': {
        title: "Play Demon by Play'n GO at {brand} | 5,000x Max Win",
        description: "Play Demon by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/derby_wheel': {
        title: "Derby Wheel Book Slot by Play'n GO | {brand}",
        description: "Derby Wheel from Play'n GO, with a 2,240x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/diamond_vortex': {
        title: "Play Diamond Vortex by Play'n GO at {brand} | 5,000x Max Win",
        description: "Play Diamond Vortex by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/diamonds_of_the_realm': {
        title: "Diamonds of the Realm by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Spin Diamonds of the Realm by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/dio_killing_the_dragon': {
        title: "Play DIO Killing the Dragon by Play'n GO at {brand} | 15,000x Max Win",
        description: "Play DIO Killing the Dragon by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/disco_diamonds': {
        title: "Disco Diamonds Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Disco Diamonds by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/divina_commedia_i_nove_cerchi': {
        title: "Play Divina Commedia I Nove Cerchi by Play'n GO at {brand} | 3,000x Max Win",
        description: "Spin Divina Commedia I Nove Cerchi by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/divine_divas': {
        title: "Play Divine Divas by Play'n GO at {brand} | 10,000x Max Win",
        description: "Spin Divine Divas by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/divine_showdown': {
        title: "Play Divine Showdown by Play'n GO at {brand} | 5,000x Max Win",
        description: "Play Divine Showdown by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/doom_of_egypt': {
        title: "Doom of Egypt by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Spin Doom of Egypt by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/dr_toonz': {
        title: "Dr. Toonz by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Spin Dr. Toonz by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/dragon_maiden': {
        title: "Dragon Maiden Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Dragon Maiden from Play'n GO, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/dragon_ship': {
        title: 'Dragon Ship: Play Online with Crypto | {brand}',
        description: "Dragon Ship from Play'n GO, with a 8,032x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/dragonfates_favour': {
        title: "Dragonfate's Favour Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Dragonfate's Favour by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/easter_eggs': {
        title: "Play Easter Eggs by Play'n GO at {brand} | 6,569x Max Win",
        description: "Play Easter Eggs by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/easter_eggspedition': {
        title: 'Easter Eggspedition: Play Online with Crypto | {brand}',
        description: "Spin Easter Eggspedition by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/enchanted_crystals': {
        title: 'Enchanted Crystals: Play Online with Crypto | {brand}',
        description: "Enchanted Crystals by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/enchanted_meadow': {
        title: "Enchanted Meadow Book Slot by Play'n GO | {brand}",
        description: "Enchanted Meadow from Play'n GO, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/energoonz': {
        title: "Energoonz by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Spin Energoonz by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/eye_of_atum': {
        title: "Eye of Atum by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Spin Eye of Atum by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/eye_of_the_kraken': {
        title: "Eye of the Kraken Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Eye of the Kraken by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/fangs_and_fire': {
        title: 'Fangs and Fire: Play Online with Crypto | {brand}',
        description: "Fangs and Fire from Play'n GO, with a 60,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/fat_frankies': {
        title: "Play Fat Frankies by Play'n GO at {brand} | 6,000x Max Win",
        description: "Spin Fat Frankies by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/fate_of_dead_blitzways': {
        title: "Play Fate of Dead Blitzways by Play'n GO at {brand} | 20,000x Max Win",
        description: "Spin Fate of Dead Blitzways by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/feline_fury': {
        title: 'Feline Fury: Play Online with Crypto | {brand}',
        description: "Feline Fury by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/fire_joker': {
        title: "Fire Joker Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Fire Joker from Play'n GO, with a 800x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/fire_joker_100': {
        title: "Fire Joker 100 Book Slot by Play'n GO | {brand}",
        description: "Fire Joker 100 by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/fire_joker_blitz': {
        title: "Fire Joker Blitz Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Fire Joker Blitz by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/fire_joker_freeze': {
        title: "Fire Joker Freeze Book Slot by Play'n GO | {brand}",
        description: "Fire Joker Freeze from Play'n GO, with a 1,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/fire_toad': {
        title: "Play Fire Toad by Play'n GO at {brand} | 5,000x Max Win",
        description: "Play Fire Toad by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/fire_toad_2': {
        title: "Fire Toad 2 Book Slot by Play'n GO | {brand}",
        description: "Fire Toad 2 by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/firefly_frenzy': {
        title: "Firefly Frenzy Book Slot by Play'n GO | {brand}",
        description: "Firefly Frenzy from Play'n GO, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/forge_of_fortunes': {
        title: "Forge of Fortunes Book Slot by Play'n GO | {brand}",
        description: "Forge of Fortunes by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/forge_of_gems': {
        title: "Forge of Gems Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Forge of Gems from Play'n GO, with a 20,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/fortune_rewind': {
        title: "Play Fortune Rewind by Play'n GO at {brand} | 8,500x Max Win",
        description: "Play Fortune Rewind by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/fortune_teller': {
        title: 'Fortune Teller: Play Online with Crypto | {brand}',
        description: "Fortune Teller by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/fortunes_of_ali_baba': {
        title: "Fortunes of Ali Baba Book Slot by Play'n GO | {brand}",
        description: "Fortunes of Ali Baba from Play'n GO, with a 9,968x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/fox_mayhem': {
        title: "Play Fox Mayhem by Play'n GO at {brand} | 400,000x Max Win",
        description: "Spin Fox Mayhem by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/free_reelin_joker': {
        title: "Free Reelin' Joker: Play Online with Crypto | {brand}",
        description: "Free Reelin' Joker by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/free_reelin_joker_1000': {
        title: "Free Reelin' Joker 1000: Play Online with Crypto | {brand}",
        description: "Free Reelin' Joker 1000 by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/frozen_gems': {
        title: "Play Frozen Gems by Play'n GO at {brand} | 10,000x Max Win",
        description: "Play Frozen Gems by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/fruit_bonanza': {
        title: 'Play Fruit Bonanza: Play Online with Crypto | {brand}',
        description: "Play Fruit Bonanza by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/fu_er_dai': {
        title: 'Fu Er Dai: Play Online with Crypto | {brand}',
        description: "Fu Er Dai by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/fulong_88': {
        title: "Fulong 88 by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Fulong 88 from Play'n GO. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/game_of_gladiators': {
        title: "Play Game of Gladiators by Play'n GO at {brand} | 5,000x Max Win",
        description: "Spin Game of Gladiators by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/game_of_gladiators_uprising': {
        title: "Game of Gladiators: Uprising by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Spin Game of Gladiators: Uprising by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/gargantoonz': {
        title: "Gargantoonz Book Slot by Play'n GO | {brand}",
        description: "Gargantoonz from Play'n GO, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/gates_of_troy': {
        title: "Play Gates of Troy by Play'n GO at {brand} | 3,000x Max Win",
        description: "Spin Gates of Troy by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/gemix': {
        title: "GEMiX Book Slot by Play'n GO | {brand}",
        description: "GEMiX by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/gemix_100': {
        title: "Gemix 100 by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Gemix 100 from Play'n GO. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/gemix_2': {
        title: "Gemix 2 by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Spin Gemix 2 by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/gerards_gambit': {
        title: "Gerard's Gambit by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Play Gerard's Gambit by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/ghost_of_dead': {
        title: "Ghost of Dead Book Slot by Play'n GO | {brand}",
        description: "Ghost of Dead from Play'n GO, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/gift_shop': {
        title: "Play Gift Shop by Play'n GO at {brand} | 10,000x Max Win",
        description: "Spin Gift Shop by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/gigantoonz': {
        title: 'Gigantoonz: Play Online with Crypto | {brand}',
        description: "Gigantoonz from Play'n GO, with a 4,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/go_craps': {
        title: "Go Craps Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Go Craps from Play'n GO, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/gold_king': {
        title: 'Gold King: Play Online with Crypto | {brand}',
        description: "Gold King by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/gold_of_fortune_god': {
        title: "Gold of Fortune God by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Spin Gold of Fortune God by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/gold_trophy_2': {
        title: 'Gold Trophy 2: Play Online with Crypto | {brand}',
        description: "Gold Trophy 2 by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/gold_volcano': {
        title: "Play Gold Volcano by Play'n GO at {brand} | 10,000x Max Win",
        description: "Spin Gold Volcano by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/golden_caravan': {
        title: "Golden Caravan Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Golden Caravan by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/golden_colts': {
        title: "Play Golden Colts by Play'n GO at {brand} | 2,500x Max Win",
        description: "Play Golden Colts by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/golden_goal': {
        title: "Play Golden Goal by Play'n GO at {brand} | 10,000x Max Win",
        description: "Spin Golden Goal by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/golden_legend': {
        title: "Golden Legend by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Play Golden Legend by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/golden_osiris': {
        title: "Golden Osiris by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Spin Golden Osiris by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/golden_ticket_2': {
        title: "Play Golden Ticket 2 by Play'n GO at {brand} | 5,000x Max Win",
        description: "Spin Golden Ticket 2 by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/grim_muerto': {
        title: "Grim Muerto Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Grim Muerto from Play'n GO, with a 2,500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/gunslinger_reloaded': {
        title: "Play Gunslinger Reloaded by Play'n GO at {brand} | 10,000x Max Win",
        description: "Spin Gunslinger Reloaded by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/happy_halloween': {
        title: 'Happy Halloween: Play Online with Crypto | {brand}',
        description: "Happy Halloween by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/highway_legends': {
        title: "Highway Legends Book Slot by Play'n GO | {brand}",
        description: "Highway Legends from Play'n GO, with a 62,500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/holiday_season': {
        title: "Holiday Season Book Slot by Play'n GO | {brand}",
        description: "Holiday Season from Play'n GO, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/holiday_spirits': {
        title: "Holiday Spirits by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Play Holiday Spirits by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/honey_rush': {
        title: 'Honey Rush: Play Online with Crypto | {brand}',
        description: "Honey Rush by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/honey_rush_100': {
        title: "Honey Rush 100 Book Slot by Play'n GO | {brand}",
        description: "Honey Rush 100 from Play'n GO, with a 5,000,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/hooligan_hustle': {
        title: "Play Hooligan Hustle by Play'n GO at {brand} | 10,000x Max Win",
        description: "Play Hooligan Hustle by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/hope_unleashed_fortune_reels': {
        title: 'Hope Unleashed Fortune Reels: Play Online with Crypto | {brand}',
        description: "Hope Unleashed Fortune Reels by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/hot_dog_heist': {
        title: "Hot Dog Heist by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Hot Dog Heist from Play'n GO. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/hotel_yetiway': {
        title: "Play Hotel Yeti-Way by Play'n GO at {brand} | 30,000x Max Win",
        description: "Play Hotel Yeti-Way by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/house_of_doom': {
        title: "House of Doom Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "House of Doom by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/house_of_doom_2_the_crypt': {
        title: "House of Doom 2: The Crypt Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "House of Doom 2: The Crypt by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/ice_joker': {
        title: "Play Ice Joker by Play'n GO at {brand} | 3,000x Max Win",
        description: "Play Ice Joker by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/idol_of_fortune': {
        title: "Idol of Fortune Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Idol of Fortune from Play'n GO, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/immortails_of_egypt': {
        title: "Immortails of Egypt by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Play Immortails of Egypt by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/imperial_opera': {
        title: "Play Imperial Opera by Play'n GO at {brand} | 2,500x Max Win",
        description: "Spin Imperial Opera by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/inferno_joker': {
        title: "Play Inferno Joker by Play'n GO at {brand} | 2,500x Max Win",
        description: "Play Inferno Joker by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/inferno_star': {
        title: 'Inferno Star: Play Online with Crypto | {brand}',
        description: "Inferno Star from Play'n GO, with a 2,500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/invading_vegas': {
        title: "Play Invading Vegas by Play'n GO at {brand} | 1,000x Max Win",
        description: "Play Invading Vegas by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/invading_vegas_las_christmas': {
        title: "Invading Vegas: Las Christmas by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Spin Invading Vegas: Las Christmas by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/invading_vegas_revenge_on_mars': {
        title: "Invading Vegas Revenge on Mars Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Invading Vegas Revenge on Mars from Play'n GO, with a 2,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/irish_gold': {
        title: "Irish Gold Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Irish Gold from Play'n GO, with a 1,050x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/iron_girl': {
        title: "Iron Girl by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Play Iron Girl by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/jade_magician': {
        title: 'Jade Magician: Play Online with Crypto | {brand}',
        description: "Jade Magician from Play'n GO, with a 3,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/jewel_box': {
        title: "Jewel Box by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Play Jewel Box by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/joker_flip': {
        title: "Play Joker Flip by Play'n GO at {brand} | 10,000x Max Win",
        description: "Play Joker Flip by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/jolly_roger': {
        title: 'Jolly Roger: Play Online with Crypto | {brand}',
        description: "Jolly Roger from Play'n GO, with a 928x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/jolly_roger_2': {
        title: "Play Jolly Roger 2 by Play'n GO at {brand} | 5,000x Max Win",
        description: "Play Jolly Roger 2 by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/jolly_roger_wild_kraken': {
        title: "Jolly Roger Wild Kraken Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Jolly Roger Wild Kraken from Play'n GO, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/journey_to_paris': {
        title: "Journey to Paris by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Journey to Paris from Play'n GO. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/king_of_sweets': {
        title: "Play King of Sweets by Play'n GO at {brand} | 5,000x Max Win",
        description: "Spin King of Sweets by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/kingdom_below': {
        title: 'Kingdom Below: Play Online with Crypto | {brand}',
        description: "Spin Kingdom Below by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/kings_mask': {
        title: "King's Mask by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Spin King's Mask by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/kings_mask_eclipse_of_gods': {
        title: "King's Mask Eclipse of Gods: Play Online with Crypto | {brand}",
        description: "Spin King's Mask Eclipse of Gods by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/lab_of_madness': {
        title: "Lab of Madness by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Play Lab of Madness by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/lady_of_fortune': {
        title: "Lady of Fortune Book Slot by Play'n GO | {brand}",
        description: "Lady of Fortune by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/lady_of_fortune_destiny_spins': {
        title: "Play Lady of Fortune Destiny Spins by Play'n GO at {brand} | 1,950x Max Win",
        description: "Play Lady of Fortune Destiny Spins by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/lady_of_fortune_remastered': {
        title: "Play Lady of Fortune Remastered by Play'n GO at {brand} | 1,500x Max Win",
        description: "Play Lady of Fortune Remastered by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/legacy_of_dead': {
        title: "Legacy of Dead Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Legacy of Dead from Play'n GO, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/legacy_of_dynasties': {
        title: "Legacy of Dynasties by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Legacy of Dynasties from Play'n GO. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/legacy_of_egypt': {
        title: "Play Legacy of Egypt by Play'n GO at {brand} | 5,000x Max Win",
        description: "Spin Legacy of Egypt by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/legacy_of_gems_blitzways': {
        title: "Legacy of Gems Blitzways Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Legacy of Gems Blitzways by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/legacy_of_inca': {
        title: "Play Legacy of Inca by Play'n GO at {brand} | 6,500x Max Win",
        description: "Play Legacy of Inca by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/legacy_of_undead_dragon_abyssways': {
        title: "Legacy of Undead Dragon Abyssways Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Legacy of Undead Dragon Abyssways from Play'n GO, with a 20,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/legend_of_the_ice_dragon': {
        title: "Legend of the Ice Dragon by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Spin Legend of the Ice Dragon by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/legion_gold': {
        title: "Legion Gold by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Spin Legion Gold by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/legion_gold_and_the_sphinx_of_dead': {
        title: "Play Legion Gold and the Sphinx of Dead by Play'n GO at {brand} | 1,000x Max Win",
        description: "Play Legion Gold and the Sphinx of Dead by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/legion_gold_unleashed': {
        title: "Play Legion Gold Unleashed by Play'n GO at {brand} | 1,000x Max Win",
        description: "Spin Legion Gold Unleashed by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/legion_gold_victory': {
        title: 'Legion Gold Victory: Play Online with Crypto | {brand}',
        description: "Legion Gold Victory from Play'n GO, with a 4,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/leprechaun_goes_egypt': {
        title: "Leprechaun goes Egypt Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Leprechaun goes Egypt by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/leprechaun_goes_to_hell': {
        title: "Play Leprechaun Goes To Hell Book Slot by Play'n GO | {brand}",
        description: "Play Leprechaun Goes To Hell from Play'n GO, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/leprechaun_goes_wild': {
        title: "Leprechaun Goes Wild by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Spin Leprechaun Goes Wild by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/leprechauns_diamond_dig': {
        title: "Leprechaun's Diamond Dig: Play Online with Crypto | {brand}",
        description: "Leprechaun's Diamond Dig from Play'n GO, with a 3,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/leprechauns_vault': {
        title: "Play Leprechaun's Vault by Play'n GO at {brand} | 9,000x Max Win",
        description: "Play Leprechaun's Vault by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/lion_saga_odyssey': {
        title: "Lion Saga Odyssey by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Lion Saga Odyssey from Play'n GO. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/loot_and_labyrinths': {
        title: "Play Loot and Labyrinths by Play'n GO at {brand} | 20,000x Max Win",
        description: "Play Loot and Labyrinths by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/lord_merlin_and_the_lady_of_the_lake': {
        title: "Lord Merlin and the Lady of the Lake Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Lord Merlin and the Lady of the Lake by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/love_is_in_the_fair': {
        title: "Love is in the Fair by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Love is in the Fair from Play'n GO. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/love_joker': {
        title: "Love Joker Book Slot by Play'n GO | {brand}",
        description: "Love Joker from Play'n GO, with a 1,008x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/luchamigos': {
        title: "Luchamigos Book Slot by Play'n GO | {brand}",
        description: "Luchamigos by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/lucky_diamonds': {
        title: 'Lucky Diamonds: Play Online with Crypto | {brand}',
        description: "Lucky Diamonds from Play'n GO, with a 833x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/madame_ink': {
        title: 'Madame Ink: Play Online with Crypto | {brand}',
        description: "Madame Ink by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/mafia_gold': {
        title: "Play Mafia Gold by Play'n GO at {brand} | 10,000x Max Win",
        description: "Play Mafia Gold by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/mahjong_88': {
        title: "Play Mahjong 88 by Play'n GO at {brand} | 5,000x Max Win",
        description: "Play Mahjong 88 by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/matsuri': {
        title: "Play Matsuri by Play'n GO at {brand} | 3,000x Max Win",
        description: "Spin Matsuri by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/medusas_madness': {
        title: "Medusa's Madness: Play Online with Crypto | {brand}",
        description: "Medusa's Madness from Play'n GO, with a 2,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/mega_don_feeding_frenzy': {
        title: "Mega Don Feeding Frenzy Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Mega Don Feeding Frenzy from Play'n GO, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/mega_don_triple_threat': {
        title: "Mega Don Triple Threat Book Slot by Play'n GO | {brand}",
        description: "Mega Don Triple Threat from Play'n GO, with a 25,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/megadon': {
        title: "Play Megadon by Play'n GO at {brand} | 10,000x Max Win",
        description: "Spin Megadon by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/merlin_and_the_ice_queen_morgana': {
        title: "Merlin and the Ice Queen Morgana Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Merlin and the Ice Queen Morgana from Play'n GO, with a 20,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/merlin_journey_of_flame': {
        title: 'Merlin: Journey of Flame: Play Online with Crypto | {brand}',
        description: "Merlin: Journey of Flame by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/merlin_realm_of_charm': {
        title: "Merlin Realm of Charm Book Slot by Play'n GO | {brand}",
        description: "Play Merlin Realm of Charm by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/merlins_grimoire': {
        title: "Play Merlin's Grimoire by Play'n GO at {brand} | 30,000x Max Win",
        description: "Spin Merlin's Grimoire by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/mermaids_diamond': {
        title: "Mermaid's Diamond by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Spin Mermaid's Diamond by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/merry_xmas': {
        title: "Merry Xmas by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Play Merry Xmas by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/midnight_gold': {
        title: "Midnight Gold Book Slot by Play'n GO | {brand}",
        description: "Play Midnight Gold by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/miner_donkey_rider': {
        title: "Play Miner Donkey Rider Slot by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Spin Play Miner Donkey Rider Slot by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/miner_donkey_trouble': {
        title: "Miner Donkey Trouble Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Miner Donkey Trouble by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/mirror_joker': {
        title: "Mirror Joker by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Spin Mirror Joker by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/mission_cash': {
        title: "Mission Cash Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Mission Cash from Play'n GO, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/mole_digger': {
        title: "Mole Digger Book Slot by Play'n GO | {brand}",
        description: "Mole Digger by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/money_wheel': {
        title: 'Money Wheel: Play Online with Crypto | {brand}',
        description: "Money Wheel from Play'n GO, with a 46x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/monkey_battle_for_the_scrolls': {
        title: "Monkey Battle for the Scrolls Book Slot by Play'n GO | {brand}",
        description: "Play Monkey Battle for the Scrolls by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/monkey_donkey_rider': {
        title: "Play Monkey Donkey Rider Slot by Play'n GO at {brand} | 10,000x Max Win",
        description: "Play Monkey Donkey Rider Slot by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/moon_princess': {
        title: "Moon Princess by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Play Moon Princess by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/moon_princess_christmas_kingdom': {
        title: "Moon Princess: Christmas Kingdom Book Slot by Play'n GO | {brand}",
        description: "Moon Princess: Christmas Kingdom by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/moon_princess_origins': {
        title: "Moon Princess Origins by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Spin Moon Princess Origins by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/moon_princess_power_of_love': {
        title: "Moon Princess Power of Love by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Moon Princess Power of Love from Play'n GO. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/moon_princess_stargazing': {
        title: 'Moon Princess Stargazing: Play Online with Crypto | {brand}',
        description: "Moon Princess Stargazing by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/moon_princess_trinity': {
        title: "Play Moon Princess Trinity by Play'n GO at {brand} | 400,000x Max Win",
        description: "Play Moon Princess Trinity by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/motley_crue': {
        title: "Motley Crue Book Slot by Play'n GO | {brand}",
        description: "Motley Crue from Play'n GO, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/mount_m': {
        title: "Play Mount M by Play'n GO at {brand} | 13,000x Max Win",
        description: "Play Mount M by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/muerto_en_mictlan': {
        title: "Muerto En Mictlan by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Spin Muerto En Mictlan by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/multifruit_81': {
        title: "Play MultiFruit 81 by Play'n GO at {brand} | 2,520x Max Win",
        description: "Spin MultiFruit 81 by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/mystery_egg_surprise': {
        title: "Mystery Egg Surprise by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Spin Mystery Egg Surprise by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/mystery_genie_fortunes_of_the_lamp': {
        title: "Mystery Genie Fortunes of the Lamp Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Mystery Genie Fortunes of the Lamp by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/mystery_joker': {
        title: "Play Mystery Joker by Play'n GO at {brand} | 6,480x Max Win",
        description: "Play Mystery Joker by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/mystery_joker_6000': {
        title: 'Mystery Joker 6000: Play Online with Crypto | {brand}',
        description: "Mystery Joker 6000 from Play'n GO, with a 2,398x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/myth': {
        title: "Myth Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Myth by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/myth_of_dead': {
        title: "Myth of Dead Book Slot by Play'n GO | {brand}",
        description: "Play Myth of Dead by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/naughty_nicks_book': {
        title: "Play Naughty Nick's Book by Play'n GO at {brand} | 7,500x Max Win",
        description: "Spin Naughty Nick's Book by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/new_year_riches': {
        title: "New Year Riches by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Spin New Year Riches by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/ninja_fruits': {
        title: 'Ninja Fruits: Play Online with Crypto | {brand}',
        description: "Ninja Fruits by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/oasis_of_dead': {
        title: "Oasis of Dead Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Oasis of Dead from Play'n GO, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/octopus_treasure': {
        title: "Play Octopus Treasure by Play'n GO at {brand} | 5,000x Max Win",
        description: "Spin Octopus Treasure by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/odin_protector_of_realms': {
        title: "Odin: Protector of Realms Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Odin: Protector of Realms from Play'n GO, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/pack_and_cash': {
        title: "Play Pack and Cash by Play'n GO at {brand} | 10,000x Max Win",
        description: "Spin Pack and Cash by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/pandastic_adventure': {
        title: "Pandastic Adventure Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Pandastic Adventure by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/pandoras_box_of_evil': {
        title: "Play Pandora's Box of Evil by Play'n GO at {brand} | 6,000x Max Win",
        description: "Play Pandora's Box of Evil by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/pearl_lagoon': {
        title: "Play Pearl Lagoon by Play'n GO at {brand} | 67,332x Max Win",
        description: "Play Pearl Lagoon by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/pearls_of_india': {
        title: "Play Pearls of India by Play'n GO at {brand} | 10,000x Max Win",
        description: "Spin Pearls of India by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/perfect_gems': {
        title: "Perfect Gems Book Slot by Play'n GO | {brand}",
        description: "Perfect Gems from Play'n GO, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/phoenix_reborn': {
        title: "Phoenix Reborn Book Slot by Play'n GO | {brand}",
        description: "Phoenix Reborn by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/photo_safari': {
        title: "Photo Safari by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Play Photo Safari by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/piggy_bank_farm': {
        title: "Piggy Bank Farm Book Slot by Play'n GO | {brand}",
        description: "Piggy Bank Farm by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/piggy_blitz': {
        title: 'Piggy Blitz: Play Online with Crypto | {brand}',
        description: "Piggy Blitz by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/piggy_blitz_disco_gold': {
        title: 'Piggy Blitz Disco Gold: Play Online with Crypto | {brand}',
        description: "Piggy Blitz Disco Gold from Play'n GO, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/piggy_heist': {
        title: "Piggy Heist Book Slot by Play'n GO | {brand}",
        description: "Piggy Heist by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/pilgrim_of_dead': {
        title: "Play Pilgrim of Dead by Play'n GO at {brand} | 10,000x Max Win",
        description: "Play Pilgrim of Dead by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/pimped': {
        title: "Play Pimped by Play'n GO at {brand} | 10,000x Max Win",
        description: "Spin Pimped by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/pirahna_pays': {
        title: 'Pirahna Pays: Play Online with Crypto | {brand}',
        description: "Spin Pirahna Pays by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/planet_fortune': {
        title: "Planet Fortune Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Planet Fortune from Play'n GO, with a 2,500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/potion_of_madness': {
        title: "Play Potion of Madness by Play'n GO at {brand} | 10,000x Max Win",
        description: "Play Potion of Madness by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/prism_of_gems': {
        title: "Prism of Gems Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Prism of Gems by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/prissy_princess': {
        title: "Prissy Princess Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Prissy Princess by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/prosperity_palace': {
        title: "Prosperity Palace Book Slot by Play'n GO | {brand}",
        description: "Prosperity Palace from Play'n GO, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/puebla_parade': {
        title: "Play Puebla Parade by Play'n GO at {brand} | 5,000x Max Win",
        description: "Spin Puebla Parade by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/queens_day_tilt': {
        title: "Queen's Day Tilt: Play Online with Crypto | {brand}",
        description: "Queen's Day Tilt by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/rabbit_hole_riches': {
        title: "Rabbit Hole Riches Book Slot by Play'n GO | {brand}",
        description: "Rabbit Hole Riches by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/rage_to_riches': {
        title: "Rage to Riches Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Rage to Riches by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/raging_rex': {
        title: "Raging Rex Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Raging Rex by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/raging_rex_2': {
        title: "Play Raging Rex 2 by Play'n GO at {brand} | 30,000x Max Win",
        description: "Spin Raging Rex 2 by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/raging_rex_3': {
        title: "Raging Rex 3 Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Raging Rex 3 by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/rainforest_magic': {
        title: "Play Rainforest Magic by Play'n GO at {brand} | 5,000x Max Win",
        description: "Spin Rainforest Magic by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/rainforest_magic_bingo': {
        title: "Rainforest Magic Bingo by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Spin Rainforest Magic Bingo by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/rally_4_riches': {
        title: "Rally 4 Riches Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Rally 4 Riches from Play'n GO, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/ras_reckoning': {
        title: "Play Ra's Reckoning by Play'n GO at {brand} | 50,000x Max Win",
        description: "Spin Ra's Reckoning by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/rascal_riches': {
        title: "Rascal Riches by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Play Rascal Riches by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/reactoonz': {
        title: "Play Reactoonz by Play'n GO at {brand} | 4,570x Max Win",
        description: "Play Reactoonz by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/reactoonz_100': {
        title: "Play Reactoonz 100 by Play'n GO at {brand} | 10,000x Max Win",
        description: "Spin Reactoonz 100 by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/reactoonz_2': {
        title: "Reactoonz 2 Book Slot by Play'n GO | {brand}",
        description: "Reactoonz 2 by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/rich_wilde_and_the_amulet_of_dead': {
        title: 'Rich Wilde and The Amulet of Dead: Play Online with Crypto | {brand}',
        description: "Rich Wilde and The Amulet of Dead from Play'n GO, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/rich_wilde_and_the_pearls_of_vishnu': {
        title: "Rich Wilde and the Pearls of Vishnu Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Rich Wilde and the Pearls of Vishnu by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/rich_wilde_and_the_shield_of_athena': {
        title: "Rich Wilde and the Shield of Athena Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Rich Wilde and the Shield of Athena by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/rich_wilde_and_the_tome_of_dead': {
        title: "Play Rich Wilde and the Tome of Dead by Play'n GO at {brand} | 5,000x Max Win",
        description: "Spin Rich Wilde and the Tome of Dead by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/rich_wilde_and_the_tome_of_insanity': {
        title: "Rich Wilde and the Tome of Insanity by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Rich Wilde and the Tome of Insanity from Play'n GO. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/rich_wilde_and_the_tome_of_madness': {
        title: "Rich Wilde and the Tome of Madness Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Rich Wilde and the Tome of Madness from Play'n GO, with a 2,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/rich_wilde_and_the_wandering_city': {
        title: "Rich Wilde and the Wandering City Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Rich Wilde and the Wandering City by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/riches_of_ra': {
        title: "Riches of RA Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Riches of RA from Play'n GO, with a 8,032x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/riches_of_robin': {
        title: "Riches of Robin by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Play Riches of Robin by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/riddle_reels_a_case_of_riches': {
        title: "Riddle Reels: A Case of Riches Book Slot by Play'n GO | {brand}",
        description: "Riddle Reels: A Case of Riches by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/ring_of_odin': {
        title: "Play Ring of Odin by Play'n GO at {brand} | 5,000x Max Win",
        description: "Spin Ring of Odin by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/rings_of_prosperity': {
        title: "Play Rings of Prosperity by Play'n GO at {brand} | 5,000x Max Win",
        description: "Play Rings of Prosperity by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/rise_of_athena': {
        title: "Play Rise of Athena by Play'n GO at {brand} | 5,000x Max Win",
        description: "Play Rise of Athena by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/rise_of_dead': {
        title: "Rise of Dead Book Slot by Play'n GO | {brand}",
        description: "Rise of Dead from Play'n GO, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/rise_of_gods_reckoning': {
        title: 'Rise of Gods: Reckoning: Play Online with Crypto | {brand}',
        description: "Rise of Gods: Reckoning from Play'n GO, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/rise_of_merlin': {
        title: "Play Rise of Merlin by Play'n GO at {brand} | 5,000x Max Win",
        description: "Play Rise of Merlin by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/rise_of_olympus': {
        title: "Play Rise of Olympus by Play'n GO at {brand} | 5,000x Max Win",
        description: "Play Rise of Olympus by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/rise_of_olympus_100': {
        title: "Play Rise of Olympus 100 by Play'n GO at {brand} | 15,000x Max Win",
        description: "Spin Rise of Olympus 100 by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/rise_of_olympus_1000': {
        title: "Play Rise of Olympus 1000 by Play'n GO at {brand} | 40,000x Max Win",
        description: "Spin Rise of Olympus 1000 by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/rise_of_olympus_extreme': {
        title: "Rise of Olympus Extreme Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Rise of Olympus Extreme from Play'n GO, with a 50,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/rise_of_olympus_origins': {
        title: "Play Rise of Olympus Origins by Play'n GO at {brand} | 10,000x Max Win",
        description: "Spin Rise of Olympus Origins by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/rise_of_orpheus': {
        title: "Rise of Orpheus Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Rise of Orpheus by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/rocco_gallo': {
        title: "Rocco Gallo Book Slot by Play'n GO | {brand}",
        description: "Rocco Gallo from Play'n GO, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/ronins_honour': {
        title: "Ronin's Honour by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Play Ronin's Honour by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/rosy_orbit_treasure_turn': {
        title: "Rosy Orbit Treasure Turn Book Slot by Play'n GO | {brand}",
        description: "Rosy Orbit Treasure Turn by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/rotiki': {
        title: "RoTiki Book Slot by Play'n GO | {brand}",
        description: "RoTiki by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/royal_masquerade': {
        title: 'Royal Masquerade: Play Online with Crypto | {brand}',
        description: "Royal Masquerade from Play'n GO, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/ruff_heist': {
        title: "Play Ruff Heist by Play'n GO at {brand} | 10,000x Max Win",
        description: "Play Ruff Heist by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/sabaton': {
        title: "Sabaton Book Slot by Play'n GO | {brand}",
        description: "Sabaton by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/safari_of_wealth': {
        title: 'Safari of Wealth: Play Online with Crypto | {brand}',
        description: "Safari of Wealth from Play'n GO, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/sails_of_gold': {
        title: "Play Sails of Gold by Play'n GO at {brand} | 5,000x Max Win",
        description: "Play Sails of Gold by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/sails_of_riches': {
        title: "Play Sails of Riches by Play'n GO at {brand} | 10,000x Max Win",
        description: "Spin Sails of Riches by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/samba_carnival': {
        title: "Play Samba Carnival by Play'n GO at {brand} | 1,756x Max Win",
        description: "Spin Samba Carnival by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/scales_of_dead': {
        title: "Scales of Dead Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Scales of Dead from Play'n GO, with a 2,000,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/scourge_of_rome': {
        title: "Scourge of Rome by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Scourge of Rome from Play'n GO. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/scroll_of_dead': {
        title: "Scroll of Dead Book Slot by Play'n GO | {brand}",
        description: "Scroll of Dead from Play'n GO, with a 7,500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/scroll_of_seth': {
        title: 'Scroll of Seth: Play Online with Crypto | {brand}',
        description: "Scroll of Seth by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/sea_hunter': {
        title: 'Sea Hunter: Play Online with Crypto | {brand}',
        description: "Sea Hunter by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/secret_of_dead': {
        title: "Play Secret of Dead by Play'n GO at {brand} | 10,000x Max Win",
        description: "Play Secret of Dead by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/shamrock_miner': {
        title: "Shamrock Miner Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Shamrock Miner from Play'n GO, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/sherwood_gold': {
        title: "Sherwood Gold Book Slot by Play'n GO | {brand}",
        description: "Sherwood Gold from Play'n GO, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/shimmering_woods': {
        title: "Shimmering Woods Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Shimmering Woods by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/sisters_of_the_sun': {
        title: "Sisters of the Sun Book Slot by Play'n GO | {brand}",
        description: "Sisters of the Sun from Play'n GO, with a 15,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/sizzling_spins': {
        title: "Sizzling Spins Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Sizzling Spins from Play'n GO, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/slashimi': {
        title: 'Slashimi: Play Online with Crypto | {brand}',
        description: "Slashimi by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/sobeks_godly_spins': {
        title: "Sobek's Godly Spins: Play Online with Crypto | {brand}",
        description: "Spin Sobek's Godly Spins by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/space_race': {
        title: "Space Race Book Slot by Play'n GO | {brand}",
        description: "Space Race from Play'n GO, with a 10,658x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/spark_of_genius': {
        title: 'Spark of Genius: Play Online with Crypto | {brand}',
        description: "Spin Spark of Genius by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/sparky_and_shortz': {
        title: "Play Sparky & Shortz by Play'n GO at {brand} | 10x Max Win",
        description: "Spin Sparky & Shortz by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/sparky_and_shortz_hidden_joules': {
        title: 'Sparky & Shortz Hidden Joules: Play Online with Crypto | {brand}',
        description: "Spin Sparky & Shortz Hidden Joules by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/speed_cash': {
        title: "Speed Cash Slot by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Spin Speed Cash Slot by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/spin_party': {
        title: "Play Spin Party by Play'n GO at {brand} | 5,000x Max Win",
        description: "Play Spin Party by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/spinnin_records_into_the_beat': {
        title: 'Spinnin Records into the Beat: Play Online with Crypto | {brand}',
        description: "Spinnin Records into the Beat from Play'n GO, with a 4,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/spinnin_records_raving_reels': {
        title: 'Spinnin Records Raving Reels: Play Online with Crypto | {brand}',
        description: "Spinnin Records Raving Reels by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/stadium_of_riches': {
        title: 'Stadium of Riches: Play Online with Crypto | {brand}',
        description: "Stadium of Riches from Play'n GO, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/star_joker': {
        title: 'Star Joker: Play Online with Crypto | {brand}',
        description: "Star Joker from Play'n GO, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/static_nightmare': {
        title: 'Static Nightmare: Play Online with Crypto | {brand}',
        description: "Static Nightmare from Play'n GO, with a 30,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/stepping_diamonds': {
        title: "Stepping Diamonds Book Slot by Play'n GO | {brand}",
        description: "Stepping Diamonds from Play'n GO, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/sticky_joker': {
        title: "Play Sticky Joker by Play'n GO at {brand} | 1,650x Max Win",
        description: "Play Sticky Joker by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/street_magic': {
        title: "Street Magic by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Play Street Magic by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/super_flip': {
        title: "Play Super Flip by Play'n GO at {brand} | 10,000x Max Win",
        description: "Play Super Flip by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/super_flip_deluxe': {
        title: "Play Super Flip Deluxe by Play'n GO at {brand} | 1,200x Max Win",
        description: "Spin Super Flip Deluxe by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/super_wheel': {
        title: "Play Super Wheel by Play'n GO at {brand} | 48x Max Win",
        description: "Play Super Wheel by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/sweet_27': {
        title: 'Sweet 27: Play Online with Crypto | {brand}',
        description: "Sweet 27 by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/sweet_alchemy': {
        title: "Sweet Alchemy Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Sweet Alchemy by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/sweet_alchemy_100': {
        title: "Sweet Alchemy 100 Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Sweet Alchemy 100 from Play'n GO, with a 15,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/sweet_alchemy_2': {
        title: "Play Sweet Alchemy 2 by Play'n GO at {brand} | 1,000,000x Max Win",
        description: "Spin Sweet Alchemy 2 by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/sweet_alchemy_bingo': {
        title: "Sweet Alchemy Bingo Book Slot by Play'n GO | {brand}",
        description: "Sweet Alchemy Bingo by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/tale_of_kyubiko': {
        title: "Tale of Kyubiko by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Play Tale of Kyubiko by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/tales_of_asgard_freyas_wedding': {
        title: "Tales of Asgard: Freya's Wedding Book Slot by Play'n GO | {brand}",
        description: "Tales of Asgard: Freya's Wedding from Play'n GO, with a 2,500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/tales_of_asgard_lokis_fortune': {
        title: "Play Tales of Asgard: Loki's Fortune by Play'n GO at {brand} | 20,000x Max Win",
        description: "Spin Tales of Asgard: Loki's Fortune by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/tales_of_mithrune_syns_fortune': {
        title: "Tales of Mithrune Syn's Fortune Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Tales of Mithrune Syn's Fortune by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/temple_of_prosperity': {
        title: "Play Temple of Prosperity by Play'n GO at {brand} | 100,000x Max Win",
        description: "Play Temple of Prosperity by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/temple_of_tollan': {
        title: "Temple of Tollan by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Temple of Tollan from Play'n GO. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/temple_of_wealth': {
        title: "Play Temple Of Wealth Slot by Play'n GO at {brand} | 10,000x Max Win",
        description: "Spin Temple Of Wealth Slot by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/ternion': {
        title: "Play Ternion by Play'n GO at {brand} | 11,111x Max Win",
        description: "Play Ternion by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/testament': {
        title: "Play Testament by Play'n GO at {brand} | 20,000x Max Win",
        description: "Spin Testament by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/thats_rich': {
        title: "Play That's Rich by Play'n GO at {brand} | 10,000x Max Win",
        description: "Spin That's Rich by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/the_faces_of_freya': {
        title: "The Faces of Freya Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "The Faces of Freya by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/the_green_knight': {
        title: "The Green Knight by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Spin The Green Knight by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/the_green_knight_oath_of_thorns': {
        title: "Play The Green Knight Oath of Thorns by Play'n GO at {brand} | 14,000x Max Win",
        description: "Play The Green Knight Oath of Thorns by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/the_last_sundown': {
        title: "The Last Sundown by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Spin The Last Sundown by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/the_paying_piano_club': {
        title: "Play The Paying Piano Club by Play'n GO at {brand} | 5,000x Max Win",
        description: "Play The Paying Piano Club by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/the_return_of_the_green_knight': {
        title: "The Return of the Green Knight by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "The Return of the Green Knight from Play'n GO. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/the_sword_and_the_grail': {
        title: "Play The Sword and The Grail by Play'n GO at {brand} | 10,000x Max Win",
        description: "Play The Sword and The Grail by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/the_sword_and_the_grail_excalibur': {
        title: 'The Sword and the Grail Excalibur: Play Online with Crypto | {brand}',
        description: "Spin The Sword and the Grail Excalibur by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/the_wild_class': {
        title: "Play The Wild Class by Play'n GO at {brand} | 6,666x Max Win",
        description: "Play The Wild Class by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/thunderscreech': {
        title: "Play Thunderscreech by Play'n GO at {brand} | 5,000x Max Win",
        description: "Spin Thunderscreech by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/tomb_of_gold': {
        title: "Tomb of Gold Book Slot by Play'n GO | {brand}",
        description: "Play Tomb of Gold by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/tomb_of_gold_ii': {
        title: "Tomb of Gold II Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Tomb of Gold II by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/tome_of_madness_bingo': {
        title: "Tome Of Madness Bingo by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Play Tome Of Madness Bingo by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/treasures_of_kongar': {
        title: "Play Treasures of Kongar by Play'n GO at {brand} | 10,000x Max Win",
        description: "Play Treasures of Kongar by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/treats_of_terror': {
        title: "Treats of Terror Book Slot by Play'n GO | {brand}",
        description: "Treats of Terror from Play'n GO, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/trinity_impact': {
        title: "Trinity Impact Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Trinity Impact from Play'n GO, with a 1,600x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/troll_hunters': {
        title: "Play Troll Hunters by Play'n GO at {brand} | 5,000x Max Win",
        description: "Spin Troll Hunters by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/troll_hunters_2': {
        title: "Troll Hunters 2 Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Troll Hunters 2 from Play'n GO, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/undefeated_xerxes': {
        title: "Play Undefeated Xerxes by Play'n GO at {brand} | 10,000x Max Win",
        description: "Spin Undefeated Xerxes by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/usa_flip': {
        title: "Play USA Flip by Play'n GO at {brand} | 1,000x Max Win",
        description: "Play USA Flip by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/viking_apocalypse': {
        title: 'Viking Apocalypse: Play Online with Crypto | {brand}',
        description: "Viking Apocalypse from Play'n GO, with a 1,000,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/viking_runecraft': {
        title: "Play Viking Runecraft by Play'n GO at {brand} | 5,000x Max Win",
        description: "Play Viking Runecraft by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/viking_runecraft_100': {
        title: "Play Viking Runecraft 100 by Play'n GO at {brand} | 10,000x Max Win",
        description: "Spin Viking Runecraft 100 by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/viking_runecraft_bingo': {
        title: "Play Viking Runecraft Bingo by Play'n GO at {brand} | 10,000x Max Win",
        description: "Play Viking Runecraft Bingo by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/viper_city_heist': {
        title: 'Viper City Heist: Play Online with Crypto | {brand}',
        description: "Viper City Heist from Play'n GO, with a 15,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/wheel_of_mictlan': {
        title: "Wheel of Mictlan Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Wheel of Mictlan by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/whispering_winds': {
        title: "Whispering Winds Book Slot by Play'n GO | {brand}",
        description: "Whispering Winds by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/wild_bandolier': {
        title: "Play Wild Bandolier by Play'n GO at {brand} | 900,000x Max Win",
        description: "Spin Wild Bandolier by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/wild_blood': {
        title: "Wild Blood by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Play Wild Blood by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/wild_blood_2': {
        title: "Wild Blood 2 Book Slot by Play'n GO | {brand}",
        description: "Wild Blood 2 by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/wild_falls': {
        title: "Play Wild Falls by Play'n GO at {brand} | 10,000x Max Win",
        description: "Spin Wild Falls by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/wild_falls_2': {
        title: 'Wild Falls 2: Play Online with Crypto | {brand}',
        description: "Wild Falls 2 from Play'n GO, with a 15,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/wild_frames': {
        title: "Play Wild Frames by Play'n GO at {brand} | 7,000x Max Win",
        description: "Play Wild Frames by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/wild_melon': {
        title: "Wild Melon Book Slot by Play'n GO | {brand}",
        description: "Wild Melon from Play'n GO, with a 3,333x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/play-n-go/wild_north': {
        title: "Wild North Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Wild North by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/wild_rails': {
        title: "Wild Rails Book Slot by Play'n GO | {brand}",
        description: "Wild Rails by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/wild_survivor': {
        title: "Wild Survivor by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Play Wild Survivor by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/wild_trigger': {
        title: "Play Wild Trigger by Play'n GO at {brand} | 2,000x Max Win",
        description: "Spin Wild Trigger by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/play-n-go/wildest_gambit': {
        title: "Wildest Gambit Book Slot by Play'n GO | {brand}",
        description: "Play Wildest Gambit by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/wildhound_derby': {
        title: "Wildhound Derby by Play'n GO at {brand} | Free Demo & Crypto Play",
        description: "Play Wildhound Derby by Play'n GO at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/play-n-go/winabeest': {
        title: "Win-A-Beest Book Slot by Play'n GO | {brand}",
        description: "Win-A-Beest by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/wizard_of_gems': {
        title: "Wizard of Gems Slot by Play'n GO at {brand} | Instant Crypto Payouts",
        description: "Wizard of Gems by Play'n GO at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/play-n-go/xmas_joker': {
        title: "Play Xmas Joker by Play'n GO at {brand} | 6,480x Max Win",
        description: "Spin Xmas Joker by Play'n GO at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/pgsoft/hawaiian_tiki': {
        title: 'Hawaiian Tiki by PG Soft at {brand} | Free Demo & Crypto Play',
        description: 'Play Hawaiian Tiki by PG Soft at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play-live/big_small_baccarat': {
        title: 'Big Small Baccarat: Play Online with Crypto | {brand}',
        description: 'Big Small Baccarat by Pragmatic Play Live at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play-live/amazing_baccarat': {
        title: 'Amazing Baccarat by Pragmatic Play Live at {brand} | Free Demo & Crypto Play',
        description: 'Spin Amazing Baccarat by Pragmatic Play Live at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pragmatic-play-live/baccarat_lobby': {
        title: 'Baccarat Lobby Slot by Pragmatic Play Live at {brand} | Instant Crypto Payouts',
        description: 'Baccarat Lobby by Pragmatic Play Live at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play-live/roulette_lobby': {
        title: 'Roulette Lobby Slot by Pragmatic Play Live at {brand} | Instant Crypto Payouts',
        description: 'Play Roulette Lobby by Pragmatic Play Live at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pragmatic-play-live/dragon_tiger_lobby': {
        title: 'Dragon Tiger Lobby Slot by Pragmatic Play Live at {brand} | Instant Crypto Payouts',
        description: 'Dragon Tiger Lobby by Pragmatic Play Live at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/pragmatic-play-live/game_show_lobby': {
        title: 'Game Show Lobby Slot by Pragmatic Play Live at {brand} | Instant Crypto Payouts',
        description: 'Play Game Show Lobby by Pragmatic Play Live at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/pgsoft/baccarat_deluxe': {
        title: 'Baccarat Deluxe by PG Soft at {brand} | Free Demo & Crypto Play',
        description: 'Baccarat Deluxe from PG Soft. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/relax-gaming/agroculture': {
        title: 'Play AgroCulture by Relax Gaming at {brand} | 10,000x Max Win',
        description: 'Play AgroCulture by Relax Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/relax-gaming/ancient_tumble': {
        title: 'Ancient Tumble: Play Online with Crypto | {brand}',
        description: 'Ancient Tumble from Relax Gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/relax-gaming/atlantis_crush': {
        title: 'Atlantis Crush: Play Online with Crypto | {brand}',
        description: 'Atlantis Crush by Relax Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/relax-gaming/attila_the_hun': {
        title: 'Play Attila The Hun by Relax Gaming at {brand} | 1,048x Max Win',
        description: 'Play Attila The Hun by Relax Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/relax-gaming/aura_god': {
        title: 'Aura God Slot by Relax Gaming at {brand} | Instant Crypto Payouts',
        description: 'Aura God by Relax Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/relax-gaming/aussies_vs_emus': {
        title: 'Aussies vs Emus by Relax Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Aussies vs Emus from Relax Gaming. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/relax-gaming/bacon_bankroll': {
        title: 'Play Bacon Bankroll by Relax Gaming at {brand} | 5,106x Max Win',
        description: 'Play Bacon Bankroll by Relax Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/relax-gaming/banana_town': {
        title: 'Banana Town by Relax Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Banana Town from Relax Gaming. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/relax-gaming/beast_gains': {
        title: 'Beast Gains: Play Online with Crypto | {brand}',
        description: 'Beast Gains from Relax Gaming, with a 25,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/relax-gaming/beast_mode': {
        title: 'Play Beast Mode by Relax Gaming at {brand} | 25,000x Max Win',
        description: 'Spin Beast Mode by Relax Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/relax-gaming/beellionaires': {
        title: 'Beellionaires Slot by Relax Gaming at {brand} | Instant Crypto Payouts',
        description: 'Beellionaires by Relax Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/relax-gaming/bill_and_coin': {
        title: 'Play Bill & Coin by Relax Gaming at {brand} | 10,000x Max Win',
        description: 'Spin Bill & Coin by Relax Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/relax-gaming/bill_and_coin_2': {
        title: 'Bill and Coin 2 Slot by Relax Gaming at {brand} | Instant Crypto Payouts',
        description: 'Bill and Coin 2 from Relax Gaming, with a 15,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/relax-gaming/blender_blitz': {
        title: 'Blender Blitz Slot by Relax Gaming at {brand} | Instant Crypto Payouts',
        description: 'Blender Blitz from Relax Gaming, with a 25,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/relax-gaming/bone_raiders': {
        title: 'Bone Raiders by Relax Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Bone Raiders by Relax Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/relax-gaming/bonsai_dragon_blitz': {
        title: 'Bonsai Dragon Blitz: Play Online with Crypto | {brand}',
        description: 'Bonsai Dragon Blitz by Relax Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/relax-gaming/book_of': {
        title: 'Book of: Play Online with Crypto | {brand}',
        description: 'Spin Book of by Relax Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/relax-gaming/book_of_power': {
        title: 'Play Book of Power by Relax Gaming at {brand} | 15,000x Max Win',
        description: 'Play Book of Power by Relax Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/relax-gaming/bounty_county': {
        title: 'Bounty County Slot by Relax Gaming at {brand} | Instant Crypto Payouts',
        description: 'Bounty County by Relax Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/relax-gaming/camelot_cash': {
        title: 'Camelot Cash by Relax Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Camelot Cash by Relax Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/relax-gaming/cash_in_transit': {
        title: 'Play Cash in Transit by Relax Gaming at {brand} | 10,000x Max Win',
        description: 'Spin Cash in Transit by Relax Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/relax-gaming/caveman_bob': {
        title: 'Play Caveman Bob by Relax Gaming at {brand} | 500x Max Win',
        description: 'Play Caveman Bob by Relax Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/relax-gaming/chip_spin': {
        title: 'Play Chip Spin by Relax Gaming at {brand} | 25,102x Max Win',
        description: 'Spin Chip Spin by Relax Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/relax-gaming/cluster_tumble': {
        title: 'Cluster Tumble Slot by Relax Gaming at {brand} | Instant Crypto Payouts',
        description: 'Cluster Tumble by Relax Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/relax-gaming/cod_of_thunder': {
        title: 'Cod of Thunder: Play Online with Crypto | {brand}',
        description: 'Spin Cod of Thunder by Relax Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/relax-gaming/conquer_babylon': {
        title: 'Play Conquer Babylon by Relax Gaming at {brand} | 15,000x Max Win',
        description: 'Spin Conquer Babylon by Relax Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/relax-gaming/cowabunga': {
        title: 'Cowabunga Cluster Slot by Relax Gaming | {brand}',
        description: 'Play Cowabunga by Relax Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/relax-gaming/dead_mans_trail': {
        title: "Play Dead Man's Trail by Relax Gaming at {brand} | 50,000x Max Win",
        description: "Play Dead Man's Trail by Relax Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/relax-gaming/dead_riders_trail': {
        title: 'Dead Riders Trail by Relax Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Dead Riders Trail by Relax Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/relax-gaming/deep_descent': {
        title: 'Deep Descent by Relax Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Deep Descent by Relax Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/relax-gaming/diamonds': {
        title: 'Diamonds: Play Online with Crypto | {brand}',
        description: 'Spin Diamonds by Relax Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/relax-gaming/dragons_awakening': {
        title: "Dragons' Awakening Slot by Relax Gaming at {brand} | Instant Crypto Payouts",
        description: "Dragons' Awakening by Relax Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/relax-gaming/emeralds_infinity_reels': {
        title: "Emerald's Infinity Reels Slot by Relax Gaming at {brand} | Instant Crypto Payouts",
        description: "Emerald's Infinity Reels by Relax Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/relax-gaming/epic_dreams': {
        title: 'Epic Dreams Cluster Slot by Relax Gaming | {brand}',
        description: 'Epic Dreams by Relax Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/relax-gaming/epic_joker': {
        title: 'Epic Joker by Relax Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Epic Joker by Relax Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/relax-gaming/erik_the_red': {
        title: 'Play Erik the Red by Relax Gaming at {brand} | 959x Max Win',
        description: 'Spin Erik the Red by Relax Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/relax-gaming/fangs_inferno': {
        title: "Play Fang's Inferno by Relax Gaming at {brand} | 5,000x Max Win",
        description: "Play Fang's Inferno by Relax Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/relax-gaming/feather_fury': {
        title: 'Feather Fury: Play Online with Crypto | {brand}',
        description: 'Feather Fury from Relax Gaming, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/relax-gaming/firewins_factory': {
        title: 'FireWins Factory Slot by Relax Gaming at {brand} | Instant Crypto Payouts',
        description: 'FireWins Factory by Relax Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/relax-gaming/fly_cat': {
        title: 'Fly Cat$ Slot by Relax Gaming at {brand} | Instant Crypto Payouts',
        description: 'Fly Cat$ by Relax Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/relax-gaming/franks_diner': {
        title: "Frank's Diner: Play Online with Crypto | {brand}",
        description: "Frank's Diner by Relax Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/relax-gaming/freaked_out_fish': {
        title: 'Freaked Out Fish by Relax Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Freaked Out Fish from Relax Gaming. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/relax-gaming/frequent_flyer': {
        title: 'Play Frequent Flyer by Relax Gaming at {brand} | 5,426x Max Win',
        description: 'Spin Frequent Flyer by Relax Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/relax-gaming/galactic_racers': {
        title: 'Galactic Racers Cluster Slot by Relax Gaming | {brand}',
        description: 'Play Galactic Racers by Relax Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/relax-gaming/giants_and_sheep': {
        title: 'Giants and Sheep Cluster Slot by Relax Gaming | {brand}',
        description: 'Giants and Sheep from Relax Gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/relax-gaming/glyph_of_gods': {
        title: 'Glyph of Gods Cluster Slot by Relax Gaming | {brand}',
        description: 'Glyph of Gods from Relax Gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/relax-gaming/grim_the_splitter': {
        title: 'Grim The Splitter: Play Online with Crypto | {brand}',
        description: 'Spin Grim The Splitter by Relax Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/relax-gaming/groovy_knights': {
        title: 'Groovy Knights Cluster Slot by Relax Gaming | {brand}',
        description: 'Play Groovy Knights by Relax Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/relax-gaming/guitar_quest': {
        title: 'Guitar Quest by Relax Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Guitar Quest by Relax Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/relax-gaming/hazakura_ways': {
        title: 'Hazakura Ways Cluster Slot by Relax Gaming | {brand}',
        description: 'Hazakura Ways by Relax Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/relax-gaming/helios_fury': {
        title: "Play Helios' Fury by Relax Gaming at {brand} | 50,000x Max Win",
        description: "Play Helios' Fury by Relax Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/relax-gaming/hellcatraz': {
        title: 'Hellcatraz by Relax Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Hellcatraz from Relax Gaming. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/relax-gaming/hellcatraz_2': {
        title: 'Hellcatraz 2 Cluster Slot by Relax Gaming | {brand}',
        description: 'Play Hellcatraz 2 by Relax Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/relax-gaming/heroes_gathering': {
        title: 'Heroes Gathering Slot by Relax Gaming at {brand} | Instant Crypto Payouts',
        description: 'Heroes Gathering by Relax Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/relax-gaming/hex': {
        title: 'Play Hex by Relax Gaming at {brand} | 25,000x Max Win',
        description: 'Play Hex by Relax Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/relax-gaming/horror_hotel': {
        title: 'Play Horror Hotel by Relax Gaming at {brand} | 20,000x Max Win',
        description: 'Spin Horror Hotel by Relax Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/relax-gaming/hot_rod_racers': {
        title: 'Hot Rod Racers Slot by Relax Gaming at {brand} | Instant Crypto Payouts',
        description: 'Hot Rod Racers by Relax Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/relax-gaming/ignite_the_night': {
        title: 'Ignite the Night by Relax Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Ignite the Night by Relax Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/relax-gaming/immortal_5': {
        title: 'Play Immortal 5 by Relax Gaming at {brand} | 10,000x Max Win',
        description: 'Play Immortal 5 by Relax Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/relax-gaming/iron_bank': {
        title: 'Iron Bank by Relax Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Iron Bank by Relax Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/relax-gaming/iron_bank_2': {
        title: 'Iron Bank 2: Play Online with Crypto | {brand}',
        description: 'Iron Bank 2 by Relax Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/relax-gaming/its_time': {
        title: "It's Time Slot by Relax Gaming at {brand} | Instant Crypto Payouts",
        description: "It's Time by Relax Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/relax-gaming/joker_split': {
        title: 'Joker Split Slot by Relax Gaming at {brand} | Instant Crypto Payouts',
        description: 'Joker Split by Relax Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/relax-gaming/jumbo_juicy': {
        title: 'Jumbo Juicy: Play Online with Crypto | {brand}',
        description: 'Jumbo Juicy from Relax Gaming, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/relax-gaming/jupiters_choice': {
        title: 'Jupiters Choice Slot by Relax Gaming at {brand} | Instant Crypto Payouts',
        description: 'Jupiters Choice by Relax Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/relax-gaming/jurassic_party': {
        title: 'Play Jurassic Party by Relax Gaming at {brand} | 20,000x Max Win',
        description: 'Spin Jurassic Party by Relax Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/relax-gaming/king_of_kings': {
        title: 'King of Kings Slot by Relax Gaming at {brand} | Instant Crypto Payouts',
        description: 'King of Kings from Relax Gaming, with a 10,509x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/relax-gaming/kluster_krystals_megaclusters': {
        title: 'Kluster Krystals MegaClusters Slot by Relax Gaming at {brand} | Instant Crypto Payouts',
        description: 'Kluster Krystals MegaClusters from Relax Gaming, with a 9,921x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/relax-gaming/krakens_cove': {
        title: "Kraken's Cove by Relax Gaming at {brand} | Free Demo & Crypto Play",
        description: "Play Kraken's Cove by Relax Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/relax-gaming/la_fiesta': {
        title: 'La Fiesta: Play Online with Crypto | {brand}',
        description: 'La Fiesta from Relax Gaming, with a 14,778x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/relax-gaming/legend_of_odysseus': {
        title: 'Legend of Odysseus Cluster Slot by Relax Gaming | {brand}',
        description: 'Play Legend of Odysseus by Relax Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/relax-gaming/lets_get_ready_to_rumble': {
        title: "Let's Get Ready to Rumble by Relax Gaming at {brand} | Free Demo & Crypto Play",
        description: "Play Let's Get Ready to Rumble by Relax Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/relax-gaming/lure_of_fortune': {
        title: 'Lure of Fortune by Relax Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Lure of Fortune from Relax Gaming. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/relax-gaming/magawa_vs_mines': {
        title: 'Magawa vs Mines: Play Online with Crypto | {brand}',
        description: 'Spin Magawa vs Mines by Relax Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/relax-gaming/marching_legions': {
        title: 'Marching Legions by Relax Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Marching Legions by Relax Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/relax-gaming/masked_treasures': {
        title: 'Masked Treasures Slot by Relax Gaming at {brand} | Instant Crypto Payouts',
        description: 'Masked Treasures by Relax Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/relax-gaming/mega_flip': {
        title: 'Mega Flip Cluster Slot by Relax Gaming | {brand}',
        description: 'Mega Flip by Relax Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/relax-gaming/mega_heist': {
        title: 'Mega Heist Slot by Relax Gaming at {brand} | Instant Crypto Payouts',
        description: 'Mega Heist by Relax Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/relax-gaming/mega_masks': {
        title: 'Mega Masks Cluster Slot by Relax Gaming | {brand}',
        description: 'Mega Masks from Relax Gaming, with a 2,451x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/relax-gaming/mega_mine': {
        title: 'Mega Mine Slot by Relax Gaming at {brand} | Instant Crypto Payouts',
        description: 'Mega Mine from Relax Gaming, with a 50,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/relax-gaming/midnight_marauder': {
        title: 'Midnight Marauder: Play Online with Crypto | {brand}',
        description: 'Midnight Marauder by Relax Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/relax-gaming/midnight_marauder_clusterbreaker': {
        title: 'Midnight Marauder ClusterBreaker: Play Online with Crypto | {brand}',
        description: 'Spin Midnight Marauder ClusterBreaker by Relax Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/relax-gaming/money_cart': {
        title: 'Play Money Cart by Relax Gaming at {brand} | 2,000x Max Win',
        description: 'Spin Money Cart by Relax Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/relax-gaming/money_cart_2': {
        title: 'Money Cart 2 Cluster Slot by Relax Gaming | {brand}',
        description: 'Money Cart 2 from Relax Gaming, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/relax-gaming/money_cart_3': {
        title: 'Money Cart 3 by Relax Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Money Cart 3 by Relax Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/relax-gaming/money_cart_4': {
        title: 'Money Cart 4: Play Online with Crypto | {brand}',
        description: 'Money Cart 4 by Relax Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/relax-gaming/money_plane': {
        title: 'Play Money Plane by Relax Gaming at {brand} | 10,000x Max Win',
        description: 'Spin Money Plane by Relax Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/relax-gaming/money_sleigh': {
        title: 'Play Money Sleigh by Relax Gaming at {brand} | 10,000x Max Win',
        description: 'Play Money Sleigh by Relax Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/relax-gaming/money_train': {
        title: 'Money Train by Relax Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Money Train by Relax Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/relax-gaming/money_train_2': {
        title: 'Money Train 2 by Relax Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Money Train 2 from Relax Gaming. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/relax-gaming/money_train_3': {
        title: 'Money Train 3: Play Online with Crypto | {brand}',
        description: 'Spin Money Train 3 by Relax Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/relax-gaming/money_train_5': {
        title: 'Money Train 5 Cluster Slot by Relax Gaming | {brand}',
        description: 'Play Money Train 5 by Relax Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/relax-gaming/money_train_origins': {
        title: 'Money Train Origins Cluster Slot by Relax Gaming | {brand}',
        description: 'Play Money Train Origins by Relax Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/relax-gaming/monkey_gods_of_the_inca': {
        title: 'Monkey Gods of the Inca: Play Online with Crypto | {brand}',
        description: 'Spin Monkey Gods of the Inca by Relax Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/relax-gaming/multiplier_odyssey': {
        title: 'Multiplier Odyssey: Play Online with Crypto | {brand}',
        description: 'Multiplier Odyssey from Relax Gaming, with a 50,895x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/relax-gaming/mystic_multipliers': {
        title: 'Mystic Multipliers by Relax Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Mystic Multipliers from Relax Gaming. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/relax-gaming/napoleon_vs_rabbits': {
        title: 'Napoleon vs Rabbits by Relax Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Napoleon vs Rabbits from Relax Gaming. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/relax-gaming/necromancers_gate': {
        title: "Necromancer's Gate Cluster Slot by Relax Gaming | {brand}",
        description: "Necromancer's Gate by Relax Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/relax-gaming/neko_night': {
        title: 'Neko Night Slot by Relax Gaming at {brand} | Instant Crypto Payouts',
        description: 'Neko Night by Relax Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/relax-gaming/net_gains': {
        title: 'Net Gains Slot by Relax Gaming at {brand} | Instant Crypto Payouts',
        description: 'Net Gains by Relax Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/relax-gaming/olympus_7s': {
        title: 'Olympus 7s by Relax Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Olympus 7s from Relax Gaming. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/relax-gaming/pharaohs_last_wish': {
        title: "Play Pharaoh's Last Wish by Relax Gaming at {brand} | 10,000x Max Win",
        description: "Spin Pharaoh's Last Wish by Relax Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/relax-gaming/pinata_popper': {
        title: 'Pinata Popper Slot by Relax Gaming at {brand} | Instant Crypto Payouts',
        description: 'Pinata Popper by Relax Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/relax-gaming/plunderland': {
        title: 'Play Plunderland by Relax Gaming at {brand} | 10,266x Max Win',
        description: 'Play Plunderland by Relax Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/relax-gaming/powerspin': {
        title: 'Powerspin by Relax Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Powerspin by Relax Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/relax-gaming/purrrminator': {
        title: 'Play Purrrminator by Relax Gaming at {brand} | 5,000x Max Win',
        description: 'Spin Purrrminator by Relax Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/relax-gaming/quackin_reels': {
        title: 'Quackin Reels Cluster Slot by Relax Gaming | {brand}',
        description: 'Quackin Reels from Relax Gaming, with a 8,850x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/relax-gaming/ramses_revenge': {
        title: 'Ramses Revenge: Play Online with Crypto | {brand}',
        description: 'Ramses Revenge from Relax Gaming, with a 49,996x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/relax-gaming/sails_of_fortune': {
        title: 'Sails of Fortune Cluster Slot by Relax Gaming | {brand}',
        description: 'Sails of Fortune from Relax Gaming, with a 36,383x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/relax-gaming/santas_stack': {
        title: "Play Santa's Stack by Relax Gaming at {brand} | 20,000x Max Win",
        description: "Spin Santa's Stack by Relax Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/relax-gaming/shark_wash': {
        title: 'Shark Wash by Relax Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Shark Wash by Relax Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/relax-gaming/sloth_tumble': {
        title: 'Sloth Tumble Slot by Relax Gaming at {brand} | Instant Crypto Payouts',
        description: 'Sloth Tumble by Relax Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/relax-gaming/snake_arena': {
        title: 'Snake Arena Slot by Relax Gaming at {brand} | Instant Crypto Payouts',
        description: 'Snake Arena from Relax Gaming, with a 2,758x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/relax-gaming/snake_arena_2': {
        title: 'Play Snake Arena 2 by Relax Gaming at {brand} | 50,000x Max Win',
        description: 'Play Snake Arena 2 by Relax Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/relax-gaming/snakes_gold': {
        title: 'Snakes Gold by Relax Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Snakes Gold from Relax Gaming. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/relax-gaming/space_miners': {
        title: 'Play Space Miners by Relax Gaming at {brand} | 50,000x Max Win',
        description: 'Play Space Miners by Relax Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/relax-gaming/spirit_of_the_beast': {
        title: 'Play Spirit of the Beast by Relax Gaming at {brand} | 11,531x Max Win',
        description: 'Play Spirit of the Beast by Relax Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/relax-gaming/st_louis_1904': {
        title: 'St Louis 1904: Play Online with Crypto | {brand}',
        description: 'Spin St Louis 1904 by Relax Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/relax-gaming/sultan_spins': {
        title: 'Sultan Spins by Relax Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Sultan Spins by Relax Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/relax-gaming/sweetopia_royale': {
        title: 'Sweetopia Royale Slot by Relax Gaming at {brand} | Instant Crypto Payouts',
        description: 'Sweetopia Royale by Relax Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/relax-gaming/templar_tumble': {
        title: 'Templar Tumble by Relax Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Templar Tumble by Relax Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/relax-gaming/templar_tumble_2': {
        title: 'Templar Tumble 2 Slot by Relax Gaming at {brand} | Instant Crypto Payouts',
        description: 'Templar Tumble 2 by Relax Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/relax-gaming/temple_tumble_megaways': {
        title: 'Temple Tumble MegaWays: Play Online with Crypto | {brand}',
        description: 'Temple Tumble MegaWays by Relax Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/relax-gaming/the_great_pigsby': {
        title: 'The Great Pigsby Cluster Slot by Relax Gaming | {brand}',
        description: 'The Great Pigsby by Relax Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/relax-gaming/the_great_pigsby_megapays': {
        title: 'The Great Pigsby Megapays Slot by Relax Gaming at {brand} | Instant Crypto Payouts',
        description: 'The Great Pigsby Megapays from Relax Gaming, with a 20,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/relax-gaming/the_great_pigsby_megaways': {
        title: 'Play The Great Pigsby MegaWays by Relax Gaming at {brand} | 20,000x Max Win',
        description: 'Spin The Great Pigsby MegaWays by Relax Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/relax-gaming/the_tumbles': {
        title: 'The Tumbles Slot by Relax Gaming at {brand} | Instant Crypto Payouts',
        description: 'The Tumbles by Relax Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/relax-gaming/tiger_kingdom': {
        title: 'Play Tiger Kingdom by Relax Gaming at {brand} | 20,000x Max Win',
        description: 'Play Tiger Kingdom by Relax Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/relax-gaming/tiger_shrine': {
        title: 'Tiger Shrine by Relax Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Tiger Shrine by Relax Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/relax-gaming/titan_strike': {
        title: 'Titan Strike by Relax Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Titan Strike by Relax Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/relax-gaming/tnt_tumble': {
        title: 'TNT Tumble Slot by Relax Gaming at {brand} | Instant Crypto Payouts',
        description: 'TNT Tumble by Relax Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/relax-gaming/top_dawg': {
        title: 'Top Dawg$ by Relax Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Spin Top Dawg$ by Relax Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/relax-gaming/torii_tumble': {
        title: 'Play Torii Tumble by Relax Gaming at {brand} | 20,000x Max Win',
        description: 'Spin Torii Tumble by Relax Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/relax-gaming/totem_guardians': {
        title: 'Totem Guardians by Relax Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Totem Guardians from Relax Gaming. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/relax-gaming/tower_tumble': {
        title: 'Play Tower Tumble by Relax Gaming at {brand} | 5,150x Max Win',
        description: 'Play Tower Tumble by Relax Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/relax-gaming/treasure_tumble': {
        title: 'Play Treasure Tumble by Relax Gaming at {brand} | 10,000x Max Win',
        description: 'Play Treasure Tumble by Relax Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/relax-gaming/trolls_gold': {
        title: "Troll's Gold by Relax Gaming at {brand} | Free Demo & Crypto Play",
        description: "Spin Troll's Gold by Relax Gaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/relax-gaming/volatile_vikings': {
        title: 'Volatile Vikings Slot by Relax Gaming at {brand} | Instant Crypto Payouts',
        description: 'Volatile Vikings from Relax Gaming, with a 20,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/relax-gaming/volatile_vikings_2': {
        title: 'Volatile Vikings 2 by Relax Gaming at {brand} | Free Demo & Crypto Play',
        description: 'Play Volatile Vikings 2 by Relax Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/relax-gaming/wild_chapo': {
        title: 'Wild Chapo Cluster Slot by Relax Gaming | {brand}',
        description: 'Wild Chapo from Relax Gaming, with a 10,044x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/relax-gaming/wild_chapo_2': {
        title: 'Play Wild Chapo 2 by Relax Gaming at {brand} | 20,000x Max Win',
        description: 'Play Wild Chapo 2 by Relax Gaming at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/relax-gaming/wild_hike': {
        title: 'Wild Hike Cluster Slot by Relax Gaming | {brand}',
        description: 'Wild Hike from Relax Gaming, with a 20,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/relax-gaming/wild_yield': {
        title: 'Wild Yield Cluster Slot by Relax Gaming | {brand}',
        description: 'Wild Yield by Relax Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/relax-gaming/wildchemy': {
        title: 'Wildchemy Slot by Relax Gaming at {brand} | Instant Crypto Payouts',
        description: 'Wildchemy by Relax Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/relax-gaming/winter_champions': {
        title: 'Winter Champions Slot by Relax Gaming at {brand} | Instant Crypto Payouts',
        description: 'Winter Champions by Relax Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/relax-gaming/world_class_kick_off': {
        title: 'World Class Kick Off by Relax Gaming at {brand} | Free Demo & Crypto Play',
        description: 'World Class Kick Off from Relax Gaming. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/relax-gaming/zombie_circus': {
        title: 'Zombie Circus Slot by Relax Gaming at {brand} | Instant Crypto Payouts',
        description: 'Zombie Circus by Relax Gaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/shadylady/black_friday': {
        title: 'Black Friday Bonus Slot by ShadyLady | {brand}',
        description: 'Black Friday by ShadyLady at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/shadylady/brainwashed': {
        title: 'Play Brainwashed by ShadyLady at {brand} | 20,000x Max Win',
        description: 'Play Brainwashed by ShadyLady at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/shadylady/devils_finger': {
        title: 'Devils Finger Slot by ShadyLady at {brand} | Instant Crypto Payouts',
        description: 'Devils Finger from ShadyLady, with a 20,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/shadylady/laced': {
        title: 'Laced Bonus Slot by ShadyLady | {brand}',
        description: 'Laced from ShadyLady, with a 20,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/shadylady/mortal_bromance': {
        title: 'Mortal Bromance by ShadyLady at {brand} | Free Demo & Crypto Play',
        description: 'Mortal Bromance from ShadyLady. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/shadylady/office_party': {
        title: 'Office Party Bonus Slot by ShadyLady | {brand}',
        description: 'Office Party by ShadyLady at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/shadylady/oops': {
        title: 'Oops Slot by ShadyLady at {brand} | Instant Crypto Payouts',
        description: 'Oops by ShadyLady at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/shadylady/orphan_organ': {
        title: 'Play Orphan Organ by ShadyLady at {brand} | 20,000x Max Win',
        description: 'Spin Orphan Organ by ShadyLady at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/shadylady/preach_tv': {
        title: 'Play Preach TV by ShadyLady at {brand} | 20,000x Max Win',
        description: 'Spin Preach TV by ShadyLady at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/shadylady/sew': {
        title: 'Sew Bonus Slot by ShadyLady | {brand}',
        description: 'Sew from ShadyLady, with a 20,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/shadylady/sheeple': {
        title: 'Play Sheeple by ShadyLady at {brand} | 20,000x Max Win',
        description: 'Play Sheeple by ShadyLady at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/shadylady/suck': {
        title: 'Play Suck by ShadyLady at {brand} | 20,000x Max Win',
        description: 'Spin Suck by ShadyLady at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/shadylady/swoll': {
        title: 'Swoll: Play Online with Crypto | {brand}',
        description: 'Swoll by ShadyLady at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/shadylady/trap_tower': {
        title: 'Trap Tower Slot by ShadyLady at {brand} | Instant Crypto Payouts',
        description: 'Trap Tower by ShadyLady at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/shadylady/truth': {
        title: 'Truth: Play Online with Crypto | {brand}',
        description: 'Truth by ShadyLady at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/yggdrasil-gaming/3021_ad_the_bounty_hunter_gigablox': {
        title: 'Play 3021 AD The Bounty Hunter Gigablox by Yggdrasil at {brand} | 9,052x Max Win',
        description: 'Play 3021 AD The Bounty Hunter Gigablox by Yggdrasil at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/yggdrasil-gaming/3_gladiators_vs_caesar': {
        title: '3 Gladiators Vs Caesar: Play Online with Crypto | {brand}',
        description: '3 Gladiators Vs Caesar by Yggdrasil at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/yggdrasil-gaming/4_foxx_crew_wild_energy_multimax': {
        title: '4 Foxx Crew Wild Energy Multimax Slot by Yggdrasil at {brand} | Instant Crypto Payouts',
        description: '4 Foxx Crew Wild Energy Multimax by Yggdrasil at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/yggdrasil-gaming/777_volt_gigablox': {
        title: 'Play 777 Volt GigaBlox by Yggdrasil at {brand} | 5,000x Max Win',
        description: 'Spin 777 Volt GigaBlox by Yggdrasil at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/yggdrasil-gaming/age_of_asgard': {
        title: 'Age of Asgard Slot by Yggdrasil at {brand} | Instant Crypto Payouts',
        description: 'Age of Asgard by Yggdrasil at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/yggdrasil-gaming/alchymedes': {
        title: 'Alchymedes by Yggdrasil at {brand} | Free Demo & Crypto Play',
        description: 'Play Alchymedes by Yggdrasil at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/yggdrasil-gaming/aldos_journey': {
        title: "Aldo's Journey Slot by Yggdrasil at {brand} | Instant Crypto Payouts",
        description: "Aldo's Journey by Yggdrasil at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/yggdrasil-gaming/aphrodite_goes_wild_rushingwilds': {
        title: 'Aphrodite Goes Wild RushingWilds: Play Online with Crypto | {brand}',
        description: 'Aphrodite Goes Wild RushingWilds from Yggdrasil, with a 82,982x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/arthurs_fortune': {
        title: "Arthur's Fortune by Yggdrasil at {brand} | Free Demo & Crypto Play",
        description: "Play Arthur's Fortune by Yggdrasil at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/yggdrasil-gaming/atlantean_gigarise': {
        title: 'Atlantean Gigarise Slot by Yggdrasil at {brand} | Instant Crypto Payouts',
        description: 'Atlantean Gigarise by Yggdrasil at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/yggdrasil-gaming/avatars_gateway_guardians': {
        title: 'Avatars: Play Online with Crypto | {brand}',
        description: 'Avatars by Yggdrasil at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/yggdrasil-gaming/badger_miners': {
        title: 'Badger Miners by Yggdrasil at {brand} | Free Demo & Crypto Play',
        description: 'Badger Miners from Yggdrasil. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/baron_samedi': {
        title: 'Baron Samedi: Play Online with Crypto | {brand}',
        description: 'Baron Samedi by Yggdrasil at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/yggdrasil-gaming/beasty_blox_gigablox': {
        title: 'Beasty Blox GigaBlox: Play Online with Crypto | {brand}',
        description: 'Beasty Blox GigaBlox from Yggdrasil, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/beauty_and_the_beast': {
        title: 'Beauty and the Beast: Play Online with Crypto | {brand}',
        description: 'Beauty and the Beast from Yggdrasil, with a 400x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/bicicleta': {
        title: 'Bicicleta: Play Online with Crypto | {brand}',
        description: 'Bicicleta from Yggdrasil, with a 1,900x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/big_blox': {
        title: 'Big Blox Gigablox Slot by Yggdrasil | {brand}',
        description: 'Big Blox from Yggdrasil, with a 3,888x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/blood_moon_wilds': {
        title: 'Blood Moon Wilds Slot by Yggdrasil at {brand} | Instant Crypto Payouts',
        description: 'Blood Moon Wilds by Yggdrasil at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/yggdrasil-gaming/bloody_pesos': {
        title: 'Bloody Pesos: Play Online with Crypto | {brand}',
        description: 'Bloody Pesos from Yggdrasil, with a 90,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/bob_marlin_goes_deep': {
        title: 'Bob Marlin Goes Deep by Yggdrasil at {brand} | Free Demo & Crypto Play',
        description: 'Spin Bob Marlin Goes Deep by Yggdrasil at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/yggdrasil-gaming/boilin_pots': {
        title: "Boilin' Pots: Play Online with Crypto | {brand}",
        description: "Boilin' Pots from Yggdrasil, with a 10,114x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/yggdrasil-gaming/brazil_bomba_mobile': {
        title: 'Brazil Bomba Mobile by Yggdrasil at {brand} | Free Demo & Crypto Play',
        description: 'Spin Brazil Bomba Mobile by Yggdrasil at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/yggdrasil-gaming/buffalo_freedom_doublemax': {
        title: 'Buffalo Freedom Doublemax: Play Online with Crypto | {brand}',
        description: 'Buffalo Freedom Doublemax from Yggdrasil, with a 25,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/calavera_crush': {
        title: 'Play Calavera Crush by Yggdrasil at {brand} | 5,000x Max Win',
        description: 'Play Calavera Crush by Yggdrasil at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/yggdrasil-gaming/candyfinity': {
        title: 'Candyfinity by Yggdrasil at {brand} | Free Demo & Crypto Play',
        description: 'Candyfinity from Yggdrasil. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/cannonade': {
        title: 'Cannonade! by Yggdrasil at {brand} | Free Demo & Crypto Play',
        description: 'Spin Cannonade! by Yggdrasil at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/yggdrasil-gaming/carol_of_the_elves': {
        title: 'Play Carol of the Elves by Yggdrasil at {brand} | 5,800x Max Win',
        description: 'Play Carol of the Elves by Yggdrasil at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/yggdrasil-gaming/casino_zeppelin_reloaded': {
        title: 'Casino Zeppelin Reloaded: Play Online with Crypto | {brand}',
        description: 'Casino Zeppelin Reloaded from Yggdrasil, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/cazino_cosmos': {
        title: 'Cazino Cosmos by Yggdrasil at {brand} | Free Demo & Crypto Play',
        description: 'Play Cazino Cosmos by Yggdrasil at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/yggdrasil-gaming/cazino_zeppelin': {
        title: 'Cazino Zeppelin Gigablox Slot by Yggdrasil | {brand}',
        description: 'Cazino Zeppelin from Yggdrasil, with a 6,700x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/champion_of_the_underworld': {
        title: 'Champion of the Underworld: Play Online with Crypto | {brand}',
        description: 'Champion of the Underworld from Yggdrasil, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/champions_of_rome': {
        title: 'Champions of Rome Slot by Yggdrasil at {brand} | Instant Crypto Payouts',
        description: 'Champions of Rome from Yggdrasil, with a 2,683x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/chibeasties': {
        title: 'Chibeasties Gigablox Slot by Yggdrasil | {brand}',
        description: 'Chibeasties from Yggdrasil, with a 2,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/christmas_plaza_doublemax': {
        title: 'Play Christmas Plaza Doublemax by Yggdrasil at {brand} | 19,978x Max Win',
        description: 'Play Christmas Plaza Doublemax by Yggdrasil at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/yggdrasil-gaming/coocoo_cashoo': {
        title: 'CooCoo Cashoo: Play Online with Crypto | {brand}',
        description: 'CooCoo Cashoo by Yggdrasil at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/yggdrasil-gaming/dark_vortex': {
        title: 'Play Dark Vortex by Yggdrasil at {brand} | 2,683x Max Win',
        description: 'Play Dark Vortex by Yggdrasil at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/yggdrasil-gaming/defenders_of_mystica': {
        title: 'Defenders of Mystica Gigablox Slot by Yggdrasil | {brand}',
        description: 'Play Defenders of Mystica by Yggdrasil at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/yggdrasil-gaming/devour_the_weak': {
        title: 'Devour the Weak Slot by Yggdrasil at {brand} | Instant Crypto Payouts',
        description: 'Devour the Weak by Yggdrasil at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/yggdrasil-gaming/dick_the_farmer': {
        title: 'Play Dick the Farmer by Yggdrasil at {brand} | 20,000x Max Win',
        description: 'Play Dick the Farmer by Yggdrasil at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/yggdrasil-gaming/double_dragons': {
        title: 'Double Dragons Gigablox Slot by Yggdrasil | {brand}',
        description: 'Double Dragons from Yggdrasil, with a 800x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/dr_fortuno': {
        title: 'Dr Fortuno Slot by Yggdrasil at {brand} | Instant Crypto Payouts',
        description: 'Dr Fortuno from Yggdrasil, with a 4,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/dwarf_mine': {
        title: 'Dwarf Mine: Play Online with Crypto | {brand}',
        description: 'Dwarf Mine by Yggdrasil at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/yggdrasil-gaming/easter_island': {
        title: 'Easter Island Gigablox Slot by Yggdrasil | {brand}',
        description: 'Easter Island by Yggdrasil at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/yggdrasil-gaming/easter_island_2': {
        title: 'Play Easter Island 2 by Yggdrasil at {brand} | 2,500x Max Win',
        description: 'Spin Easter Island 2 by Yggdrasil at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/yggdrasil-gaming/eforce': {
        title: 'E-Force Slot by Yggdrasil at {brand} | Instant Crypto Payouts',
        description: 'E-Force from Yggdrasil, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/elysian_jackpots': {
        title: 'Elysian Jackpots by Yggdrasil at {brand} | Free Demo & Crypto Play',
        description: 'Spin Elysian Jackpots by Yggdrasil at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/yggdrasil-gaming/fatzs_diner': {
        title: "Play Fatz's Diner by Yggdrasil at {brand} | 9,052x Max Win",
        description: "Spin Fatz's Diner by Yggdrasil at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/yggdrasil-gaming/firekick_multimax': {
        title: 'Firekick! Multimax: Play Online with Crypto | {brand}',
        description: 'Firekick! Multimax by Yggdrasil at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/yggdrasil-gaming/florageddon': {
        title: 'Play Florageddon by Yggdrasil at {brand} | 20,000x Max Win',
        description: 'Spin Florageddon by Yggdrasil at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/yggdrasil-gaming/football_glory': {
        title: 'Play Football Glory by Yggdrasil at {brand} | 4,000x Max Win',
        description: 'Spin Football Glory by Yggdrasil at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/yggdrasil-gaming/frost_queen_jackpots': {
        title: 'Frost Queen Jackpots by Yggdrasil at {brand} | Free Demo & Crypto Play',
        description: 'Play Frost Queen Jackpots by Yggdrasil at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/yggdrasil-gaming/fruitoids': {
        title: 'Play Fruitoids by Yggdrasil at {brand} | 2,500x Max Win',
        description: 'Spin Fruitoids by Yggdrasil at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/yggdrasil-gaming/gator_gold_deluxe_gigablox': {
        title: 'Gator Gold Deluxe Gigablox Gigablox Slot by Yggdrasil | {brand}',
        description: 'Gator Gold Deluxe Gigablox from Yggdrasil, with a 20,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/gator_gold_gigablox': {
        title: 'Gator Gold Gigablox Gigablox Slot by Yggdrasil | {brand}',
        description: 'Gator Gold Gigablox from Yggdrasil, with a 20,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/gem_rocks': {
        title: 'Gem Rocks Slot by Yggdrasil at {brand} | Instant Crypto Payouts',
        description: 'Gem Rocks by Yggdrasil at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/yggdrasil-gaming/gemstone_jam': {
        title: 'Play Gemstone Jam by Yggdrasil at {brand} | 10,000x Max Win',
        description: 'Play Gemstone Jam by Yggdrasil at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/yggdrasil-gaming/giga_zombies_giga_blox': {
        title: 'Giga Zombies Giga Blox by Yggdrasil at {brand} | Free Demo & Crypto Play',
        description: 'Play Giga Zombies Giga Blox by Yggdrasil at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/yggdrasil-gaming/giganimals_gigablox': {
        title: 'Giganimals Gigablox Gigablox Slot by Yggdrasil | {brand}',
        description: 'Giganimals Gigablox from Yggdrasil, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/gold_frontier_jackpots_fastpot5': {
        title: 'Play Gold frontier Jackpots FastPot5 by Yggdrasil at {brand} | 1,265x Max Win',
        description: 'Play Gold frontier Jackpots FastPot5 by Yggdrasil at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/yggdrasil-gaming/golden_fish_tank_2_gigablox': {
        title: 'Golden Fish Tank 2 Gigablox: Play Online with Crypto | {brand}',
        description: 'Golden Fish Tank 2 Gigablox from Yggdrasil, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/golden_fish_tank_party': {
        title: 'Golden Fish Tank Party Gigablox Slot by Yggdrasil | {brand}',
        description: 'Golden Fish Tank Party from Yggdrasil, with a 6,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/golden_fishtank': {
        title: 'Golden Fishtank Slot by Yggdrasil at {brand} | Instant Crypto Payouts',
        description: 'Golden Fishtank from Yggdrasil, with a 2,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/golden_gorgon': {
        title: 'Golden Gorgon: Play Online with Crypto | {brand}',
        description: 'Golden Gorgon by Yggdrasil at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/yggdrasil-gaming/hades': {
        title: 'Play Hades by Yggdrasil at {brand} | 11,129x Max Win',
        description: 'Spin Hades by Yggdrasil at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/yggdrasil-gaming/holmes_and_the_stolen_stones': {
        title: 'Play Holmes and the Stolen Stones by Yggdrasil at {brand} | 600x Max Win',
        description: 'Spin Holmes and the Stolen Stones by Yggdrasil at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/yggdrasil-gaming/hyperburst': {
        title: 'Hyperburst Slot by Yggdrasil at {brand} | Instant Crypto Payouts',
        description: 'Hyperburst by Yggdrasil at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/yggdrasil-gaming/incinerator': {
        title: 'Incinerator Gigablox Slot by Yggdrasil | {brand}',
        description: 'Incinerator by Yggdrasil at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/yggdrasil-gaming/jackpot_express': {
        title: 'Play Jackpot Express by Yggdrasil at {brand} | 2,175x Max Win',
        description: 'Play Jackpot Express by Yggdrasil at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/yggdrasil-gaming/jackpot_raiders': {
        title: 'Play Jackpot Raiders by Yggdrasil at {brand} | 4,110x Max Win',
        description: 'Play Jackpot Raiders by Yggdrasil at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/yggdrasil-gaming/jellycious_doublemax': {
        title: 'Play Jellycious DoubleMax by Yggdrasil at {brand} | 25,000x Max Win',
        description: 'Play Jellycious DoubleMax by Yggdrasil at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/yggdrasil-gaming/jungle_books': {
        title: 'Jungle Books: Play Online with Crypto | {brand}',
        description: 'Jungle Books by Yggdrasil at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/yggdrasil-gaming/legend_of_the_golden_monkey': {
        title: 'Play Legend of the Golden Monkey by Yggdrasil at {brand} | 1,000x Max Win',
        description: 'Spin Legend of the Golden Monkey by Yggdrasil at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/yggdrasil-gaming/lightning_joker': {
        title: 'Lightning Joker Gigablox Slot by Yggdrasil | {brand}',
        description: 'Lightning Joker by Yggdrasil at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/yggdrasil-gaming/lucha_maniacs': {
        title: 'Lucha Maniacs: Play Online with Crypto | {brand}',
        description: 'Lucha Maniacs by Yggdrasil at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/yggdrasil-gaming/lucky_apocalypse_gigablox': {
        title: 'Lucky Apocalypse Gigablox Gigablox Slot by Yggdrasil | {brand}',
        description: 'Lucky Apocalypse Gigablox from Yggdrasil, with a 6,260x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/lucky_neko': {
        title: 'Lucky Neko Slot by Yggdrasil at {brand} | Instant Crypto Payouts',
        description: 'Lucky Neko from Yggdrasil, with a 6,953x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/lucky_ryan_gigablox': {
        title: 'Lucky Ryan Gigablox by Yggdrasil at {brand} | Free Demo & Crypto Play',
        description: 'Play Lucky Ryan Gigablox by Yggdrasil at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/yggdrasil-gaming/max_elements_gigablox': {
        title: 'Max Elements Gigablox Gigablox Slot by Yggdrasil | {brand}',
        description: 'Max Elements Gigablox from Yggdrasil, with a 25,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/mexomax_multimax': {
        title: 'MexoMax! Multimax by Yggdrasil at {brand} | Free Demo & Crypto Play',
        description: 'Play MexoMax! Multimax by Yggdrasil at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/yggdrasil-gaming/monkeys_go_bananas': {
        title: 'Monkeys Go Bananas: Play Online with Crypto | {brand}',
        description: 'Monkeys Go Bananas from Yggdrasil, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/multifly': {
        title: 'Multifly!: Play Online with Crypto | {brand}',
        description: 'Multifly! from Yggdrasil, with a 10,513x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/multifly_2_multimax': {
        title: 'Play Multifly! 2 Multimax by Yggdrasil at {brand} | 10,311x Max Win',
        description: 'Spin Multifly! 2 Multimax by Yggdrasil at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/yggdrasil-gaming/neon_rush_splitz': {
        title: 'Neon Rush - Splitz: Play Online with Crypto | {brand}',
        description: 'Neon Rush - Splitz from Yggdrasil, with a 25,676x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/neon_villains_doublemax': {
        title: 'Neon Villains Doublemax by Yggdrasil at {brand} | Free Demo & Crypto Play',
        description: 'Spin Neon Villains Doublemax by Yggdrasil at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/yggdrasil-gaming/nice_catch_2': {
        title: 'Nice Catch 2 Slot by Yggdrasil at {brand} | Instant Crypto Payouts',
        description: 'Nice Catch 2 by Yggdrasil at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/yggdrasil-gaming/nice_catch_doublemax': {
        title: 'Nice Catch DoubleMax Gigablox Slot by Yggdrasil | {brand}',
        description: 'Play Nice Catch DoubleMax by Yggdrasil at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/yggdrasil-gaming/nirvana': {
        title: 'Play Nirvana by Yggdrasil at {brand} | 800x Max Win',
        description: 'Spin Nirvana by Yggdrasil at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/yggdrasil-gaming/notredame_tales_gigablox': {
        title: 'Notre-Dame Tales GigaBlox™ Gigablox Slot by Yggdrasil | {brand}',
        description: 'Play Notre-Dame Tales GigaBlox™ by Yggdrasil at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/yggdrasil-gaming/of_sabers_and_monsters_wildfight': {
        title: 'Play Of Sabers and Monsters WildFight by Yggdrasil at {brand} | 14,755x Max Win',
        description: 'Play Of Sabers and Monsters WildFight by Yggdrasil at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/yggdrasil-gaming/orient_express': {
        title: 'Orient Express: Play Online with Crypto | {brand}',
        description: 'Orient Express from Yggdrasil, with a 1,150x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/ozwins_jackpots': {
        title: 'Ozwins Jackpots Gigablox Slot by Yggdrasil | {brand}',
        description: 'Ozwins Jackpots by Yggdrasil at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/yggdrasil-gaming/penguin_city': {
        title: 'Penguin City Slot by Yggdrasil at {brand} | Instant Crypto Payouts',
        description: 'Penguin City from Yggdrasil, with a 1,647x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/pirates_2_mutiny': {
        title: 'Pirates 2 Slot by Yggdrasil at {brand} | Instant Crypto Payouts',
        description: 'Pirates 2 from Yggdrasil, with a 4,900x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/pirates_smugglers_paradise': {
        title: 'Pirates Gigablox Slot by Yggdrasil | {brand}',
        description: 'Pirates from Yggdrasil, with a 1,243x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/pumpkin_smash': {
        title: 'Play Pumpkin Smash by Yggdrasil at {brand} | 1,800x Max Win',
        description: 'Spin Pumpkin Smash by Yggdrasil at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/yggdrasil-gaming/pushy_cats': {
        title: 'Play Pushy Cats by Yggdrasil at {brand} | 20,000x Max Win',
        description: 'Play Pushy Cats by Yggdrasil at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/yggdrasil-gaming/ragnaravens_wildenergy': {
        title: 'Ragnaravens WildEnergy: Play Online with Crypto | {brand}',
        description: 'Spin Ragnaravens WildEnergy by Yggdrasil at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/yggdrasil-gaming/ragnawolves_wildenergy': {
        title: 'Ragnawolves WildEnergy by Yggdrasil at {brand} | Free Demo & Crypto Play',
        description: 'Ragnawolves WildEnergy from Yggdrasil. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/rainbow_ryan': {
        title: 'Play Rainbow Ryan by Yggdrasil at {brand} | 5,100x Max Win',
        description: 'Play Rainbow Ryan by Yggdrasil at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/yggdrasil-gaming/rainbow_ryan_2': {
        title: 'Rainbow Ryan 2: Play Online with Crypto | {brand}',
        description: 'Rainbow Ryan 2 by Yggdrasil at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/yggdrasil-gaming/raptor_2': {
        title: 'Play Raptor 2 by Yggdrasil at {brand} | 9,493x Max Win',
        description: 'Play Raptor 2 by Yggdrasil at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/yggdrasil-gaming/raptor_doublemax': {
        title: 'Raptor Doublemax Slot by Yggdrasil at {brand} | Instant Crypto Payouts',
        description: 'Raptor Doublemax from Yggdrasil, with a 20,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/reel_desire': {
        title: 'Reel Desire by Yggdrasil at {brand} | Free Demo & Crypto Play',
        description: 'Play Reel Desire by Yggdrasil at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/yggdrasil-gaming/rock_star_santa_multimax': {
        title: 'Rock Star Santa MultiMax Gigablox Slot by Yggdrasil | {brand}',
        description: 'Rock Star Santa MultiMax by Yggdrasil at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/yggdrasil-gaming/sahara_nights': {
        title: 'Sahara Nights Slot by Yggdrasil at {brand} | Instant Crypto Payouts',
        description: 'Sahara Nights from Yggdrasil, with a 3,068x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/seasons': {
        title: 'Seasons Gigablox Slot by Yggdrasil | {brand}',
        description: 'Seasons from Yggdrasil, with a 1,400x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/spina_colada': {
        title: 'Spina Colada: Play Online with Crypto | {brand}',
        description: 'Spina Colada from Yggdrasil, with a 3,200x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/starfire_fortunes_tophit': {
        title: 'Starfire Fortunes TopHit Gigablox Slot by Yggdrasil | {brand}',
        description: 'Starfire Fortunes TopHit by Yggdrasil at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/yggdrasil-gaming/suncatcher_gigablox': {
        title: 'Suncatcher Gigablox Slot by Yggdrasil at {brand} | Instant Crypto Payouts',
        description: 'Suncatcher Gigablox by Yggdrasil at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/yggdrasil-gaming/sunny_shores': {
        title: 'Sunny Shores Gigablox Slot by Yggdrasil | {brand}',
        description: 'Sunny Shores from Yggdrasil, with a 324x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/syncronite': {
        title: 'Syncronite: Play Online with Crypto | {brand}',
        description: 'Syncronite by Yggdrasil at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/yggdrasil-gaming/temple_stacks_splitz': {
        title: 'Temple Stacks Gigablox Slot by Yggdrasil | {brand}',
        description: 'Temple Stacks from Yggdrasil, with a 25,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/the_one_armed_bandit': {
        title: 'Play The One Armed Bandit by Yggdrasil at {brand} | 11,863x Max Win',
        description: 'Spin The One Armed Bandit by Yggdrasil at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/yggdrasil-gaming/the_royal_family': {
        title: 'The Royal Family: Play Online with Crypto | {brand}',
        description: 'The Royal Family from Yggdrasil, with a 3,500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/thunder_of_thor': {
        title: 'Thunder Of Thor: Play Online with Crypto | {brand}',
        description: 'Thunder Of Thor from Yggdrasil, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/time_travel_tigers': {
        title: 'Time Travel Tigers by Yggdrasil at {brand} | Free Demo & Crypto Play',
        description: 'Spin Time Travel Tigers by Yggdrasil at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/yggdrasil-gaming/trickstar_spins': {
        title: 'Play Trickstar Spins by Yggdrasil at {brand} | 800x Max Win',
        description: 'Play Trickstar Spins by Yggdrasil at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/yggdrasil-gaming/trolls_bridge': {
        title: 'Trolls Bridge: Play Online with Crypto | {brand}',
        description: 'Trolls Bridge by Yggdrasil at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/yggdrasil-gaming/tutstwister': {
        title: 'TutsTwister Gigablox Slot by Yggdrasil | {brand}',
        description: 'TutsTwister from Yggdrasil, with a 966x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/valley_of_the_dead_only_wins_boltlock': {
        title: 'Valley of the Dead Only Wins BoltLock Slot by Yggdrasil at {brand} | Instant Crypto Payouts',
        description: 'Valley of the Dead Only Wins BoltLock by Yggdrasil at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/yggdrasil-gaming/valley_of_the_gods': {
        title: 'Valley of the Gods by Yggdrasil at {brand} | Free Demo & Crypto Play',
        description: 'Play Valley of the Gods by Yggdrasil at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/yggdrasil-gaming/valley_of_the_gods_2': {
        title: 'Valley of the Gods 2: Play Online with Crypto | {brand}',
        description: 'Valley of the Gods 2 by Yggdrasil at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/yggdrasil-gaming/vampire_riches': {
        title: 'Play Vampire Riches by Yggdrasil at {brand} | 25,000x Max Win',
        description: 'Spin Vampire Riches by Yggdrasil at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/yggdrasil-gaming/vault_of_fortune': {
        title: 'Vault of Fortune Slot by Yggdrasil at {brand} | Instant Crypto Payouts',
        description: 'Vault of Fortune from Yggdrasil, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/vikings_go_berzerk': {
        title: 'Vikings go Berzerk: Play Online with Crypto | {brand}',
        description: 'Vikings go Berzerk from Yggdrasil, with a 4,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/vikings_go_berzerk_reloaded': {
        title: 'Vikings Go Berzerk by Yggdrasil at {brand} | Free Demo & Crypto Play',
        description: 'Spin Vikings Go Berzerk by Yggdrasil at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/yggdrasil-gaming/vikings_go_to_egypt_wild_fight': {
        title: 'Vikings Go To Egypt Wild Fight by Yggdrasil at {brand} | Free Demo & Crypto Play',
        description: 'Vikings Go To Egypt Wild Fight from Yggdrasil. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/vikings_go_to_hell': {
        title: 'Vikings Go To Hell: Play Online with Crypto | {brand}',
        description: 'Vikings Go To Hell by Yggdrasil at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/yggdrasil-gaming/vikings_go_to_valhalla': {
        title: 'Vikings go to Valhalla: Play Online with Crypto | {brand}',
        description: 'Vikings go to Valhalla from Yggdrasil, with a 23,634x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/vikings_go_to_vegas_wild_fight': {
        title: 'Play Vikings go to Vegas Wild Fight by Yggdrasil at {brand} | 4,375x Max Win',
        description: 'Spin Vikings go to Vegas Wild Fight by Yggdrasil at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/yggdrasil-gaming/vikings_go_wild': {
        title: 'Play Vikings go Wild by Yggdrasil at {brand} | 1,900x Max Win',
        description: 'Play Vikings go Wild by Yggdrasil at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/yggdrasil-gaming/wild_robo_factory': {
        title: 'Wild Robo Factory Slot by Yggdrasil at {brand} | Instant Crypto Payouts',
        description: 'Wild Robo Factory by Yggdrasil at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/yggdrasil-gaming/wild_stack_frenzy': {
        title: 'Wild Stack Frenzy Gigablox Slot by Yggdrasil | {brand}',
        description: 'Wild Stack Frenzy from Yggdrasil, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/wilhelm_tell': {
        title: 'Wilhelm Tell: Play Online with Crypto | {brand}',
        description: 'Wilhelm Tell by Yggdrasil at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/yggdrasil-gaming/winterberries': {
        title: 'Play Winterberries by Yggdrasil at {brand} | 2,500x Max Win',
        description: 'Play Winterberries by Yggdrasil at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/yggdrasil-gaming/winterberries_2': {
        title: 'Winterberries 2 Slot by Yggdrasil at {brand} | Instant Crypto Payouts',
        description: 'Winterberries 2 by Yggdrasil at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/yggdrasil-gaming/wolf_hunters': {
        title: 'Wolf Hunters Gigablox Slot by Yggdrasil | {brand}',
        description: 'Wolf Hunters from Yggdrasil, with a 2,324x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/yokozuna_clash': {
        title: 'Yokozuna Clash Gigablox Slot by Yggdrasil | {brand}',
        description: 'Yokozuna Clash from Yggdrasil, with a 3,449x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/yggdrasil-gaming/your_own_island': {
        title: 'Your Own Island: Play Online with Crypto | {brand}',
        description: 'Your Own Island by Yggdrasil at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/gamomat-games/100_flaring_fruits': {
        title: 'Play 100 Flaring Fruits by Gamomat at {brand} | 5,000x Max Win',
        description: 'Play 100 Flaring Fruits by Gamomat at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/gamomat-games/20_flaring_fruits': {
        title: '20 Flaring Fruits Fruit Slot by Gamomat | {brand}',
        description: '20 Flaring Fruits from Gamomat, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/gamomat-games/40_finest_xxl': {
        title: 'Play 40 Finest XXL by Gamomat at {brand} | 5,000x Max Win',
        description: 'Play 40 Finest XXL by Gamomat at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/gamomat-games/40_finest_xxl_flaming_link': {
        title: '40 Finest XXL Flaming Link by Gamomat at {brand} | Free Demo & Crypto Play',
        description: 'Play 40 Finest XXL Flaming Link by Gamomat at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/gamomat-games/50_flaring_fruit': {
        title: '50 Flaring Fruit: Play Online with Crypto | {brand}',
        description: '50 Flaring Fruit by Gamomat at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/gamomat-games/50_flaring_fruits': {
        title: 'Play 50 Flaring Fruits by Gamomat at {brand} | 5,000x Max Win',
        description: 'Play 50 Flaring Fruits by Gamomat at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/gamomat-games/5_ember_wilds': {
        title: '5 Ember Wilds by Gamomat at {brand} | Free Demo & Crypto Play',
        description: 'Play 5 Ember Wilds by Gamomat at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/gamomat-games/5_flaring_fruits': {
        title: 'Play 5 Flaring Fruits by Gamomat at {brand} | 5,000x Max Win',
        description: 'Play 5 Flaring Fruits by Gamomat at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/gamomat-games/alexandria_fire': {
        title: 'Alexandria Fire Slot by Gamomat at {brand} | Instant Crypto Payouts',
        description: 'Alexandria Fire from Gamomat, with a 3,550x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/gamomat-games/ancient_magic': {
        title: 'Ancient Magic Fruit Slot by Gamomat | {brand}',
        description: 'Ancient Magic by Gamomat at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/gamomat-games/ancient_riches': {
        title: 'Ancient Riches by Gamomat at {brand} | Free Demo & Crypto Play',
        description: 'Play Ancient Riches by Gamomat at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/gamomat-games/atlantic_wilds': {
        title: 'Atlantic Wilds Slot by Gamomat at {brand} | Instant Crypto Payouts',
        description: 'Atlantic Wilds from Gamomat, with a 1,300x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/gamomat-games/aura_of_jupiter': {
        title: 'Aura of Jupiter by Gamomat at {brand} | Free Demo & Crypto Play',
        description: 'Spin Aura of Jupiter by Gamomat at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/gamomat-games/back_to_the_fruits': {
        title: 'Play Back to the Fruits by Gamomat at {brand} | 1,600x Max Win',
        description: 'Play Back to the Fruits by Gamomat at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/gamomat-games/back_to_the_fruits_respins_of_amunre': {
        title: 'Back to the Fruits Respins of Amun-Re Fruit Slot by Gamomat | {brand}',
        description: 'Play Back to the Fruits Respins of Amun-Re by Gamomat at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/gamomat-games/beautiful_nature': {
        title: 'Play Beautiful Nature by Gamomat at {brand} | 1,400x Max Win',
        description: 'Play Beautiful Nature by Gamomat at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/gamomat-games/beer_party': {
        title: 'Play Beer Party by Gamomat at {brand} | 1,000x Max Win',
        description: 'Spin Beer Party by Gamomat at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/gamomat-games/black_beauty': {
        title: 'Black Beauty: Play Online with Crypto | {brand}',
        description: 'Black Beauty by Gamomat at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/gamomat-games/book_of_ages': {
        title: 'Book of Ages: Play Online with Crypto | {brand}',
        description: 'Book of Ages from Gamomat, with a 6,100x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/gamomat-games/book_of_crazy_chicken': {
        title: 'Book of Crazy Chicken: Play Online with Crypto | {brand}',
        description: 'Spin Book of Crazy Chicken by Gamomat at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/gamomat-games/book_of_elements': {
        title: 'Play Book of Elements by Gamomat at {brand} | 7,800x Max Win',
        description: 'Play Book of Elements by Gamomat at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/gamomat-games/book_of_juno': {
        title: 'Book of Juno Fruit Slot by Gamomat | {brand}',
        description: 'Book of Juno from Gamomat, with a 6,100x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/gamomat-games/book_of_madness': {
        title: 'Book of Madness by Gamomat at {brand} | Free Demo & Crypto Play',
        description: 'Spin Book of Madness by Gamomat at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/gamomat-games/book_of_madness_2': {
        title: 'Book of Madness 2 Slot by Gamomat at {brand} | Instant Crypto Payouts',
        description: 'Book of Madness 2 from Gamomat, with a 11,800x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/gamomat-games/book_of_madness_deluxe': {
        title: 'Play Book Of Madness Deluxe by Gamomat at {brand} | 10,800x Max Win',
        description: 'Play Book Of Madness Deluxe by Gamomat at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/gamomat-games/book_of_madness_flaming_link': {
        title: 'Play Book of Madness Flaming Link by Gamomat at {brand} | 12,176x Max Win',
        description: 'Spin Book of Madness Flaming Link by Gamomat at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/gamomat-games/book_of_madness_respins_of_amunre': {
        title: 'Book of Madness Respins of Amun-Re: Play Online with Crypto | {brand}',
        description: 'Spin Book of Madness Respins of Amun-Re by Gamomat at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/gamomat-games/book_of_oasis': {
        title: 'Play Book of Oasis by Gamomat at {brand} | 6,360x Max Win',
        description: 'Spin Book of Oasis by Gamomat at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/gamomat-games/book_of_romeo_and_julia': {
        title: 'Book of Romeo and Julia Fruit Slot by Gamomat | {brand}',
        description: 'Book of Romeo and Julia by Gamomat at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/gamomat-games/books_and_bounties': {
        title: 'Books & Bounties: Play Online with Crypto | {brand}',
        description: 'Books & Bounties from Gamomat, with a 2,250x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/gamomat-games/books_and_bulls': {
        title: 'Play Books and Bulls by Gamomat at {brand} | 4,800x Max Win',
        description: 'Play Books and Bulls by Gamomat at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/gamomat-games/books_and_pearls': {
        title: 'Books and Pearls: Play Online with Crypto | {brand}',
        description: 'Books and Pearls from Gamomat, with a 6,300x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/gamomat-games/books_and_pearls_respins_of_amunre': {
        title: 'Books and Pearls Respins of Amun-Re Fruit Slot by Gamomat | {brand}',
        description: 'Books and Pearls Respins of Amun-Re from Gamomat, with a 9,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/gamomat-games/books_and_temples': {
        title: 'Play Books and Temples by Gamomat at {brand} | 2,400x Max Win',
        description: 'Spin Books and Temples by Gamomat at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/gamomat-games/crystal_ball': {
        title: 'Crystal Ball Slot by Gamomat at {brand} | Instant Crypto Payouts',
        description: 'Crystal Ball by Gamomat at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/gamomat-games/crystal_ball_deluxe': {
        title: 'Crystal Ball Deluxe Slot by Gamomat at {brand} | Instant Crypto Payouts',
        description: 'Crystal Ball Deluxe by Gamomat at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/gamomat-games/crystal_ball_flaming_link': {
        title: 'Crystal Ball Flaming Link Fruit Slot by Gamomat | {brand}',
        description: 'Crystal Ball Flaming Link from Gamomat, with a 5,400x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/gamomat-games/crystal_ball_multi_symbols': {
        title: 'Crystal Ball Multi Symbols Fruit Slot by Gamomat | {brand}',
        description: 'Crystal Ball Multi Symbols from Gamomat, with a 10,100x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/gamomat-games/crystal_burst_xxl': {
        title: 'Crystal Burst XXL Fruit Slot by Gamomat | {brand}',
        description: 'Crystal Burst XXL from Gamomat, with a 4,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/gamomat-games/crystal_strike': {
        title: 'Crystal Strike by Gamomat at {brand} | Free Demo & Crypto Play',
        description: 'Spin Crystal Strike by Gamomat at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/gamomat-games/cutie_cat': {
        title: 'Play Cutie Cat by Gamomat at {brand} | 1,100x Max Win',
        description: 'Spin Cutie Cat by Gamomat at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/gamomat-games/dead_legion': {
        title: 'Dead Legion by Gamomat at {brand} | Free Demo & Crypto Play',
        description: 'Spin Dead Legion by Gamomat at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/gamomat-games/disc_of_athena': {
        title: 'Play Disc of Athena by Gamomat at {brand} | 12,000x Max Win',
        description: 'Play Disc of Athena by Gamomat at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/gamomat-games/divine_fire': {
        title: 'Divine Fire: Play Online with Crypto | {brand}',
        description: 'Divine Fire by Gamomat at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/gamomat-games/dragon_of_the_princess': {
        title: 'Play Dragon of the Princess by Gamomat at {brand} | 2,200x Max Win',
        description: 'Spin Dragon of the Princess by Gamomat at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/gamomat-games/duck_shooter': {
        title: 'Duck Shooter Fruit Slot by Gamomat | {brand}',
        description: 'Duck Shooter from Gamomat, with a 550x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/gamomat-games/expanding_fireworks': {
        title: 'Play Expanding Fireworks by Gamomat at {brand} | 1,200x Max Win',
        description: 'Spin Expanding Fireworks by Gamomat at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/gamomat-games/explodiac': {
        title: 'Play Explodiac by Gamomat at {brand} | 1,000x Max Win',
        description: 'Play Explodiac by Gamomat at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/gamomat-games/fancy_fruits': {
        title: 'Fancy Fruits by Gamomat at {brand} | Free Demo & Crypto Play',
        description: 'Play Fancy Fruits by Gamomat at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/gamomat-games/fancy_fruits_deluxe': {
        title: 'Fancy Fruits Deluxe by Gamomat at {brand} | Free Demo & Crypto Play',
        description: 'Spin Fancy Fruits Deluxe by Gamomat at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/gamomat-games/fancy_fruits_flaming_link': {
        title: 'Fancy Fruits Flaming Link by Gamomat at {brand} | Free Demo & Crypto Play',
        description: 'Play Fancy Fruits Flaming Link by Gamomat at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/gamomat-games/fancy_fruits_respins_of_amunre': {
        title: 'Play Fancy Fruits Respins of Amun-Re by Gamomat at {brand} | 9,000x Max Win',
        description: 'Play Fancy Fruits Respins of Amun-Re by Gamomat at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/gamomat-games/fengs_fortune': {
        title: "Feng's Fortune: Play Online with Crypto | {brand}",
        description: "Spin Feng's Fortune by Gamomat at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/gamomat-games/football_super_spins': {
        title: 'Play Football Super Spins by Gamomat at {brand} | 550x Max Win',
        description: 'Spin Football Super Spins by Gamomat at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/gamomat-games/fort_brave': {
        title: 'Fort Brave Slot by Gamomat at {brand} | Instant Crypto Payouts',
        description: 'Fort Brave by Gamomat at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/gamomat-games/frooty_troupe_game_on_94': {
        title: 'Frooty Troupe Game On 94: Play Online with Crypto | {brand}',
        description: 'Frooty Troupe Game On 94 from Gamomat, with a 230x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/gamomat-games/frooty_troupe_gold_club': {
        title: 'Frooty Troupe Gold Club by Gamomat at {brand} | Free Demo & Crypto Play',
        description: 'Spin Frooty Troupe Gold Club by Gamomat at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/gamomat-games/frooty_troupe_sun_splash': {
        title: 'Frooty Troupe Sun Splash Fruit Slot by Gamomat | {brand}',
        description: 'Frooty Troupe Sun Splash from Gamomat, with a 5,100x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/gamomat-games/fruit_love': {
        title: 'Play Fruit Love by Gamomat at {brand} | 4,020x Max Win',
        description: 'Play Fruit Love by Gamomat at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/gamomat-games/fruit_mania': {
        title: 'Fruit Mania by Gamomat at {brand} | Free Demo & Crypto Play',
        description: 'Play Fruit Mania by Gamomat at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/gamomat-games/fruit_mania_deluxe': {
        title: 'Fruit Mania Deluxe by Gamomat at {brand} | Free Demo & Crypto Play',
        description: 'Spin Fruit Mania Deluxe by Gamomat at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/gamomat-games/fruit_mania_flaming_link': {
        title: 'Play Fruit Mania Flaming Link by Gamomat at {brand} | 2,700x Max Win',
        description: 'Play Fruit Mania Flaming Link by Gamomat at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/gamomat-games/fruit_rush': {
        title: 'Play Fruit Rush by Gamomat at {brand} | 1,810x Max Win',
        description: 'Spin Fruit Rush by Gamomat at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/gamomat-games/gates_of_persia': {
        title: 'Play Gates of Persia by Gamomat at {brand} | 600x Max Win',
        description: 'Play Gates of Persia by Gamomat at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/gamomat-games/glamorous_times': {
        title: 'Glamorous Times Slot by Gamomat at {brand} | Instant Crypto Payouts',
        description: 'Glamorous Times from Gamomat, with a 900x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/gamomat-games/golden_egg_of_crazy_chicken': {
        title: 'Golden Egg of Crazy Chicken Fruit Slot by Gamomat | {brand}',
        description: 'Play Golden Egg of Crazy Chicken by Gamomat at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/gamomat-games/golden_touch': {
        title: 'Golden Touch by Gamomat at {brand} | Free Demo & Crypto Play',
        description: 'Play Golden Touch by Gamomat at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/gamomat-games/great_grizzly': {
        title: 'Great Grizzly by Gamomat at {brand} | Free Demo & Crypto Play',
        description: 'Spin Great Grizzly by Gamomat at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/gamomat-games/great_warrior': {
        title: 'Great Warrior Slot by Gamomat at {brand} | Instant Crypto Payouts',
        description: 'Great Warrior from Gamomat, with a 8,200x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/gamomat-games/hellfire': {
        title: 'Hellfire by Gamomat at {brand} | Free Demo & Crypto Play',
        description: 'Spin Hellfire by Gamomat at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/gamomat-games/juicy_jester': {
        title: 'Juicy Jester Slot by Gamomat at {brand} | Instant Crypto Payouts',
        description: 'Juicy Jester by Gamomat at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/gamomat-games/king_and_queen': {
        title: 'King and Queen: Play Online with Crypto | {brand}',
        description: 'King and Queen from Gamomat, with a 900x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/gamomat-games/king_of_the_jungle': {
        title: 'King of the Jungle by Gamomat at {brand} | Free Demo & Crypto Play',
        description: 'Spin King of the Jungle by Gamomat at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/gamomat-games/la_dolce_vita': {
        title: 'La Dolce Vita Fruit Slot by Gamomat | {brand}',
        description: 'La Dolce Vita by Gamomat at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/gamomat-games/la_dolce_vita_2': {
        title: 'La Dolce Vita 2 by Gamomat at {brand} | Free Demo & Crypto Play',
        description: 'Spin La Dolce Vita 2 by Gamomat at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/gamomat-games/la_dolce_vita_deluxe': {
        title: 'La Dolce Vita Deluxe Fruit Slot by Gamomat | {brand}',
        description: 'La Dolce Vita Deluxe by Gamomat at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/gamomat-games/la_dolce_vita_flaming_link': {
        title: 'La Dolce Vita Flaming Link: Play Online with Crypto | {brand}',
        description: 'La Dolce Vita Flaming Link from Gamomat, with a 2,900x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/gamomat-games/land_of_heroes': {
        title: 'Land of Heroes Slot by Gamomat at {brand} | Instant Crypto Payouts',
        description: 'Land of Heroes by Gamomat at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/gamomat-games/lava_lions': {
        title: 'Lava Lions Slot by Gamomat at {brand} | Instant Crypto Payouts',
        description: 'Lava Lions by Gamomat at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/gamomat-games/legacy_of_ramses_book': {
        title: 'Play Legacy of Ramses Book by Gamomat at {brand} | 12,000x Max Win',
        description: 'Play Legacy of Ramses Book by Gamomat at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/gamomat-games/maaax_diamonds': {
        title: 'Maaax Diamonds: Play Online with Crypto | {brand}',
        description: 'Maaax Diamonds from Gamomat, with a 1,100x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/gamomat-games/maaax_diamonds_christmas_edition': {
        title: 'Maaax Diamonds Christmas Edition: Play Online with Crypto | {brand}',
        description: 'Maaax Diamonds Christmas Edition by Gamomat at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/gamomat-games/maaax_diamonds_deluxe': {
        title: 'Maaax Diamonds Deluxe Fruit Slot by Gamomat | {brand}',
        description: 'Maaax Diamonds Deluxe from Gamomat, with a 1,060x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/gamomat-games/magic_stone': {
        title: 'Magic Stone by Gamomat at {brand} | Free Demo & Crypto Play',
        description: 'Play Magic Stone by Gamomat at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/gamomat-games/mayan_fire': {
        title: 'Mayan Fire by Gamomat at {brand} | Free Demo & Crypto Play',
        description: 'Spin Mayan Fire by Gamomat at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/gamomat-games/mighty_dragon': {
        title: 'Mighty Dragon: Play Online with Crypto | {brand}',
        description: 'Mighty Dragon from Gamomat, with a 1,800x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/gamomat-games/monkey_mania': {
        title: 'Monkey Mania Fruit Slot by Gamomat | {brand}',
        description: 'Monkey Mania from Gamomat, with a 1,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/gamomat-games/multi_machine': {
        title: 'Play Multi Machine by Gamomat at {brand} | 2,400x Max Win',
        description: 'Spin Multi Machine by Gamomat at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/gamomat-games/night_wolves': {
        title: 'Play Night Wolves by Gamomat at {brand} | 1,400x Max Win',
        description: 'Spin Night Wolves by Gamomat at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/gamomat-games/nordic_fire': {
        title: 'Nordic Fire Slot by Gamomat at {brand} | Instant Crypto Payouts',
        description: 'Nordic Fire from Gamomat, with a 3,525x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/gamomat-games/old_fisherman': {
        title: 'Play Old Fisherman by Gamomat at {brand} | 2,400x Max Win',
        description: 'Spin Old Fisherman by Gamomat at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/gamomat-games/phantoms_mirror': {
        title: "Phantom's Mirror Slot by Gamomat at {brand} | Instant Crypto Payouts",
        description: "Phantom's Mirror from Gamomat, with a 700x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/gamomat-games/pharaos_riches': {
        title: "Play Pharao's Riches by Gamomat at {brand} | 2,000x Max Win",
        description: "Play Pharao's Riches by Gamomat at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/gamomat-games/ramses_book': {
        title: 'Play Ramses Book by Gamomat at {brand} | 6,300x Max Win',
        description: 'Spin Ramses Book by Gamomat at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/gamomat-games/ramses_book_christmas_edition': {
        title: 'Play Ramses Book Christmas Edition by Gamomat at {brand} | 6,300x Max Win',
        description: 'Play Ramses Book Christmas Edition by Gamomat at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/gamomat-games/ramses_book_deluxe': {
        title: 'Ramses Book Deluxe Fruit Slot by Gamomat | {brand}',
        description: 'Play Ramses Book Deluxe by Gamomat at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/gamomat-games/ramses_book_easter_edition': {
        title: 'Ramses Book Easter Edition: Play Online with Crypto | {brand}',
        description: 'Spin Ramses Book Easter Edition by Gamomat at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/gamomat-games/ramses_book_flaming_link': {
        title: 'Play Ramses Book Flaming Link by Gamomat at {brand} | 12,176x Max Win',
        description: 'Spin Ramses Book Flaming Link by Gamomat at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/gamomat-games/ramses_book_respins_of_amunre': {
        title: 'Play Ramses Book Respins of Amun-Re by Gamomat at {brand} | 9,000x Max Win',
        description: 'Spin Ramses Book Respins of Amun-Re by Gamomat at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/gamomat-games/ramses_book_rock_edition': {
        title: 'Ramses Book Rock Edition Slot by Gamomat at {brand} | Instant Crypto Payouts',
        description: 'Ramses Book Rock Edition from Gamomat, with a 10,800x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/gamomat-games/roman_legion': {
        title: 'Roman Legion Slot by Gamomat at {brand} | Instant Crypto Payouts',
        description: 'Roman Legion by Gamomat at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/gamomat-games/roman_legion_deluxe': {
        title: 'Roman Legion Deluxe Fruit Slot by Gamomat | {brand}',
        description: 'Roman Legion Deluxe by Gamomat at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/gamomat-games/roman_legion_extreme': {
        title: 'Roman Legion Extreme Fruit Slot by Gamomat | {brand}',
        description: 'Play Roman Legion Extreme by Gamomat at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/gamomat-games/roman_legion_flaming_link': {
        title: 'Roman Legion Flaming Link Slot by Gamomat at {brand} | Instant Crypto Payouts',
        description: 'Roman Legion Flaming Link from Gamomat, with a 12,150x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/gamomat-games/royal_7_xxl': {
        title: 'Royal 7 XXL by Gamomat at {brand} | Free Demo & Crypto Play',
        description: 'Royal 7 XXL from Gamomat. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/gamomat-games/royal_seven': {
        title: 'Play Royal Seven by Gamomat at {brand} | 550x Max Win',
        description: 'Spin Royal Seven by Gamomat at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/gamomat-games/royal_seven_deluxe': {
        title: 'Royal Seven Deluxe by Gamomat at {brand} | Free Demo & Crypto Play',
        description: 'Play Royal Seven Deluxe by Gamomat at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/gamomat-games/royal_seven_flaming_link': {
        title: 'Play Royal Seven Flaming Link by Gamomat at {brand} | 2,800x Max Win',
        description: 'Spin Royal Seven Flaming Link by Gamomat at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/gamomat-games/royal_seven_ultra': {
        title: 'Royal Seven Ultra Slot by Gamomat at {brand} | Instant Crypto Payouts',
        description: 'Royal Seven Ultra by Gamomat at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/gamomat-games/royal_seven_ultra_flaming_link': {
        title: 'Royal Seven Ultra Flaming Link Slot by Gamomat at {brand} | Instant Crypto Payouts',
        description: 'Royal Seven Ultra Flaming Link from Gamomat, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/gamomat-games/royal_seven_xxl': {
        title: 'Royal Seven XXL: Play Online with Crypto | {brand}',
        description: 'Royal Seven XXL by Gamomat at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/gamomat-games/royal_seven_xxl_easter_edition': {
        title: 'Royal Seven XXL Easter Edition by Gamomat at {brand} | Free Demo & Crypto Play',
        description: 'Royal Seven XXL Easter Edition from Gamomat. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/gamomat-games/royal_seven_xxl_flaming_link': {
        title: 'Royal Seven XXL Flaming Link Slot by Gamomat at {brand} | Instant Crypto Payouts',
        description: 'Royal Seven XXL Flaming Link from Gamomat, with a 12,150x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/gamomat-games/royale_seven_deluxe_xxl_deluxe': {
        title: 'Royale Seven Deluxe XXL Deluxe: Play Online with Crypto | {brand}',
        description: 'Spin Royale Seven Deluxe XXL Deluxe by Gamomat at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/gamomat-games/savanna_moon': {
        title: 'Savanna Moon: Play Online with Crypto | {brand}',
        description: 'Savanna Moon by Gamomat at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/gamomat-games/sevens_and_books': {
        title: 'Play Sevens & Books by Gamomat at {brand} | 1,000x Max Win',
        description: 'Play Sevens & Books by Gamomat at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/gamomat-games/sevens_fire': {
        title: 'Sevens Fire by Gamomat at {brand} | Free Demo & Crypto Play',
        description: 'Play Sevens Fire by Gamomat at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/gamomat-games/shoguns_secret': {
        title: "Shogun's Secret Slot by Gamomat at {brand} | Instant Crypto Payouts",
        description: "Shogun's Secret from Gamomat, with a 1,200x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/gamomat-games/simply_the_best': {
        title: 'Play Simply the Best by Gamomat at {brand} | 1,100x Max Win',
        description: 'Play Simply the Best by Gamomat at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/gamomat-games/sticky_diamonds': {
        title: 'Play Sticky Diamonds by Gamomat at {brand} | 1,500x Max Win',
        description: 'Spin Sticky Diamonds by Gamomat at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/gamomat-games/sticky_diamonds_easter_egg': {
        title: 'Sticky Diamonds Easter Egg by Gamomat at {brand} | Free Demo & Crypto Play',
        description: 'Sticky Diamonds Easter Egg from Gamomat. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/gamomat-games/sunny_sevens': {
        title: 'Sunny Sevens Fruit Slot by Gamomat | {brand}',
        description: 'Sunny Sevens from Gamomat, with a 1,500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/gamomat-games/super_duper_cherry': {
        title: 'Super Duper Cherry: Play Online with Crypto | {brand}',
        description: 'Super Duper Cherry by Gamomat at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/gamomat-games/take_5': {
        title: 'Play Take 5 by Gamomat at {brand} | 200x Max Win',
        description: 'Play Take 5 by Gamomat at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/gamomat-games/take_5_christmas_edition': {
        title: 'Take 5 Christmas Edition by Gamomat at {brand} | Free Demo & Crypto Play',
        description: 'Spin Take 5 Christmas Edition by Gamomat at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/gamomat-games/the_book_beyond': {
        title: 'Play The Book Beyond by Gamomat at {brand} | 7,200x Max Win',
        description: 'Play The Book Beyond by Gamomat at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/gamomat-games/the_book_beyond_2': {
        title: 'The Book Beyond 2 Slot by Gamomat at {brand} | Instant Crypto Payouts',
        description: 'The Book Beyond 2 by Gamomat at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/gamomat-games/the_expandable': {
        title: 'The Expandable Slot by Gamomat at {brand} | Instant Crypto Payouts',
        description: 'The Expandable from Gamomat, with a 1,500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/gamomat-games/the_mighty_king': {
        title: 'The Mighty King: Play Online with Crypto | {brand}',
        description: 'The Mighty King by Gamomat at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/gamomat-games/tower_of_power': {
        title: 'Play Tower of Power by Gamomat at {brand} | 1,000x Max Win',
        description: 'Spin Tower of Power by Gamomat at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/gamomat-games/vegas_joker': {
        title: 'Vegas Joker Fruit Slot by Gamomat | {brand}',
        description: 'Vegas Joker by Gamomat at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/gamomat-games/western_jack': {
        title: 'Western Jack Slot by Gamomat at {brand} | Instant Crypto Payouts',
        description: 'Western Jack by Gamomat at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/gamomat-games/wild_rubies': {
        title: 'Wild Rubies by Gamomat at {brand} | Free Demo & Crypto Play',
        description: 'Spin Wild Rubies by Gamomat at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/gamomat-games/wild_rubies_christmas_edition': {
        title: 'Play Wild Rubies Christmas Edition by Gamomat at {brand} | 2,000x Max Win',
        description: 'Play Wild Rubies Christmas Edition by Gamomat at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/gamomat-games/win_blaster': {
        title: 'Win Blaster Fruit Slot by Gamomat | {brand}',
        description: 'Win Blaster by Gamomat at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/gamomat-games/win_blaster_christmas_edition': {
        title: 'Win Blaster Christmas Edition Fruit Slot by Gamomat | {brand}',
        description: 'Win Blaster Christmas Edition from Gamomat, with a 20,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/gamomat-games/win_shooter': {
        title: 'Win Shooter by Gamomat at {brand} | Free Demo & Crypto Play',
        description: 'Spin Win Shooter by Gamomat at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/gamomat-games/xploding_pumpkins': {
        title: 'Xploding Pumpkins by Gamomat at {brand} | Free Demo & Crypto Play',
        description: 'Spin Xploding Pumpkins by Gamomat at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/playson/100_joker_staxx': {
        title: '100 Joker Staxx Hold and Win Slot by playson | {brand}',
        description: '100 Joker Staxx from playson, with a 3,825x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/playson/25_cookies_hit_the_bonus': {
        title: 'Play 25 Cookies by playson at {brand} | 10,000x Max Win',
        description: 'Spin 25 Cookies by playson at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/playson/3_carts_of_gold_hold_and_win': {
        title: 'Play 3 Carts of Gold by playson at {brand} | 6,591x Max Win',
        description: 'Play 3 Carts of Gold by playson at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/playson/3_chillies_and_joker_hold_and_win': {
        title: '3 Chillies and Joker Hold and Win Slot by playson at {brand} | Instant Crypto Payouts',
        description: '3 Chillies and Joker Hold and Win by playson at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/playson/3_luxor_pots_hold_and_win': {
        title: '3 Luxor Pots Hold and Win Hold and Win Slot by playson | {brand}',
        description: '3 Luxor Pots Hold and Win by playson at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/playson/3_magic_lamps_hold_and_win': {
        title: '3 Magic Lamps Slot by playson at {brand} | Instant Crypto Payouts',
        description: '3 Magic Lamps by playson at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/playson/3_pirate_barrels_hold_and_win': {
        title: '3 Pirate Barrels Hold and Win Slot by playson | {brand}',
        description: '3 Pirate Barrels by playson at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/playson/3_pots_riches_hold_and_win': {
        title: '3 Pots Riches by playson at {brand} | Free Demo & Crypto Play',
        description: '3 Pots Riches from playson. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/playson/3_royal_coins_hold_and_win': {
        title: 'Play 3 Royal Coins Hold and Win by playson at {brand} | 10,050x Max Win',
        description: 'Spin 3 Royal Coins Hold and Win by playson at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/playson/3_supercharged_diamonds_hold_and_win': {
        title: '3 Supercharged Diamonds Hold and Win Slot by playson at {brand} | Instant Crypto Payouts',
        description: '3 Supercharged Diamonds Hold and Win by playson at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/playson/3_thunder_coins_hold_and_win': {
        title: '3 Thunder Coins Hold and Win Slot by playson | {brand}',
        description: '3 Thunder Coins from playson, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/playson/3x_catch': {
        title: '3x Catch by playson at {brand} | Free Demo & Crypto Play',
        description: 'Spin 3x Catch by playson at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/playson/4_chili_amigos_hold_and_win': {
        title: '4 Chili Amigos Hold and Win Hold and Win Slot by playson | {brand}',
        description: '4 Chili Amigos Hold and Win by playson at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/playson/4_chili_pots_hold_and_win': {
        title: '4 Chili Pots Slot by playson at {brand} | Instant Crypto Payouts',
        description: '4 Chili Pots by playson at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/playson/4_pots_riches_super_wheel': {
        title: '4 Pots Riches Hold and Win Slot by playson | {brand}',
        description: '4 Pots Riches by playson at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/playson/4_supercharged_clovers': {
        title: '4 Supercharged Clovers by playson at {brand} | Free Demo & Crypto Play',
        description: 'Play 4 Supercharged Clovers by playson at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/playson/4_supershiny_diamonds_hold_and_win': {
        title: '4 Supershiny Diamonds by playson at {brand} | Free Demo & Crypto Play',
        description: '4 Supershiny Diamonds from playson. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/playson/5_fortunator': {
        title: '5 Fortunator: Play Online with Crypto | {brand}',
        description: '5 Fortunator from playson, with a 820x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/playson/5_super_sevens_and_fruits': {
        title: '5 Super Sevens & Fruits Hold and Win Slot by playson | {brand}',
        description: '5 Super Sevens & Fruits from playson, with a 1,100x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/playson/777_sizzling_wins_5_line': {
        title: '777 Sizzling Wins Hold and Win Slot by playson | {brand}',
        description: 'Play 777 Sizzling Wins by playson at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/playson/arizona_heist_hold_and_win': {
        title: 'Arizona Heist: Play Online with Crypto | {brand}',
        description: 'Spin Arizona Heist by playson at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/playson/blazing_wins_5_lines': {
        title: 'Blazing Wins: Play Online with Crypto | {brand}',
        description: 'Spin Blazing Wins by playson at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/playson/book_del_sol': {
        title: 'Book Del Sol: Play Online with Crypto | {brand}',
        description: 'Book Del Sol by playson at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/playson/book_of_gold_classic': {
        title: 'Book of Gold by playson at {brand} | Free Demo & Crypto Play',
        description: 'Spin Book of Gold by playson at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/playson/book_of_gold_double_chance': {
        title: 'Play Book of Gold by playson at {brand} | 4,067x Max Win',
        description: 'Spin Book of Gold by playson at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/playson/book_of_gold_multichance': {
        title: 'Book of Gold Hold and Win Slot by playson | {brand}',
        description: 'Book of Gold from playson, with a 6,550x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/playson/buffalo_power_2': {
        title: 'Buffalo Power 2 by playson at {brand} | Free Demo & Crypto Play',
        description: 'Buffalo Power 2 from playson. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/playson/buffalo_power_christmas': {
        title: 'Buffalo Power Slot by playson at {brand} | Instant Crypto Payouts',
        description: 'Buffalo Power from playson, with a 1,187x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/playson/buffalo_power_hold_and_win': {
        title: 'Buffalo Power: Play Online with Crypto | {brand}',
        description: 'Buffalo Power from playson, with a 1,187x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/playson/buffalo_power_megaways': {
        title: 'Buffalo Power Megaways: Play Online with Crypto | {brand}',
        description: 'Buffalo Power Megaways by playson at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/playson/burning_fortunator': {
        title: 'Burning Fortunator Slot by playson at {brand} | Instant Crypto Payouts',
        description: 'Burning Fortunator by playson at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/playson/burning_wins': {
        title: 'Play Burning Wins by playson at {brand} | 60x Max Win',
        description: 'Play Burning Wins by playson at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/playson/burning_wins_x2': {
        title: 'Burning Wins x2 Hold and Win Slot by playson | {brand}',
        description: 'Burning Wins x2 from playson, with a 15x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/playson/charge_the_clovers_hit_the_bonus': {
        title: 'Charge the Clovers Hit the Bonus Hold and Win Slot by playson | {brand}',
        description: 'Play Charge the Clovers Hit the Bonus by playson at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/playson/classic_fruit_hold_and_win': {
        title: 'Classic Fruit Hold and Win Slot by playson at {brand} | Instant Crypto Payouts',
        description: 'Classic Fruit Hold and Win from playson, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/playson/clover_charm_hit_the_bonus': {
        title: 'Play Clover Charm by playson at {brand} | 10,000x Max Win',
        description: 'Play Clover Charm by playson at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/playson/clover_smash': {
        title: 'Clover Smash: Play Online with Crypto | {brand}',
        description: 'Clover Smash by playson at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/playson/clover_strike_hold_and_win': {
        title: 'Clover Strike Hold and Win by playson at {brand} | Free Demo & Crypto Play',
        description: 'Play Clover Strike Hold and Win by playson at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/playson/coin_strike_2_hold_and_win': {
        title: 'Coin Strike 2 by playson at {brand} | Free Demo & Crypto Play',
        description: 'Coin Strike 2 from playson. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/playson/coin_strike_xxl': {
        title: 'Coin Strike XXL by playson at {brand} | Free Demo & Crypto Play',
        description: 'Play Coin Strike XXL by playson at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/playson/crown_and_diamonds_hold_and_win': {
        title: 'Crown and Diamonds Slot by playson at {brand} | Instant Crypto Payouts',
        description: 'Crown and Diamonds by playson at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/playson/crown_strike_hold_and_win': {
        title: 'Crown Strike Hold and Win Slot by playson | {brand}',
        description: 'Play Crown Strike by playson at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/playson/diamond_fortunator': {
        title: 'Play Diamond Fortunator by playson at {brand} | 2,620x Max Win',
        description: 'Spin Diamond Fortunator by playson at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/playson/diamond_power_hold_and_win': {
        title: 'Diamond Power: Play Online with Crypto | {brand}',
        description: 'Spin Diamond Power by playson at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/playson/diamond_power_xxl_hold_and_win': {
        title: 'Diamond Power XXL Hold and Win Hold and Win Slot by playson | {brand}',
        description: 'Diamond Power XXL Hold and Win from playson, with a 5,405x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/playson/diamond_wins': {
        title: 'Diamond Wins Hold and Win Slot by playson | {brand}',
        description: 'Diamond Wins by playson at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/playson/divine_dragon_hold_and_win': {
        title: 'Divine Dragon: Play Online with Crypto | {brand}',
        description: 'Divine Dragon from playson, with a 1,248x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/playson/eagle_power_hold_and_win': {
        title: 'Eagle Power by playson at {brand} | Free Demo & Crypto Play',
        description: 'Spin Eagle Power by playson at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/playson/empire_gold_hold_and_win': {
        title: 'Empire Gold Hold and Win Slot by playson | {brand}',
        description: 'Empire Gold from playson, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/playson/energy_coins_hold_and_win': {
        title: 'Energy Coins Slot by playson at {brand} | Instant Crypto Payouts',
        description: 'Energy Coins by playson at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/playson/energy_joker_hold_and_win': {
        title: 'Energy Joker: Play Online with Crypto | {brand}',
        description: 'Spin Energy Joker by playson at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/playson/fruits_and_jokers_100_lines': {
        title: 'Fruits & Jokers: Play Online with Crypto | {brand}',
        description: 'Fruits & Jokers from playson, with a 2,545x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/playson/fruits_and_jokers_20_lines': {
        title: 'Play Fruits & Jokers by playson at {brand} | 819x Max Win',
        description: 'Spin Fruits & Jokers by playson at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/playson/fruits_and_jokers_40_lines': {
        title: 'Play Fruits & Jokers by playson at {brand} | 1,500x Max Win',
        description: 'Play Fruits & Jokers by playson at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/playson/giza_nights_hold_and_win': {
        title: 'Giza Nights Hold and Win Slot by playson | {brand}',
        description: 'Giza Nights by playson at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/playson/golden_penny_x1000': {
        title: 'Golden Penny x1000 Slot by playson at {brand} | Instant Crypto Payouts',
        description: 'Golden Penny x1000 by playson at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/playson/hit_the_bank_hold_and_win': {
        title: 'Play Hit the Bank by playson at {brand} | 20,000x Max Win',
        description: 'Play Hit the Bank by playson at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/playson/hot_burning_wins': {
        title: 'Hot Burning Wins by playson at {brand} | Free Demo & Crypto Play',
        description: 'Spin Hot Burning Wins by playson at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/playson/hot_coins_hold_and_win': {
        title: 'Play Hot Coins by playson at {brand} | 1,387x Max Win',
        description: 'Play Hot Coins by playson at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/playson/imperial_fruits_100_lines': {
        title: 'Play Imperial Fruits by playson at {brand} | 1,057x Max Win',
        description: 'Play Imperial Fruits by playson at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/playson/imperial_fruits_5_lines': {
        title: 'Play Imperial Fruits by playson at {brand} | 820x Max Win',
        description: 'Play Imperial Fruits by playson at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/playson/jingle_coins_hold_and_win': {
        title: 'Jingle Coins by playson at {brand} | Free Demo & Crypto Play',
        description: 'Spin Jingle Coins by playson at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/playson/joker_expand_5_lines': {
        title: 'Joker Expand Hold and Win Slot by playson | {brand}',
        description: 'Joker Expand from playson, with a 1,050x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/playson/jokers_coins_hold_and_win': {
        title: "Joker's Coins Hold and Win Slot by playson | {brand}",
        description: "Joker's Coins by playson at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/playson/king_of_the_sky_hit_the_bonus': {
        title: 'King of the Sky Hit the Bonus Hold and Win Slot by playson | {brand}',
        description: 'Play King of the Sky Hit the Bonus by playson at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/playson/legend_of_cleopatra': {
        title: 'Play Legend of Cleopatra by playson at {brand} | 657x Max Win',
        description: 'Play Legend of Cleopatra by playson at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/playson/legend_of_cleopatra_megaways': {
        title: 'Legend of Cleopatra Megaways: Play Online with Crypto | {brand}',
        description: 'Legend of Cleopatra Megaways from playson, with a 6,584x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/playson/lightning_clovers_hit_the_bonus': {
        title: 'Lightning Clovers - Hit the Bonus™: Play Online with Crypto | {brand}',
        description: 'Spin Lightning Clovers - Hit the Bonus™ by playson at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/playson/lion_gems_3_pot_hold_and_win': {
        title: 'Lion Gems 3 Pot Hold and Win Slot by playson at {brand} | Instant Crypto Payouts',
        description: 'Lion Gems 3 Pot Hold and Win by playson at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/playson/lion_gems_hold_and_win': {
        title: 'Lion Gems Slot by playson at {brand} | Instant Crypto Payouts',
        description: 'Lion Gems from playson, with a 3,504x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/playson/merry_giftmas_hold_and_win': {
        title: 'Merry Giftmas: Play Online with Crypto | {brand}',
        description: 'Merry Giftmas by playson at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/playson/pearl_beauty_hold_and_win': {
        title: 'Pearl Beauty Hold and Win Slot by playson | {brand}',
        description: 'Pearl Beauty from playson, with a 1,192x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/playson/pearl_ocean_hold_and_win': {
        title: 'Pearl Ocean Slot by playson at {brand} | Instant Crypto Payouts',
        description: 'Pearl Ocean by playson at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/playson/piggy_power_hit_the_bonus': {
        title: 'Piggy Power Slot by playson at {brand} | Instant Crypto Payouts',
        description: 'Piggy Power by playson at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/playson/pink_clovers_xxxl_hold_and_win': {
        title: 'Pink Clovers XXXL: Play Online with Crypto | {brand}',
        description: 'Spin Pink Clovers XXXL by playson at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/playson/pink_joker_hold_and_win': {
        title: 'Pink Joker Hold and Win Slot by playson | {brand}',
        description: 'Play Pink Joker by playson at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/playson/pirate_chest_hold_and_win': {
        title: 'Pirate Chest Slot by playson at {brand} | Instant Crypto Payouts',
        description: 'Pirate Chest by playson at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/playson/power_crown_hold_and_win': {
        title: 'Power Crown Slot by playson at {brand} | Instant Crypto Payouts',
        description: 'Power Crown by playson at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/playson/rhino_coins_hit_the_bonus': {
        title: 'Play Rhino Coins Hit the Bonus by playson at {brand} | 15,000x Max Win',
        description: 'Play Rhino Coins Hit the Bonus by playson at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/playson/rich_diamonds_hold_and_win': {
        title: 'Rich Diamonds by playson at {brand} | Free Demo & Crypto Play',
        description: 'Spin Rich Diamonds by playson at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/playson/rise_of_egypt': {
        title: 'Play Rise of Egypt by playson at {brand} | 944x Max Win',
        description: 'Play Rise of Egypt by playson at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/playson/rockin_joker_hold_and_win': {
        title: 'Play Rockin Joker Hold and Win by playson at {brand} | 10,000x Max Win',
        description: 'Play Rockin Joker Hold and Win by playson at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/playson/royal_coins_2_hold_and_win': {
        title: 'Royal Coins 2 Slot by playson at {brand} | Instant Crypto Payouts',
        description: 'Royal Coins 2 by playson at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/playson/royal_coins_hold_and_win': {
        title: 'Play Royal Coins by playson at {brand} | 4,259x Max Win',
        description: 'Spin Royal Coins by playson at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/playson/royal_express_hold_and_win': {
        title: 'Play Royal Express Hold and Win by playson at {brand} | 9,585x Max Win',
        description: 'Play Royal Express Hold and Win by playson at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/playson/royal_fortunator_hold_and_win': {
        title: 'Royal Fortunator Hold and Win Slot by playson | {brand}',
        description: 'Play Royal Fortunator by playson at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/playson/sevens_and_fruits': {
        title: 'Sevens & Fruits: Play Online with Crypto | {brand}',
        description: 'Sevens & Fruits by playson at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/playson/sevens_and_fruits_20_lines': {
        title: 'Sevens and Fruits by playson at {brand} | Free Demo & Crypto Play',
        description: 'Spin Sevens and Fruits by playson at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/playson/solar_king': {
        title: 'Solar King by playson at {brand} | Free Demo & Crypto Play',
        description: 'Spin Solar King by playson at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/playson/solar_queen': {
        title: 'Solar Queen: Play Online with Crypto | {brand}',
        description: 'Solar Queen by playson at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/playson/solar_temple': {
        title: 'Play Solar Temple by playson at {brand} | 20,000x Max Win',
        description: 'Play Solar Temple by playson at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/playson/sugar_teddy': {
        title: 'Play Sugar Teddy by playson at {brand} | 20,000x Max Win',
        description: 'Spin Sugar Teddy by playson at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/playson/sunny_fruits_2_hold_and_win': {
        title: 'Sunny Fruits 2 by playson at {brand} | Free Demo & Crypto Play',
        description: 'Play Sunny Fruits 2 by playson at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/playson/sunny_fruits_hold_and_win': {
        title: 'Sunny Fruits Hold and Win Slot by playson | {brand}',
        description: 'Sunny Fruits by playson at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/playson/super_pink_joker_hold_and_win': {
        title: 'Super Pink Joker Hold and Win Slot by playson | {brand}',
        description: 'Play Super Pink Joker by playson at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/playson/supercharged_clovers_hold_and_win': {
        title: 'Supercharged Clovers: Play Online with Crypto | {brand}',
        description: 'Spin Supercharged Clovers by playson at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/playson/thunder_coins_hold_and_win': {
        title: 'Thunder Coins by playson at {brand} | Free Demo & Crypto Play',
        description: 'Thunder Coins from playson. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/playson/thunder_coins_xxl_hold_and_win': {
        title: 'Thunder Coins XXL Hold and Win Slot by playson | {brand}',
        description: 'Play Thunder Coins XXL by playson at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/playson/thunder_coins_xxl_multicoin': {
        title: 'Play Thunder Coins XXL Multicoin by playson at {brand} | 7,426x Max Win',
        description: 'Spin Thunder Coins XXL Multicoin by playson at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/playson/tornado_power_hold_and_win': {
        title: 'Tornado Power Hold and Win Hold and Win Slot by playson | {brand}',
        description: 'Tornado Power Hold and Win from playson, with a 4,816x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/playson/treasures_of_fire': {
        title: 'Play Treasures of Fire by playson at {brand} | 20,000x Max Win',
        description: 'Spin Treasures of Fire by playson at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/playson/wolf_power_hold_and_win': {
        title: 'Wolf Power by playson at {brand} | Free Demo & Crypto Play',
        description: 'Spin Wolf Power by playson at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/playson/wolf_power_megaways': {
        title: 'Play Wolf Power Megaways by playson at {brand} | 20,000x Max Win',
        description: 'Play Wolf Power Megaways by playson at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/playson/x1000_golden_penny_2': {
        title: 'x1000 Golden Penny 2 by playson at {brand} | Free Demo & Crypto Play',
        description: 'Spin x1000 Golden Penny 2 by playson at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/quickspin/adventures_beyond_wonderland_magical_maze': {
        title: 'Adventures Beyond Wonderland Magical Maze Slot by Quickspin at {brand} | Instant Crypto Payouts',
        description: 'Adventures Beyond Wonderland Magical Maze by Quickspin at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/quickspin/arcane_gems': {
        title: 'Arcane Gems by Quickspin at {brand} | Free Demo & Crypto Play',
        description: 'Arcane Gems from Quickspin. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/quickspin/ark_of_mystery': {
        title: 'Ark of Mystery Bonus Slot by Quickspin | {brand}',
        description: 'Play Ark of Mystery by Quickspin at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/quickspin/artemis_vs_medusa': {
        title: 'Artemis vs Medusa Slot by Quickspin at {brand} | Instant Crypto Payouts',
        description: 'Artemis vs Medusa by Quickspin at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/quickspin/azticons_chaos_clusters': {
        title: 'Azticons Chaos Clusters Bonus Slot by Quickspin | {brand}',
        description: 'Play Azticons Chaos Clusters by Quickspin at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/quickspin/big_bad_wolf': {
        title: 'Big Bad Wolf Slot by Quickspin at {brand} | Instant Crypto Payouts',
        description: 'Big Bad Wolf by Quickspin at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/quickspin/big_bad_wolf_christmas_special': {
        title: 'Big Bad Wolf Christmas Special Bonus Slot by Quickspin | {brand}',
        description: 'Play Big Bad Wolf Christmas Special by Quickspin at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/quickspin/big_bad_wolf_megaways': {
        title: 'Big Bad Wolf Megaways: Play Online with Crypto | {brand}',
        description: 'Spin Big Bad Wolf Megaways by Quickspin at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/quickspin/big_bad_wolf_pigs_of_steel': {
        title: 'Big Bad Wolf Pigs of Steel Slot by Quickspin at {brand} | Instant Crypto Payouts',
        description: 'Big Bad Wolf Pigs of Steel from Quickspin, with a 18,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/quickspin/big_bot_crew': {
        title: 'Big Bot Crew Bonus Slot by Quickspin | {brand}',
        description: 'Play Big Bot Crew by Quickspin at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/quickspin/blue_fortune': {
        title: 'Blue Fortune Bonus Slot by Quickspin | {brand}',
        description: 'Play Blue Fortune by Quickspin at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/quickspin/book_of_duat': {
        title: 'Book of Duat: Play Online with Crypto | {brand}',
        description: 'Spin Book of Duat by Quickspin at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/quickspin/book_of_yuletide': {
        title: 'Book of Yuletide Bonus Slot by Quickspin | {brand}',
        description: 'Book of Yuletide from Quickspin, with a 32,760x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/quickspin/brawlers_bar_cash_collect': {
        title: 'Brawlers Bar Cash Collect by Quickspin at {brand} | Free Demo & Crypto Play',
        description: 'Brawlers Bar Cash Collect from Quickspin. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/quickspin/brawlers_brew': {
        title: 'Brawlers Brew: Play Online with Crypto | {brand}',
        description: 'Brawlers Brew from Quickspin, with a 7,620x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/quickspin/brooklyn_bootleggers': {
        title: 'Brooklyn Bootleggers: Play Online with Crypto | {brand}',
        description: 'Spin Brooklyn Bootleggers by Quickspin at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/quickspin/cabin_crashers': {
        title: 'Cabin Crashers by Quickspin at {brand} | Free Demo & Crypto Play',
        description: 'Cabin Crashers from Quickspin. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/quickspin/candy_glyph': {
        title: 'Candy Glyph: Play Online with Crypto | {brand}',
        description: 'Spin Candy Glyph by Quickspin at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/quickspin/cash_truck': {
        title: 'Cash Truck Slot by Quickspin at {brand} | Instant Crypto Payouts',
        description: 'Cash Truck by Quickspin at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/quickspin/cash_truck_2': {
        title: 'Cash Truck 2: Play Online with Crypto | {brand}',
        description: 'Spin Cash Truck 2 by Quickspin at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/quickspin/cash_truck_3_turbo': {
        title: 'Cash Truck 3 Turbo: Play Online with Crypto | {brand}',
        description: 'Spin Cash Truck 3 Turbo by Quickspin at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/quickspin/cash_truck_begins': {
        title: 'Play Cash Truck Begins by Quickspin at {brand} | 20,000x Max Win',
        description: 'Spin Cash Truck Begins by Quickspin at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/quickspin/cash_truck_xmas_delivery': {
        title: 'Cash Truck Xmas Delivery Bonus Slot by Quickspin | {brand}',
        description: 'Play Cash Truck Xmas Delivery by Quickspin at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/quickspin/crown_of_valor': {
        title: 'Crown of Valor Bonus Slot by Quickspin | {brand}',
        description: 'Play Crown of Valor by Quickspin at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/quickspin/crystal_prince': {
        title: 'Crystal Prince: Play Online with Crypto | {brand}',
        description: 'Spin Crystal Prince by Quickspin at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/quickspin/crystal_queen': {
        title: 'Crystal Queen by Quickspin at {brand} | Free Demo & Crypto Play',
        description: 'Crystal Queen from Quickspin. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/quickspin/crystal_queen_coins': {
        title: 'Play Crystal Queen Coins by Quickspin at {brand} | 10,150x Max Win',
        description: 'Play Crystal Queen Coins by Quickspin at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/quickspin/diamond_duke': {
        title: 'Diamond Duke: Play Online with Crypto | {brand}',
        description: 'Spin Diamond Duke by Quickspin at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/quickspin/dinosaur_rage': {
        title: 'Dinosaur Rage: Play Online with Crypto | {brand}',
        description: 'Dinosaur Rage by Quickspin at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/quickspin/divine_dreams': {
        title: 'Divine Dreams Bonus Slot by Quickspin | {brand}',
        description: 'Play Divine Dreams by Quickspin at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/quickspin/dragon_chase': {
        title: 'Dragon Chase: Play Online with Crypto | {brand}',
        description: 'Spin Dragon Chase by Quickspin at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/quickspin/dragon_shrine': {
        title: 'Dragon Shrine Slot by Quickspin at {brand} | Instant Crypto Payouts',
        description: 'Dragon Shrine by Quickspin at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/quickspin/durian_dynamite': {
        title: 'Durian Dynamite Slot by Quickspin at {brand} | Instant Crypto Payouts',
        description: 'Durian Dynamite by Quickspin at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/quickspin/dwarfs_gone_wild': {
        title: 'Dwarfs Gone Wild Bonus Slot by Quickspin | {brand}',
        description: 'Play Dwarfs Gone Wild by Quickspin at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/quickspin/eastern_emeralds': {
        title: 'Eastern Emeralds by Quickspin at {brand} | Free Demo & Crypto Play',
        description: 'Spin Eastern Emeralds by Quickspin at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/quickspin/epic_fish_adventure': {
        title: 'Epic Fish Adventure: Play Online with Crypto | {brand}',
        description: 'Epic Fish Adventure by Quickspin at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/quickspin/epic_fish_marlin_madness': {
        title: 'Epic Fish Marlin Madness by Quickspin at {brand} | Free Demo & Crypto Play',
        description: 'Play Epic Fish Marlin Madness by Quickspin at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/quickspin/epic_fish_net_of_fortune': {
        title: 'Epic Fish Net of Fortune by Quickspin at {brand} | Free Demo & Crypto Play',
        description: 'Play Epic Fish Net of Fortune by Quickspin at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/quickspin/fairy_gate': {
        title: 'Fairy Gate by Quickspin at {brand} | Free Demo & Crypto Play',
        description: 'Fairy Gate from Quickspin. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/quickspin/feasting_fox': {
        title: 'Feasting Fox Slot by Quickspin at {brand} | Instant Crypto Payouts',
        description: 'Feasting Fox by Quickspin at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/quickspin/fire_tale': {
        title: 'Fire Tale Slot by Quickspin at {brand} | Instant Crypto Payouts',
        description: 'Fire Tale by Quickspin at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/quickspin/genies_touch': {
        title: 'Genies Touch Slot by Quickspin at {brand} | Instant Crypto Payouts',
        description: 'Genies Touch by Quickspin at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/quickspin/ghost_glyph': {
        title: 'Ghost Glyph Bonus Slot by Quickspin | {brand}',
        description: 'Play Ghost Glyph by Quickspin at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/quickspin/gloria_invicta': {
        title: 'Gloria Invicta Slot by Quickspin at {brand} | Instant Crypto Payouts',
        description: 'Gloria Invicta from Quickspin, with a 18,143x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/quickspin/golden_glyph': {
        title: 'Golden Glyph: Play Online with Crypto | {brand}',
        description: 'Spin Golden Glyph by Quickspin at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/quickspin/golden_glyph_2': {
        title: 'Golden Glyph 2 by Quickspin at {brand} | Free Demo & Crypto Play',
        description: 'Golden Glyph 2 from Quickspin. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/quickspin/golden_glyph_3': {
        title: 'Golden Glyph 3: Play Online with Crypto | {brand}',
        description: 'Spin Golden Glyph 3 by Quickspin at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/quickspin/goldilocks': {
        title: 'Goldilocks Slot by Quickspin at {brand} | Instant Crypto Payouts',
        description: 'Goldilocks by Quickspin at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/quickspin/guardian_of_athens': {
        title: 'Guardian of athens Slot by Quickspin at {brand} | Instant Crypto Payouts',
        description: 'Guardian of athens by Quickspin at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/quickspin/hall_of_the_mountain_king': {
        title: 'Hall of the Mountain King: Play Online with Crypto | {brand}',
        description: 'Hall of the Mountain King from Quickspin, with a 7,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/quickspin/hammer_of_vulcan': {
        title: 'Play Hammer of Vulcan by Quickspin at {brand} | 20,000x Max Win',
        description: 'Spin Hammer of Vulcan by Quickspin at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/quickspin/hidden_valley_120': {
        title: 'Hidden Valley 120 Bonus Slot by Quickspin | {brand}',
        description: 'Play Hidden Valley 120 by Quickspin at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/quickspin/high_street_heist': {
        title: 'High Street Heist: Play Online with Crypto | {brand}',
        description: 'Spin High Street Heist by Quickspin at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/quickspin/honeylocks_pots': {
        title: 'Honeylocks Pots by Quickspin at {brand} | Free Demo & Crypto Play',
        description: 'Play Honeylocks Pots by Quickspin at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/quickspin/ivan_and_the_immortal_king': {
        title: 'Ivan and the Immortal King Bonus Slot by Quickspin | {brand}',
        description: 'Play Ivan and the Immortal King by Quickspin at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/quickspin/joker_strike': {
        title: 'Joker Strike: Play Online with Crypto | {brand}',
        description: 'Spin Joker Strike by Quickspin at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/quickspin/king_colossus': {
        title: 'King Colossus by Quickspin at {brand} | Free Demo & Crypto Play',
        description: 'King Colossus from Quickspin. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/quickspin/leprechaun_hills': {
        title: 'Leprechaun Hills: Play Online with Crypto | {brand}',
        description: 'Spin Leprechaun Hills by Quickspin at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/quickspin/loco_the_monkey': {
        title: 'Loco The Monkey by Quickspin at {brand} | Free Demo & Crypto Play',
        description: 'Loco The Monkey from Quickspin. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/quickspin/mayana': {
        title: 'Mayana Slot by Quickspin at {brand} | Instant Crypto Payouts',
        description: 'Mayana by Quickspin at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/quickspin/midas_coins': {
        title: 'Midas Coins: Play Online with Crypto | {brand}',
        description: 'Midas Coins from Quickspin, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/quickspin/mighty_arthur': {
        title: 'Mighty Arthur Slot by Quickspin at {brand} | Instant Crypto Payouts',
        description: 'Mighty Arthur by Quickspin at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/quickspin/neros_fortune': {
        title: "Nero's Fortune by Quickspin at {brand} | Free Demo & Crypto Play",
        description: "Nero's Fortune from Quickspin. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/quickspin/northern_sky': {
        title: 'Northern Sky: Play Online with Crypto | {brand}',
        description: 'Spin Northern Sky by Quickspin at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/quickspin/panthers_reign': {
        title: 'Panthers Reign Slot by Quickspin at {brand} | Instant Crypto Payouts',
        description: 'Panthers Reign by Quickspin at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/quickspin/pearl_o_plinko': {
        title: 'Pearl O Plinko: Play Online with Crypto | {brand}',
        description: 'Spin Pearl O Plinko by Quickspin at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/quickspin/pearl_o_plinko_mermaid': {
        title: 'Pearl O Plinko Mermaid Bonus Slot by Quickspin | {brand}',
        description: 'Play Pearl O Plinko Mermaid by Quickspin at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/quickspin/phoenix_sun': {
        title: 'Phoenix Sun Bonus Slot by Quickspin | {brand}',
        description: 'Play Phoenix Sun by Quickspin at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/quickspin/pied_piper': {
        title: 'Pied Piper by Quickspin at {brand} | Free Demo & Crypto Play',
        description: 'Pied Piper from Quickspin. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/quickspin/pineapple_crush': {
        title: 'Pineapple Crush by Quickspin at {brand} | Free Demo & Crypto Play',
        description: 'Spin Pineapple Crush by Quickspin at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/quickspin/pirates_charm': {
        title: "Pirate's Charm: Play Online with Crypto | {brand}",
        description: "Spin Pirate's Charm by Quickspin at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/quickspin/polar_paws': {
        title: 'Polar Paws: Play Online with Crypto | {brand}',
        description: 'Spin Polar Paws by Quickspin at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/quickspin/prime_zone': {
        title: 'Prime Zone Bonus Slot by Quickspin | {brand}',
        description: 'Play Prime Zone by Quickspin at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/quickspin/rapunzels_tower': {
        title: "Rapunzel's Tower: Play Online with Crypto | {brand}",
        description: "Spin Rapunzel's Tower by Quickspin at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/quickspin/razortooth': {
        title: 'Razortooth: Play Online with Crypto | {brand}',
        description: 'Spin Razortooth by Quickspin at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/quickspin/reel_nightmare': {
        title: 'Reel Nightmare by Quickspin at {brand} | Free Demo & Crypto Play',
        description: 'Spin Reel Nightmare by Quickspin at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/quickspin/reno_7s': {
        title: "Reno 7's Slot by Quickspin at {brand} | Instant Crypto Payouts",
        description: "Reno 7's by Quickspin at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/quickspin/robbits_94': {
        title: 'Robbits 94 Slot by Quickspin at {brand} | Instant Crypto Payouts',
        description: 'Robbits 94 by Quickspin at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/quickspin/sakura_fortune': {
        title: 'Sakura Fortune by Quickspin at {brand} | Free Demo & Crypto Play',
        description: 'Sakura Fortune from Quickspin. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/quickspin/sakura_fortune_2': {
        title: 'Sakura Fortune 2 Bonus Slot by Quickspin | {brand}',
        description: 'Play Sakura Fortune 2 by Quickspin at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/quickspin/sakura_fortune_epic_bloom': {
        title: 'Sakura Fortune Epic Bloom Slot by Quickspin at {brand} | Instant Crypto Payouts',
        description: 'Sakura Fortune Epic Bloom by Quickspin at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/quickspin/scepter_of_anubis': {
        title: 'Scepter of Anubis Bonus Slot by Quickspin | {brand}',
        description: 'Scepter of Anubis by Quickspin at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/quickspin/second_strike': {
        title: 'Second Strike by Quickspin at {brand} | Free Demo & Crypto Play',
        description: 'Second Strike from Quickspin. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/quickspin/sevens_high': {
        title: 'Sevens High Slot by Quickspin at {brand} | Instant Crypto Payouts',
        description: 'Sevens High by Quickspin at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/quickspin/sevens_high_ultra': {
        title: 'Sevens High Ultra Bonus Slot by Quickspin | {brand}',
        description: 'Play Sevens High Ultra by Quickspin at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/quickspin/shields_of_lambda': {
        title: 'Shields of Lambda: Play Online with Crypto | {brand}',
        description: 'Spin Shields of Lambda by Quickspin at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/quickspin/sinbad': {
        title: 'Sinbad by Quickspin at {brand} | Free Demo & Crypto Play',
        description: 'Sinbad from Quickspin. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/quickspin/skulls_up': {
        title: 'Skulls UP! Bonus Slot by Quickspin | {brand}',
        description: 'Play Skulls UP! by Quickspin at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/quickspin/slugger_time': {
        title: 'Slugger Time Slot by Quickspin at {brand} | Instant Crypto Payouts',
        description: 'Slugger Time by Quickspin at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/quickspin/spinions': {
        title: 'Spinions by Quickspin at {brand} | Free Demo & Crypto Play',
        description: 'Spinions from Quickspin. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/quickspin/spinions_xmas_party': {
        title: 'Spinions x-mas party Bonus Slot by Quickspin | {brand}',
        description: 'Play Spinions x-mas party by Quickspin at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/quickspin/sticky_bandits': {
        title: 'Sticky Bandits by Quickspin at {brand} | Free Demo & Crypto Play',
        description: 'Sticky Bandits from Quickspin. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/quickspin/sticky_bandits_3_most_wanted': {
        title: 'Sticky Bandits 3 Most Wanted Bonus Slot by Quickspin | {brand}',
        description: 'Sticky Bandits 3 Most Wanted from Quickspin, with a 22,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/quickspin/sticky_bandits_thunder_rail': {
        title: 'Sticky Bandits Thunder Rail Bonus Slot by Quickspin | {brand}',
        description: 'Sticky Bandits Thunder Rail by Quickspin at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/quickspin/sticky_bandits_trail_of_blood': {
        title: 'Sticky Bandits Trail of Blood Bonus Slot by Quickspin | {brand}',
        description: 'Sticky Bandits Trail of Blood from Quickspin, with a 17,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/quickspin/sticky_bandits_unchained': {
        title: 'Sticky Bandits Unchained by Quickspin at {brand} | Free Demo & Crypto Play',
        description: 'Sticky Bandits Unchained from Quickspin. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/quickspin/sticky_bandits_wild_return': {
        title: 'Sticky Bandits: Wild return Slot by Quickspin at {brand} | Instant Crypto Payouts',
        description: 'Sticky Bandits: Wild return by Quickspin at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/quickspin/tales_of_dr_dolittle': {
        title: 'Tales of Dr. dolittle Bonus Slot by Quickspin | {brand}',
        description: 'Play Tales of Dr. dolittle by Quickspin at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/quickspin/temple_of_paw': {
        title: 'Temple of Paw by Quickspin at {brand} | Free Demo & Crypto Play',
        description: 'Play Temple of Paw by Quickspin at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/quickspin/the_grand': {
        title: 'The Grand: Play Online with Crypto | {brand}',
        description: 'Spin The Grand by Quickspin at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/quickspin/the_grim_reaper': {
        title: 'The Grim Reaper Slot by Quickspin at {brand} | Instant Crypto Payouts',
        description: 'The Grim Reaper from Quickspin, with a 5,360x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/quickspin/the_wild_chase': {
        title: 'The Wild Chase Slot by Quickspin at {brand} | Instant Crypto Payouts',
        description: 'The Wild Chase by Quickspin at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/quickspin/ticket_to_the_stars': {
        title: 'Ticket to the stars: Play Online with Crypto | {brand}',
        description: 'Spin Ticket to the stars by Quickspin at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/quickspin/tigers_glory': {
        title: "Play Tiger's Glory by Quickspin at {brand} | 12,000x Max Win",
        description: "Spin Tiger's Glory by Quickspin at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/quickspin/tigers_glory_ultra': {
        title: "Tiger's Glory Ultra Slot by Quickspin at {brand} | Instant Crypto Payouts",
        description: "Tiger's Glory Ultra by Quickspin at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/quickspin/treasure_island': {
        title: 'Treasure Island by Quickspin at {brand} | Free Demo & Crypto Play',
        description: 'Treasure Island from Quickspin. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/quickspin/vampire_senpai': {
        title: 'Vampire Senpai Bonus Slot by Quickspin | {brand}',
        description: 'Vampire Senpai from Quickspin, with a 8,800x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/quickspin/volcano_riches': {
        title: 'Volcano Riches Slot by Quickspin at {brand} | Instant Crypto Payouts',
        description: 'Volcano Riches by Quickspin at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/quickspin/warp_wreckers_power_glyph': {
        title: 'Play Warp Wreckers Power Glyph by Quickspin at {brand} | 4,500x Max Win',
        description: 'Spin Warp Wreckers Power Glyph by Quickspin at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/quickspin/wild_beans': {
        title: 'Wild Beans: Play Online with Crypto | {brand}',
        description: 'Spin Wild Beans by Quickspin at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/quickspin/wild_cauldron': {
        title: 'Wild Cauldron Slot by Quickspin at {brand} | Instant Crypto Payouts',
        description: 'Wild Cauldron by Quickspin at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/quickspin/wild_chase_tokyo_go': {
        title: 'Wild Chase: Tokyo Go Slot by Quickspin at {brand} | Instant Crypto Payouts',
        description: 'Wild Chase: Tokyo Go by Quickspin at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/quickspin/wild_harlequin': {
        title: 'Wild Harlequin: Play Online with Crypto | {brand}',
        description: 'Spin Wild Harlequin by Quickspin at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/quickspin/wild_luchador': {
        title: 'Wild Luchador Bonus Slot by Quickspin | {brand}',
        description: 'Wild Luchador from Quickspin, with a 40,500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/quickspin/wild_tome_of_the_woods': {
        title: 'Wild Tome of the Woods Slot by Quickspin at {brand} | Instant Crypto Payouts',
        description: 'Wild Tome of the Woods by Quickspin at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/quickspin/wins_of_fortune': {
        title: 'Wins of Fortune by Quickspin at {brand} | Free Demo & Crypto Play',
        description: 'Wins of Fortune from Quickspin. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/12_bells': {
        title: '12 Bells Volatility Slot by Wazdan | {brand}',
        description: 'Play 12 Bells by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/12_coins': {
        title: '12 Coins™: Play Online with Crypto | {brand}',
        description: 'Spin 12 Coins™ by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/12_coins_grand_diamond_edition': {
        title: '12 Coins Grand Diamond Edition Slot by Wazdan at {brand} | Instant Crypto Payouts',
        description: '12 Coins Grand Diamond Edition by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/12_coins_grand_gold_edition': {
        title: '12 Coins Grand Gold Edition Volatility Slot by Wazdan | {brand}',
        description: '12 Coins Grand Gold Edition by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/12_coins_grand_platinum_edition': {
        title: '12 Coins Grand Platinum Edition Volatility Slot by Wazdan | {brand}',
        description: '12 Coins Grand Platinum Edition by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/15_coins': {
        title: '15 Coins: Play Online with Crypto | {brand}',
        description: '15 Coins from Wazdan, with a 100,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/15_coins_grand_gold_edition': {
        title: 'Play 15 Coins Grand Gold Edition by Wazdan at {brand} | 2,000x Max Win',
        description: 'Play 15 Coins Grand Gold Edition by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/15_coins_grand_platinum_edition': {
        title: 'Play 15 Coins Grand Platinum Edition by Wazdan at {brand} | 2,500x Max Win',
        description: 'Play 15 Coins Grand Platinum Edition by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/16_coins': {
        title: '16 Coins: Play Online with Crypto | {brand}',
        description: 'Spin 16 Coins by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/16_coins_grand_gold_edition': {
        title: '16 Coins Grand Gold Edition: Play Online with Crypto | {brand}',
        description: '16 Coins Grand Gold Edition by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/16_coins_grand_platinum_edition': {
        title: '16 Coins Grand Platinum Edition Slot by Wazdan at {brand} | Instant Crypto Payouts',
        description: '16 Coins Grand Platinum Edition by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/16_coins_x5000': {
        title: 'Play 16 Coins x5000 by Wazdan at {brand} | 5,000x Max Win',
        description: 'Spin 16 Coins x5000 by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/20_coins': {
        title: '20 Coins: Play Online with Crypto | {brand}',
        description: '20 Coins by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/20_coins_grand_gold_edition': {
        title: 'Play 20 Coins Grand Gold Edition by Wazdan at {brand} | 2,000x Max Win',
        description: 'Spin 20 Coins Grand Gold Edition by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/24_coins': {
        title: '24 Coins: Play Online with Crypto | {brand}',
        description: '24 Coins by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/25_coins': {
        title: 'Play 25 Coins by Wazdan at {brand} | 2,000x Max Win',
        description: 'Play 25 Coins by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/25_coins_grand_gold_edition': {
        title: '25 Coins Grand Gold Edition Slot by Wazdan at {brand} | Instant Crypto Payouts',
        description: '25 Coins Grand Gold Edition from Wazdan, with a 2,500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/30_coins': {
        title: 'Play 30 Coins by Wazdan at {brand} | 1,500x Max Win',
        description: 'Spin 30 Coins by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/30_coins_grand_gold_edition': {
        title: '30 Coins Grand Gold Edition: Play Online with Crypto | {brand}',
        description: '30 Coins Grand Gold Edition by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/36_coins': {
        title: '36 Coins Volatility Slot by Wazdan | {brand}',
        description: 'Play 36 Coins by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/36_coins_grand_gold_edition': {
        title: '36 Coins Grand Gold Edition: Play Online with Crypto | {brand}',
        description: '36 Coins Grand Gold Edition from Wazdan, with a 2,500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/9_balls': {
        title: 'Play 9 Balls by Wazdan at {brand} | 2,500x Max Win',
        description: 'Play 9 Balls by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/9_bells': {
        title: '9 Bells Volatility Slot by Wazdan | {brand}',
        description: 'Play 9 Bells by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/9_burning_dragons': {
        title: 'Play 9 Burning Dragons by Wazdan at {brand} | 2,187x Max Win',
        description: 'Play 9 Burning Dragons by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/9_burning_stars': {
        title: '9 Burning Stars Volatility Slot by Wazdan | {brand}',
        description: '9 Burning Stars from Wazdan, with a 1,500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/9_coins': {
        title: 'Play 9 Coins by Wazdan at {brand} | 500x Max Win',
        description: 'Spin 9 Coins by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/9_coins_1000_edition': {
        title: '9 Coins 1000 Edition Volatility Slot by Wazdan | {brand}',
        description: '9 Coins 1000 Edition by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/9_coins_extremely_light': {
        title: '9 Coins Extremely Light Volatility Slot by Wazdan | {brand}',
        description: '9 Coins Extremely Light by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/9_coins_grand_diamond_edition': {
        title: '9 Coins Grand Diamond Edition: Play Online with Crypto | {brand}',
        description: '9 Coins Grand Diamond Edition by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/9_coins_grand_gold_edition': {
        title: '9 Coins: Grand Gold Edition Slot by Wazdan at {brand} | Instant Crypto Payouts',
        description: '9 Coins: Grand Gold Edition by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/9_coins_grand_platinum_edition': {
        title: '9 Coins Grand Platinum Edition Slot by Wazdan at {brand} | Instant Crypto Payouts',
        description: '9 Coins Grand Platinum Edition by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/9_lions': {
        title: '9 Lions: Play Online with Crypto | {brand}',
        description: '9 Lions by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/9_lions_hold_the_jackpot': {
        title: '9 Lions Hold the Jackpot Volatility Slot by Wazdan | {brand}',
        description: 'Play 9 Lions Hold the Jackpot by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/9_tigers': {
        title: 'Play 9 Tigers by Wazdan at {brand} | 1,000x Max Win',
        description: 'Play 9 Tigers by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/american_gold_poker': {
        title: 'American Gold Poker Slot by Wazdan at {brand} | Instant Crypto Payouts',
        description: 'American Gold Poker by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/arcade': {
        title: 'Arcade by Wazdan at {brand} | Free Demo & Crypto Play',
        description: 'Spin Arcade by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/back_to_70s': {
        title: "Back to 70's by Wazdan at {brand} | Free Demo & Crypto Play",
        description: "Play Back to 70's by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/wazdan/back_to_the_70s': {
        title: "Back to the 70's: Play Online with Crypto | {brand}",
        description: "Spin Back to the 70's by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/wazdan/bars_and_7s': {
        title: 'BARs and 7s: Play Online with Crypto | {brand}',
        description: 'BARs and 7s from Wazdan, with a 40x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/barsand7s': {
        title: 'BARsand7s by Wazdan at {brand} | Free Demo & Crypto Play',
        description: 'BARsand7s from Wazdan. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/beach_party': {
        title: 'Play Beach Party by Wazdan at {brand} | 36x Max Win',
        description: 'Play Beach Party by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/beach_party_hot': {
        title: 'Play Beach Party Hot by Wazdan at {brand} | 305x Max Win',
        description: 'Spin Beach Party Hot by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/beauty_fruity': {
        title: 'Play Beauty Fruity by Wazdan at {brand} | 2,500x Max Win',
        description: 'Spin Beauty Fruity by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/bell_wizard': {
        title: 'Bell Wizard Volatility Slot by Wazdan | {brand}',
        description: 'Bell Wizard from Wazdan, with a 2,300x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/bells_of_fortune': {
        title: 'Bells of Fortune: Play Online with Crypto | {brand}',
        description: 'Spin Bells of Fortune by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/black_hawk': {
        title: 'Black Hawk Volatility Slot by Wazdan | {brand}',
        description: 'Black Hawk by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/black_hawk_deluxe': {
        title: 'Black Hawk Deluxe Volatility Slot by Wazdan | {brand}',
        description: 'Black Hawk Deluxe by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/black_horse': {
        title: 'Black Horse: Play Online with Crypto | {brand}',
        description: 'Black Horse by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/black_horse_cash_out': {
        title: 'Black Horse Cash Out: Play Online with Crypto | {brand}',
        description: 'Spin Black Horse Cash Out by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/black_horse_deluxe': {
        title: 'Black Horse Deluxe Volatility Slot by Wazdan | {brand}',
        description: 'Black Horse Deluxe by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/book_of_faith': {
        title: 'Play Book of Faith by Wazdan at {brand} | 500,000x Max Win',
        description: 'Spin Book of Faith by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/bumba_meu_boi_coin': {
        title: 'Bumba Meu Boi Coin: Play Online with Crypto | {brand}',
        description: 'Spin Bumba Meu Boi Coin by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/burning_reels': {
        title: 'Burning Reels: Play Online with Crypto | {brand}',
        description: 'Burning Reels by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/burning_stars': {
        title: 'Burning Stars: Play Online with Crypto | {brand}',
        description: 'Burning Stars by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/burning_stars_3': {
        title: 'Burning Stars 3 Volatility Slot by Wazdan | {brand}',
        description: 'Burning Stars 3 by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/burning_sun': {
        title: 'Burning Sun by Wazdan at {brand} | Free Demo & Crypto Play',
        description: 'Spin Burning Sun by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/burning_sun_extremely_light': {
        title: 'Burning Sun Extremely Light: Play Online with Crypto | {brand}',
        description: 'Burning Sun Extremely Light by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/butterfly_lovers': {
        title: 'Butterfly Lovers Volatility Slot by Wazdan | {brand}',
        description: 'Butterfly Lovers from Wazdan, with a 1,600x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/captain_shark': {
        title: 'Play Captain Shark by Wazdan at {brand} | 748x Max Win',
        description: 'Play Captain Shark by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/carribean_beach_poker': {
        title: 'Carribean Beach Poker Slot by Wazdan at {brand} | Instant Crypto Payouts',
        description: 'Carribean Beach Poker by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/cash_grotto': {
        title: 'Cash Grotto Slot by Wazdan at {brand} | Instant Crypto Payouts',
        description: 'Cash Grotto from Wazdan, with a 1,500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/choco_reels': {
        title: 'Choco Reels by Wazdan at {brand} | Free Demo & Crypto Play',
        description: 'Spin Choco Reels by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/clover_lady': {
        title: 'Play Clover Lady by Wazdan at {brand} | 3,500x Max Win',
        description: 'Spin Clover Lady by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/colin_the_cat': {
        title: 'Play Colin The Cat by Wazdan at {brand} | 260x Max Win',
        description: 'Play Colin The Cat by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/corrida_romance': {
        title: 'Play Corrida Romance by Wazdan at {brand} | 5,150x Max Win',
        description: 'Play Corrida Romance by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/corrida_romance_deluxe': {
        title: 'Corrida Romance Deluxe by Wazdan at {brand} | Free Demo & Crypto Play',
        description: 'Spin Corrida Romance Deluxe by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/crazy_cars': {
        title: 'Crazy Cars Slot by Wazdan at {brand} | Instant Crypto Payouts',
        description: 'Crazy Cars by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/criss_cross_81': {
        title: 'Criss Cross 81 Volatility Slot by Wazdan | {brand}',
        description: 'Criss Cross 81 by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/cube_mania': {
        title: 'Play Cube Mania by Wazdan at {brand} | 1,000x Max Win',
        description: 'Spin Cube Mania by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/cube_mania_deluxe': {
        title: 'Play Cube Mania Deluxe by Wazdan at {brand} | 570x Max Win',
        description: 'Play Cube Mania Deluxe by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/demon_jack_27': {
        title: 'Demon Jack 27 Slot by Wazdan at {brand} | Instant Crypto Payouts',
        description: 'Demon Jack 27 by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/dino_reels_81': {
        title: 'Dino Reels 81 by Wazdan at {brand} | Free Demo & Crypto Play',
        description: 'Spin Dino Reels 81 by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/double_tigers': {
        title: 'Double Tigers by Wazdan at {brand} | Free Demo & Crypto Play',
        description: 'Play Double Tigers by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/draculas_castle': {
        title: "Dracula's Castle by Wazdan at {brand} | Free Demo & Crypto Play",
        description: "Play Dracula's Castle by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/wazdan/dragons_lucky_8': {
        title: 'Dragons Lucky 8 by Wazdan at {brand} | Free Demo & Crypto Play',
        description: 'Play Dragons Lucky 8 by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/dwarfs_fortune': {
        title: 'Dwarfs Fortune Volatility Slot by Wazdan | {brand}',
        description: 'Dwarfs Fortune from Wazdan, with a 2,500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/easter_coins': {
        title: 'Easter Coins Slot by Wazdan at {brand} | Instant Crypto Payouts',
        description: 'Easter Coins by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/eggs_of_fortune': {
        title: 'Play Eggs of Fortune by Wazdan at {brand} | 5,000x Max Win',
        description: 'Play Eggs of Fortune by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/extra_bingo': {
        title: 'Extra Bingo by Wazdan at {brand} | Free Demo & Crypto Play',
        description: 'Spin Extra Bingo by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/fenix_play': {
        title: 'Fenix Play Slot by Wazdan at {brand} | Instant Crypto Payouts',
        description: 'Fenix Play by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/fenix_play_27': {
        title: 'Fenix Play 27 Volatility Slot by Wazdan | {brand}',
        description: 'Fenix Play 27 from Wazdan, with a 72x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/fenix_play_27_deluxe': {
        title: 'Fenix Play 27 Deluxe Volatility Slot by Wazdan | {brand}',
        description: 'Fenix Play 27 Deluxe from Wazdan, with a 748x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/fenix_play_deluxe': {
        title: 'Fenix Play Deluxe Volatility Slot by Wazdan | {brand}',
        description: 'Fenix Play Deluxe by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/fire_bird': {
        title: 'Play Fire Bird by Wazdan at {brand} | 1,000x Max Win',
        description: 'Play Fire Bird by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/fishermans_luck': {
        title: "Fisherman's Luck by Wazdan at {brand} | Free Demo & Crypto Play",
        description: "Play Fisherman's Luck by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/wazdan/football_mania': {
        title: 'Football Mania by Wazdan at {brand} | Free Demo & Crypto Play',
        description: 'Spin Football Mania by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/football_mania_deluxe': {
        title: 'Play Football Mania Deluxe by Wazdan at {brand} | 1,000x Max Win',
        description: 'Play Football Mania Deluxe by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/fortune_reels': {
        title: 'Fortune Reels: Play Online with Crypto | {brand}',
        description: 'Fortune Reels from Wazdan, with a 2,100x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/fruit_fiesta': {
        title: 'Fruit Fiesta: Play Online with Crypto | {brand}',
        description: 'Fruit Fiesta by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/fruit_mania': {
        title: 'Fruit Mania by Wazdan at {brand} | Free Demo & Crypto Play',
        description: 'Fruit Mania from Wazdan. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/fruit_mania_deluxe': {
        title: 'Fruit Mania Deluxe Volatility Slot by Wazdan | {brand}',
        description: 'Fruit Mania Deluxe from Wazdan, with a 1,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/fruits_go_bananas': {
        title: 'Fruits Go Bananas: Play Online with Crypto | {brand}',
        description: 'Fruits Go Bananas from Wazdan, with a 850x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/gem_splitter': {
        title: 'Gem Splitter Slot by Wazdan at {brand} | Instant Crypto Payouts',
        description: 'Gem Splitter from Wazdan, with a 9,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/golden_sphinx': {
        title: 'Play Golden Sphinx by Wazdan at {brand} | 2,000x Max Win',
        description: 'Play Golden Sphinx by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/good_luck_40': {
        title: 'Good Luck 40 by Wazdan at {brand} | Free Demo & Crypto Play',
        description: 'Spin Good Luck 40 by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/great_book_of_magic': {
        title: 'Great Book of Magic Volatility Slot by Wazdan | {brand}',
        description: 'Great Book of Magic by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/great_book_of_magic_deluxe': {
        title: 'Great Book of Magic Deluxe Slot by Wazdan at {brand} | Instant Crypto Payouts',
        description: 'Great Book of Magic Deluxe by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/haunted_coins_x1000': {
        title: 'Play Haunted Coins x1000 by Wazdan at {brand} | 1,000x Max Win',
        description: 'Spin Haunted Coins x1000 by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/haunted_hospital': {
        title: 'Haunted Hospital by Wazdan at {brand} | Free Demo & Crypto Play',
        description: 'Spin Haunted Hospital by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/highschool_manga': {
        title: 'Highschool Manga Slot by Wazdan at {brand} | Instant Crypto Payouts',
        description: 'Highschool Manga from Wazdan, with a 320x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/highway_to_hell': {
        title: 'Highway To Hell Volatility Slot by Wazdan | {brand}',
        description: 'Highway To Hell from Wazdan, with a 2,144x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/highway_to_hell_deluxe': {
        title: 'Highway to Hell Deluxe: Play Online with Crypto | {brand}',
        description: 'Highway to Hell Deluxe from Wazdan, with a 1,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/hot_777': {
        title: 'Hot 777: Play Online with Crypto | {brand}',
        description: 'Hot 777 by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/hot_777_deluxe': {
        title: 'Hot 777 Deluxe: Play Online with Crypto | {brand}',
        description: 'Hot 777 Deluxe by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/hot_party': {
        title: 'Play Hot Party by Wazdan at {brand} | 4,650x Max Win',
        description: 'Spin Hot Party by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/hot_party_deluxe': {
        title: 'Hot Party Deluxe by Wazdan at {brand} | Free Demo & Crypto Play',
        description: 'Play Hot Party Deluxe by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/hot_slot777_hold_the_jackpot': {
        title: 'Hot Slot: Play Online with Crypto | {brand}',
        description: 'Spin Hot Slot by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/hot_slot_777_cash_out': {
        title: 'Hot Slot: 777 Cash Out: Play Online with Crypto | {brand}',
        description: 'Hot Slot: 777 Cash Out by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/hot_slot_777_cash_out_extremely_light': {
        title: 'Hot Slot: 777 Cash Out Extremely Light Volatility Slot by Wazdan | {brand}',
        description: 'Play Hot Slot: 777 Cash Out Extremely Light by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/hot_slot_777_cash_out_grand_gold_edition': {
        title: 'Hot Slot: 777 Cash Out Grand Gold Edition: Play Online with Crypto | {brand}',
        description: 'Spin Hot Slot: 777 Cash Out Grand Gold Edition by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/hot_slot_777_coins': {
        title: 'Hot Slot by Wazdan at {brand} | Free Demo & Crypto Play',
        description: 'Hot Slot from Wazdan. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/hot_slot_777_coins_extremely_light': {
        title: 'Hot Slot 777 Coins Extremely Light: Play Online with Crypto | {brand}',
        description: 'Spin Hot Slot 777 Coins Extremely Light by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/hot_slot_777_crown': {
        title: 'Play Hot Slot: 777 Crown by Wazdan at {brand} | 305x Max Win',
        description: 'Spin Hot Slot: 777 Crown by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/hot_slot_777_crown_extremely_light': {
        title: 'Hot Slot: 777 Crown Extremely Light Slot by Wazdan at {brand} | Instant Crypto Payouts',
        description: 'Hot Slot: 777 Crown Extremely Light by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/hot_slot_777_diamond_crown': {
        title: 'Hot Slot 777 Diamond Crown Volatility Slot by Wazdan | {brand}',
        description: 'Hot Slot 777 Diamond Crown by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/hot_slot_777_gold_crown': {
        title: 'Hot Slot 777 Gold Crown: Play Online with Crypto | {brand}',
        description: 'Hot Slot 777 Gold Crown from Wazdan, with a 1,500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/hot_slot_777_hold_the_jackpot': {
        title: 'Hot Slot 777 Hold the Jackpot: Play Online with Crypto | {brand}',
        description: 'Hot Slot 777 Hold the Jackpot from Wazdan, with a 1,500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/hot_slot_777_platinum_crown': {
        title: 'Hot Slot 777 Platinum Crown: Play Online with Crypto | {brand}',
        description: 'Hot Slot 777 Platinum Crown from Wazdan, with a 2,500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/hot_slot_777_rubies': {
        title: 'Hot Slot: 777 Rubies Slot by Wazdan at {brand} | Instant Crypto Payouts',
        description: 'Hot Slot: 777 Rubies from Wazdan, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/hot_slot_777_rubies_extremely_light': {
        title: 'Hot Slot: 777 Rubies Extremely Light: Play Online with Crypto | {brand}',
        description: 'Spin Hot Slot: 777 Rubies Extremely Light by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/hot_slot_777_stars': {
        title: 'Hot Slot: 777 Stars by Wazdan at {brand} | Free Demo & Crypto Play',
        description: 'Play Hot Slot: 777 Stars by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/hot_slot_777_stars_extremely_light': {
        title: 'Hot Slot by Wazdan at {brand} | Free Demo & Crypto Play',
        description: 'Hot Slot from Wazdan. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/hot_slot_diamond_coins': {
        title: 'Play Hot Slot Diamond Coins by Wazdan at {brand} | 3,000x Max Win',
        description: 'Spin Hot Slot Diamond Coins by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/hot_slot_gold_coins': {
        title: 'Play Hot Slot Gold Coins by Wazdan at {brand} | 750x Max Win',
        description: 'Play Hot Slot Gold Coins by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/hot_slot_great_book_of_magic': {
        title: 'Play Hot Slot: Great Book of Magic by Wazdan at {brand} | 6,000x Max Win',
        description: 'Play Hot Slot: Great Book of Magic by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/hot_slot_magic_bombs': {
        title: 'Play Hot Slot: Magic Bombs by Wazdan at {brand} | 6,000x Max Win',
        description: 'Spin Hot Slot: Magic Bombs by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/hot_slot_magic_pearls': {
        title: 'Play Hot Slot: Magic Pearls by Wazdan at {brand} | 2,500x Max Win',
        description: 'Play Hot Slot: Magic Pearls by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/hot_slot_mystery_jackpot_joker': {
        title: 'Hot Slot: Mystery Jackpot Joker Volatility Slot by Wazdan | {brand}',
        description: 'Hot Slot: Mystery Jackpot Joker from Wazdan, with a 1,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/hot_slot_platinum_coins': {
        title: 'Hot Slot Platinum Coins by Wazdan at {brand} | Free Demo & Crypto Play',
        description: 'Play Hot Slot Platinum Coins by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/hungry_shark': {
        title: 'Hungry Shark Slot by Wazdan at {brand} | Instant Crypto Payouts',
        description: 'Hungry Shark from Wazdan, with a 5,150x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/in_the_forest': {
        title: 'In the Forest: Play Online with Crypto | {brand}',
        description: 'In the Forest by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/infinity_hero': {
        title: 'Infinity Hero Volatility Slot by Wazdan | {brand}',
        description: 'Infinity Hero by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/jack_on_hold': {
        title: 'Jack on Hold Slot by Wazdan at {brand} | Instant Crypto Payouts',
        description: 'Jack on Hold from Wazdan, with a 500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/jackpot_builders': {
        title: 'Jackpot Builders: Play Online with Crypto | {brand}',
        description: 'Jackpot Builders by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/jacks_ride': {
        title: "Jack's Ride Volatility Slot by Wazdan | {brand}",
        description: "Jack's Ride from Wazdan, with a 81x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees."
    },
    '/p/wazdan/jelly_reels': {
        title: 'Play Jelly Reels by Wazdan at {brand} | 2,500x Max Win',
        description: 'Spin Jelly Reels by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/joker_explosion': {
        title: 'Joker Explosion Slot by Wazdan at {brand} | Instant Crypto Payouts',
        description: 'Joker Explosion by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/juicy_reels': {
        title: 'Juicy Reels by Wazdan at {brand} | Free Demo & Crypto Play',
        description: 'Play Juicy Reels by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/jumping_fruits': {
        title: 'Jumping Fruits by Wazdan at {brand} | Free Demo & Crypto Play',
        description: 'Play Jumping Fruits by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/kickoff': {
        title: 'KickOff: Play Online with Crypto | {brand}',
        description: 'KickOff by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/larry_the_leprechaun': {
        title: 'Play Larry the Leprechaun by Wazdan at {brand} | 350x Max Win',
        description: 'Spin Larry the Leprechaun by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/los_muertos': {
        title: 'Los Muertos by Wazdan at {brand} | Free Demo & Crypto Play',
        description: 'Spin Los Muertos by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/los_muertos_ii': {
        title: 'Los Muertos II Volatility Slot by Wazdan | {brand}',
        description: 'Los Muertos II from Wazdan, with a 4,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/lost_treasure': {
        title: 'Play Lost Treasure by Wazdan at {brand} | 3,500x Max Win',
        description: 'Play Lost Treasure by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/lucky_9': {
        title: 'Play Lucky 9 by Wazdan at {brand} | 1,300x Max Win',
        description: 'Play Lucky 9 by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/lucky_fish': {
        title: 'Lucky Fish: Play Online with Crypto | {brand}',
        description: 'Lucky Fish from Wazdan, with a 350x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/lucky_fortune': {
        title: 'Play Lucky Fortune by Wazdan at {brand} | 1,104x Max Win',
        description: 'Play Lucky Fortune by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/lucky_queen': {
        title: 'Lucky Queen: Play Online with Crypto | {brand}',
        description: 'Lucky Queen from Wazdan, with a 4,500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/lucky_reels': {
        title: 'Play Lucky Reels by Wazdan at {brand} | 900x Max Win',
        description: 'Play Lucky Reels by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/magic_eggs': {
        title: 'Play Magic Eggs by Wazdan at {brand} | 40x Max Win',
        description: 'Spin Magic Eggs by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/magic_fruit_cherries': {
        title: 'Play Magic Fruit: Cherries by Wazdan at {brand} | 500x Max Win',
        description: 'Spin Magic Fruit: Cherries by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/magic_fruit_dice': {
        title: 'Magic Fruit Dice by Wazdan at {brand} | Free Demo & Crypto Play',
        description: 'Spin Magic Fruit Dice by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/magic_fruit_oranges': {
        title: 'Magic Fruit$: Play Online with Crypto | {brand}',
        description: 'Spin Magic Fruit$ by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/magic_fruits': {
        title: 'Magic Fruits: Play Online with Crypto | {brand}',
        description: 'Magic Fruits by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/magic_fruits_27': {
        title: 'Magic Fruits 27: Play Online with Crypto | {brand}',
        description: 'Magic Fruits 27 from Wazdan, with a 2,240x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/magic_fruits_4': {
        title: 'Play Magic Fruits 4 by Wazdan at {brand} | 1,000x Max Win',
        description: 'Play Magic Fruits 4 by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/magic_fruits_4_deluxe': {
        title: 'Magic Fruits 4 Deluxe by Wazdan at {brand} | Free Demo & Crypto Play',
        description: 'Spin Magic Fruits 4 Deluxe by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/magic_fruits_81': {
        title: 'Magic Fruits 81: Play Online with Crypto | {brand}',
        description: 'Magic Fruits 81 from Wazdan, with a 260x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/magic_fruits_deluxe': {
        title: 'Magic Fruits Deluxe Slot by Wazdan at {brand} | Instant Crypto Payouts',
        description: 'Magic Fruits Deluxe by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/magic_fruits_dice': {
        title: 'Magic Fruits Dice Slot by Wazdan at {brand} | Instant Crypto Payouts',
        description: 'Magic Fruits Dice by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/magic_fruits_oranges': {
        title: 'Magic Fruits Oranges Slot by Wazdan at {brand} | Instant Crypto Payouts',
        description: 'Magic Fruits Oranges from Wazdan, with a 10,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/magic_hot': {
        title: 'Magic Hot Volatility Slot by Wazdan | {brand}',
        description: 'Magic Hot from Wazdan, with a 800x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/magic_hot_4': {
        title: 'Magic Hot 4 by Wazdan at {brand} | Free Demo & Crypto Play',
        description: 'Spin Magic Hot 4 by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/magic_hot_4_deluxe': {
        title: 'Play Magic Hot 4 Deluxe by Wazdan at {brand} | 260x Max Win',
        description: 'Play Magic Hot 4 Deluxe by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/magic_of_the_ring': {
        title: 'Play Magic Of The Ring by Wazdan at {brand} | 800x Max Win',
        description: 'Spin Magic Of The Ring by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/magic_of_the_ring_deluxe': {
        title: 'Magic of the Ring Deluxe by Wazdan at {brand} | Free Demo & Crypto Play',
        description: 'Play Magic of the Ring Deluxe by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/magic_spins': {
        title: 'Magic Spins: Play Online with Crypto | {brand}',
        description: 'Magic Spins from Wazdan, with a 2,500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/magic_stars': {
        title: 'Magic Stars: Play Online with Crypto | {brand}',
        description: 'Magic Stars from Wazdan, with a 40x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/magic_stars_3': {
        title: 'Magic Stars 3: Play Online with Crypto | {brand}',
        description: 'Magic Stars 3 from Wazdan, with a 200x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/magic_stars_5': {
        title: 'Magic Stars 5 Slot by Wazdan at {brand} | Instant Crypto Payouts',
        description: 'Magic Stars 5 by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/magic_stars_6': {
        title: 'Play Magic Stars 6 by Wazdan at {brand} | 750x Max Win',
        description: 'Play Magic Stars 6 by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/magic_stars_9': {
        title: 'Magic Stars 9: Play Online with Crypto | {brand}',
        description: 'Magic Stars 9 by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/magic_target': {
        title: 'Magic Target Slot by Wazdan at {brand} | Instant Crypto Payouts',
        description: 'Magic Target from Wazdan, with a 1,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/magic_target_deluxe': {
        title: 'Magic Target Deluxe Slot by Wazdan at {brand} | Instant Crypto Payouts',
        description: 'Magic Target Deluxe from Wazdan, with a 1,250x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/mayan_ritual': {
        title: 'Play Mayan Ritual by Wazdan at {brand} | 850x Max Win',
        description: 'Spin Mayan Ritual by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/miami_beach': {
        title: 'Miami Beach: Play Online with Crypto | {brand}',
        description: 'Miami Beach by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/midnight_in_tokyo': {
        title: 'Midnight in Tokyo Slot by Wazdan at {brand} | Instant Crypto Payouts',
        description: 'Midnight in Tokyo from Wazdan, with a 3,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/mighty_crown_empire_of_gold': {
        title: 'Play Mighty Crown: Empire of Gold by Wazdan at {brand} | 1,500x Max Win',
        description: 'Play Mighty Crown: Empire of Gold by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/mighty_crown_legacy_of_mars': {
        title: 'Mighty Crown Legacy of Mars by Wazdan at {brand} | Free Demo & Crypto Play',
        description: 'Spin Mighty Crown Legacy of Mars by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/mighty_fish_blue_marlin': {
        title: 'Play Mighty Fish: Blue Marlin by Wazdan at {brand} | 2,500x Max Win',
        description: 'Play Mighty Fish: Blue Marlin by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/mighty_hot_777': {
        title: 'Mighty Hot 777 by Wazdan at {brand} | Free Demo & Crypto Play',
        description: 'Spin Mighty Hot 777 by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/mighty_hot_amazonia': {
        title: 'Mighty Hot: Amazonia: Play Online with Crypto | {brand}',
        description: 'Mighty Hot: Amazonia from Wazdan, with a 1,500x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/mighty_symbols_crowns': {
        title: 'Mighty Symbols Crowns Slot by Wazdan at {brand} | Instant Crypto Payouts',
        description: 'Mighty Symbols Crowns by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/mighty_symbols_diamonds': {
        title: 'Mighty Symbols Diamonds by Wazdan at {brand} | Free Demo & Crypto Play',
        description: 'Spin Mighty Symbols Diamonds by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/mighty_symbols_jokers': {
        title: 'Mighty Symbols: Jokers Volatility Slot by Wazdan | {brand}',
        description: 'Mighty Symbols: Jokers by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/mighty_symbols_sevens': {
        title: 'Mighty Symbols: Sevens Volatility Slot by Wazdan | {brand}',
        description: 'Mighty Symbols: Sevens from Wazdan, with a 2,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/mighty_wild_gorilla': {
        title: 'Mighty Wild Gorilla Volatility Slot by Wazdan | {brand}',
        description: 'Play Mighty Wild Gorilla by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/mighty_wild_jaguar': {
        title: 'Mighty Wild Jaguar by Wazdan at {brand} | Free Demo & Crypto Play',
        description: 'Play Mighty Wild Jaguar by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/mighty_wild_panther': {
        title: 'Play Mighty Wild: Panther by Wazdan at {brand} | 750x Max Win',
        description: 'Play Mighty Wild: Panther by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/mighty_wild_panther_grand_gold_edition': {
        title: 'Mighty Wild Panther Grand Gold Edition by Wazdan at {brand} | Free Demo & Crypto Play',
        description: 'Mighty Wild Panther Grand Gold Edition from Wazdan. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/moon_of_fortune': {
        title: 'Moon of Fortune by Wazdan at {brand} | Free Demo & Crypto Play',
        description: 'Moon of Fortune from Wazdan. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/mystery_jack': {
        title: 'Mystery Jack Slot by Wazdan at {brand} | Instant Crypto Payouts',
        description: 'Mystery Jack from Wazdan, with a 532x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/mystery_jack_deluxe': {
        title: 'Mystery Jack Deluxe Slot by Wazdan at {brand} | Instant Crypto Payouts',
        description: 'Mystery Jack Deluxe from Wazdan, with a 820x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/mystery_kindom_mystery_bells': {
        title: 'Mystery Kindom: Mystery Bells Volatility Slot by Wazdan | {brand}',
        description: 'Mystery Kindom: Mystery Bells from Wazdan, with a 750x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/mystery_kingdom_mystery_bells': {
        title: 'Mystery Kingdom Mystery Bells: Play Online with Crypto | {brand}',
        description: 'Spin Mystery Kingdom Mystery Bells by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/neon_city': {
        title: 'Neon City by Wazdan at {brand} | Free Demo & Crypto Play',
        description: 'Spin Neon City by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/night_club_81': {
        title: 'Night Club 81 Slot by Wazdan at {brand} | Instant Crypto Payouts',
        description: 'Night Club 81 from Wazdan, with a 2,240x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/one_coin': {
        title: 'One Coin Volatility Slot by Wazdan | {brand}',
        description: 'Play One Coin by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/one_coins': {
        title: 'One Coins Volatility Slot by Wazdan | {brand}',
        description: 'One Coins by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/ox_coin': {
        title: 'Ox Coin Slot by Wazdan at {brand} | Instant Crypto Payouts',
        description: 'Ox Coin from Wazdan, with a 250,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/power_of_god_medusa_extremely_light': {
        title: 'Power of God: Medusa Extremely Light Slot by Wazdan at {brand} | Instant Crypto Payouts',
        description: 'Power of God: Medusa Extremely Light by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/power_of_gods_egypt': {
        title: 'Power of Gods: Egypt Slot by Wazdan at {brand} | Instant Crypto Payouts',
        description: 'Power of Gods: Egypt by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/power_of_gods_hades': {
        title: 'Power of Gods: Hades Slot by Wazdan at {brand} | Instant Crypto Payouts',
        description: 'Power of Gods: Hades from Wazdan, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/power_of_gods_medusa': {
        title: 'Power of Gods: Medusa Volatility Slot by Wazdan | {brand}',
        description: 'Power of Gods: Medusa by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/power_of_gods_medusa_extremely_light': {
        title: 'Power of Gods Volatility Slot by Wazdan | {brand}',
        description: 'Play Power of Gods by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/power_of_gods_the_pantheon': {
        title: 'Power of Gods: The Pantheon Slot by Wazdan at {brand} | Instant Crypto Payouts',
        description: 'Power of Gods: The Pantheon from Wazdan, with a 1,450x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/power_of_gods_valhalla': {
        title: 'Power of Gods: Valhalla Volatility Slot by Wazdan | {brand}',
        description: 'Power of Gods: Valhalla by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/power_of_gods_valhalla_extremely_light': {
        title: 'Power of Gods: Valhalla Extremely Light Volatility Slot by Wazdan | {brand}',
        description: 'Play Power of Gods: Valhalla Extremely Light by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/power_of_sun_svarog': {
        title: 'Power of Sun: Svarog Slot by Wazdan at {brand} | Instant Crypto Payouts',
        description: 'Power of Sun: Svarog by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/prosperity_pearls': {
        title: 'Prosperity Pearls: Play Online with Crypto | {brand}',
        description: 'Prosperity Pearls by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/prosperity_reels': {
        title: 'Prosperity Reels Slot by Wazdan at {brand} | Instant Crypto Payouts',
        description: 'Prosperity Reels by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/reel_hero': {
        title: 'Reel Hero: Play Online with Crypto | {brand}',
        description: 'Reel Hero from Wazdan, with a 1,050x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/reel_joke': {
        title: 'Play Reel Joke by Wazdan at {brand} | 9,500x Max Win',
        description: 'Spin Reel Joke by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/relic_hunters_and_the_book_of_faith': {
        title: 'Play Relic Hunters and the Book of Faith by Wazdan at {brand} | 750x Max Win',
        description: 'Play Relic Hunters and the Book of Faith by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/santas_gift_frenzy': {
        title: "Play Santa's Gift Frenzy by Wazdan at {brand} | 10,000x Max Win",
        description: "Play Santa's Gift Frenzy by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee."
    },
    '/p/wazdan/santas_gifts_frenzy': {
        title: "Santa's Gifts Frenzy Slot by Wazdan at {brand} | Instant Crypto Payouts",
        description: "Santa's Gifts Frenzy by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/wazdan/sizzling_777': {
        title: 'Play Sizzling 777 by Wazdan at {brand} | 305x Max Win',
        description: 'Spin Sizzling 777 by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/sizzling_777_deluxe': {
        title: 'Play Sizzling 777 Deluxe by Wazdan at {brand} | 305x Max Win',
        description: 'Play Sizzling 777 Deluxe by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/sizzling_bells': {
        title: 'Sizzling Bells: Play Online with Crypto | {brand}',
        description: 'Sizzling Bells by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/sizzling_eggs': {
        title: 'Sizzling Eggs: Play Online with Crypto | {brand}',
        description: 'Sizzling Eggs by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/sizzling_eggs_extremely_light': {
        title: 'Sizzling Eggs Extremely Light Volatility Slot by Wazdan | {brand}',
        description: 'Play Sizzling Eggs Extremely Light by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/sizzling_eggs_grand_gold_edition': {
        title: 'Sizzling Eggs Grand Gold Edition by Wazdan at {brand} | Free Demo & Crypto Play',
        description: 'Spin Sizzling Eggs Grand Gold Edition by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/sizzling_eggs_grand_platinum_edition': {
        title: 'Sizzling Eggs Grand Platinum Edition: Play Online with Crypto | {brand}',
        description: 'Spin Sizzling Eggs Grand Platinum Edition by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/sizzling_kindom_bison': {
        title: 'Sizzling Kindom: Bison: Play Online with Crypto | {brand}',
        description: 'Sizzling Kindom: Bison by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/sizzling_kingdom_bison': {
        title: 'Sizzling Kingdom Bison: Play Online with Crypto | {brand}',
        description: 'Spin Sizzling Kingdom Bison by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/sizzling_moon': {
        title: 'Play Sizzling Moon by Wazdan at {brand} | 2,500x Max Win',
        description: 'Spin Sizzling Moon by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/slot_jam': {
        title: 'Slot Jam Volatility Slot by Wazdan | {brand}',
        description: 'Slot Jam by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/sonic_reels': {
        title: 'Sonic Reels by Wazdan at {brand} | Free Demo & Crypto Play',
        description: 'Play Sonic Reels by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/space_gem': {
        title: 'Play Space Gem by Wazdan at {brand} | 1,000x Max Win',
        description: 'Play Space Gem by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/space_spins': {
        title: 'Space Spins by Wazdan at {brand} | Free Demo & Crypto Play',
        description: 'Spin Space Spins by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/spectrum': {
        title: 'Spectrum Slot by Wazdan at {brand} | Instant Crypto Payouts',
        description: 'Spectrum by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/sun_of_fortune': {
        title: 'Sun of Fortune by Wazdan at {brand} | Free Demo & Crypto Play',
        description: 'Spin Sun of Fortune by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/super_hot': {
        title: 'Super Hot: Play Online with Crypto | {brand}',
        description: 'Super Hot by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/telly_reels': {
        title: 'Play Telly Reels by Wazdan at {brand} | 1,400x Max Win',
        description: 'Play Telly Reels by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/three_cards': {
        title: 'Three Cards by Wazdan at {brand} | Free Demo & Crypto Play',
        description: 'Play Three Cards by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/triple_star': {
        title: 'Triple Star: Play Online with Crypto | {brand}',
        description: 'Triple Star from Wazdan, with a 300x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/turbo_play': {
        title: 'Turbo Play: Play Online with Crypto | {brand}',
        description: 'Turbo Play by Wazdan at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/wazdan/unicorn_reels': {
        title: 'Play Unicorn Reels by Wazdan at {brand} | 1,000x Max Win',
        description: 'Play Unicorn Reels by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/valentines_coins': {
        title: "Play Valentine's Coins by Wazdan at {brand} | 50,000x Max Win",
        description: "Spin Valentine's Coins by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes."
    },
    '/p/wazdan/valhalla': {
        title: 'Valhalla: Play Online with Crypto | {brand}',
        description: 'Valhalla from Wazdan, with a 600x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/vegas_hot': {
        title: 'Play Vegas Hot by Wazdan at {brand} | 340x Max Win',
        description: 'Spin Vegas Hot by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/vegas_hot_81': {
        title: 'Play Vegas Hot 81 by Wazdan at {brand} | 5,850x Max Win',
        description: 'Spin Vegas Hot 81 by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/vegas_reels_ii': {
        title: 'Vegas Reels II: Play Online with Crypto | {brand}',
        description: 'Vegas Reels II from Wazdan, with a 710x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/wazdan/welcome_to_hell_81': {
        title: 'Play Welcome to Hell 81 by Wazdan at {brand} | 5,850x Max Win',
        description: 'Spin Welcome to Hell 81 by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/wild_girls': {
        title: 'Play Wild Girls by Wazdan at {brand} | 750x Max Win',
        description: 'Play Wild Girls by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/wazdan/wild_guns': {
        title: 'Play Wild Guns by Wazdan at {brand} | 850x Max Win',
        description: 'Spin Wild Guns by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/wild_jack': {
        title: 'Play Wild Jack by Wazdan at {brand} | 3,000x Max Win',
        description: 'Spin Wild Jack by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/wild_jack_81': {
        title: 'Play Wild Jack 81 by Wazdan at {brand} | 2,240x Max Win',
        description: 'Spin Wild Jack 81 by Wazdan at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/wazdan/win_and_replay': {
        title: 'Win and Replay by Wazdan at {brand} | Free Demo & Crypto Play',
        description: 'Play Win and Replay by Wazdan at {brand}. Free demo, crypto deposits and instant withdrawals with no platform fee.'
    },
    '/p/avatarux/7_lucky_gods': {
        title: '7 Lucky Gods PopWins Slot by AvatarUX | {brand}',
        description: '7 Lucky Gods from AvatarUX, with a 1,200x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    },
    '/p/bgaming/book_of_hidden_tombs': {
        title: 'Play Book of Hidden Tombs by BGaming at {brand} | 10,000x Max Win',
        description: 'Spin Book of Hidden Tombs by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/fortune_trio_minions_of_fu': {
        title: 'Play Fortune Trio by BGaming at {brand} | 2,000x Max Win',
        description: 'Spin Fortune Trio by BGaming at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/bgaming/lucky_pinball': {
        title: 'Lucky Pinball Slot by BGaming at {brand} | Instant Crypto Payouts',
        description: 'Lucky Pinball by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake.'
    },
    '/p/bgaming/st_patricks_pots_hold_and_win': {
        title: "St. Patrick's Pots Hold and Win Provably Fair Slot by BGaming | {brand}",
        description: "St. Patrick's Pots Hold and Win by BGaming at {brand}: instant crypto withdrawals, no platform fee, and a free demo before you stake."
    },
    '/p/pragmatic-play/super_serge': {
        title: 'Play Super Serge by Pragmatic Play at {brand} | 10,000x Max Win',
        description: 'Spin Super Serge by Pragmatic Play at {brand}. Try the free demo, then play with crypto and withdraw in minutes.'
    },
    '/p/pgsoft/farmstead_fortune': {
        title: 'Farmstead Fortune Slot by PG Soft at {brand} | Instant Crypto Payouts',
        description: 'Farmstead Fortune from PG Soft, with a 5,000x max win. Play at {brand} with BTC, ETH, USDT and more. Instant payouts, no fees.'
    }
};
export const gameSeo = {
    ...gameSeoBase
};
export function normalizeGameSeoPath(pathname) {
    const clean = pathname.replace(/\/$/, '').split('?')[0] || '';
    const pIdx = clean.indexOf('/p/');
    if (pIdx < 0)
        return null;
    const parts = clean.slice(pIdx).split('/').filter(Boolean);
    if (parts.length < 3 || parts[0] !== 'p')
        return null;
    if (parts.length > 3)
        return null;
    const [, providerSlug, gameSlug] = parts;
    return `/p/${providerSlug}/${gameSlug}`;
}
export function getGameSeo(pathname) {
    const key = normalizeGameSeoPath(pathname);
    if (!key)
        return undefined;
    return gameSeo[key];
}
export function applyGameSeoBrandSubstitution(title, description, companyName, titleBrand = companyName) {
    return {
        title: title.replace(/\{brand\}/g, titleBrand),
        description: description.replace(/\{brand\}/g, companyName)
    };
}
